import "./styles.css";
import {
  acknowledgeNotificationEvent,
  approveRiskQuantification,
  challengeRiskQuantification,
  createAction,
  createAssuranceTest,
  createControl,
  createControlObligation,
  createCustomFieldDefinition,
  createEvidence,
  createEvidenceAttachment,
  createEvidencePackage,
  createImportMappingProfile,
  createImportValidationRule,
  createProgrammeItem,
  createQraModelRun,
  createReportDistributionList,
  createReportLayoutVariant,
  createReportSchedule,
  createRiskControl,
  createRiskIndicator,
  createReportTemplate,
  createSrsConnection,
  createTaxonomyItem,
  createWorkflowDefinition,
  dispatchDueNotifications,
  dispatchDueReportSchedules,
  closeReportingPeriod,
  deactivateControl,
  deactivateReportTemplate,
  deactivateTaxonomyItem,
  createRisk,
  createReportRun,
  createReportingPeriod,
  createUser,
  deactivateUser,
  deleteAction,
  deleteAssuranceTest,
  deleteControlObligation,
  deleteRiskControl,
  deleteRisk,
  dismissNotificationEvent,
  archiveEvidence,
  archiveEvidenceAttachment,
  generateReportPack,
  getSession,
  issueReportPack,
  loadAssuranceTests,
  loadControlObligations,
  loadSamplingPlans,
  createSamplingPlan,
  deleteSamplingPlan,
  loadObligationEscalations,
  raiseObligationEscalation,
  updateObligationEscalation,
  loadControls,
  loadCustomFieldDefinitions,
  loadCustomFieldValues,
  loadEvidence,
  loadEvidenceAttachments,
  uploadAttachmentBytes,
  loadEvidencePackages,
  loadAudit,
  loadQraExport,
  loadRiskAppetite,
  loadRiskAppetiteAssessments,
  loadRiskIndicatorEvents,
  loadRiskIndicators,
  loadManagedRiskIndicators,
  loadNotifications,
  loadRiskWorkshopDecisions,
  loadQraModelRun,
  loadQraModelRuns,
  loadQraExposureStates,
  loadQraReadiness,
  loadRiskEscalationEvents,
  loadProgrammeItems,
  loadReportPackSections,
  loadReportPacks,
  loadReportDistributionLists,
  loadReportDistributionRecipients,
  loadReportLayoutVariants,
  loadReportDeliveryJobs,
  loadReportDeliveryEvents,
  loadReportScheduleRuns,
  loadReportSchedules,
  loadReportRuns,
  loadReportTemplates,
  loadReportingPeriods,
  loadRiskQuantification,
  loadRiskTimeline,
  loadRiskControls,
  loadRiskExposureStateEvidence,
  loadRisks,
  loadTaxonomyItems,
  loadTenant,
  loadUsers,
  loadWorkflowDefinitions,
  loadWorkflows,
  logout,
  rejectRiskQuantification,
  recordActionProgress,
  recordRiskEscalationEvent,
  recordRiskIndicatorEvent,
  retireProgrammeItem,
  retireCustomFieldDefinition,
  retireImportMappingProfile,
  retireImportValidationRule,
  retireWorkflowDefinition,
  resolveImportRow,
  retireReportLayoutVariant,
  retireReportDistributionList,
  retireReportSchedule,
  retireRiskIndicator,
  saveTenantSettings,
  sealEvidencePackage,
  saveRiskExposureStateEvidence,
  saveRiskAppetiteAssessment,
  saveRiskQuantification,
  sendFeedback,
  sendReportDeliveryJob,
  snapshotReportingPeriod,
  startLogin,
  submitRiskQuantification,
  transitionWorkflow,
  importQraModelRunResults,
  importTaxonomyItems,
  loadImportMappingProfiles,
  loadImportValidationRules,
  loadImports,
  loadExports,
  createExportBatch,
  reconcileExportBatch,
  commitReconciliationRun,
  downloadExportBatchCsv,
  loadPackageGrants,
  createPackageGrant,
  revokePackageGrant,
  loadCompliance,
  loadIntegrations,
  saveIntegration,
  verifyIntegration,
  createRetentionPolicy,
  retireRetentionPolicy,
  createSecurityControl,
  recordBackupManifest,
  loadSchedule,
  processScheduleImport,
  loadCost,
  processCostImport,
  loadSrsConnections,
  loadSrsSyncEvents,
  pollQraModelRunFromSrs,
  pushQraModelRunToSrs,
  processImport,
  runSrsHealthCheck,
  runReportSchedule,
  updateAction,
  updateAssuranceTest,
  updateControl,
  updateControlObligation,
  updateCustomFieldDefinition,
  updateEvidence,
  updateImportMappingProfile,
  updateImportValidationRule,
  updateProgrammeItem,
  updateReportLayoutVariant,
  updateReportDistributionList,
  updateReportSchedule,
  updateReportTemplate,
  updateRisk,
  updateRiskControl,
  updateRiskIndicator,
  updateSrsConnection,
  updateTaxonomyItem,
  updateUser,
  updateWorkflowDefinition,
  upsertCustomFieldValue,
  verifyLogin,
} from "./api";
import type {
  ActionInput,
  ActionProgressInput,
  AssuranceTest,
  AssuranceTestInput,
  AssuranceStatus,
  AuditEntry,
  BowtieSide,
  Control,
  ControlEffectiveness,
  ControlInput,
  ControlObligation,
  ControlObligationInput,
  SamplingPlan,
  ObligationEscalation,
  ControlType,
  ConfigEntityType,
  CustomFieldDefinition,
  CustomFieldDefinitionInput,
  CustomFieldType,
  CustomFieldValue,
  CustomFieldValueInput,
  EvidenceEntityType,
  EvidenceAttachment,
  EvidenceAttachmentInput,
  EvidenceInput,
  EvidenceLink,
  EvidenceLinkRole,
  EvidencePackage,
  EvidencePackageInput,
  EvidencePackageItem,
  EvidenceRecord,
  EvidenceSensitivity,
  EvidenceStatus,
  EvidenceStorageProvider,
  EvidenceType,
  ImportBatch,
  ImportBatchInput,
  ImportMappingEntry,
  ImportMappingProfile,
  ImportMappingProfileInput,
  ImportResolutionDecision,
  ImportReviewMetadata,
  ImportReviewRecommendedAction,
  ImportRow,
  ImportRowResolutionInput,
  ImportRowPayload,
  ImportTargetType,
  ImportValidationIssue,
  ImportValidationRule,
  ImportValidationRuleCheckType,
  ImportValidationRuleInput,
  ExportBatch,
  ExportRow,
  ExportReconciliationRun,
  ExportReconciliationRow,
  ExportReconciliationCommit,
  ReconciliationCommitDecision,
  ExportScope,
  ExportTargetType,
  PackageAccessGrant,
  PackageAccessGrantInput,
  TenantPackage,
  IntegrationSetting,
  RetentionPolicy,
  RetentionPolicyInput,
  SecurityControl,
  SecurityControlInput,
  BackupManifest,
  BackupManifestInput,
  ScheduleImportBatch,
  ScheduleActivity,
  ScheduleRiskLink,
  CostImportBatch,
  CostLine,
  CostRiskReconciliation,
  NotificationEvent,
  NotificationRule,
  ProgrammeItem,
  ProgrammeItemInput,
  ProgrammeItemPriority,
  ProgrammeItemStatus,
  ProgrammeItemType,
  QraModelRun,
  QraModelRunDetail,
  QraModelRunInput,
  QraResultImportInput,
  RiskControl,
  RiskControlInput,
  ExposureStateKey,
  ReportDeliveryEvent,
  ReportDeliveryJob,
  ReportDeliverySendInput,
  ReportDistributionList,
  ReportDistributionListInput,
  ReportDistributionRecipient,
  ReportPackRun,
  ReportPackSection,
  ReportLayoutVariant,
  ReportLayoutVariantInput,
  ReportRun,
  ReportSchedule,
  ReportScheduleInput,
  ReportScheduleRun,
  ReportingPeriod,
  ReportingRow,
  RiskAction,
  RiskAppetiteAssessment,
  RiskAppetiteAssessmentInput,
  RiskAppetiteDetail,
  RiskAppetiteStatus,
  RiskEscalationEvent,
  RiskEscalationEventInput,
  RiskEscalationEventType,
  RiskIndicator,
  RiskIndicatorInput,
  RiskIndicatorEvent,
  RiskIndicatorEventInput,
  RiskWorkshopDecision,
  RiskExposureStateEvidence,
  RiskExposureStateEvidenceInput,
  RiskExposureState,
  RiskExposureStateInput,
  RiskQuantification,
  RiskQuantificationInput,
  RiskInput,
  RiskRecord,
  RiskTimelineEvent,
  SrsConnection,
  SrsConnectionInput,
  SrsSyncEvent,
  TenantSettings,
  TaxonomyItem,
  TaxonomyItemInput,
  TaxonomyType,
  TenantUser,
  UserInput,
  UserSession,
  ReportTemplate,
  ReportTemplateInput,
  WorkflowDefinition,
  WorkflowDefinitionInput,
  WorkflowEvent,
  WorkflowInstance,
  WorkflowTransitionInput,
} from "./types";

const app = document.getElementById("app") as HTMLDivElement;

let session: UserSession | null = null;
let settings: TenantSettings;
let risks: RiskRecord[] = [];
let riskTimelineEvents: RiskTimelineEvent[] = [];
let programmeItems: ProgrammeItem[] = [];
let importBatches: ImportBatch[] = [];
let importRows: ImportRow[] = [];
let importMappingProfiles: ImportMappingProfile[] = [];
let importValidationRules: ImportValidationRule[] = [];
let activeImportBatchId = "";
let exportBatches: ExportBatch[] = [];
let exportRows: ExportRow[] = [];
let exportReconciliations: ExportReconciliationRun[] = [];
let exportReconciliationRows: ExportReconciliationRow[] = [];
let exportReconciliationCommits: ExportReconciliationCommit[] = [];
let activeExportBatchId = "";
let activeReconciliationRunId = "";
let scheduleBatches: ScheduleImportBatch[] = [];
let scheduleActivities: ScheduleActivity[] = [];
let scheduleRiskLinks: ScheduleRiskLink[] = [];
let costBatches: CostImportBatch[] = [];
let costLines: CostLine[] = [];
let costReconciliation: CostRiskReconciliation[] = [];
let evidenceRecords: EvidenceRecord[] = [];
let evidenceLinks: EvidenceLink[] = [];
let evidenceAttachments: EvidenceAttachment[] = [];
let evidencePackages: EvidencePackage[] = [];
let evidencePackageItems: EvidencePackageItem[] = [];
let activeEvidenceId = "";
let activeEvidencePackageId = "";
let customFieldDefinitions: CustomFieldDefinition[] = [];
let customFieldValues: CustomFieldValue[] = [];
let workflowDefinitions: WorkflowDefinition[] = [];
let workflowInstances: WorkflowInstance[] = [];
let workflowEvents: WorkflowEvent[] = [];
let activeWorkflowInstanceId = "";
let activeWorkflowDefinitionId = "";
let users: TenantUser[] = [];
let packageGrants: PackageAccessGrant[] = [];
let packageOptions: TenantPackage[] = [];
let retentionPolicies: RetentionPolicy[] = [];
let securityControls: SecurityControl[] = [];
let backupManifests: BackupManifest[] = [];
let integrationSettings: IntegrationSetting[] = [];
let auditEntries: AuditEntry[] = [];
let reportingPeriods: ReportingPeriod[] = [];
let reportRuns: ReportRun[] = [];
let reportTemplates: ReportTemplate[] = [];
let reportLayoutVariants: ReportLayoutVariant[] = [];
let reportDistributionLists: ReportDistributionList[] = [];
let reportDistributionRecipients: ReportDistributionRecipient[] = [];
let reportSchedules: ReportSchedule[] = [];
let reportScheduleRuns: ReportScheduleRun[] = [];
let reportDeliveryJobs: ReportDeliveryJob[] = [];
let reportDeliveryEvents: ReportDeliveryEvent[] = [];
let notificationRules: NotificationRule[] = [];
let notificationEvents: NotificationEvent[] = [];
let reportPacks: ReportPackRun[] = [];
let reportPackSections: ReportPackSection[] = [];
let taxonomyItems: TaxonomyItem[] = [];
let controls: Control[] = [];
let riskControls: RiskControl[] = [];
let assuranceTests: AssuranceTest[] = [];
let controlObligations: ControlObligation[] = [];
let samplingPlans: SamplingPlan[] = [];
let obligationEscalations: ObligationEscalation[] = [];
let qraReadinessRows: ReportingRow[] = [];
let qraExportRows: ReportingRow[] = [];
let qraExposureStateRows: ReportingRow[] = [];
let riskAppetiteRows: RiskAppetiteAssessment[] = [];
let riskEscalationEvents: RiskEscalationEvent[] = [];
let riskWorkshopDecisions: RiskWorkshopDecision[] = [];
let riskIndicators: RiskIndicator[] = [];
let riskIndicatorEvents: RiskIndicatorEvent[] = [];
let indicatorEditId = "";
let qraModelRuns: QraModelRun[] = [];
let qraModelRunDetail: QraModelRunDetail | null = null;
let activeQraModelRunId = "";
let srsConnections: SrsConnection[] = [];
let srsSyncEvents: SrsSyncEvent[] = [];
let activeSrsConnectionId = "";
let appetiteModalRiskId = "";
let appetiteModalDetail: RiskAppetiteDetail | null = null;
let quantificationDraft: RiskQuantification | null = null;
let activeExposureState: ExposureStateKey = "current";
let quantificationEvidenceLinks: RiskExposureStateEvidence[] = [];
let quantificationEvidenceDraft: Record<ExposureStateKey, RiskExposureStateEvidenceInput[]> = {
  inherent: [],
  current: [],
  target: [],
  post_mitigation: [],
};
let LIKE = ["", "Rare", "Unlikely", "Possible", "Likely", "Almost certain"];
let IMP = ["", "Negligible", "Minor", "Moderate", "Major", "Severe"];
const DEF_LIKE = LIKE.slice();
const DEF_IMP = IMP.slice();
let BANDS = { low: 4, medium: 9, high: 15 };
let CATS = [
  "Commercial / cost",
  "Programme / schedule",
  "Design",
  "Construction / delivery",
  "Stakeholder / political",
  "Statutory / consents",
  "Environmental",
  "Health & safety",
  "Funding",
];
const EXPOSURE_STATE_DEFS: Array<{ key: ExposureStateKey; label: string; short: string; note: string }> = [
  { key: "inherent", label: "Inherent / pre-mitigation", short: "Inherent", note: "Before planned controls or mitigation reduce the exposure." },
  { key: "current", label: "Current residual", short: "Current", note: "The risk position now, after controls already in place." },
  { key: "target", label: "Target / forecast residual", short: "Forecast", note: "Expected residual exposure after planned mitigation is delivered." },
  { key: "post_mitigation", label: "Post-mitigation actual", short: "Actual", note: "Actual position after mitigation completion or closure evidence." },
];
const REPORT_SECTION_DEFS: Array<{ key: string; label: string }> = [
  { key: "executive_summary", label: "Executive summary" },
  { key: "risk_profile", label: "Risk profile" },
  { key: "top_risks", label: "Top risks" },
  { key: "movement", label: "Movement" },
  { key: "actions", label: "Actions" },
  { key: "reviews", label: "Reviews" },
  { key: "risk_appetite", label: "Risk appetite" },
  { key: "qra_readiness", label: "QRA readiness" },
  { key: "qra_export", label: "QRA export" },
  { key: "srs_results", label: "SRS results" },
  { key: "tornado_drivers", label: "Tornado drivers" },
  { key: "s_curves", label: "S-curves" },
  { key: "exposure_states", label: "Exposure states" },
  { key: "quant_governance", label: "Quant governance" },
  { key: "audit_trail", label: "Audit trail" },
  { key: "decisions_required", label: "Decisions required" },
  { key: "notifications", label: "Notifications" },
  { key: "controls_assurance", label: "Controls and assurance" },
  { key: "obligations", label: "Obligations" },
  { key: "srs_sync", label: "SRS sync evidence" },
  { key: "power_bi_index", label: "Power BI index" },
];
const TAXONOMY_TYPE_DEFS: Array<{ key: TaxonomyType; label: string; note: string }> = [
  { key: "rbs", label: "RBS", note: "Risk breakdown structure" },
  { key: "wbs", label: "WBS", note: "Work breakdown structure" },
  { key: "cbs", label: "CBS", note: "Cost breakdown structure" },
  { key: "obs", label: "OBS", note: "Organisation breakdown structure" },
];
const CONTROL_TYPE_DEFS: Array<{ key: ControlType; label: string }> = [
  { key: "preventive", label: "Preventive" },
  { key: "detective", label: "Detective" },
  { key: "corrective", label: "Corrective" },
  { key: "recovery", label: "Recovery" },
];
const CONTROL_EFFECTIVENESS_DEFS: Array<{ key: ControlEffectiveness; label: string }> = [
  { key: "effective", label: "Effective" },
  { key: "partially_effective", label: "Partially effective" },
  { key: "ineffective", label: "Ineffective" },
  { key: "untested", label: "Untested" },
];
const CONFIG_ENTITY_DEFS: Array<{ key: ConfigEntityType; label: string }> = [
  { key: "risk", label: "Risk" },
  { key: "programme_item", label: "Programme item" },
  { key: "control", label: "Control" },
  { key: "evidence", label: "Evidence" },
  { key: "qra_model_run", label: "QRA model run" },
  { key: "import_batch", label: "Import batch" },
  { key: "report_pack", label: "Report pack" },
];
const CUSTOM_FIELD_TYPE_DEFS: Array<{ key: CustomFieldType; label: string }> = [
  { key: "text", label: "Text" },
  { key: "number", label: "Number" },
  { key: "date", label: "Date" },
  { key: "select", label: "Select" },
  { key: "multiselect", label: "Multi-select" },
  { key: "boolean", label: "Boolean" },
  { key: "url", label: "URL / controlled reference" },
];
const WORKFLOW_TEMPLATES: Array<{ key: string; label: string; definition: WorkflowDefinitionInput }> = [
  {
    key: "major-risk",
    label: "Major risk lifecycle",
    definition: {
      entityType: "risk",
      workflowKey: "major_risk_lifecycle_custom",
      name: "Major risk lifecycle",
      description: "Configurable lifecycle for major project and programme risks, from identification through quantification, response approval, monitoring and closure.",
      defaultState: "identified",
      status: "active",
      states: [
        { key: "identified", label: "Identified", category: "open", sortOrder: 10 },
        { key: "assessed", label: "Assessed", category: "assessment", sortOrder: 20 },
        { key: "quantified", label: "Quantified", category: "qra", sortOrder: 30 },
        { key: "response_planned", label: "Response planned", category: "approval", sortOrder: 40 },
        { key: "active_monitoring", label: "Active monitoring", category: "monitoring", sortOrder: 50 },
        { key: "closed", label: "Closed", category: "terminal", sortOrder: 60, terminal: true },
      ],
      transitions: [
        { key: "submit_assessment", label: "Submit assessment", from: ["identified"], to: "assessed", roles: ["Admin", "Risk Manager", "Contributor"] },
        { key: "submit_quantification", label: "Submit quantification", from: ["assessed"], to: "quantified", roles: ["Admin", "Risk Manager", "Contributor"] },
        { key: "challenge_quantification", label: "Challenge quantification", from: ["quantified"], to: "assessed", roles: ["Admin", "Risk Manager"] },
        { key: "request_response_plan", label: "Request response plan", from: ["assessed", "quantified"], to: "response_planned", roles: ["Admin", "Risk Manager"] },
        { key: "approve_response", label: "Approve response", from: ["response_planned", "quantified"], to: "active_monitoring", roles: ["Admin", "Risk Manager"] },
        { key: "close", label: "Close", from: ["active_monitoring"], to: "closed", roles: ["Admin", "Risk Manager"] },
        { key: "reopen", label: "Reopen", from: ["closed"], to: "active_monitoring", roles: ["Admin", "Risk Manager"] },
      ],
    },
  },
  {
    key: "issue-escalation",
    label: "Issue / assumption escalation",
    definition: {
      entityType: "programme_item",
      workflowKey: "issue_escalation_custom",
      name: "Issue escalation lifecycle",
      description: "Escalation lifecycle for issues, assumptions, dependencies and decisions across programme intelligence records.",
      defaultState: "captured",
      status: "active",
      states: [
        { key: "captured", label: "Captured", category: "open", sortOrder: 10 },
        { key: "triaged", label: "Triaged", category: "assessment", sortOrder: 20 },
        { key: "escalated", label: "Escalated", category: "escalation", sortOrder: 30 },
        { key: "decision_pending", label: "Decision pending", category: "approval", sortOrder: 40 },
        { key: "resolved", label: "Resolved", category: "terminal", sortOrder: 50, terminal: true },
      ],
      transitions: [
        { key: "triage", label: "Triage", from: ["captured"], to: "triaged", roles: ["Admin", "Risk Manager", "Contributor"] },
        { key: "escalate", label: "Escalate", from: ["triaged"], to: "escalated", roles: ["Admin", "Risk Manager"] },
        { key: "request_decision", label: "Request decision", from: ["escalated"], to: "decision_pending", roles: ["Admin", "Risk Manager"] },
        { key: "resolve", label: "Resolve", from: ["decision_pending", "escalated"], to: "resolved", roles: ["Admin", "Risk Manager"] },
        { key: "reopen", label: "Reopen", from: ["resolved"], to: "triaged", roles: ["Admin", "Risk Manager"] },
      ],
    },
  },
  {
    key: "evidence-approval",
    label: "Evidence approval",
    definition: {
      entityType: "evidence",
      workflowKey: "evidence_approval_custom",
      name: "Evidence approval lifecycle",
      description: "Approval lifecycle for assumptions, decisions, model outputs and controlled evidence records.",
      defaultState: "draft",
      status: "active",
      states: [
        { key: "draft", label: "Draft", category: "open", sortOrder: 10 },
        { key: "in_review", label: "In review", category: "review", sortOrder: 20 },
        { key: "approved", label: "Approved", category: "approved", sortOrder: 30 },
        { key: "superseded", label: "Superseded", category: "terminal", sortOrder: 40, terminal: true },
      ],
      transitions: [
        { key: "submit_review", label: "Submit for review", from: ["draft"], to: "in_review", roles: ["Admin", "Risk Manager", "Contributor"] },
        { key: "approve", label: "Approve", from: ["in_review"], to: "approved", roles: ["Admin", "Risk Manager"] },
        { key: "return_to_draft", label: "Return to draft", from: ["in_review"], to: "draft", roles: ["Admin", "Risk Manager"] },
        { key: "supersede", label: "Supersede", from: ["approved"], to: "superseded", roles: ["Admin", "Risk Manager"] },
      ],
    },
  },
  {
    key: "control-assurance",
    label: "Control assurance",
    definition: {
      entityType: "control",
      workflowKey: "control_assurance_lifecycle",
      name: "Control assurance lifecycle",
      description: "Lifecycle for control design, assurance planning, testing, acceptance and retirement.",
      defaultState: "draft",
      status: "active",
      states: [
        { key: "draft", label: "Draft", category: "open", sortOrder: 10 },
        { key: "mapped", label: "Mapped to risks", category: "mapping", sortOrder: 20 },
        { key: "assurance_planned", label: "Assurance planned", category: "assurance", sortOrder: 30 },
        { key: "tested", label: "Tested", category: "assurance", sortOrder: 40 },
        { key: "accepted", label: "Accepted", category: "approved", sortOrder: 50 },
        { key: "retired", label: "Retired", category: "terminal", sortOrder: 60, terminal: true },
      ],
      transitions: [
        { key: "map_control", label: "Map control", from: ["draft"], to: "mapped", roles: ["Admin", "Risk Manager", "Contributor"] },
        { key: "plan_assurance", label: "Plan assurance", from: ["mapped"], to: "assurance_planned", roles: ["Admin", "Risk Manager"] },
        { key: "record_test", label: "Record test", from: ["assurance_planned"], to: "tested", roles: ["Admin", "Risk Manager", "Contributor"] },
        { key: "accept_control", label: "Accept control", from: ["tested"], to: "accepted", roles: ["Admin", "Risk Manager"] },
        { key: "retire_control", label: "Retire control", from: ["accepted"], to: "retired", roles: ["Admin", "Risk Manager"] },
      ],
    },
  },
  {
    key: "report-pack-issue",
    label: "Report pack issue",
    definition: {
      entityType: "report_pack",
      workflowKey: "report_pack_issue_lifecycle",
      name: "Report pack issue lifecycle",
      description: "Lifecycle for pack drafting, quality review, approval, issue and supersession.",
      defaultState: "draft",
      status: "active",
      states: [
        { key: "draft", label: "Draft", category: "open", sortOrder: 10 },
        { key: "quality_review", label: "Quality review", category: "review", sortOrder: 20 },
        { key: "issue_approved", label: "Issue approved", category: "approval", sortOrder: 30 },
        { key: "issued", label: "Issued", category: "approved", sortOrder: 40 },
        { key: "superseded", label: "Superseded", category: "terminal", sortOrder: 50, terminal: true },
      ],
      transitions: [
        { key: "submit_quality_review", label: "Submit quality review", from: ["draft"], to: "quality_review", roles: ["Admin", "Risk Manager"] },
        { key: "approve_issue", label: "Approve issue", from: ["quality_review"], to: "issue_approved", roles: ["Admin", "Risk Manager"] },
        { key: "issue_pack", label: "Issue pack", from: ["issue_approved"], to: "issued", roles: ["Admin", "Risk Manager"] },
        { key: "return_to_draft", label: "Return to draft", from: ["quality_review"], to: "draft", roles: ["Admin", "Risk Manager"] },
        { key: "supersede", label: "Supersede", from: ["issued"], to: "superseded", roles: ["Admin", "Risk Manager"] },
      ],
    },
  },
];
const MAJOR_RISK_WORKFLOW_TEMPLATE = WORKFLOW_TEMPLATES[0].definition;

const TODAY = new Date();
TODAY.setHours(0, 0, 0, 0);

const fillFor = { low: "#C0DD97", medium: "#FAC775", high: "#F7C1C1", critical: "#F09595" };
const inkFor = { low: "#173404", medium: "#412402", high: "#791F1F", critical: "#501313" };
const LV = { low: "Low", medium: "Medium", high: "High", critical: "Critical" };

let sortK = "post";
let sortDir = -1;
let curD: RiskRecord | null = null;
let editIdx = -1;
let riskEditId: string | null = null;
let fbSent = "";

void init();

async function init() {
  // A failed session check is a genuine auth state → show the sign-in screen.
  try {
    session = await getSession();
  } catch {
    renderLogin();
    return;
  }
  // Anything after authentication is a data/render failure — surface a recoverable error,
  // never silently sign the user out.
  try {
    await loadAppData();
    renderShell();
    bindShell();
    renderAll();
  } catch (err) {
    renderAppError(err);
  }
}

function renderAppError(err: unknown) {
  const message = err instanceof Error ? err.message : "Something went wrong loading the workspace.";
  app.innerHTML = `
    <div class="login">
      <div class="sheet" style="max-width:440px" role="alert">
        <img class="login-logo" src="/brand/rs-mark.svg" alt="Risk Register — Risk Studio" width="46" height="46"/>
        <h2>Couldn’t load the workspace</h2>
        <div class="muted" style="font-size:13px;margin-top:8px;line-height:1.5">${esc(message)}</div>
        <div class="muted" style="font-size:12px;margin-top:6px;line-height:1.5">You are still signed in. This is usually transient — retry, or reload the page.</div>
        <div style="display:flex;justify-content:flex-end;gap:8px;margin-top:14px">
          <button class="btn" id="app-error-reload" type="button">Reload</button>
          <button class="btnp" id="app-error-retry" type="button">Retry</button>
        </div>
      </div>
    </div>`;
  document.getElementById("app-error-retry")?.addEventListener("click", () => void init());
  document.getElementById("app-error-reload")?.addEventListener("click", () => window.location.reload());
}

function hasPermissionUi(permission: string) {
  return Boolean(session?.permissions?.includes(permission) || session?.user.permissions?.includes(permission));
}

function canAdminUi() {
  return hasPermissionUi("system.admin");
}

async function loadAppData() {
  const tenant = await loadTenant();
  settings = tenant.settings;
  CATS = settings.categories.slice();
  LIKE = settings.likelihood.slice();
  IMP = settings.impact.slice();
  BANDS = { ...settings.bands };
  applyTheme(settings.theme);
  risks = (await loadRisks()).risks;
  programmeItems = (await loadProgrammeItems().catch(() => ({ items: [] }))).items;
  const importResult = await loadImports().catch(() => ({ batches: [], rows: [] }));
  importBatches = importResult.batches;
  importRows = importResult.rows;
  importMappingProfiles = (await loadImportMappingProfiles().catch(() => ({ profiles: [] }))).profiles;
  importValidationRules = (await loadImportValidationRules().catch(() => ({ rules: [] }))).rules;
  const exportResult = await loadExports().catch(() => ({ batches: [], rows: [], reconciliations: [], reconciliationRows: [], reconciliationCommits: [], activeExportBatchId: "", activeReconciliationRunId: "" }));
  exportBatches = exportResult.batches;
  exportRows = exportResult.rows;
  exportReconciliations = exportResult.reconciliations;
  exportReconciliationRows = exportResult.reconciliationRows;
  exportReconciliationCommits = exportResult.reconciliationCommits;
  activeExportBatchId = exportResult.activeExportBatchId;
  activeReconciliationRunId = exportResult.activeReconciliationRunId;
  const scheduleResult = await loadSchedule().catch(() => ({ batches: [], activities: [], riskLinks: [] }));
  scheduleBatches = scheduleResult.batches;
  scheduleActivities = scheduleResult.activities;
  scheduleRiskLinks = scheduleResult.riskLinks;
  const costResult = await loadCost().catch(() => ({ batches: [], lines: [], reconciliation: [] }));
  costBatches = costResult.batches;
  costLines = costResult.lines;
  costReconciliation = costResult.reconciliation;
  const evidenceResult = await loadEvidence().catch(() => ({ items: [], links: [] }));
  evidenceRecords = evidenceResult.items;
  evidenceLinks = evidenceResult.links;
  const evidenceAttachmentResult = await loadEvidenceAttachments().catch(() => ({ attachments: [] }));
  evidenceAttachments = evidenceAttachmentResult.attachments;
  const evidencePackageResult = await loadEvidencePackages().catch(() => ({ packages: [], items: [] }));
  evidencePackages = evidencePackageResult.packages;
  evidencePackageItems = evidencePackageResult.items;
  activeEvidencePackageId = evidencePackages[0]?.package_id || "";
  try {
    const configResult = await Promise.all([
      loadCustomFieldDefinitions().catch(() => ({ items: [] })),
      loadCustomFieldValues().catch(() => ({ items: [] })),
      loadWorkflows().catch(() => ({ definitions: [], instances: [], events: [] })),
    ]);
    customFieldDefinitions = configResult[0].items;
    customFieldValues = configResult[1].items;
    workflowDefinitions = configResult[2].definitions;
    workflowInstances = configResult[2].instances;
    workflowEvents = configResult[2].events;
    activeWorkflowInstanceId = workflowInstances[0]?.workflow_instance_id || "";
    [reportingPeriods, reportRuns, reportTemplates, reportLayoutVariants, reportDistributionLists, reportDistributionRecipients, reportSchedules, reportScheduleRuns, reportDeliveryJobs, reportDeliveryEvents, reportPacks, reportPackSections, qraReadinessRows, qraExportRows, qraExposureStateRows, riskAppetiteRows, riskEscalationEvents, riskWorkshopDecisions, riskIndicators, riskIndicatorEvents, qraModelRuns, srsConnections, srsSyncEvents, controls, riskControls, assuranceTests, controlObligations, samplingPlans, obligationEscalations] = await Promise.all([
      loadReportingPeriods().then((result) => result.rows),
      loadReportRuns().then((result) => result.rows),
      loadReportTemplates().then((result) => result.rows),
      loadReportLayoutVariants().then((result) => result.rows),
      loadReportDistributionLists().then((result) => result.rows),
      loadReportDistributionRecipients().then((result) => result.rows),
      loadReportSchedules().then((result) => result.rows),
      loadReportScheduleRuns().then((result) => result.rows),
      loadReportDeliveryJobs().then((result) => result.rows),
      loadReportDeliveryEvents().then((result) => result.rows),
      loadReportPacks().then((result) => result.rows),
      loadReportPackSections().then((result) => result.rows),
      loadQraReadiness().then((result) => result.rows),
      loadQraExport("ready").then((result) => result.rows),
      loadQraExposureStates().then((result) => result.rows),
      loadRiskAppetiteAssessments().then((result) => result.rows),
      loadRiskEscalationEvents().then((result) => result.rows),
      loadRiskWorkshopDecisions().then((result) => result.rows),
      loadRiskIndicators().then((result) => result.rows),
      loadRiskIndicatorEvents().then((result) => result.rows),
      loadQraModelRuns().then((result) => result.items),
      loadSrsConnections().then((result) => result.items),
      loadSrsSyncEvents().then((result) => result.items),
      loadControls().then((result) => result.items),
      loadRiskControls().then((result) => result.items),
      loadAssuranceTests().then((result) => result.items),
      loadControlObligations().then((result) => result.items),
      loadSamplingPlans().then((result) => result.items),
      loadObligationEscalations().then((result) => result.items),
    ]);
    activeQraModelRunId = qraModelRuns[0]?.id || "";
    activeSrsConnectionId = qraModelRuns[0]?.srsConnectionId || srsConnections[0]?.id || "";
    qraModelRunDetail = activeQraModelRunId ? await loadQraModelRun(activeQraModelRunId).catch(() => null) : null;
    const notificationResult = await loadNotifications().catch(() => ({ rules: [], events: [] }));
    notificationRules = notificationResult.rules;
    notificationEvents = notificationResult.events;
  } catch {
    reportingPeriods = [];
    reportRuns = [];
    reportTemplates = [];
    reportLayoutVariants = [];
    reportDistributionLists = [];
    reportDistributionRecipients = [];
    reportSchedules = [];
    reportScheduleRuns = [];
    reportDeliveryJobs = [];
    reportDeliveryEvents = [];
    notificationRules = [];
    notificationEvents = [];
    reportPacks = [];
    reportPackSections = [];
    qraReadinessRows = [];
    qraExportRows = [];
    qraExposureStateRows = [];
    riskAppetiteRows = [];
    riskEscalationEvents = [];
    qraModelRuns = [];
    qraModelRunDetail = null;
    activeQraModelRunId = "";
    srsConnections = [];
    srsSyncEvents = [];
    activeSrsConnectionId = "";
    controls = [];
    riskControls = [];
    assuranceTests = [];
    controlObligations = [];
    importBatches = [];
    importRows = [];
    importMappingProfiles = [];
    importValidationRules = [];
    exportBatches = [];
    exportRows = [];
    exportReconciliations = [];
    exportReconciliationRows = [];
    exportReconciliationCommits = [];
    activeExportBatchId = "";
    activeReconciliationRunId = "";
    scheduleBatches = [];
    scheduleActivities = [];
    scheduleRiskLinks = [];
    costBatches = [];
    costLines = [];
    costReconciliation = [];
    evidenceRecords = [];
    evidenceLinks = [];
    activeEvidenceId = "";
    customFieldDefinitions = [];
    customFieldValues = [];
    workflowDefinitions = [];
    workflowInstances = [];
    workflowEvents = [];
    activeWorkflowInstanceId = "";
  }
  if (canAdminUi()) {
    [users, auditEntries, taxonomyItems] = await Promise.all([
      loadUsers().then((result) => result.users),
      loadAudit().then((result) => result.audit),
      loadTaxonomyItems().then((result) => result.items).catch(() => []),
    ]);
    const grantResult = await loadPackageGrants().catch(() => ({ grants: [], packages: [], users: [] }));
    packageGrants = grantResult.grants;
    packageOptions = grantResult.packages;
    const complianceResult = await loadCompliance().catch(() => ({ retentionPolicies: [], securityControls: [], backupManifests: [] }));
    retentionPolicies = complianceResult.retentionPolicies;
    securityControls = complianceResult.securityControls;
    backupManifests = complianceResult.backupManifests;
    const integrationResult = await loadIntegrations().catch(() => ({ settings: [] }));
    integrationSettings = integrationResult.settings;
  } else {
    users = [];
    auditEntries = [];
    taxonomyItems = [];
    packageGrants = [];
    packageOptions = [];
    retentionPolicies = [];
    securityControls = [];
    backupManifests = [];
    integrationSettings = [];
  }
}

function renderLogin(devCode = "") {
  app.innerHTML = `
    <div class="login">
      <div class="sheet">
        <img class="login-logo" src="/brand/rs-mark.svg" alt="Risk Register — Risk Studio" width="46" height="46"/>
        <h2>Risk Register</h2>
        <div class="muted" style="font-size:12.5px;margin-top:2px;letter-spacing:.04em;text-transform:uppercase;color:var(--teal)">Risk Studio suite</div>
        <div class="muted" style="font-size:11px;margin-top:3px;letter-spacing:.04em;text-transform:uppercase;color:var(--grey)">A SOMA Project Controls module · register · controls · QRA hand-off</div>
        <div class="muted" style="font-size:13px;margin-top:8px;line-height:1.5">Sign in with your approved pilot email address.</div>
        <div class="field" style="margin-top:16px"><label>Email</label><input id="login-email" autocomplete="email" placeholder="you@yourcompany.com"/></div>
        <div class="field" id="login-code-wrap" style="display:none"><label>Six-digit code</label><input id="login-code" inputmode="numeric" autocomplete="one-time-code"/></div>
        <div id="login-note" class="fbnote">${devCode ? `Development code: <b>${devCode}</b>` : ""}</div>
        <div style="display:flex;justify-content:flex-end;gap:8px;margin-top:12px">
          <button class="btn" id="login-code-btn">Send code</button>
          <button class="btnp" id="login-submit" style="display:none">Sign in</button>
        </div>
      </div>
    </div>`;

  $("login-code-btn").addEventListener("click", async () => {
    const email = value("login-email");
    if (!email) return;
    try {
      const result = await startLogin(email);
      renderLogin(result.devCode || "");
      $<HTMLInputElement>("login-email").value = email;
      $("login-code-wrap").style.display = "block";
      $("login-submit").style.display = "inline-flex";
      $("login-code").focus();
    } catch (err) {
      $("login-note").textContent = err instanceof Error ? err.message : "Unable to send code";
    }
  });

  $("login-submit").addEventListener("click", async () => {
    try {
      await verifyLogin(value("login-email"), value("login-code"));
      await init();
    } catch (err) {
      $("login-note").textContent = err instanceof Error ? err.message : "Unable to sign in";
    }
  });
}

function renderShell() {
  if (!session) return;
  app.innerHTML = `
    <div class="toast" id="toast" role="status" aria-live="polite" aria-atomic="true"></div>
    <div class="top">
      <div class="brand">
        <img id="brandlogo" class="logo" src="/brand/rs-mark-on-navy.svg" alt="" width="34" height="34"/>
        <span class="brand-wm"><span class="prod">Risk Register</span><span class="endorse">Risk Studio suite</span></span>
        <span class="tag">Major programme pilot</span>
      </div>
      <div class="tenant">
        <span class="chip-mode">SRS module</span>
        <span>${esc(session.tenant.name)} &#9662;</span>
        <span class="who"><span class="av">${esc(session.user.initials)}</span>${esc(session.user.name)} · ${esc(session.user.role)}</span>
        <button class="lnk" id="logoutBtn">Sign out</button>
      </div>
    </div>

    <div class="layout">
      <nav class="sbar" aria-label="Primary">
        <div class="grp">Programme</div>
        <button type="button" class="nav active" aria-current="page" data-v="control"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 19V5"/><path d="M4 19h16"/><path d="M8 15l3-4 3 2 4-6"/><circle cx="8" cy="15" r="1.6" fill="#cfe0ea"/><circle cx="11" cy="11" r="1.6" fill="#cfe0ea"/><circle cx="14" cy="13" r="1.6" fill="#cfe0ea"/><circle cx="18" cy="7" r="1.6" fill="#cfe0ea"/></svg>Control centre</button>
        <button type="button" class="nav" data-v="register"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="4" width="18" height="16" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="9" x2="9" y2="20"/></svg>Register</button>
        <button type="button" class="nav" data-v="intelligence"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 17l5-5 4 4 7-8"/><path d="M14 8h6v6"/><circle cx="7" cy="17" r="2" fill="#cfe0ea"/></svg>Intelligence</button>
        <button type="button" class="nav" data-v="imports"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 7h11"/><path d="M4 12h9"/><path d="M4 17h7"/><path d="M15 11l3 3 3-3"/><path d="M18 4v10"/><path d="M14 20h8"/></svg>Data intake</button>
        <button type="button" class="nav" data-v="evidence"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 3h9l3 3v15H6z"/><path d="M15 3v4h4"/><path d="M8.5 12h7"/><path d="M8.5 16h5"/><circle cx="18" cy="18" r="3" fill="#cfe0ea"/><path d="M17 18l.8.8 1.5-1.7"/></svg>Evidence</button>
        <button type="button" class="nav" data-v="controls"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 3l7 3v5c0 4.7-2.8 8-7 10-4.2-2-7-5.3-7-10V6l7-3z"/><path d="M8.5 12l2.2 2.2L15.8 9"/></svg>Controls</button>
        <button type="button" class="nav" data-v="qra"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 18h16"/><path d="M7 18V8"/><path d="M12 18V5"/><path d="M17 18v-7"/><circle cx="7" cy="8" r="2" fill="#cfe0ea"/><circle cx="12" cy="5" r="2" fill="#cfe0ea"/><circle cx="17" cy="11" r="2" fill="#cfe0ea"/></svg>QRA workbench</button>
        <button type="button" class="nav" data-v="srs"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 7h16"/><path d="M4 17h16"/><path d="M7 4v16"/><path d="M17 4v16"/><circle cx="7" cy="7" r="2" fill="#cfe0ea"/><circle cx="17" cy="17" r="2" fill="#cfe0ea"/><path d="M9 8.5l6 6"/></svg>SRS results</button>
        <button type="button" class="nav" data-v="dashboard"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="8" height="8" rx="1.5"/><rect x="13" y="3" width="8" height="5" rx="1.5"/><rect x="13" y="10" width="8" height="11" rx="1.5"/><rect x="3" y="13" width="8" height="8" rx="1.5"/></svg>Dashboard</button>
        <button type="button" class="nav" data-v="reviews"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M9 5h10M9 12h10M9 19h10"/><path d="M4 5l1.2 1.2L7 4"/><path d="M4 12l1.2 1.2L7 11"/><path d="M4 19l1.2 1.2L7 18"/></svg>Reviews</button>
        <button type="button" class="nav" data-v="reporting"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 19V5"/><path d="M4 19h16"/><rect x="7" y="11" width="3" height="5" rx="0.8" fill="#cfe0ea"/><rect x="12" y="8" width="3" height="8" rx="0.8" fill="#cfe0ea"/><rect x="17" y="4" width="3" height="12" rx="0.8" fill="#cfe0ea"/></svg>Reporting</button>
        <div class="grp">Settings</div>
        <button type="button" class="nav" data-v="configuration"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 7h16"/><path d="M4 17h16"/><circle cx="8" cy="7" r="2.4" fill="#cfe0ea"/><circle cx="16" cy="17" r="2.4" fill="#cfe0ea"/><path d="M8 10v7"/><path d="M16 7v7"/></svg>Configuration</button>
        <button type="button" class="nav" data-v="admin"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><line x1="4" y1="7" x2="20" y2="7"/><circle cx="9" cy="7" r="2.4" fill="#cfe0ea"/><line x1="4" y1="14" x2="20" y2="14"/><circle cx="15" cy="14" r="2.4" fill="#cfe0ea"/></svg>Admin</button>
      </nav>

      <main class="main">
        <section class="view active" id="v-control">
          <div class="vhead">
            <div><h1>Programme risk control centre</h1><div class="sub">${esc(session.tenant.name)} · ${esc(session.tenant.programmeName)}</div></div>
            <div class="head-actions">
              <button class="btn" id="control-reporting">Reporting suite</button>
              <button class="btn" id="control-qra-workbench">QRA workbench</button>
              <a class="btn" href="/api/reporting/qra-export?format=csv" target="_blank" rel="noreferrer" id="control-qra-feed">Ready export</a>
              <button class="btnp" id="control-add-risk">+ New risk</button>
            </div>
          </div>
          <div class="control-band" id="controlBand"></div>
          <div class="kpis control-kpis" id="controlKpis"></div>
          <div class="control-grid">
            <div class="control-panel" id="assurancePanel"></div>
            <div class="control-panel" id="sponsorBrief"></div>
          </div>
          <div class="control-grid lower">
            <div class="control-panel" id="watchlistPanel"></div>
            <div class="control-panel" id="ownerLoadPanel"></div>
          </div>
        </section>

        <section class="view" id="v-register">
          <div class="vhead">
            <div><h1>Programme risk register</h1><div class="sub">${esc(session.tenant.name)} · ${esc(session.tenant.programmeName)} · qualitative, QRA-ready risk capture</div></div>
            <div style="display:flex;gap:8px">
              <button class="btn" id="pdfBtn">PDF report</button>
              <button class="btn" id="exportBtn">Export CSV</button>
              <button class="btnp" id="newBtn">+ New risk</button>
            </div>
          </div>
          <div class="toolbar">
            <input id="search" placeholder="Search risks…" style="flex:1;min-width:200px"/>
            <select id="fcat"></select>
            <select id="fstatus"><option value="">All statuses</option><option>Open</option><option>Managed</option><option>Closed</option></select>
            <label class="chkbx"><input type="checkbox" id="fhigh" style="width:auto;padding:0"/> High &amp; critical</label>
          </div>
          <div class="summ" id="summ"></div>
          <div class="card" style="padding:6px 14px">
            <table>
              <thead><tr>
                <th class="sortable" data-k="id" style="width:64px">ID<span class="ar"></span></th>
                <th class="sortable" data-k="title">Risk<span class="ar"></span></th>
                <th class="sortable" data-k="cat" style="width:150px">Category<span class="ar"></span></th>
                <th class="sortable" data-k="owner" style="width:104px">Owner<span class="ar"></span></th>
                <th class="sortable" data-k="pre" style="width:64px">Pre<span class="ar"></span></th>
                <th class="sortable" data-k="post" style="width:150px">Residual<span class="ar"></span></th>
                <th style="width:132px">Appetite<span class="ar"></span></th>
                <th style="width:144px">Forecast<span class="ar"></span></th>
                <th class="sortable" data-k="status" style="width:90px">Status<span class="ar"></span></th>
                <th class="sortable" data-k="due" style="width:100px">Reviewed<span class="ar"></span></th>
              </tr></thead>
              <tbody id="rtb"></tbody>
            </table>
            <div id="empty" class="muted" style="padding:18px;text-align:center;display:none">No risks match your filters.</div>
          </div>
          <div class="legend" id="legend" style="display:flex;gap:14px;margin-top:10px;font-size:12px;color:var(--grey);flex-wrap:wrap"></div>
        </section>

        <section class="view" id="v-intelligence">
          <div class="vhead">
            <div><h1>Programme intelligence</h1><div class="sub">Opportunities, issues, dependencies, assumptions, benefits, incidents and audit findings linked to the risk register</div></div>
            <div class="head-actions">
              <a class="btn" href="/api/reporting/programme-items?format=csv" target="_blank" rel="noreferrer" id="programme-items-csv">CSV feed</a>
              <button class="btn" id="programme-refresh">Refresh</button>
              <button class="btnp" id="programme-new">+ New item</button>
            </div>
          </div>
          <div class="kpis programme-kpis" id="programmeKpis"></div>
          <div class="programme-workbench-grid" id="programmeWorkbench">
            <div class="programme-list-panel">
              <div class="toolbar programme-toolbar">
                <input id="programme-search" placeholder="Search title, code, owner, linked risk or decision"/>
                <select id="programme-type-filter"><option value="">All types</option><option value="opportunity">Opportunities</option><option value="issue">Issues</option><option value="dependency">Dependencies</option><option value="assumption">Assumptions</option><option value="benefit">Benefits</option><option value="incident">Incidents</option><option value="audit_finding">Audit findings</option></select>
                <select id="programme-status-filter"><option value="">All statuses</option><option>Proposed</option><option>Open</option><option>Active</option><option>Managed</option><option>Realised</option><option>Closed</option><option>Retired</option></select>
              </div>
              <div class="programme-item-list" id="programmeItemList"></div>
            </div>
            <div class="programme-form-panel">
              <div class="panel-head"><h3>Programme item</h3><button class="lnk" id="programme-clear">Clear</button></div>
              <input id="pi-current-code" type="hidden"/>
              <div class="frow">
                <div class="field"><label>Code</label><input id="pi-code" placeholder="Auto or O-001"/></div>
                <div class="field"><label>Type</label><select id="pi-type"><option value="opportunity">Opportunity</option><option value="issue">Issue</option><option value="dependency">Dependency</option><option value="assumption">Assumption</option><option value="benefit">Benefit</option><option value="incident">Incident</option><option value="audit_finding">Audit finding</option></select></div>
              </div>
              <div class="field"><label>Title</label><input id="pi-title" placeholder="Clear item title"/></div>
              <div class="frow">
                <div class="field"><label>Status</label><select id="pi-status"><option>Proposed</option><option>Open</option><option>Active</option><option>Managed</option><option>Realised</option><option>Closed</option><option>Retired</option></select></div>
                <div class="field"><label>Priority</label><select id="pi-priority"><option>Low</option><option>Medium</option><option>High</option><option>Critical</option></select></div>
                <div class="field"><label>Owner</label><input id="pi-owner" placeholder="Owner"/></div>
              </div>
              <div class="frow">
                <div class="field"><label>Category</label><input id="pi-category" placeholder="Category / RBS"/></div>
                <div class="field"><label>Linked risk</label><select id="pi-linked-risk"></select></div>
              </div>
              <div class="frow">
                <div class="field"><label>Package</label><input id="pi-package" placeholder="Package code"/></div>
                <div class="field"><label>WBS</label><input id="pi-wbs" placeholder="WBS code"/></div>
                <div class="field"><label>CBS</label><input id="pi-cbs" placeholder="CBS code"/></div>
              </div>
              <div class="frow">
                <div class="field"><label>OBS owner</label><input id="pi-obs" placeholder="Organisation / accountable team"/></div>
                <div class="field"><label>Probability / confidence (%)</label><input id="pi-prob" type="number" min="0" max="100" step="0.01"/></div>
              </div>
              <div class="programme-ranges">
                <div class="programme-subsection">
                  <h4>Value / impact range</h4>
                  <div class="frow">
                    <div class="field"><label>Low</label><input id="pi-value-low" type="number" step="0.01"/></div>
                    <div class="field"><label>Most likely</label><input id="pi-value-ml" type="number" step="0.01"/></div>
                    <div class="field"><label>High</label><input id="pi-value-high" type="number" step="0.01"/></div>
                  </div>
                </div>
                <div class="programme-subsection">
                  <h4>Schedule range (days)</h4>
                  <div class="frow">
                    <div class="field"><label>Low</label><input id="pi-sch-low" type="number" step="0.01"/></div>
                    <div class="field"><label>Most likely</label><input id="pi-sch-ml" type="number" step="0.01"/></div>
                    <div class="field"><label>High</label><input id="pi-sch-high" type="number" step="0.01"/></div>
                  </div>
                </div>
              </div>
              <div class="frow">
                <div class="field"><label>Trigger</label><input id="pi-trigger" type="date"/></div>
                <div class="field"><label>Target</label><input id="pi-target" type="date"/></div>
                <div class="field"><label>Review due</label><input id="pi-review" type="date"/></div>
              </div>
              <div class="field"><label>Description</label><textarea id="pi-description" class="draft programme-textarea" placeholder="Item basis, context, evidence and current position"></textarea></div>
              <div class="field"><label>Response strategy</label><textarea id="pi-response" class="draft programme-textarea" placeholder="Exploit, resolve, manage, validate, escalate or assure"></textarea></div>
              <div class="field"><label>Decision required</label><textarea id="pi-decision" class="draft programme-textarea compact" placeholder="Board / sponsor / workstream decision or escalation needed"></textarea></div>
              <div class="programme-actions"><button class="btn danger" id="programme-retire">Retire</button><button class="btnp" id="programme-save">Save item</button></div>
            </div>
          </div>
        </section>

        <section class="view" id="v-imports">
          <div class="vhead">
            <div><h1>Data intake</h1><div class="sub">Controlled CSV validation, import and consolidation for legacy client registers</div></div>
            <div class="head-actions">
              <a class="btn" href="/api/reporting/import-batches?format=csv" target="_blank" rel="noreferrer" id="import-batches-csv">Batches CSV</a>
              <a class="btn" href="/api/reporting/import-rows?format=csv" target="_blank" rel="noreferrer" id="import-rows-csv">Rows CSV</a>
              <a class="btn" href="/api/reporting/export-batches?format=csv" target="_blank" rel="noreferrer" id="export-batches-csv">Exports CSV</a>
              <a class="btn" href="/api/reporting/export-reconciliation-rows?format=csv" target="_blank" rel="noreferrer" id="export-reconciliation-rows-csv">Reconcile CSV</a>
              <button class="btn" id="imports-refresh">Refresh</button>
            </div>
          </div>
          <div class="kpis import-kpis" id="importKpis"></div>
          <div class="import-template-panel">
            <div class="panel-head"><h3>Import templates and mapping presets</h3><span class="muted" id="importTemplateSummary">ARM, RiskHive, Safran, Excel paste and SOMA shapes</span></div>
            <div class="import-template-grid">
              <div class="field"><label>Preset</label><select id="import-template-select"></select></div>
              <button class="btn" id="import-template-load">Load sample</button>
              <button class="btn" id="import-template-download">Download CSV</button>
              <button class="btn" id="import-excel-paste">Load Excel paste</button>
              <button class="btn" id="import-excel-pack">Download XLSX pack</button>
            </div>
            <div class="import-template-help" id="importTemplateHelp"></div>
          </div>
          <div class="import-mapping-panel">
            <div class="panel-head"><h3>Field mapping workbench</h3><span class="muted" id="importMappingSummary">Paste or load rows to review headings</span></div>
            <div class="import-profile-grid">
              <div class="field"><label>Saved profile</label><select id="import-mapping-profile-select"></select></div>
              <div class="field"><label>Profile name</label><input id="import-mapping-profile-name" placeholder="Client ARM / RiskHive / RAID profile"/></div>
              <div class="field import-profile-notes"><label>Profile notes</label><input id="import-mapping-profile-notes" placeholder="Scope, workbook tab, assumptions or owner"/></div>
            </div>
            <div class="import-profile-actions">
              <button class="btn" id="import-mapping-profile-load">Load profile</button>
              <button class="btn" id="import-mapping-profile-save">Save profile</button>
              <button class="btn danger" id="import-mapping-profile-retire">Retire</button>
              <span class="muted" id="importMappingProfileSummary"></span>
            </div>
            <div class="import-mapping-actions">
              <button class="btn" id="import-mapping-refresh">Review headings</button>
              <button class="btnp" id="import-mapping-apply">Apply mappings</button>
            </div>
            <div class="import-mapping-grid" id="importMappingGrid"></div>
          </div>
          <div class="import-validation-rule-panel" id="importValidationRulePanel">
            <div class="panel-head"><h3>Validation rulebook</h3><span class="muted" id="importValidationRuleSummary"></span></div>
            <div class="import-validation-rule-grid">
              <div class="import-validation-rule-list" id="importValidationRuleList"></div>
              <div class="import-validation-rule-form">
                <input id="import-validation-rule-id" type="hidden"/>
                <div class="frow">
                  <div class="field"><label>Rule key</label><input id="import-validation-rule-key" placeholder="client.current_score_required"/></div>
                  <div class="field"><label>Target</label><select id="import-validation-rule-target"><option value="all">All imports</option><option value="risks">Risks</option><option value="programme_items">Programme intelligence</option></select></div>
                  <div class="field"><label>Severity</label><select id="import-validation-rule-severity"><option value="warning">Warning</option><option value="error">Error</option><option value="info">Info</option></select></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Check</label><select id="import-validation-rule-check"><option value="required_field">Required field</option><option value="required_all">Required all fields</option><option value="allowed_values">Allowed values</option><option value="numeric_min">Numeric minimum</option><option value="numeric_max">Numeric maximum</option></select></div>
                  <div class="field"><label>Field</label><select id="import-validation-rule-field"></select></div>
                  <div class="field"><label>Fields / values / threshold</label><input id="import-validation-rule-extra" placeholder="lpost, ipost or Open, Managed or 1"/></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Name</label><input id="import-validation-rule-name" placeholder="Client QRA current score required"/></div>
                  <div class="field"><label>Source match</label><input id="import-validation-rule-source" placeholder="Optional source-system text"/></div>
                  <div class="field"><label>Status</label><select id="import-validation-rule-status"><option value="active">Active</option><option value="retired">Retired</option></select></div>
                </div>
                <div class="field"><label>Issue text</label><input id="import-validation-rule-issue" placeholder="What will appear on failed rows"/></div>
                <div class="field"><label>Recommendation</label><input id="import-validation-rule-recommendation" placeholder="Required correction, waiver or governance action"/></div>
                <div class="import-validation-rule-actions">
                  <button class="btn" id="import-validation-rule-clear">Clear</button>
                  <button class="btn danger" id="import-validation-rule-retire">Retire</button>
                  <button class="btnp" id="import-validation-rule-save">Save rule</button>
                </div>
                <div class="fbnote" id="import-validation-rule-note"></div>
              </div>
            </div>
          </div>
          <div class="import-workbench-grid" id="importWorkbench">
            <div class="import-panel import-form-panel">
              <div class="panel-head"><h3>Import batch</h3><button class="lnk" id="import-sample">Sample CSV</button></div>
              <div class="frow">
                <div class="field"><label>Target</label><select id="import-target"><option value="programme_items">Programme intelligence</option><option value="risks">Risks</option></select></div>
                <div class="field"><label>Source system</label><input id="import-source" placeholder="Legacy Excel register / ARM export"/></div>
                <div class="field"><label>File name</label><input id="import-file" placeholder="client-register.csv"/></div>
              </div>
              <div class="field"><label>CSV rows</label><textarea id="import-csv" class="draft import-csv" spellcheck="false" placeholder="Paste CSV with headings"></textarea></div>
              <label class="chkbx import-commit"><input id="import-commit" type="checkbox" style="width:auto;padding:0"/> Commit accepted rows after validation</label>
              <div class="import-actions">
                <button class="btn" id="import-validate">Validate only</button>
                <button class="btnp" id="import-run">Run import</button>
              </div>
              <div class="fbnote" id="import-note"></div>
            </div>
            <div class="import-panel">
              <div class="panel-head"><h3>Batch history</h3><span class="muted" id="importBatchCount"></span></div>
              <div class="import-batch-list" id="importBatchList"></div>
            </div>
          </div>
          <div class="import-panel import-row-panel">
            <div class="panel-head"><h3>Row evidence</h3><span class="muted" id="importRowCount"></span></div>
            <div class="import-row-list" id="importRowList"></div>
          </div>
          <div class="export-reconciliation-panel" id="exportReconciliationPanel">
            <div class="panel-head"><h3>Round-trip export and reconciliation</h3><span class="muted" id="exportReconciliationSummary"></span></div>
            <div class="export-reconciliation-grid">
              <div class="export-panel export-generate-panel">
                <div class="panel-head"><h3>Generate export</h3><span class="muted">Stable, import-compatible CSV baseline</span></div>
                <div class="frow">
                  <div class="field"><label>Target</label><select id="export-target"><option value="risks">Risks</option><option value="programme_items">Programme intelligence</option></select></div>
                  <div class="field"><label>Scope</label><select id="export-scope"><option value="active">Active records</option><option value="all">All records</option><option value="qra_candidates">QRA candidates</option></select></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Destination / audience</label><input id="export-source" placeholder="Migration workshop / client review"/></div>
                  <div class="field"><label>File name</label><input id="export-file" placeholder="risk-register-export.csv"/></div>
                </div>
                <div class="field"><label>Notes</label><input id="export-notes" placeholder="Scope, audience or governance basis"/></div>
                <div class="export-actions">
                  <button class="btnp" id="export-generate">Generate export</button>
                  <button class="btn" id="export-download" disabled>Download CSV</button>
                </div>
                <div class="fbnote" id="export-note"></div>
              </div>
              <div class="export-panel export-batch-panel">
                <div class="panel-head"><h3>Export batches</h3><span class="muted" id="exportBatchCount"></span></div>
                <div class="export-batch-list" id="exportBatchList"></div>
              </div>
            </div>
            <div class="export-reconcile-grid">
              <div class="export-panel export-reconcile-form">
                <div class="panel-head"><h3>Return and reconcile</h3><span class="muted" id="exportReconcileTarget"></span></div>
                <div class="frow">
                  <div class="field"><label>Returned source</label><input id="reconcile-source" placeholder="Returned register / wave"/></div>
                  <div class="field"><label>Returned file name</label><input id="reconcile-file" placeholder="returned-register.csv"/></div>
                </div>
                <div class="field"><label>Returned CSV</label><textarea id="reconcile-csv" class="draft export-reconcile-csv" spellcheck="false" placeholder="Paste the returned CSV with the export headers"></textarea></div>
                <div class="field"><label>Notes</label><input id="reconcile-notes" placeholder="Review basis or governance note"/></div>
                <div class="export-actions">
                  <button class="btn" id="reconcile-load-baseline">Load baseline CSV</button>
                  <button class="btnp" id="export-reconcile">Reconcile return</button>
                </div>
                <div class="fbnote" id="reconcile-note"></div>
              </div>
              <div class="export-panel export-reconcile-results">
                <div class="panel-head"><h3>Reconciliation evidence</h3><span class="muted" id="exportReconcileSummary"></span></div>
                <div class="export-reconcile-counts" id="exportReconcileCounts"></div>
                <div class="export-commit-bar" id="exportCommitBar"></div>
                <div class="export-reconcile-runs" id="exportReconcileRuns"></div>
                <div class="export-reconcile-row-list" id="exportReconcileRowList"></div>
                <div class="export-commit-log" id="exportCommitLog"></div>
              </div>
            </div>
          </div>
          <div class="schedule-import-panel" id="scheduleImportPanel">
            <div class="panel-head"><h3>P6 / MS Project schedule import</h3><span class="muted" id="scheduleSummary"></span></div>
            <div class="schedule-import-head-actions">
              <a class="btn" href="/api/reporting/schedule-activities?format=csv" target="_blank" rel="noreferrer" id="schedule-activities-csv">Activities CSV</a>
              <a class="btn" href="/api/reporting/schedule-risk-links?format=csv" target="_blank" rel="noreferrer" id="schedule-risk-links-csv">Risk links CSV</a>
            </div>
            <div class="schedule-kpis" id="scheduleKpis"></div>
            <div class="schedule-import-grid">
              <div class="schedule-import-form">
                <div class="frow">
                  <div class="field"><label>Source system</label><input id="schedule-source" placeholder="Primavera P6 / MS Project export"/></div>
                  <div class="field"><label>File name</label><input id="schedule-file" placeholder="schedule-export.csv"/></div>
                </div>
                <div class="field"><label>Schedule CSV</label><textarea id="schedule-csv" class="draft schedule-csv" spellcheck="false" placeholder="Paste a P6/MSP export: Activity ID, Activity Name, WBS, Start, Finish, Original Duration, % Complete, Total Float, Critical"></textarea></div>
                <label class="chkbx schedule-commit"><input id="schedule-commit" type="checkbox" style="width:auto;padding:0"/> Commit accepted activities</label>
                <div class="schedule-actions">
                  <button class="btn" id="schedule-sample">Sample CSV</button>
                  <button class="btn" id="schedule-validate">Validate only</button>
                  <button class="btnp" id="schedule-run">Run import</button>
                </div>
                <div class="fbnote" id="schedule-note"></div>
              </div>
              <div class="schedule-evidence">
                <div class="schedule-recon" id="scheduleReconList"></div>
                <div class="schedule-activity-list" id="scheduleActivityList"></div>
              </div>
            </div>
          </div>
          <div class="schedule-import-panel" id="costImportPanel">
            <div class="panel-head"><h3>Cost-system import and reconciliation</h3><span class="muted" id="costSummary"></span></div>
            <div class="schedule-import-head-actions">
              <a class="btn" href="/api/reporting/cost-lines?format=csv" target="_blank" rel="noreferrer" id="cost-lines-csv">Cost lines CSV</a>
              <a class="btn" href="/api/reporting/cost-risk-reconciliation?format=csv" target="_blank" rel="noreferrer" id="cost-risk-csv">Reconciliation CSV</a>
            </div>
            <div class="schedule-kpis" id="costKpis"></div>
            <div class="schedule-import-grid">
              <div class="schedule-import-form">
                <div class="frow">
                  <div class="field"><label>Source system</label><input id="cost-source" placeholder="Cost system export"/></div>
                  <div class="field"><label>File name</label><input id="cost-file" placeholder="cost-export.csv"/></div>
                </div>
                <div class="field"><label>Cost CSV</label><textarea id="cost-csv" class="draft schedule-csv" spellcheck="false" placeholder="Paste a cost export: CBS, WBS, Description, Budget, Committed, Actual, Forecast, Contingency"></textarea></div>
                <label class="chkbx schedule-commit"><input id="cost-commit" type="checkbox" style="width:auto;padding:0"/> Commit accepted cost lines</label>
                <div class="schedule-actions">
                  <button class="btn" id="cost-sample">Sample CSV</button>
                  <button class="btn" id="cost-validate">Validate only</button>
                  <button class="btnp" id="cost-run">Run import</button>
                </div>
                <div class="fbnote" id="cost-note"></div>
              </div>
              <div class="schedule-evidence">
                <div class="schedule-recon" id="costReconList"></div>
              </div>
            </div>
          </div>
        </section>

        <section class="view" id="v-evidence">
          <div class="vhead">
            <div><h1>Evidence library</h1><div class="sub">Auditable evidence, assumptions, decisions, model outputs and document links tied to risks, QRA and controls</div></div>
            <div class="head-actions">
              <a class="btn" href="/api/reporting/evidence-records?format=csv" target="_blank" rel="noreferrer" id="evidence-records-csv">Evidence CSV</a>
              <a class="btn" href="/api/reporting/evidence-links?format=csv" target="_blank" rel="noreferrer" id="evidence-links-csv">Links CSV</a>
              <a class="btn" href="/api/reporting/evidence-attachments?format=csv" target="_blank" rel="noreferrer" id="evidence-attachments-csv">Attachments CSV</a>
              <a class="btn" href="/api/reporting/evidence-packages?format=csv" target="_blank" rel="noreferrer" id="evidence-packages-csv">Packages CSV</a>
              <button class="btn" id="evidence-refresh">Refresh</button>
              <button class="btnp" id="evidence-new">+ New evidence</button>
            </div>
          </div>
          <div class="kpis evidence-kpis" id="evidenceKpis"></div>
          <div class="evidence-workbench-grid" id="evidenceWorkbench">
            <div class="evidence-list-panel">
              <div class="toolbar evidence-toolbar">
                <input id="evidence-search" placeholder="Search code, title, reference, owner, tags or links"/>
                <select id="evidence-type-filter"><option value="">All types</option><option value="document">Documents</option><option value="decision">Decisions</option><option value="assumption">Assumptions</option><option value="meeting">Meetings</option><option value="model_file">Model files</option><option value="link">Links</option><option value="email">Emails</option><option value="photo">Photos</option><option value="other">Other</option></select>
                <select id="evidence-status-filter"><option value="">All statuses</option><option value="draft">Draft</option><option value="active">Active</option><option value="superseded">Superseded</option><option value="archived">Archived</option></select>
              </div>
              <div class="evidence-list" id="evidenceList"></div>
            </div>
            <div class="evidence-form-panel">
              <div class="panel-head"><h3>Evidence record</h3><button class="lnk" id="evidence-clear">Clear</button></div>
              <input id="evidence-id" type="hidden"/>
              <div class="frow">
                <div class="field"><label>Code</label><input id="evidence-code" placeholder="Auto or EVID-001"/></div>
                <div class="field"><label>Type</label><select id="evidence-type"><option value="document">Document</option><option value="decision">Decision</option><option value="assumption">Assumption</option><option value="meeting">Meeting</option><option value="model_file">Model file</option><option value="link">Link</option><option value="email">Email</option><option value="photo">Photo</option><option value="other">Other</option></select></div>
              </div>
              <div class="field"><label>Title</label><input id="evidence-title" placeholder="Evidence title"/></div>
              <div class="frow">
                <div class="field"><label>Status</label><select id="evidence-status"><option value="draft">Draft</option><option value="active">Active</option><option value="superseded">Superseded</option><option value="archived">Archived</option></select></div>
                <div class="field"><label>Sensitivity</label><select id="evidence-sensitivity"><option value="public">Public</option><option value="internal">Internal</option><option value="confidential">Confidential</option><option value="restricted">Restricted</option></select></div>
                <div class="field"><label>Owner</label><input id="evidence-owner" placeholder="Evidence owner"/></div>
              </div>
              <div class="frow">
                <div class="field"><label>Source</label><input id="evidence-source" placeholder="SharePoint, SRS, client system"/></div>
                <div class="field"><label>Reference</label><input id="evidence-reference" placeholder="Document / model / meeting ref"/></div>
              </div>
              <div class="field"><label>URI / controlled location</label><input id="evidence-uri" placeholder="https://, soma://, SharePoint ref or document-control path"/></div>
              <div class="frow">
                <div class="field"><label>Evidence date</label><input id="evidence-document-date" type="date"/></div>
                <div class="field"><label>Review due</label><input id="evidence-review-due" type="date"/></div>
              </div>
              <div class="field"><label>Tags</label><input id="evidence-tags" placeholder="qra, asbestos, decision"/></div>
              <div class="field"><label>Summary / basis</label><textarea id="evidence-summary" class="draft evidence-summary" placeholder="What this evidence proves, assumptions, limitations and review notes"></textarea></div>
              <div class="field"><label>Linked objects</label><textarea id="evidence-links" class="draft evidence-links-textarea" spellcheck="false" placeholder="One per line: risk,R-002,basis,Quantification basis evidence"></textarea></div>
              <div class="evidence-link-help">Format: entity type, entity id, role, notes. Entity types include risk, programme_item, control, qra_model_run, import_batch and report_pack.</div>
              <div class="evidence-actions"><button class="btn danger" id="evidence-archive">Archive</button><button class="btnp" id="evidence-save">Save evidence</button></div>
              <div class="fbnote" id="evidence-note"></div>
            </div>
          </div>
          <div class="evidence-link-panel">
            <div class="panel-head"><h3>Link evidence</h3><span class="muted" id="evidenceLinkCount"></span></div>
            <div class="evidence-link-list" id="evidenceLinkList"></div>
          </div>
          <div class="evidence-governance-grid">
            <div class="evidence-attachment-panel">
              <div class="panel-head"><h3>Attachment register</h3><span class="muted" id="evidenceAttachmentCount"></span></div>
              <div class="evidence-attachment-form">
                <div class="frow">
                  <div class="field"><label>Code</label><input id="attachment-code" placeholder="Auto or ATT-001"/></div>
                  <div class="field"><label>Provider</label><select id="attachment-provider"><option value="sharepoint">SharePoint</option><option value="r2">R2 object store</option><option value="srs">SRS</option><option value="url">URL</option><option value="local_ref">Local reference</option><option value="other">Other</option></select></div>
                  <div class="field"><label>Classification</label><select id="attachment-classification"><option value="internal">Internal</option><option value="confidential">Confidential</option><option value="restricted">Restricted</option><option value="public">Public</option></select></div>
                </div>
                <div class="field"><label>File / object name</label><input id="attachment-file-name" placeholder="risk-evidence.pdf"/></div>
                <div class="field"><label>Controlled URI</label><input id="attachment-uri" placeholder="soma://sharepoint/... or https://..."/></div>
                <div class="frow">
                  <div class="field"><label>MIME type</label><input id="attachment-mime" placeholder="application/pdf"/></div>
                  <div class="field"><label>Size bytes</label><input id="attachment-size" type="number" min="0" step="1"/></div>
                  <div class="field"><label>Version</label><input id="attachment-version" placeholder="Rev A"/></div>
                </div>
                <div class="field"><label>SHA-256 checksum</label><input id="attachment-checksum" placeholder="64-character file digest"/></div>
                <div class="field"><label>Notes</label><input id="attachment-notes" placeholder="What file this is and any storage limitations"/></div>
                <div class="structure-actions"><button class="btnp" id="attachment-save">Register attachment</button></div>
              </div>
              <div class="evidence-attachment-list" id="evidenceAttachmentList"></div>
              <input type="file" id="attachment-bytes-input" style="display:none"/>
            </div>
            <div class="evidence-package-panel">
              <div class="panel-head"><h3>Evidence packages</h3><span class="muted" id="evidencePackageCount"></span></div>
              <input id="evidence-package-id" type="hidden"/>
              <div class="frow">
                <div class="field"><label>Code</label><input id="package-code" placeholder="Auto or EPKG-001"/></div>
                <div class="field"><label>Status</label><select id="package-status"><option value="draft">Draft</option><option value="sealed">Sealed</option><option value="superseded">Superseded</option><option value="archived">Archived</option></select></div>
                <div class="field"><label>Sensitivity</label><select id="package-sensitivity"><option value="internal">Internal</option><option value="confidential">Confidential</option><option value="restricted">Restricted</option><option value="public">Public</option></select></div>
              </div>
              <div class="field"><label>Title</label><input id="package-title" placeholder="Evidence package title"/></div>
              <div class="field"><label>Owner</label><input id="package-owner" placeholder="Package owner"/></div>
              <div class="field"><label>Purpose</label><textarea id="package-purpose" class="draft evidence-summary" placeholder="Governance use, pack audience and limitations"></textarea></div>
              <div class="field"><label>Package items</label><textarea id="package-items" class="draft evidence-links-textarea" spellcheck="false" placeholder="One per line: EVID-ASB-RD-001,basis,Why this evidence is in the pack"></textarea></div>
              <div class="evidence-link-help">Format: evidence code, role, notes. Sealing writes a manifest hash across package items and registered attachments.</div>
              <div class="evidence-actions"><button class="btn" id="package-clear">Clear</button><button class="btn" id="package-seal">Seal package</button><button class="btnp" id="package-save">Save package</button></div>
              <div class="evidence-package-list" id="evidencePackageList"></div>
              <div class="evidence-link-list" id="evidencePackageItemList"></div>
            </div>
          </div>
        </section>

        <section class="view" id="v-controls">
          <div class="vhead">
            <div><h1>Controls and assurance</h1><div class="sub">Control library, bow-tie mapping, assurance tests and obligation evidence</div></div>
            <div class="head-actions">
              <a class="btn" href="/api/reporting/controls?format=csv" target="_blank" rel="noreferrer">Controls CSV</a>
              <a class="btn" href="/api/reporting/bowtie-controls?format=csv" target="_blank" rel="noreferrer">Bow-tie CSV</a>
              <a class="btn" href="/api/reporting/control-assurance-tests?format=csv" target="_blank" rel="noreferrer">Assurance CSV</a>
              <button class="btn" id="controls-refresh">Refresh</button>
            </div>
          </div>
          <div class="kpis control-kpis" id="controlsKpis"></div>
          <div class="control-panel control-coverage-panel">
            <div class="panel-head"><h3>Control coverage heat map</h3><span class="muted" id="controlCoverageSummary"></span></div>
            <div class="control-coverage-grid" id="controlCoverageHeatmap"></div>
          </div>
          <div class="controls-workbench-grid">
            <div class="control-panel control-library-panel">
              <div class="panel-head"><h3>Control library</h3><span class="muted" id="controlLibraryCount"></span></div>
              <div class="toolbar control-toolbar">
                <input id="control-search" placeholder="Search code, control, owner or source"/>
                <select id="control-effect-filter"><option value="">All effectiveness</option><option value="effective">Effective</option><option value="partially_effective">Partially effective</option><option value="ineffective">Ineffective</option><option value="untested">Untested</option></select>
              </div>
              <div class="control-list" id="controlList"></div>
            </div>
            <div class="control-panel control-form-panel">
              <div class="panel-head"><h3>Control record</h3><button class="lnk" id="control-clear">Clear</button></div>
              <input id="control-id" type="hidden"/>
              <div class="frow">
                <div class="field"><label>Code</label><input id="control-code" placeholder="CTRL-XXX-001"/></div>
                <div class="field"><label>Status</label><select id="control-status"><option value="active">Active</option><option value="inactive">Inactive</option></select></div>
              </div>
              <div class="field"><label>Name</label><input id="control-name" placeholder="Control name"/></div>
              <div class="frow">
                <div class="field"><label>Type</label><select id="control-type"><option value="preventive">Preventive</option><option value="detective">Detective</option><option value="corrective">Corrective</option><option value="recovery">Recovery</option></select></div>
                <div class="field"><label>Criticality</label><select id="control-criticality"><option value="critical">Critical</option><option value="key">Key</option><option value="supporting">Supporting</option></select></div>
              </div>
              <div class="frow">
                <div class="field"><label>Effectiveness</label><select id="control-effectiveness"><option value="effective">Effective</option><option value="partially_effective">Partially effective</option><option value="ineffective">Ineffective</option><option value="untested">Untested</option></select></div>
                <div class="field"><label>Owner</label><input id="control-owner" placeholder="Control owner"/></div>
              </div>
              <div class="field"><label>Source</label><input id="control-source" placeholder="Library, procedure, contract or assurance source"/></div>
              <div class="field"><label>Description</label><textarea id="control-description" class="draft control-description" placeholder="Control purpose, design and operating expectation"></textarea></div>
              <div class="structure-actions"><button class="btn danger" id="control-deactivate">Deactivate</button><button class="btnp" id="control-save">Save control</button></div>
            </div>
          </div>
          <div class="controls-workbench-grid lower">
            <div class="control-panel">
              <div class="panel-head"><h3>Bow-tie control mapping</h3><span class="muted" id="bowtieCount"></span></div>
              <div class="bowtie-board" id="bowtiePanel"></div>
              <div class="bowtie-form">
                <div class="frow">
                  <div class="field"><label>Risk</label><select id="rc-risk"></select></div>
                  <div class="field"><label>Control</label><select id="rc-control"></select></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Bow-tie side</label><select id="rc-side"><option value="cause">Cause</option><option value="event">Event</option><option value="effect">Effect</option></select></div>
                  <div class="field"><label>Link type</label><select id="rc-link-type"><option value="preventive">Preventive</option><option value="detective">Detective</option><option value="corrective">Corrective</option><option value="recovery">Recovery</option></select></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Assurance status</label><select id="rc-assurance"><option value="assured">Assured</option><option value="needs_test">Needs test</option><option value="overdue">Overdue</option><option value="failed">Failed</option><option value="not_tested">Not tested</option></select></div>
                  <div class="field"><label>Next test due</label><input id="rc-next-test" type="date"/></div>
                </div>
                <div class="field"><label>Coverage notes</label><input id="rc-notes" placeholder="How this control prevents, detects, corrects or recovers the risk"/></div>
                <button class="btnp" id="rc-save">Link control to risk</button>
              </div>
            </div>
            <div class="control-panel">
              <div class="panel-head"><h3>Assurance queue</h3><span class="muted" id="assuranceCount"></span></div>
              <div class="assurance-queue" id="assuranceQueue"></div>
              <div class="assurance-form">
                <div class="frow">
                  <div class="field"><label>Risk control</label><select id="assure-risk-control"></select></div>
                  <div class="field"><label>Result</label><select id="assure-result"><option value="not_run">Not run</option><option value="pass">Pass</option><option value="partial">Partial</option><option value="fail">Fail</option></select></div>
                </div>
                <div class="field"><label>Test name</label><input id="assure-name" placeholder="Assurance test"/></div>
                <div class="frow">
                  <div class="field"><label>Type</label><select id="assure-type"><option value="design">Design</option><option value="operating">Operating</option><option value="evidence">Evidence</option><option value="review">Review</option></select></div>
                  <div class="field"><label>Owner</label><input id="assure-owner" placeholder="Assurance owner"/></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Due date</label><input id="assure-due" type="date"/></div>
                  <div class="field"><label>Completed</label><input id="assure-completed" type="date"/></div>
                </div>
                <div class="field"><label>Evidence ref</label><input id="assure-evidence" placeholder="Document, SharePoint or audit reference"/></div>
                <div class="field"><label>Notes</label><textarea id="assure-notes" class="draft assurance-notes" placeholder="Assurance findings, limitations and actions"></textarea></div>
                <button class="btnp" id="assure-save">Save assurance test</button>
              </div>
            </div>
          </div>
          <div class="control-panel obligations-panel">
            <div class="panel-head"><h3>Obligations</h3><a class="lnk" href="/api/reporting/control-obligations?format=csv" target="_blank" rel="noreferrer">CSV</a></div>
            <div class="obligation-layout">
              <div class="obligation-queue" id="obligationQueue"></div>
              <div class="obligation-form">
                <div class="frow">
                  <div class="field"><label>Control</label><select id="obl-control"></select></div>
                  <div class="field"><label>Type</label><select id="obl-type"><option value="statutory">Statutory</option><option value="contractual">Contractual</option><option value="client">Client</option><option value="internal">Internal</option></select></div>
                </div>
                <div class="field"><label>Description</label><input id="obl-description" placeholder="Obligation description"/></div>
                <div class="frow">
                  <div class="field"><label>Reference</label><input id="obl-reference" placeholder="Clause, regulation or gateway"/></div>
                  <div class="field"><label>Owner</label><input id="obl-owner" placeholder="Owner"/></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Frequency</label><input id="obl-frequency" placeholder="Monthly, daily, per package"/></div>
                  <div class="field"><label>Due date</label><input id="obl-due" type="date"/></div>
                  <div class="field"><label>Status</label><select id="obl-status"><option value="open">Open</option><option value="compliant">Compliant</option><option value="overdue">Overdue</option><option value="waived">Waived</option></select></div>
                </div>
                <button class="btnp" id="obl-save">Save obligation</button>
              </div>
            </div>
          </div>
          <div class="control-panel sampling-panel">
            <div class="panel-head"><h3>Assurance sampling plans</h3><a class="lnk" href="/api/reporting/assurance-sampling-plans?format=csv" target="_blank" rel="noreferrer">CSV</a></div>
            <div class="obligation-layout">
              <div class="obligation-queue" id="samplingPlanList"></div>
              <div class="obligation-form">
                <div class="frow">
                  <div class="field"><label>Plan code</label><input id="samp-code" placeholder="SAMP-CTRL-001"/></div>
                  <div class="field"><label>Control</label><select id="samp-control"></select></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Method</label><select id="samp-method"><option value="risk_based">Risk-based</option><option value="statistical">Statistical</option><option value="judgmental">Judgmental</option><option value="census">Census</option></select></div>
                  <div class="field"><label>Frequency</label><input id="samp-frequency" placeholder="Quarterly"/></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Population</label><input id="samp-population" type="number" min="0" placeholder="0"/></div>
                  <div class="field"><label>Sample size</label><input id="samp-sample" type="number" min="0" placeholder="0"/></div>
                  <div class="field"><label>Coverage %</label><input id="samp-coverage" type="number" min="0" max="100" placeholder="0"/></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Owner</label><input id="samp-owner" placeholder="Plan owner"/></div>
                  <div class="field"><label>Next sample due</label><input id="samp-due" type="date"/></div>
                </div>
                <button class="btnp" id="samp-save">Save sampling plan</button>
              </div>
            </div>
          </div>
          <div class="control-panel escalation-panel">
            <div class="panel-head"><h3>Obligation escalations</h3><a class="lnk" href="/api/reporting/obligation-escalations?format=csv" target="_blank" rel="noreferrer">CSV</a></div>
            <div class="obligation-layout">
              <div class="obligation-queue" id="escalationQueue"></div>
              <div class="obligation-form">
                <div class="frow">
                  <div class="field"><label>Obligation</label><select id="esc-obligation"></select></div>
                  <div class="field"><label>Level</label><select id="esc-level"><option value="notice">Notice</option><option value="formal">Formal</option><option value="board">Board</option></select></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Raised to</label><input id="esc-raised-to" placeholder="Programme Board"/></div>
                  <div class="field"><label>Due date</label><input id="esc-due" type="date"/></div>
                </div>
                <div class="field"><label>Reason</label><textarea id="esc-reason" class="draft assurance-notes" placeholder="Why this obligation is being escalated"></textarea></div>
                <button class="btnp" id="esc-save">Raise escalation</button>
              </div>
            </div>
          </div>
        </section>

        <section class="view" id="v-qra">
          <div class="vhead">
            <div><h1>QRA workbench</h1><div class="sub">Quantitative risk pipeline, SRS export readiness and exception management</div></div>
            <div class="head-actions">
              <a class="btn" href="/api/reporting/qra-export?format=csv" target="_blank" rel="noreferrer" id="qra-ready-export">Ready export</a>
              <a class="btn" href="/api/reporting/qra-export?mode=candidate&format=csv" target="_blank" rel="noreferrer" id="qra-candidate-export">Candidate export</a>
              <button class="btn" id="qra-refresh">Refresh</button>
            </div>
          </div>
          <div class="qra-command-band" id="qraCommandBand"></div>
          <div class="kpis qra-kpis" id="qraWorkbenchKpis"></div>
          <div class="qra-workbench-grid">
            <div class="qra-workbench-panel">
              <div class="panel-head"><h3>QRA exception queue</h3><span class="muted" id="qraExceptionCount"></span></div>
              <div class="toolbar qra-toolbar">
                <input id="qra-search" placeholder="Search risks, WBS, CBS, package…" style="flex:1;min-width:220px"/>
                <select id="qra-filter">
                  <option value="exceptions">Exceptions</option>
                  <option value="ready">Ready</option>
                  <option value="needs_review">Needs review</option>
                  <option value="incomplete">Incomplete</option>
                  <option value="included">Included</option>
                  <option value="all">All non-excluded</option>
                </select>
              </div>
              <div style="overflow:auto">
                <table class="qra-table"><thead><tr><th style="width:70px">ID</th><th>Risk</th><th style="width:130px">Mapping</th><th style="width:98px">Probability</th><th style="width:136px">Cost</th><th style="width:136px">Schedule</th><th style="width:106px">Status</th><th style="width:110px"></th></tr></thead><tbody id="qraWorkbenchTb"></tbody></table>
              </div>
            </div>
            <div class="qra-workbench-panel">
              <div class="panel-head"><h3>SRS export pack</h3><a class="lnk" href="/api/reporting/schema" target="_blank" rel="noreferrer">Schema</a></div>
              <div id="qraExportPack"></div>
            </div>
          </div>
        </section>

        <section class="view" id="v-srs">
          <div class="vhead">
            <div><h1>SRS QRA results</h1><div class="sub">Model-run register, P-values, tornado drivers, S-curves and result evidence</div></div>
            <div class="head-actions">
              <a class="btn" href="/api/reporting/qra-model-runs?format=csv" target="_blank" rel="noreferrer" id="srs-runs-csv">Runs CSV</a>
              <a class="btn" href="/api/reporting/qra-tornado-drivers?format=csv" target="_blank" rel="noreferrer" id="srs-tornado-csv">Tornado CSV</a>
              <a class="btn" href="/api/reporting/qra-s-curve-points?format=csv" target="_blank" rel="noreferrer" id="srs-scurve-csv">S-curve CSV</a>
              <button class="btn" id="srs-refresh">Refresh</button>
            </div>
          </div>
          <div class="srs-command-band" id="srsCommandBand"></div>
          <div class="kpis srs-kpis" id="srsKpis"></div>
          <div class="srs-grid">
            <div class="srs-panel">
              <div class="panel-head"><h3>Model-run register</h3><span class="muted" id="srsRunCount"></span></div>
              <div class="srs-run-list" id="srsRunList"></div>
              <div class="srs-create">
                <div class="panel-head"><h3>Create run from QRA export</h3></div>
                <div class="field"><label>Name</label><input id="srs-run-name" placeholder="e.g. July integrated QRA"/></div>
                <div class="frow">
                  <div class="field"><label>Run reference</label><input id="srs-run-ref" placeholder="SRS-WCC-JUL26-QRA"/></div>
                  <div class="field"><label>Export mode</label><select id="srs-export-mode"><option value="ready">Ready</option><option value="candidate">Candidate</option><option value="all">All</option></select></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Model type</label><select id="srs-model-type"><option value="integrated">Integrated</option><option value="qcra">QCRA</option><option value="qsra">QSRA</option><option value="qra">QRA</option></select></div>
                  <div class="field"><label>Reporting period</label><select id="srs-period"></select></div>
                </div>
                <div class="field"><label>Notes</label><textarea id="srs-run-notes" class="draft srs-notes" placeholder="Model boundary, version, SRS file reference or analysis basis"></textarea></div>
                <button class="btnp" id="srs-create-run">Create model run</button>
              </div>
            </div>
            <div class="srs-panel srs-detail-panel">
              <div class="panel-head"><h3>Result dashboard</h3><span class="muted" id="srsDetailMeta"></span></div>
              <div id="srsRunDetail"></div>
              <div class="srs-import-panel">
                <div class="panel-head"><h3>Pilot result import</h3><span class="muted">Result values</span></div>
                <div class="frow">
                  <div class="field"><label>P50 cost (£k)</label><input id="srs-p50-cost" type="number" min="0" step="0.01"/></div>
                  <div class="field"><label>P80 cost (£k)</label><input id="srs-p80-cost" type="number" min="0" step="0.01"/></div>
                  <div class="field"><label>P90 cost (£k)</label><input id="srs-p90-cost" type="number" min="0" step="0.01"/></div>
                </div>
                <div class="frow">
                  <div class="field"><label>P50 schedule (days)</label><input id="srs-p50-schedule" type="number" min="0" step="0.01"/></div>
                  <div class="field"><label>P80 schedule (days)</label><input id="srs-p80-schedule" type="number" min="0" step="0.01"/></div>
                  <div class="field"><label>P90 schedule (days)</label><input id="srs-p90-schedule" type="number" min="0" step="0.01"/></div>
                </div>
                <div class="field"><label>Result summary</label><textarea id="srs-result-summary" class="draft srs-notes" placeholder="Key P-value and driver narrative for board/reporting use"></textarea></div>
                <button class="btnp" id="srs-import-results">Import result values</button>
              </div>
            </div>
          </div>
          <div class="srs-grid lower">
            <div class="srs-panel">
              <div class="panel-head"><h3>Tornado drivers</h3><a class="lnk" href="/api/reporting/qra-tornado-drivers?format=csv" target="_blank" rel="noreferrer">CSV</a></div>
              <div id="srsTornado"></div>
            </div>
            <div class="srs-panel">
              <div class="panel-head"><h3>S-curves and risk contribution</h3><a class="lnk" href="/api/reporting/qra-model-run-risks?format=csv" target="_blank" rel="noreferrer">Risks CSV</a></div>
              <div id="srsCurves"></div>
              <div id="srsRiskContrib"></div>
            </div>
          </div>
          <div class="srs-grid ops">
            <div class="srs-panel">
              <div class="panel-head"><h3>Live SRS integration</h3><a class="lnk" href="/api/reporting/srs-connections?format=csv" target="_blank" rel="noreferrer">Connections CSV</a></div>
              <div id="srsConnectionPanel"></div>
              <div class="srs-connection-form">
                <div class="frow">
                  <div class="field"><label>Connection name</label><input id="srs-conn-name" placeholder="SOMA Risk Studio dev integration"/></div>
                  <div class="field"><label>Environment</label><select id="srs-conn-env"><option value="development">Development</option><option value="test">Test</option><option value="production">Production</option></select></div>
                </div>
                <div class="field"><label>Base URL</label><input id="srs-conn-base" placeholder="Leave blank for contract / mock-ready mode"/></div>
                <div class="frow">
                  <div class="field"><label>API version</label><input id="srs-conn-version" placeholder="srs-qra-v1"/></div>
                  <div class="field"><label>Auth mode</label><select id="srs-conn-auth"><option value="manual">Manual / secret outside D1</option><option value="none">None</option><option value="api_key">API key</option><option value="access_service_token">Access service token</option><option value="oauth">OAuth</option></select></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Status</label><select id="srs-conn-status"><option value="mock_ready">Mock ready</option><option value="draft">Draft</option><option value="ready">Ready</option><option value="error">Error</option><option value="disabled">Disabled</option></select></div>
                  <div class="field"><label>Health endpoint</label><input id="srs-conn-health" placeholder="/health"/></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Push endpoint</label><input id="srs-conn-push" placeholder="/api/qra/model-runs"/></div>
                  <div class="field"><label>Poll template</label><input id="srs-conn-poll" placeholder="/api/qra/model-runs/{externalRunId}/results"/></div>
                </div>
                <div class="field"><label>Notes</label><textarea id="srs-conn-notes" class="draft srs-notes" placeholder="Credential handling, API boundary and integration basis"></textarea></div>
                <div class="button-row">
                  <button class="btnp" id="srs-save-connection">Save connection</button>
                  <button class="btn" id="srs-health-check">Health check</button>
                  <button class="btn" id="srs-push-run">Push selected run</button>
                  <button class="btn" id="srs-poll-run">Poll selected run</button>
                </div>
              </div>
            </div>
            <div class="srs-panel">
              <div class="panel-head"><h3>Sync event trail</h3><a class="lnk" href="/api/reporting/srs-sync-events?format=csv" target="_blank" rel="noreferrer">Events CSV</a></div>
              <div id="srsSyncEvents"></div>
            </div>
          </div>
        </section>

        <section class="view" id="v-dashboard">
          <div class="vhead"><div><h1>Risk dashboard</h1><div class="sub">Residual position across the capital programme</div></div><button class="btn" id="pdfBtn2">PDF report</button></div>
          <div class="kpis" id="kpis"></div>
          <div class="movement" id="movement"></div>
          <div class="grid2">
            <div class="card"><h3 style="font-size:16px;margin-bottom:12px">Residual heat map</h3><div id="hm"></div></div>
            <div class="card"><h3 style="font-size:16px;margin-bottom:14px">Residual exposure by category</h3><div id="bars"></div></div>
          </div>
          <div class="card" style="margin-top:16px"><div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px"><h3 style="font-size:16px">Top 5 exposures</h3><button class="lnk" id="viewHC">View high &amp; critical →</button></div><div class="toplist" id="top"></div></div>
        </section>

        <section class="view" id="v-reviews">
          <div class="vhead"><div><h1>Reviews</h1><div class="sub">Risks past or near their review date</div></div></div>
          <div class="card" style="padding:6px 14px">
            <table><thead><tr><th style="width:64px">ID</th><th>Risk</th><th style="width:120px">Owner</th><th style="width:120px">Due</th><th style="width:120px">Status</th><th style="width:120px"></th></tr></thead>
            <tbody id="revtb"></tbody></table>
          </div>
        </section>

        <section class="view" id="v-reporting">
          <div class="vhead"><div><h1>Reporting suite</h1><div class="sub">Board packs, period snapshots, QRA readiness and Power BI-ready exports</div></div><button class="btn" id="reporting-refresh">Refresh</button></div>
          <div class="report-suite" id="reportSuite"></div>
          <div class="card report-builder" id="reportBuilder">
            <div class="panel-head"><h3>Report pack builder</h3><span class="muted" id="reportTemplateCount"></span></div>
            <div class="report-builder-grid">
              <div class="report-template-list" id="reportTemplates"></div>
              <div class="report-template-form">
                <input id="rt-id" type="hidden"/>
                <div class="frow">
                  <div class="field"><label>Template name</label><input id="rt-name" placeholder="e.g. Monthly board risk pack"/></div>
                  <div class="field"><label>Audience</label><select id="rt-audience"><option value="board">Board</option><option value="client">Client</option><option value="project_team">Project team</option><option value="qra_workshop">QRA workshop</option><option value="executive">Executive</option><option value="custom">Custom</option></select></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Cadence</label><select id="rt-cadence"><option value="monthly">Monthly</option><option value="weekly">Weekly</option><option value="period">Period based</option><option value="ad_hoc">Ad hoc</option></select></div>
                  <div class="field"><label>Default format</label><select id="rt-format"><option value="pdf">PDF</option><option value="xlsx">XLSX</option><option value="csv">CSV</option><option value="power-bi">Power BI</option><option value="json">JSON</option></select></div>
                </div>
                <div class="field"><label>Description</label><textarea id="rt-description" class="draft report-template-description" placeholder="Purpose, audience and governance use"></textarea></div>
                <div class="report-section-picker" id="rt-sections"></div>
                <div class="frow">
                  <label class="checkline"><input id="rt-active" type="checkbox" checked/> Active</label>
                  <button class="btn" id="rt-clear">Clear</button>
                  <button class="btnp" id="rt-save">Save template</button>
                </div>
              </div>
            </div>
          </div>
          <div class="card report-layout-designer" id="reportLayoutDesigner">
            <div class="panel-head"><h3>Report layout designer</h3><span class="muted" id="reportLayoutCount"></span></div>
            <div class="report-builder-grid">
              <div class="report-template-list" id="reportLayouts"></div>
              <div class="report-template-form">
                <input id="rl-id" type="hidden"/>
                <div class="frow">
                  <div class="field"><label>Template</label><select id="rl-template"></select></div>
                  <div class="field"><label>Layout name</label><input id="rl-name" placeholder="e.g. Client steering group landscape"/></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Theme</label><select id="rl-theme"><option value="soma_board">SOMA board</option><option value="client_formal">Client formal</option><option value="qra_workshop">QRA workshop</option><option value="assurance">Assurance</option><option value="power_bi">Power BI</option></select></div>
                  <div class="field"><label>Page size</label><select id="rl-page-size"><option value="a4_landscape">A4 landscape</option><option value="a4_portrait">A4 portrait</option><option value="wide">Wide / workbook</option></select></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Status</label><select id="rl-status"><option value="draft">Draft</option><option value="active">Active</option><option value="retired">Retired</option></select></div>
                  <label class="checkline"><input id="rl-default" type="checkbox"/> Default for template</label>
                </div>
                <div class="field"><label>Description</label><textarea id="rl-description" class="draft report-template-description" placeholder="Audience, output purpose and issue basis"></textarea></div>
                <div class="field"><label>Layout blocks JSON</label><textarea id="rl-layout" class="draft report-layout-json" placeholder='{"sectionOrder":["executive_summary","top_risks"],"blocks":[...]}'></textarea></div>
                <div class="field"><label>Quality rules JSON</label><textarea id="rl-quality" class="draft report-quality-json" placeholder='{"requireNoCriticalIssues":true,"allowIssueOverride":true}'></textarea></div>
                <div class="frow">
                  <button class="btn" id="rl-seed">Seed from template</button>
                  <button class="btn" id="rl-clear">Clear</button>
                  <button class="btnp" id="rl-save">Save layout</button>
                </div>
              </div>
            </div>
          </div>
          <div class="card report-scheduler" id="reportScheduler">
            <div class="panel-head"><h3>Scheduled reporting and Power BI model</h3><span class="muted" id="reportScheduleCount"></span></div>
            <div class="report-builder-grid">
              <div class="report-template-list" id="reportSchedules"></div>
              <div class="report-template-form">
                <input id="rs-id" type="hidden"/>
                <div class="report-distribution-manager" id="reportDistributionManager">
                  <div class="panel-head compact-head">
                    <h3>Governed distribution lists</h3>
                    <span class="muted" id="reportDistributionCount"></span>
                  </div>
                  <div class="report-distribution-grid">
                    <div class="report-distribution-list" id="reportDistributionLists"></div>
                    <div class="report-distribution-form">
                      <input id="rdl-id" type="hidden"/>
                      <div class="frow">
                        <div class="field"><label>List name</label><input id="rdl-name" placeholder="e.g. Board sponsors"/></div>
                        <div class="field"><label>Status</label><select id="rdl-status"><option value="active">Active</option><option value="draft">Draft</option><option value="retired">Retired</option></select></div>
                      </div>
                      <div class="frow">
                        <div class="field"><label>Audience</label><select id="rdl-audience"><option value="board">Board</option><option value="client">Client</option><option value="project_team">Project team</option><option value="qra_workshop">QRA workshop</option><option value="executive">Executive</option><option value="custom">Custom</option></select></div>
                        <div class="field"><label>Description</label><input id="rdl-description" placeholder="Purpose and issue basis"/></div>
                      </div>
                      <div class="field"><label>Recipients</label><textarea id="rdl-recipients" class="draft report-recipient-textarea" placeholder="Name, email, role, active"></textarea></div>
                      <div class="report-pack-actions">
                        <button class="btn" id="rdl-clear">Clear list</button>
                        <button class="btnp" id="rdl-save">Save list</button>
                        <a class="btn" href="/api/reporting/distribution-lists?format=csv" target="_blank" rel="noreferrer">Lists CSV</a>
                        <a class="btn" href="/api/reporting/distribution-recipients?format=csv" target="_blank" rel="noreferrer">Recipients CSV</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="frow">
                  <div class="field"><label>Schedule name</label><input id="rs-name" placeholder="e.g. Monthly board pack issue"/></div>
                  <div class="field"><label>Status</label><select id="rs-status"><option value="active">Active</option><option value="paused">Paused</option><option value="retired">Retired</option></select></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Template</label><select id="rs-template"></select></div>
                  <div class="field"><label>Layout</label><select id="rs-layout"></select></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Cadence</label><select id="rs-cadence"><option value="monthly">Monthly</option><option value="weekly">Weekly</option><option value="period">Period based</option><option value="ad_hoc">Ad hoc</option></select></div>
                  <div class="field"><label>Format</label><select id="rs-format"><option value="pdf">PDF</option><option value="xlsx">XLSX</option><option value="power-bi">Power BI</option><option value="json">JSON</option><option value="csv">CSV</option></select></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Period mode</label><select id="rs-period-mode"><option value="latest_closed">Latest closed</option><option value="live">Live</option><option value="manual">Manual at run</option></select></div>
                  <div class="field"><label>Next due</label><input id="rs-next-due" type="date"/></div>
                </div>
                <div class="field"><label>Recipient group</label><input id="rs-recipients" placeholder="Board / sponsor group"/></div>
                <div class="field"><label>Distribution list</label><select id="rs-distribution-list"></select></div>
                <div class="field"><label>Description</label><textarea id="rs-description" class="draft report-template-description" placeholder="Production purpose, audience and issue expectations"></textarea></div>
                <label class="checkline"><input id="rs-auto-issue" type="checkbox"/> Auto-issue when ready</label>
                <div class="report-pack-actions">
                  <button class="btn" id="rs-clear">Clear</button>
                  <button class="btnp" id="rs-save">Save schedule</button>
                  <button class="btn" id="rs-run">Run now</button>
                  <button class="btn" id="rs-dispatch-due">Dispatch due</button>
                  <a class="btn" href="/api/reporting/power-bi/semantic-model" target="_blank" rel="noreferrer">Power BI model</a>
                  <a class="btn" id="power-bi-connector-pack" href="/api/reporting/power-bi/connector-pack" target="_blank" rel="noreferrer">Power BI pack</a>
                  <a class="btn" href="/api/reporting/schedules?format=csv" target="_blank" rel="noreferrer">Schedules CSV</a>
                  <a class="btn" href="/api/reporting/delivery-jobs?format=csv" target="_blank" rel="noreferrer">Delivery CSV</a>
                </div>
                <div class="report-pack-sections" id="reportScheduleRuns"></div>
                <div class="report-pack-sections" id="reportDeliveryJobs"></div>
              </div>
            </div>
          </div>
          <div class="card notification-outbox-card" id="notificationOutbox">
            <div class="panel-head">
              <h3>Notification and escalation outbox</h3>
              <span class="muted" id="notificationOutboxCount"></span>
            </div>
            <div class="notification-toolbar">
              <div class="field"><label>Due horizon</label><input id="notification-due-date" type="date"/></div>
              <div class="field"><label>Limit</label><input id="notification-limit" type="number" min="1" max="250" step="1" value="100"/></div>
              <label class="checkline"><input id="notification-dry-run" type="checkbox"/> Dry run</label>
              <button class="btnp" id="notification-dispatch-due">Dispatch due</button>
              <a class="btn" id="notification-events-csv" href="/api/reporting/notification-events?format=csv" target="_blank" rel="noreferrer">Outbox CSV</a>
            </div>
            <div class="notification-summary" id="notificationRuleSummary"></div>
            <div class="notification-list" id="notificationEventList"></div>
          </div>
          <div class="card report-pack-generator" id="reportPackGenerator">
            <div class="panel-head"><h3>Generated report packs</h3><span class="muted" id="reportPackCount"></span></div>
            <div class="report-pack-grid">
              <div class="report-pack-form">
                <div class="frow">
                  <div class="field"><label>Template</label><select id="pack-template"></select></div>
                  <div class="field"><label>Layout</label><select id="pack-layout"></select></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Reporting period</label><select id="pack-period"></select></div>
                  <div class="field"><label>Pack title</label><input id="pack-title" placeholder="e.g. Westshire June board risk pack"/></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Output format</label><select id="pack-format"><option value="pdf">PDF</option><option value="xlsx">XLSX</option><option value="power-bi">Power BI</option><option value="json">JSON</option><option value="csv">CSV</option></select></div>
                  <div class="field"><label>Issue note</label><input id="pack-issue-note" placeholder="Formal issue note or exception basis"/></div>
                </div>
                <div class="report-pack-actions">
                  <button class="btnp" id="pack-generate">Generate pack</button>
                  <a class="btn" href="/api/reporting/report-packs?format=csv" target="_blank" rel="noreferrer">Packs CSV</a>
                  <a class="btn" href="/api/reporting/report-pack-sections?format=csv" target="_blank" rel="noreferrer">Sections CSV</a>
                </div>
                <div class="report-pack-hint" id="reportPackHint"></div>
              </div>
              <div class="report-pack-list" id="reportPacks"></div>
            </div>
            <div class="report-pack-sections" id="reportPackSections"></div>
          </div>
          <div class="grid2">
            <div class="card"><h3 style="font-size:16px;margin-bottom:4px">Reporting period</h3><div class="muted" style="font-size:12px;margin-bottom:12px">Freeze the current register before producing governance outputs.</div>
              <div class="toolbar" style="margin-bottom:12px">
                <input id="rp-name" placeholder="e.g. June 2026 board pack" style="min-width:220px"/>
                <input id="rp-start" type="date"/>
                <input id="rp-end" type="date"/>
                <button class="btnp" id="rp-create">Create period</button>
              </div>
              <textarea id="rp-notes" class="draft" style="height:70px;margin-top:0;margin-bottom:12px" placeholder="Period notes"></textarea>
              <div style="overflow:auto">
                <table><thead><tr><th>Name</th><th style="width:136px">Period</th><th style="width:82px">Status</th><th style="width:210px"></th></tr></thead><tbody id="periodsTb"></tbody></table>
              </div>
            </div>
            <div class="card"><h3 style="font-size:16px;margin-bottom:4px">QRA readiness</h3><div class="muted" style="font-size:12px;margin-bottom:12px">Candidate risks need quantitative and mapping data before QRA export.</div>
              <div class="kpis" id="qra-kpis" style="grid-template-columns:repeat(3,minmax(0,1fr));margin-bottom:12px"></div>
              <div style="overflow:auto">
                <table><thead><tr><th style="width:64px">ID</th><th>Risk</th><th style="width:90px">State</th><th>Missing</th></tr></thead><tbody id="qraTb"></tbody></table>
              </div>
            </div>
          </div>
          <div class="grid2" style="margin-top:16px">
            <div class="card"><h3 style="font-size:16px;margin-bottom:10px">Power BI / CSV feeds</h3><div class="report-links" id="reportLinks"></div></div>
            <div class="card"><h3 style="font-size:16px;margin-bottom:10px">Report run evidence</h3>
              <div class="toolbar" style="margin-bottom:12px">
                <select id="rr-period" style="min-width:200px"></select>
                <input id="rr-type" placeholder="Report type" value="Monthly project risk report"/>
                <select id="rr-format"><option>pdf</option><option>xlsx</option><option>csv</option><option>power-bi</option><option>json</option></select>
                <button class="btnp" id="rr-log">Log run</button>
              </div>
              <div style="overflow:auto">
                <table><thead><tr><th>Report</th><th style="width:150px">Period</th><th style="width:82px">Format</th><th style="width:124px">When</th></tr></thead><tbody id="reportRunsTb"></tbody></table>
              </div>
            </div>
          </div>
        </section>

        <section class="view" id="v-configuration">
          <div class="vhead">
            <div><h1>Configuration</h1><div class="sub">Client-specific fields, lifecycle states, workflow transitions and reportable governance configuration</div></div>
            <div class="head-actions">
              <a class="btn" href="/api/reporting/custom-field-definitions?format=csv" target="_blank" rel="noreferrer" id="custom-fields-csv">Fields CSV</a>
              <a class="btn" href="/api/reporting/custom-field-values?format=csv" target="_blank" rel="noreferrer" id="custom-values-csv">Values CSV</a>
              <a class="btn" href="/api/reporting/workflow-instances?format=csv" target="_blank" rel="noreferrer" id="workflow-instances-csv">Workflows CSV</a>
              <a class="btn" href="/api/reporting/workflow-events?format=csv" target="_blank" rel="noreferrer" id="workflow-events-csv">Events CSV</a>
              <button class="btn" id="configuration-refresh">Refresh</button>
            </div>
          </div>
          <div class="kpis configuration-kpis" id="configurationKpis"></div>
          <div class="configuration-grid" id="configurationWorkbench">
            <div class="configuration-panel">
              <div class="panel-head"><h3>Custom field catalogue</h3><span class="muted" id="customFieldCount"></span></div>
              <div class="toolbar configuration-toolbar">
                <input id="custom-field-search" placeholder="Search fields, keys, help text or options"/>
                <select id="custom-field-entity-filter"><option value="">All objects</option>${CONFIG_ENTITY_DEFS.map((item) => `<option value="${item.key}">${item.label}</option>`).join("")}</select>
                <select id="custom-field-status-filter"><option value="">All statuses</option><option value="active">Active</option><option value="retired">Retired</option></select>
              </div>
              <div class="custom-field-list" id="customFieldList"></div>
            </div>
            <div class="configuration-panel">
              <div class="panel-head"><h3>Field definition</h3><button class="lnk" id="custom-field-clear">Clear</button></div>
              <input id="cf-id" type="hidden"/>
              <div class="frow">
                <div class="field"><label>Object</label><select id="cf-entity">${CONFIG_ENTITY_DEFS.map((item) => `<option value="${item.key}">${item.label}</option>`).join("")}</select></div>
                <div class="field"><label>Type</label><select id="cf-type">${CUSTOM_FIELD_TYPE_DEFS.map((item) => `<option value="${item.key}">${item.label}</option>`).join("")}</select></div>
              </div>
              <div class="frow">
                <div class="field"><label>Key</label><input id="cf-key" placeholder="gateway_stage"/></div>
                <div class="field"><label>Label</label><input id="cf-label" placeholder="Gateway stage"/></div>
              </div>
              <div class="field"><label>Help text</label><input id="cf-help" placeholder="What this field means and how it is governed"/></div>
              <div class="frow">
                <div class="field"><label>Status</label><select id="cf-status"><option value="active">Active</option><option value="retired">Retired</option></select></div>
                <div class="field"><label>Sort order</label><input id="cf-sort" type="number" step="1"/></div>
                <label class="checkline config-check"><input id="cf-required" type="checkbox"/> Required</label>
              </div>
              <div class="field"><label>Options</label><textarea id="cf-options" class="draft config-options" placeholder="One per line for select or multi-select fields"></textarea></div>
              <div class="field"><label>Display / scope rules JSON</label><textarea id="cf-applies" class="draft config-json" spellcheck="false" placeholder='{"showOnRegister":true}'></textarea></div>
              <div class="configuration-actions"><button class="btn danger" id="custom-field-retire">Retire</button><button class="btnp" id="custom-field-save">Save field</button></div>
              <div class="fbnote" id="custom-field-note"></div>
            </div>
          </div>
          <div class="configuration-grid lower">
            <div class="configuration-panel">
              <div class="panel-head"><h3>Custom field values</h3><span class="muted" id="customValueCount"></span></div>
              <div class="custom-value-form">
                <div class="frow">
                  <div class="field"><label>Field</label><select id="cfv-definition"></select></div>
                  <div class="field"><label>Object</label><select id="cfv-entity">${CONFIG_ENTITY_DEFS.map((item) => `<option value="${item.key}">${item.label}</option>`).join("")}</select></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Object id</label><input id="cfv-entity-id" placeholder="R-002, I-001, EVID-QRA-JUN26-001"/></div>
                  <div class="field"><label>Value</label><input id="cfv-value" placeholder="Configured value"/></div>
                </div>
                <button class="btnp" id="custom-value-save">Save value</button>
              </div>
              <div class="custom-value-list" id="customValueList"></div>
            </div>
            <div class="configuration-panel">
              <div class="panel-head"><h3>Workflow lifecycle board</h3><span class="muted" id="workflowCount"></span></div>
              <div class="toolbar configuration-toolbar">
                <input id="workflow-search" placeholder="Search workflow, owner, entity or state"/>
                <select id="workflow-entity-filter"><option value="">All objects</option>${CONFIG_ENTITY_DEFS.map((item) => `<option value="${item.key}">${item.label}</option>`).join("")}</select>
                <select id="workflow-status-filter"><option value="">All statuses</option><option value="active">Active</option><option value="completed">Completed</option><option value="cancelled">Cancelled</option></select>
              </div>
              <div class="workflow-instance-list" id="workflowInstanceList"></div>
            </div>
          </div>
          <div class="configuration-grid lower workflow-definition-editor" id="workflowDefinitionDesigner">
            <div class="configuration-panel">
              <div class="panel-head">
                <h3>Workflow definition designer</h3>
                <div class="panel-actions workflow-template-actions">
                  <select id="workflow-template-select">${WORKFLOW_TEMPLATES.map((item) => `<option value="${item.key}">${item.label}</option>`).join("")}</select>
                  <button class="lnk" id="workflow-definition-template">Load template</button>
                  <button class="lnk" id="workflow-definition-clear">Clear</button>
                </div>
              </div>
              <input id="wfd-id" type="hidden"/>
              <div class="frow">
                <div class="field"><label>Object</label><select id="wfd-entity">${CONFIG_ENTITY_DEFS.map((item) => `<option value="${item.key}">${item.label}</option>`).join("")}</select></div>
                <div class="field"><label>Status</label><select id="wfd-status"><option value="active">Active</option><option value="retired">Retired</option></select></div>
                <div class="field"><label>Default state</label><input id="wfd-default-state" placeholder="identified"/></div>
              </div>
              <div class="frow">
                <div class="field"><label>Key</label><input id="wfd-key" placeholder="major_risk_lifecycle"/></div>
                <div class="field"><label>Name</label><input id="wfd-name" placeholder="Major risk lifecycle"/></div>
              </div>
              <div class="field"><label>Description</label><input id="wfd-description" placeholder="How this lifecycle governs object review, challenge and approval"/></div>
              <div class="workflow-definition-json-grid">
                <div class="field"><label>States JSON</label><textarea id="wfd-states" class="draft config-json workflow-definition-json" spellcheck="false"></textarea></div>
                <div class="field"><label>Transitions JSON</label><textarea id="wfd-transitions" class="draft config-json workflow-definition-json" spellcheck="false"></textarea></div>
              </div>
              <div class="workflow-definition-preview" id="workflowDefinitionPreview"></div>
              <div class="workflow-definition-help">States require key, label, category and optional terminal/sortOrder. Transitions require key, label, from, to and roles.</div>
              <div class="configuration-actions"><button class="btn danger" id="workflow-definition-retire">Retire</button><button class="btnp" id="workflow-definition-save">Save definition</button></div>
              <div class="fbnote" id="workflow-definition-note"></div>
            </div>
            <div class="configuration-panel">
              <div class="panel-head"><h3>Workflow definitions</h3><a class="lnk" href="/api/reporting/workflow-definitions?format=csv" target="_blank" rel="noreferrer" id="workflow-definitions-csv">Definitions CSV</a></div>
              <div class="workflow-definition-list" id="workflowDefinitionList"></div>
            </div>
          </div>
          <div class="configuration-grid lower">
            <div class="configuration-panel">
              <div class="panel-head"><h3>Workflow transition</h3><span class="muted" id="workflowSelectedMeta"></span></div>
              <div id="workflowSelectedCard"></div>
              <div class="workflow-transition-form">
                <div class="frow">
                  <div class="field"><label>Transition</label><select id="workflow-transition"></select></div>
                  <div class="field"><label>Decision</label><input id="workflow-decision" placeholder="Approved, challenge, decision required"/></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Owner</label><input id="workflow-owner" placeholder="Leave blank to keep owner"/></div>
                  <div class="field"><label>Due date</label><input id="workflow-due" type="date"/></div>
                </div>
                <div class="field"><label>Transition note</label><textarea id="workflow-note" class="draft workflow-note" placeholder="Basis for the lifecycle decision or challenge"></textarea></div>
                <button class="btnp" id="workflow-run-transition">Run transition</button>
              </div>
            </div>
            <div class="configuration-panel">
              <div class="panel-head"><h3>Workflow event history</h3><a class="lnk" href="/api/reporting/workflow-events?format=csv" target="_blank" rel="noreferrer">Events CSV</a></div>
              <div class="workflow-event-list" id="workflowEventList"></div>
            </div>
          </div>
        </section>

        <section class="view" id="v-admin">
          <div class="vhead"><div><h1>Admin</h1><div class="sub">Configuration for this tenant</div></div></div>
          <div class="card" style="margin-bottom:16px"><h3 style="font-size:16px;margin-bottom:4px">Users &amp; access</h3><div class="muted" style="font-size:12px;margin-bottom:12px">Add pilot users, change roles or deactivate access for this tenant.</div>
            <div class="toolbar" id="user-form" style="margin-bottom:12px">
              <input id="user-id" type="hidden"/>
              <input id="user-name" placeholder="Name" style="min-width:160px"/>
              <input id="user-email" placeholder="Email" style="min-width:230px"/>
              <select id="user-role"><option>Admin</option><option>Risk Manager</option><option>Contributor</option><option>Viewer</option></select>
              <label class="chkbx"><input type="checkbox" id="user-active" style="width:auto;padding:0" checked/> Active</label>
              <button class="btnp" id="user-save">Save user</button>
              <button class="btn" id="user-clear">Clear</button>
            </div>
            <div style="overflow:auto">
              <table><thead><tr><th>Name</th><th>Email</th><th style="width:130px">Role</th><th style="width:90px">Status</th><th style="width:120px"></th></tr></thead><tbody id="usersTb"></tbody></table>
            </div>
          </div>
          <div class="card package-access-card" id="packageAccessCard" style="margin-bottom:16px">
            <div style="display:flex;justify-content:space-between;gap:12px;align-items:flex-start">
              <div><h3 style="font-size:16px;margin-bottom:4px">Package access</h3><div class="muted" style="font-size:12px;margin-bottom:12px">Restrict a non-admin user to specific work packages. A user with no grants keeps full tenant access; granting one or more packages scopes their risk and programme-intelligence views and edits.</div></div>
              <a class="btn" href="/api/reporting/package-access-grants?format=csv" target="_blank" rel="noreferrer" id="package-grants-csv">Grants CSV</a>
            </div>
            <div class="toolbar package-grant-form" id="package-grant-form" style="margin-bottom:12px">
              <select id="package-grant-user" style="min-width:200px"></select>
              <select id="package-grant-package" style="min-width:220px"></select>
              <select id="package-grant-level"><option value="contribute">Contribute</option><option value="read">Read only</option></select>
              <input id="package-grant-notes" placeholder="Governance note (optional)" style="min-width:200px"/>
              <button class="btnp" id="package-grant-save">Grant access</button>
            </div>
            <div class="fbnote" id="package-grant-note" style="margin-bottom:8px"></div>
            <div style="overflow:auto">
              <table><thead><tr><th>User</th><th style="width:140px">Package</th><th style="width:110px">Access</th><th>Note</th><th style="width:100px"></th></tr></thead><tbody id="packageGrantsTb"></tbody></table>
            </div>
          </div>
          <div class="card compliance-card" id="complianceCard" style="margin-bottom:16px">
            <div style="display:flex;justify-content:space-between;gap:12px;align-items:flex-start">
              <div><h3 style="font-size:16px;margin-bottom:4px">Compliance, retention &amp; backup</h3><div class="muted" style="font-size:12px;margin-bottom:4px">Governed data-retention schedule, backup/restore evidence and the security-control posture register — exportable for security questionnaires and audits.</div></div>
              <div style="display:flex;gap:8px;flex-wrap:wrap">
                <a class="btn" href="/api/reporting/retention-policies?format=csv" target="_blank" rel="noreferrer" id="retention-policies-csv">Retention CSV</a>
                <a class="btn" href="/api/reporting/security-controls?format=csv" target="_blank" rel="noreferrer" id="security-controls-csv">Controls CSV</a>
                <a class="btn" href="/api/reporting/backup-manifests?format=csv" target="_blank" rel="noreferrer" id="backup-manifests-csv">Backups CSV</a>
              </div>
            </div>
            <div class="compliance-kpis" id="complianceKpis"></div>
            <h4 class="compliance-sub">Retention schedule</h4>
            <div class="toolbar compliance-form" id="retention-form" style="margin-bottom:10px">
              <input id="retention-key" placeholder="Policy key (e.g. risk_register)" style="min-width:170px"/>
              <input id="retention-category" placeholder="Data category" style="min-width:180px"/>
              <input id="retention-months" type="number" min="0" placeholder="Months" style="width:90px"/>
              <input id="retention-owner" placeholder="Owner" style="min-width:130px"/>
              <input id="retention-basis" placeholder="Basis" style="min-width:160px"/>
              <button class="btnp" id="retention-save">Add policy</button>
            </div>
            <div style="overflow:auto"><table><thead><tr><th>Category</th><th style="width:90px">Months</th><th style="width:120px">Owner</th><th>Basis</th><th style="width:90px">Status</th><th style="width:90px"></th></tr></thead><tbody id="retentionTb"></tbody></table></div>
            <h4 class="compliance-sub">Security control posture</h4>
            <div class="toolbar compliance-form" id="security-form" style="margin-bottom:10px">
              <input id="security-ref" placeholder="Control ref (e.g. SEC-AC-01)" style="min-width:150px"/>
              <input id="security-domain" placeholder="Domain" style="min-width:140px"/>
              <input id="security-title" placeholder="Control title" style="min-width:200px"/>
              <select id="security-status"><option value="implemented">Implemented</option><option value="partial">Partial</option><option value="planned">Planned</option><option value="not_applicable">N/A</option></select>
              <input id="security-owner" placeholder="Owner" style="min-width:130px"/>
              <button class="btnp" id="security-save">Add control</button>
            </div>
            <div style="overflow:auto"><table><thead><tr><th style="width:120px">Ref</th><th style="width:140px">Domain</th><th>Title</th><th style="width:120px">Status</th><th style="width:120px">Owner</th></tr></thead><tbody id="securityTb"></tbody></table></div>
            <h4 class="compliance-sub">Backup &amp; restore evidence</h4>
            <div class="toolbar compliance-form" id="backup-form" style="margin-bottom:10px">
              <input id="backup-location" placeholder="Storage location (off-repo)" style="min-width:220px"/>
              <input id="backup-checksum" placeholder="Checksum" style="min-width:160px"/>
              <select id="backup-status"><option value="recorded">Recorded</option><option value="verified">Verified</option><option value="restore_tested">Restore tested</option><option value="failed">Failed</option></select>
              <input id="backup-performer" placeholder="Performed by" style="min-width:130px"/>
              <button class="btnp" id="backup-save">Record backup</button>
            </div>
            <div style="overflow:auto"><table><thead><tr><th style="width:150px">When</th><th>Location</th><th style="width:120px">Status</th><th style="width:130px">Operator</th></tr></thead><tbody id="backupTb"></tbody></table></div>
            <div class="fbnote" id="compliance-note"></div>
          </div>
          <div class="card integrations-card" id="integrationsCard" style="margin-bottom:16px">
            <div style="display:flex;justify-content:space-between;gap:12px;align-items:flex-start">
              <div><h3 style="font-size:16px;margin-bottom:4px">External integration readiness</h3><div class="muted" style="font-size:12px;margin-bottom:4px">Governed disposition for each external integration (SSO group mapping, Power BI refresh, email and Teams delivery, scheduled dispatch, native binary storage): record configuration, attest readiness, or formally scope out with documented evidence and an external-dependency note.</div></div>
              <a class="btn" href="/api/reporting/integration-settings?format=csv" target="_blank" rel="noreferrer" id="integration-settings-csv">Integrations CSV</a>
            </div>
            <div class="integration-kpis" id="integrationKpis"></div>
            <div class="integration-list" id="integrationList"></div>
            <div class="fbnote" id="integration-note"></div>
          </div>
          <div class="card" style="margin-bottom:16px"><div style="display:flex;justify-content:space-between;gap:12px;align-items:flex-start"><div><h3 style="font-size:16px;margin-bottom:4px">Audit trail</h3><div class="muted" style="font-size:12px;margin-bottom:12px">Latest tenant changes, kept as record-level history.</div></div><div style="display:flex;gap:8px"><button class="btn" id="audit-refresh">Refresh</button><button class="btn" id="audit-export">Export CSV</button></div></div>
            <div style="overflow:auto">
              <table><thead><tr><th style="width:132px">When</th><th style="width:150px">User</th><th style="width:92px">Action</th><th style="width:112px">Record</th><th>Summary</th></tr></thead><tbody id="auditTb"></tbody></table>
            </div>
          </div>
          <div class="card structure-admin" id="structureAdmin" style="margin-bottom:16px">
            <div class="panel-head"><div><h3>Programme structure and taxonomies</h3><div class="muted" style="font-size:12px;margin-top:4px">Governed RBS, WBS, CBS and OBS libraries for major-project mapping, QRA and Power BI.</div></div><span class="muted" id="taxonomySummary"></span></div>
            <div class="structure-export-row">
              <a class="btn" href="/api/reporting/projects?format=csv" target="_blank" rel="noreferrer">Projects CSV</a>
              <a class="btn" href="/api/reporting/packages?format=csv" target="_blank" rel="noreferrer">Packages CSV</a>
              <a class="btn" href="/api/reporting/taxonomy-items?format=csv" target="_blank" rel="noreferrer">Taxonomy CSV</a>
            </div>
            <div class="structure-kpis" id="structureKpis"></div>
            <div class="structure-admin-grid">
              <div class="structure-panel">
                <div class="toolbar structure-toolbar">
                  <select id="tax-filter"><option value="">All taxonomies</option><option value="rbs">RBS</option><option value="wbs">WBS</option><option value="cbs">CBS</option><option value="obs">OBS</option></select>
                  <input id="tax-search" placeholder="Search code, name, parent or owner"/>
                </div>
                <div class="taxonomy-list" id="taxonomyList"></div>
              </div>
              <div class="structure-panel structure-form">
                <input id="tax-id" type="hidden"/>
                <div class="frow">
                  <div class="field"><label>Type</label><select id="tax-type"><option value="rbs">RBS</option><option value="wbs">WBS</option><option value="cbs">CBS</option><option value="obs">OBS</option></select></div>
                  <div class="field"><label>Status</label><select id="tax-status"><option value="active">Active</option><option value="inactive">Inactive</option></select></div>
                </div>
                <div class="frow">
                  <div class="field"><label>Code</label><input id="tax-code" placeholder="e.g. WBS-1.2.3"/></div>
                  <div class="field"><label>Parent code</label><input id="tax-parent" placeholder="Optional"/></div>
                </div>
                <div class="field"><label>Name</label><input id="tax-name" placeholder="Taxonomy item name"/></div>
                <div class="frow">
                  <div class="field"><label>Owner / function</label><input id="tax-owner" placeholder="Accountable owner"/></div>
                  <div class="field"><label>Sort order</label><input id="tax-sort" type="number" value="0"/></div>
                </div>
                <div class="field"><label>Description</label><textarea id="tax-description" class="draft structure-description" placeholder="Use, scope, mapping notes or import source"></textarea></div>
                <div class="structure-actions"><button class="btn" id="tax-clear">Clear</button><button class="btnp" id="tax-save">Save item</button></div>
                <div class="structure-import">
                  <label>CSV import</label>
                  <textarea id="tax-import" class="draft" placeholder="type,code,name,parent_code,owner,status,description,sort_order"></textarea>
                  <div class="structure-actions"><button class="btn" id="tax-sample">Sample</button><button class="btnp" id="tax-import-btn">Import rows</button></div>
                </div>
              </div>
            </div>
          </div>
          <div class="card" style="margin-bottom:16px"><h3 style="font-size:16px;margin-bottom:4px">Risk categories</h3><div class="muted" style="font-size:12px;margin-bottom:12px">Rename, add or remove categories — one layer, applied across the register.</div><div id="cats"></div></div>
          <div class="card" style="margin-bottom:16px"><h3 style="font-size:16px;margin-bottom:4px">Scoring scales <span class="muted" style="font-size:12px">· editable qualitative 5 × 5</span></h3><div class="muted" style="font-size:12px;margin-bottom:12px">Rename the descriptors or move the rating thresholds — changes apply across the whole register.</div><div id="scales"></div></div>
          <div class="grid2">
            <div class="card permission-card"><h3 style="font-size:16px;margin-bottom:10px">Roles &amp; permissions</h3>
              <div class="permission-summary" id="permissionSummary"></div>
              <div class="permission-table-wrap"><table class="permission-table" id="permissionMatrix"></table></div>
            </div>
            <div class="card"><h3 style="font-size:16px;margin-bottom:12px">Branding &amp; access</h3>
              <div class="muted" style="font-size:13px;margin-bottom:10px">Tenant: ${esc(session.tenant.name)}</div>
              <div style="display:flex;gap:10px;margin-bottom:14px">
                <span style="width:40px;height:40px;border-radius:8px;background:#003366" title="Navy #003366"></span>
                <span style="width:40px;height:40px;border-radius:8px;background:#00728A" title="Teal #00728A"></span>
                <span style="width:40px;height:40px;border-radius:8px;background:#4BACC6" title="Light teal #4BACC6"></span>
                <span style="width:40px;height:40px;border-radius:8px;background:#D6EAF0;border:1px solid var(--line)" title="Ice #D6EAF0"></span>
              </div>
              <div style="font-size:13px;line-height:2">
                <div>White-label theming &nbsp;<span class="pill o-managed">Enabled</span></div>
                <div>Single sign-on &nbsp;<span class="pill o-managed">Microsoft Entra ready</span></div>
                <div>Power BI / CSV export &nbsp;<span class="pill o-managed">On</span></div>
                <div>Hosting &nbsp;<span class="pill" style="background:var(--ice);color:var(--navy)">SaaS · Cloudflare</span></div>
              </div>
            </div>
          </div>
        </section>

        <section id="report"></section>
      </main>
    </div>

    <button class="fab" id="fabFeedback" aria-label="Send feedback"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>Feedback</button>

    ${feedbackModal()}
    ${riskDetailModal()}
    ${riskFormModal()}
    ${quantificationModal()}
    ${appetiteEscalationModal()}
  `;
  // Masthead carries the white-on-navy Risk Studio mark (set in markup); no override needed.
}

function feedbackModal() {
  return `
    <div class="ovl" id="fbmodal" role="dialog" aria-modal="true" aria-labelledby="fbmodal-title">
      <div class="sheet" style="max-width:560px">
        <div style="display:flex;align-items:flex-start"><div><h2 id="fbmodal-title">Share your feedback</h2><div class="muted" style="font-size:12px;margin-top:3px">Goes to the SOMA team to shape the next version.</div></div><button class="x" id="fb-x" aria-label="Close">&times;</button></div>
        <div id="fbform">
          <div class="field" style="margin-top:14px"><label>Your name (optional)</label><input id="fb-name" placeholder="e.g. Ray Sloane"/></div>
          <div class="field"><label>Area</label><select id="fb-area"><option>Overall impression</option><option>Register</option><option>Dashboard</option><option>Reports / PDF</option><option>Scoring</option><option>Reviews</option><option>Admin</option><option>Something else</option></select></div>
          <div class="field"><label>Overall</label><div class="sentiment" id="fb-sent"><button type="button" data-s="Very positive">Very positive</button><button type="button" data-s="Positive">Positive</button><button type="button" data-s="Mixed">Mixed</button><button type="button" data-s="Needs work">Needs work</button></div></div>
          <div class="field"><label>Comments</label><textarea id="fb-comments" class="draft" style="height:120px;margin-top:0" placeholder="What works, what doesn't, what's missing…"></textarea></div>
          <div class="fbnote" id="fb-err" style="color:#A32D2D;display:none">Please add a comment before sending.</div>
          <div style="display:flex;justify-content:flex-end;gap:8px;margin-top:10px"><button class="btn" id="fb-cancel">Cancel</button><button class="btnp" id="fb-send">Send feedback</button></div>
        </div>
        <div id="fbthanks" style="display:none" class="fbok"><div class="tick">&#10003;</div><div style="font-family:var(--font-head);color:var(--navy);font-size:18px">Thank you</div><div class="muted" id="fbthanks-sub" style="font-size:13px;margin-top:6px">Your feedback has been sent to the SOMA team.</div><div style="margin-top:16px"><button class="btnp" id="fb-done">Done</button></div></div>
      </div>
    </div>`;
}

function riskDetailModal() {
  return `
    <div class="ovl" id="modal" role="dialog" aria-modal="true" aria-labelledby="m-title">
      <div class="sheet detail-sheet">
        <div class="detail-head">
          <div class="detail-titlebar">
            <div><div class="detail-id" id="m-id"></div><h2 id="m-title"></h2></div>
            <button class="x" id="m-x" aria-label="Close">&times;</button>
          </div>
          <div class="meta" id="m-meta"></div>
        </div>
        <div class="detail-body">
          <div class="detail-focusbar" id="m-focusbar">
            <span class="focus-nav" id="m-focusnav"></span>
            <span class="focus-actions">
              <button class="chip-btn" id="m-expand-all" type="button">Expand all</button>
              <button class="chip-btn" id="m-collapse-all" type="button">Collapse all</button>
            </span>
          </div>
          <div class="cegrid">
            <div class="ceitem"><div class="celab">Cause</div><div id="m-cause"></div></div>
            <div class="ceitem"><div class="celab">Event</div><div id="m-event"></div></div>
            <div class="ceitem"><div class="celab">Effect</div><div id="m-effect"></div></div>
          </div>
          <div class="detail-section" data-sec="strategy" data-sec-label="Mitigation strategy">
            <div class="seclab">Mitigation strategy</div>
            <div class="strategy-copy" id="m-strategy"></div>
          </div>
          <div class="scoregrid">
            <div class="scorecard"><div class="l">Pre-mitigation</div><div id="m-pre" class="scoreval"></div></div>
            <div class="scorecard"><div class="l">Residual</div><div id="m-post" class="scoreval"></div></div>
            <div class="scorecard exposure-card"><div class="l">Exposure</div><div id="m-exp" class="scoreval exposure-val"></div></div>
          </div>
          <div class="detail-section" data-sec="bowtie" data-sec-label="Bow-tie controls">
            <div class="actions-head"><h3>Bow-tie controls and assurance</h3><div class="actions-inline"><button class="btn" id="m-controls-open">Controls</button><a class="lnk" href="/api/reporting/bowtie-controls?format=csv" target="_blank" rel="noreferrer">Bow-tie CSV</a></div></div>
            <div class="risk-bowtie-detail" id="m-bowtie"></div>
          </div>
          <div class="detail-section collapsed" data-sec="qra" data-sec-label="QRA & governance">
            <div class="actions-head"><h3>QRA and governance</h3><button class="btn" id="m-quant-open">Quantify risk</button></div>
            <div class="qra-detail" id="m-qra"></div>
          </div>
          <div class="detail-section collapsed" data-sec="appetite" data-sec-label="Appetite & escalation">
            <div class="actions-head"><h3>Risk appetite and escalation</h3><button class="btn" id="m-appetite-open">Record escalation</button></div>
            <div class="risk-appetite-panel" id="m-appetite"></div>
          </div>
          <div class="detail-section collapsed" data-sec="workshops" data-sec-label="Workshops">
            <div class="actions-head"><h3>Workshop decisions and QRA challenge</h3><a class="lnk" href="/api/reporting/risk-workshop-decisions?format=csv" target="_blank" rel="noreferrer">Decisions CSV</a></div>
            <div class="risk-workshop-panel" id="m-workshops"></div>
          </div>
          <div class="detail-section collapsed" data-sec="indicators" data-sec-label="KRIs & triggers">
            <div class="actions-head"><h3>KRIs, triggers and early warnings</h3><div class="actions-inline"><button class="btn" id="m-indicator-new">New indicator</button><a class="lnk" href="/api/reporting/risk-indicators?format=csv" target="_blank" rel="noreferrer">Indicators CSV</a></div></div>
            <div class="risk-indicator-panel" id="m-indicators"></div>
            <div class="risk-indicator-admin" id="m-indicator-admin"></div>
          </div>
          <div class="detail-section collapsed" data-sec="exposure" data-sec-label="Exposure profile">
            <div class="actions-head"><h3>Lifecycle exposure profile</h3><a class="lnk" href="/api/reporting/qra-exposure-states?format=csv" target="_blank" rel="noreferrer">State CSV</a></div>
            <div class="risk-exposure-profile" id="m-exposure-profile"></div>
          </div>
          <div class="detail-section collapsed" data-sec="config" data-sec-label="Configuration">
            <div class="actions-head"><h3>Risk configuration and workflow</h3><button class="btn" id="m-config-open">Configuration</button></div>
            <div class="risk-object-governance" id="m-object-governance"></div>
          </div>
          <div class="detail-section collapsed" data-sec="timeline" data-sec-label="History &amp; timeline">
            <div class="actions-head"><h3>Risk history and timeline</h3><button class="btn" id="m-timeline-refresh">Refresh</button></div>
            <div class="risk-timeline" id="m-timeline"></div>
          </div>
          <div class="actions-head">
            <h3>Mitigation actions</h3>
            <button class="btn" id="m-addbtn">+ Add action</button>
          </div>
          <div id="m-actions" class="action-list"></div>
          <div id="m-addform" class="action-form" style="display:none">
            <input id="m-atask" placeholder="Mitigation action" style="width:100%;margin-bottom:8px"/>
            <div class="action-form-grid">
              <div class="field"><label>Owner</label><input id="m-aowner" placeholder="Owner"/></div>
              <div class="field"><label>Response</label><select id="m-response-type"><option value="mitigate">Mitigate</option><option value="avoid">Avoid</option><option value="transfer">Transfer</option><option value="accept">Accept</option><option value="exploit">Exploit</option><option value="enhance">Enhance</option></select></div>
              <div class="field"><label>Priority</label><select id="m-apriority"><option value="low">Low</option><option value="medium">Medium</option><option value="high">High</option><option value="critical">Critical</option></select></div>
              <div class="field"><label>Status</label><select id="m-astatus"><option>Open</option><option>In progress</option><option>Done</option></select></div>
              <div class="field"><label>Baseline date</label><input id="m-abase" type="date"/></div>
              <div class="field"><label>Current date</label><input id="m-adue" type="date"/></div>
              <div class="field"><label>% complete</label><input id="m-apct" type="number" min="0" max="100" step="5"/></div>
              <div class="field"><label>Effectiveness</label><select id="m-aeffect"><option value="not_assessed">Not assessed</option><option value="effective">Effective</option><option value="partially_effective">Partially effective</option><option value="ineffective">Ineffective</option></select></div>
              <div class="field"><label>Forecast cost (£k)</label><input id="m-afcost" type="number" min="0" step="1"/></div>
              <div class="field"><label>Actual cost (£k)</label><input id="m-aacost" type="number" min="0" step="1"/></div>
              <div class="field"><label>Forecast days</label><input id="m-afdays" type="number" min="0" step="0.5"/></div>
              <div class="field"><label>Actual days</label><input id="m-aadays" type="number" min="0" step="0.5"/></div>
              <div class="field"><label>Linked control</label><input id="m-acontrol" placeholder="control id"/></div>
              <div class="field"><label>Evidence ref</label><input id="m-aevidence" placeholder="EVID-..."/></div>
              <div class="field wide"><label>Progress note</label><textarea id="m-anote" placeholder="Progress, blocker, mitigation benefit or evidence basis"></textarea></div>
              <div class="field"><label>Completed at</label><input id="m-acompleted" type="date"/></div>
            </div>
            <div style="display:flex;justify-content:flex-end;gap:8px;margin-top:10px"><button class="btn" id="m-acancel">Cancel</button><button class="btn" id="m-aprogress">Record progress</button><button class="btnp" id="m-asave">Add action</button></div>
          </div>
          <textarea class="draft" id="m-emailbox" style="display:none" readonly></textarea>
        </div>
        <div class="detail-footer">
          <div class="footer-actions"><button class="btn" id="m-draft">Generate planner email</button><button class="btn danger" id="m-delete">Delete risk</button></div>
          <div class="footer-actions footer-actions-right"><button class="btn" id="m-edit">Edit risk</button><button class="btnp" id="m-close">Close</button></div>
        </div>
      </div>
    </div>`;
}

function riskFormModal() {
  return `
    <div class="ovl" id="riskmodal" role="dialog" aria-modal="true" aria-labelledby="rm-title">
      <div class="sheet">
        <div style="display:flex;align-items:flex-start"><h2 id="rm-title">New risk</h2><button class="x" id="rm-x" aria-label="Close">&times;</button></div>
        <div class="field" style="margin-top:12px"><label>Risk title</label><input id="rm-rtitle" placeholder="Describe the risk"/></div>
        <div class="frow">
          <div class="field"><label>Category</label><select id="rm-cat"></select></div>
          <div class="field"><label>Owner</label><input id="rm-owner" placeholder="Name"/></div>
          <div class="field"><label>Status</label><select id="rm-status"><option>Open</option><option>Managed</option><option>Closed</option></select></div>
        </div>
        <div class="field"><label>Cause</label><input id="rm-cause"/></div>
        <div class="field"><label>Event</label><input id="rm-event"/></div>
        <div class="field"><label>Effect</label><input id="rm-effect"/></div>
        <div class="field"><label>Mitigation strategy</label><textarea id="rm-strategy" style="min-height:60px" placeholder="Overall approach to managing this risk"></textarea></div>
        <div class="frow">
          <div class="field"><label>Likelihood (pre)</label><select id="rm-lpre"></select></div>
          <div class="field"><label>Impact (pre)</label><select id="rm-ipre"></select></div>
        </div>
        <div class="frow">
          <div class="field"><label>Residual likelihood</label><select id="rm-lpost"></select></div>
          <div class="field"><label>Residual impact</label><select id="rm-ipost"></select></div>
        </div>
        <div class="frow">
          <div class="field"><label>Exposure (£k)</label><input id="rm-exp" type="number" min="0"/></div>
          <div class="field"><label>Next review</label><input id="rm-due" type="date"/></div>
        </div>
        <div class="fbnote" id="rm-preview" style="margin-bottom:6px"></div>
        <div style="display:flex;justify-content:flex-end;gap:8px;margin-top:4px"><button class="btn" id="rm-cancel">Cancel</button><button class="btnp" id="rm-save">Save risk</button></div>
      </div>
    </div>`;
}

function appetiteEscalationModal() {
  return `
    <div class="ovl" id="appetitemodal" role="dialog" aria-modal="true" aria-labelledby="appetitemodal-title">
      <div class="sheet appetite-sheet">
        <div class="modal-head">
          <div><h2 id="appetitemodal-title">Risk appetite escalation</h2><div class="muted" id="appetite-risk-sub" style="font-size:12px;margin-top:3px"></div></div>
          <button class="x" id="appetite-x" aria-label="Close">&times;</button>
        </div>
        <div class="appetite-modal-grid">
          <div class="card appetite-modal-card">
            <h3>Assessment</h3>
            <div class="frow">
              <div class="field"><label>Appetite status</label><select id="appetite-status"><option value="within_appetite">Within appetite</option><option value="monitor">Monitor</option><option value="breach">Breach</option><option value="critical_breach">Critical breach</option><option value="accepted_exposure">Accepted exposure</option></select></div>
              <div class="field"><label>Assessment status</label><select id="appetite-assessment-status"><option value="open">Open</option><option value="in_review">In review</option><option value="accepted">Accepted</option><option value="mitigation_required">Mitigation required</option><option value="closed">Closed</option><option value="waived">Waived</option></select></div>
            </div>
            <div class="frow">
              <div class="field"><label>Escalation level</label><input id="appetite-level" placeholder="Programme / Sponsor / Client board"/></div>
              <div class="field"><label>Escalation forum</label><input id="appetite-forum" placeholder="Programme board"/></div>
            </div>
            <div class="frow">
              <div class="field"><label>Decision due</label><input id="appetite-due" type="date"/></div>
              <div class="field"><label>Next review</label><input id="appetite-review" type="date"/></div>
            </div>
            <div class="field"><label>Decision required</label><textarea id="appetite-decision" class="draft appetite-textarea"></textarea></div>
            <div class="field"><label>Assessment note</label><textarea id="appetite-note" class="draft appetite-textarea"></textarea></div>
          </div>
          <div class="card appetite-modal-card">
            <h3>Escalation event</h3>
            <div class="frow">
              <div class="field"><label>Event type</label><select id="appetite-event-type"><option value="raised">Raised</option><option value="reviewed">Reviewed</option><option value="accepted">Accepted</option><option value="mitigation_required">Mitigation required</option><option value="closed">Closed</option><option value="waived">Waived</option></select></div>
              <div class="field"><label>Event due</label><input id="appetite-event-due" type="date"/></div>
            </div>
            <div class="field"><label>Decision</label><input id="appetite-event-decision" placeholder="Decision or outcome"/></div>
            <div class="field"><label>Event note</label><textarea id="appetite-event-note" class="draft appetite-textarea"></textarea></div>
            <div class="risk-appetite-history" id="appetite-event-history"></div>
          </div>
        </div>
        <div class="modal-actions">
          <button class="btn" id="appetite-cancel">Cancel</button>
          <button class="btn" id="appetite-save-assessment">Save assessment</button>
          <button class="btnp" id="appetite-record-event">Save and record event</button>
        </div>
      </div>
    </div>`;
}

function quantificationModal() {
  const stateTabs = `
    <button type="button" class="quant-state-tab" id="q-state-inherent" data-exposure-state="inherent">Inherent</button>
    <button type="button" class="quant-state-tab" id="q-state-current" data-exposure-state="current">Current</button>
    <button type="button" class="quant-state-tab" id="q-state-target" data-exposure-state="target">Forecast</button>
    <button type="button" class="quant-state-tab" id="q-state-post_mitigation" data-exposure-state="post_mitigation">Actual</button>`;
  return `
    <div class="ovl" id="quantmodal" role="dialog" aria-modal="true" aria-labelledby="quantmodal-title">
      <div class="sheet quant-sheet">
        <div style="display:flex;align-items:flex-start;gap:12px">
          <div><h2 id="quantmodal-title">Quantitative risk data</h2><div class="muted" id="q-risk-sub" style="font-size:12px;margin-top:3px">Lifecycle cost and schedule assumptions for QRA.</div></div>
          <button class="x" id="q-x" aria-label="Close">&times;</button>
        </div>
        <div class="quant-derived" id="q-derived"></div>
        <div class="quant-governance" id="q-governance"></div>
        <div class="quant-grid">
          <div class="quant-section">
            <h3>QRA decision and gate</h3>
            <div class="frow">
              <div class="field"><label>Inclusion</label><select id="q-inclusion"><option value="candidate">Candidate</option><option value="included">Included</option><option value="excluded">Excluded</option></select></div>
              <div class="field"><label>Readiness gate</label><select id="q-quality"><option value="incomplete">Incomplete</option><option value="needs_review">Needs review</option><option value="ready">Ready</option></select></div>
            </div>
            <div class="field"><label>Exclusion reason</label><input id="q-exclusion" placeholder="Only required when excluded"/></div>
          </div>
          <div class="quant-section">
            <h3>Programme mapping</h3>
            <div class="mapping-note" id="q-project"></div>
            <div class="frow">
              <div class="field"><label>WBS code</label><input id="q-wbs" placeholder="e.g. 1.2.4"/></div>
              <div class="field"><label>CBS code</label><input id="q-cbs" placeholder="e.g. C-3100"/></div>
            </div>
            <div class="field"><label>Schedule activity / milestone</label><input id="q-activity" placeholder="Primavera / MSP activity ID"/></div>
          </div>
          <div class="quant-section span2">
            <h3>Exposure states</h3>
            <div class="quant-state-tabs" id="q-state-tabs">${stateTabs}</div>
            <div class="quant-state-note" id="q-state-note"></div>
            <div class="frow">
              <div class="field"><label>Probability (%)</label><input id="q-prob" type="number" min="0" max="100" step="0.01"/></div>
              <div class="field"><label>Distribution</label><select id="q-dist"><option value="triangular">Triangular</option><option value="pert">PERT</option><option value="normal">Normal</option><option value="lognormal">Lognormal</option><option value="discrete">Discrete</option><option value="fixed">Fixed</option><option value="other">Other</option></select></div>
              <div class="field"><label>State data quality</label><select id="q-state-quality"><option value="incomplete">Incomplete</option><option value="needs_review">Needs review</option><option value="ready">Ready</option></select></div>
              <div class="field"><label>Confidence</label><select id="q-state-confidence"><option value="">Not set</option><option value="low">Low</option><option value="medium">Medium</option><option value="high">High</option></select></div>
            </div>
            <div class="quant-state-grid">
              <div class="quant-subsection">
                <h4>Cost impact (£k)</h4>
                <div class="frow">
                  <div class="field"><label>Low</label><input id="q-cost-low" type="number" min="0" step="0.01"/></div>
                  <div class="field"><label>Most likely</label><input id="q-cost-ml" type="number" min="0" step="0.01"/></div>
                  <div class="field"><label>High</label><input id="q-cost-high" type="number" min="0" step="0.01"/></div>
                </div>
              </div>
              <div class="quant-subsection">
                <h4>Schedule impact (days)</h4>
                <div class="frow">
                  <div class="field"><label>Low</label><input id="q-sch-low" type="number" min="0" step="0.01"/></div>
                  <div class="field"><label>Most likely</label><input id="q-sch-ml" type="number" min="0" step="0.01"/></div>
                  <div class="field"><label>High</label><input id="q-sch-high" type="number" min="0" step="0.01"/></div>
                </div>
              </div>
            </div>
            <div class="frow">
              <div class="field"><label>Effective from</label><input id="q-effective-from" type="date"/></div>
              <div class="field"><label>Effective to</label><input id="q-effective-to" type="date"/></div>
            </div>
            <div class="field"><label>State basis</label><textarea id="q-state-basis" class="draft quant-state-basis" placeholder="Evidence, control assumptions, action dependency, estimating source"></textarea></div>
            <div class="quant-state-evidence">
              <div class="panel-head compact-head"><h4>State evidence and assumptions</h4><span class="muted" id="q-state-evidence-count"></span></div>
              <textarea id="q-state-evidence" class="draft quant-state-evidence-textarea" spellcheck="false" placeholder="One per line: EVID-ASB-RD-001, basis, Survey pack supports this state"></textarea>
              <div class="quant-state-evidence-list" id="q-state-evidence-list"></div>
            </div>
          </div>
          <div class="quant-section span2">
            <h3>Risk window, correlation and basis</h3>
            <div class="frow">
              <div class="field"><label>Window start</label><input id="q-window-start" type="date"/></div>
              <div class="field"><label>Window end</label><input id="q-window-end" type="date"/></div>
              <div class="field"><label>Correlation group</label><input id="q-correlation" placeholder="e.g. utilities-diversions"/></div>
            </div>
            <div class="field"><label>Quantification assumptions</label><textarea id="q-notes" class="draft quant-notes" placeholder="Basis of estimate, source data, inclusions/exclusions, modelling assumptions"></textarea></div>
          </div>
        </div>
        <div class="quant-workflow-note">
          <div class="field"><label>Workflow note</label><input id="q-workflow-note" placeholder="Reason for submission, approval, challenge or rejection"/></div>
          <div class="quant-attestation" id="q-attestation">
            <label class="checkline"><input id="q-attest" type="checkbox"/>I attest this quantitative record is ready for QRA handoff.</label>
            <textarea id="q-attestation-statement" class="draft quant-attestation-statement" readonly></textarea>
            <div class="quant-attestation-latest" id="q-attestation-latest"></div>
          </div>
        </div>
        <div class="fbnote" id="q-error" style="display:none;color:#A32D2D"></div>
        <div style="display:flex;justify-content:flex-end;gap:8px;margin-top:14px"><button class="btn" id="q-cancel">Cancel</button><button class="btnp" id="q-save">Save quantitative data</button></div>
      </div>
    </div>`;
}

function bindShell() {
  document.querySelectorAll(".nav").forEach((n) => n.addEventListener("click", () => navTo((n as HTMLElement).dataset.v || "register")));
  $("logoutBtn").addEventListener("click", async () => {
    if (session?.authSource === "access") {
      window.location.href = "/cdn-cgi/access/logout";
      return;
    }
    await logout();
    session = null;
    renderLogin();
  });
  ["search", "fcat", "fstatus"].forEach((id) => $(id).addEventListener("input", renderTable));
  $("fhigh").addEventListener("change", renderTable);
  document.querySelectorAll("th.sortable").forEach((th) => {
    // Make sortable headers keyboard-operable (WCAG 2.1.1). Keep the native columnheader role +
    // aria-sort (the correct sortable-column pattern); do not override with role=button.
    th.setAttribute("tabindex", "0");
    const sort = () => {
      const k = (th as HTMLElement).dataset.k || "post";
      if (sortK === k) sortDir *= -1;
      else {
        sortK = k;
        sortDir = k === "pre" || k === "post" || k === "due" ? -1 : 1;
      }
      renderTable();
    };
    th.addEventListener("click", sort);
    th.addEventListener("keydown", (e) => {
      const ke = e as KeyboardEvent;
      if (ke.key === "Enter" || ke.key === " ") {
        e.preventDefault();
        sort();
      }
    });
  });

  $("newBtn").addEventListener("click", () => openRiskForm(null));
  $("control-add-risk").addEventListener("click", () => openRiskForm(null));
  $("control-reporting").addEventListener("click", () => navTo("reporting"));
  $("control-qra-workbench").addEventListener("click", () => navTo("qra"));
  $("programme-refresh").addEventListener("click", () => void refreshProgrammeItems());
  $("programme-new").addEventListener("click", () => {
    clearProgrammeItemForm();
    $("pi-title").focus();
  });
  $("programme-clear").addEventListener("click", clearProgrammeItemForm);
  $("programme-save").addEventListener("click", () => void saveProgrammeItemFromForm());
  $("programme-retire").addEventListener("click", () => void retireProgrammeItemFromView());
  ["programme-search", "programme-type-filter", "programme-status-filter"].forEach((id) => $(id).addEventListener("input", renderProgrammeItems));
  $("programmeItemList").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-programme-action]") as HTMLElement | null;
    if (!button) return;
    const code = button.dataset.programmeCode || "";
    const action = button.dataset.programmeAction || "";
    if (action === "edit") fillProgrammeItemForm(code);
    if (action === "retire") void retireProgrammeItemFromView(code);
  });
  $("imports-refresh").addEventListener("click", () => void refreshImports());
  $("import-sample").addEventListener("click", seedImportSample);
  $("import-template-select").addEventListener("change", renderImportTemplateHelp);
  $("import-template-load").addEventListener("click", loadSelectedImportTemplate);
  $("import-template-download").addEventListener("click", downloadSelectedImportTemplate);
  $("import-excel-paste").addEventListener("click", loadExcelPasteSample);
  $("import-excel-pack").addEventListener("click", downloadExcelWorkbookPack);
  $("import-mapping-refresh").addEventListener("click", renderImportFieldMapper);
  $("import-mapping-apply").addEventListener("click", applyImportFieldMappings);
  $("import-mapping-profile-select").addEventListener("change", fillSelectedImportMappingProfile);
  $("import-mapping-profile-load").addEventListener("click", loadSelectedImportMappingProfile);
  $("import-mapping-profile-save").addEventListener("click", () => void saveImportMappingProfileFromView());
  $("import-mapping-profile-retire").addEventListener("click", () => void retireSelectedImportMappingProfile());
  $("import-validation-rule-target").addEventListener("change", renderImportValidationRuleFields);
  $("import-validation-rule-check").addEventListener("change", renderImportValidationRuleFields);
  $("import-validation-rule-clear").addEventListener("click", clearImportValidationRuleForm);
  $("import-validation-rule-save").addEventListener("click", () => void saveImportValidationRuleFromView());
  $("import-validation-rule-retire").addEventListener("click", () => void retireImportValidationRuleFromView());
  $("importValidationRuleList").addEventListener("click", (event) => {
    const card = (event.target as HTMLElement).closest("[data-import-validation-rule-id]") as HTMLElement | null;
    if (!card) return;
    fillImportValidationRuleForm(card.dataset.importValidationRuleId || "");
  });
  $("import-csv").addEventListener("input", renderImportFieldMapper);
  $("import-validate").addEventListener("click", () => void runImportFromView(false));
  $("import-run").addEventListener("click", () => void runImportFromView($<HTMLInputElement>("import-commit").checked));
  $("import-target").addEventListener("change", () => {
    seedImportSample();
    renderImportMappingProfiles();
    renderImportFieldMapper();
    renderImportValidationRuleFields();
    renderImportValidationRules();
  });
  $("importBatchList").addEventListener("click", (event) => {
    const card = (event.target as HTMLElement).closest("[data-import-batch-id]") as HTMLElement | null;
    if (card) void selectImportBatch(card.dataset.importBatchId || "");
  });
  $("importRowList").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-import-resolution-save]") as HTMLElement | null;
    if (button) void saveImportRowResolutionFromView(button.dataset.importResolutionSave || "");
  });
  $("export-generate").addEventListener("click", () => void generateExportFromView());
  $("export-download").addEventListener("click", () => void downloadActiveExportCsv());
  $("reconcile-load-baseline").addEventListener("click", () => void loadBaselineCsvIntoReconcile());
  $("export-reconcile").addEventListener("click", () => void reconcileReturnedExportFromView());
  $("export-target").addEventListener("change", () => {
    setValue("export-file", `${value("export-target") === "programme_items" ? "programme-intelligence" : "risk-register"}-export.csv`);
  });
  $("exportBatchList").addEventListener("click", (event) => {
    const card = (event.target as HTMLElement).closest("[data-export-batch-id]") as HTMLElement | null;
    if (card) void selectExportBatch(card.dataset.exportBatchId || "");
  });
  $("exportReconcileRuns").addEventListener("click", (event) => {
    const card = (event.target as HTMLElement).closest("[data-reconciliation-run-id]") as HTMLElement | null;
    if (card) void selectReconciliationRun(card.dataset.reconciliationRunId || "");
  });
  $("schedule-sample").addEventListener("click", seedScheduleSample);
  $("schedule-validate").addEventListener("click", () => void runScheduleImport(false));
  $("schedule-run").addEventListener("click", () => void runScheduleImport($<HTMLInputElement>("schedule-commit").checked));
  $("cost-sample").addEventListener("click", seedCostSample);
  $("cost-validate").addEventListener("click", () => void runCostImport(false));
  $("cost-run").addEventListener("click", () => void runCostImport($<HTMLInputElement>("cost-commit").checked));
  $("evidence-refresh").addEventListener("click", () => void refreshEvidence());
  $("evidence-new").addEventListener("click", () => {
    clearEvidenceForm();
    $("evidence-title").focus();
  });
  $("evidence-clear").addEventListener("click", clearEvidenceForm);
  $("evidence-save").addEventListener("click", () => void saveEvidenceFromForm());
  $("evidence-archive").addEventListener("click", () => void archiveEvidenceFromView());
  $("attachment-save").addEventListener("click", () => void saveEvidenceAttachmentFromForm());
  $("package-save").addEventListener("click", () => void saveEvidencePackageFromForm());
  $("package-seal").addEventListener("click", () => void sealEvidencePackageFromView());
  $("package-clear").addEventListener("click", clearEvidencePackageForm);
  ["evidence-search", "evidence-type-filter", "evidence-status-filter"].forEach((id) => $(id).addEventListener("input", renderEvidence));
  $("evidenceList").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-evidence-id]") as HTMLElement | null;
    if (!button) return;
    const id = button.dataset.evidenceId || "";
    if (button.dataset.evidenceAction === "archive") void archiveEvidenceFromView(id);
    else void selectEvidence(id);
  });
  $("evidenceAttachmentList").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-attachment-action]") as HTMLElement | null;
    if (!button) return;
    if (button.dataset.attachmentAction === "archive") void archiveEvidenceAttachmentFromView(button.dataset.attachmentId || "");
    if (button.dataset.attachmentAction === "upload") triggerAttachmentUpload(button.dataset.attachmentId || "");
  });
  $("attachment-bytes-input").addEventListener("change", () => void uploadAttachmentBytesFromUi());
  $("evidencePackageList").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-package-action]") as HTMLElement | null;
    if (!button) return;
    const id = button.dataset.packageId || "";
    if (button.dataset.packageAction === "select") selectEvidencePackage(id);
    if (button.dataset.packageAction === "seal") void sealEvidencePackageFromView(id);
  });
  $("qra-refresh").addEventListener("click", () => void refreshReporting());
  $("srs-refresh").addEventListener("click", () => void refreshSrsIntegration());
  $("srs-create-run").addEventListener("click", () => void createSrsRunFromForm());
  $("srs-import-results").addEventListener("click", () => void importSrsResultsFromForm());
  $("srs-save-connection").addEventListener("click", () => void saveSrsConnectionFromForm());
  $("srs-health-check").addEventListener("click", () => void healthCheckSrsConnection());
  $("srs-push-run").addEventListener("click", () => void pushSelectedRunToSrs());
  $("srs-poll-run").addEventListener("click", () => void pollSelectedRunFromSrs());
  $("srsRunList").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-srs-run-id]") as HTMLElement | null;
    if (!button) return;
    void selectSrsRun(button.dataset.srsRunId || "");
  });
  ["qra-search", "qra-filter"].forEach((id) => $(id).addEventListener("input", renderQraWorkbench));
  $("pdfBtn").addEventListener("click", doReport);
  $("pdfBtn2").addEventListener("click", doReport);
  $("exportBtn").addEventListener("click", exportCsv);
  $("viewHC").addEventListener("click", () => {
    navTo("register");
    $<HTMLInputElement>("fhigh").checked = true;
    renderTable();
  });

  bindDetail();
  bindRiskForm();
  bindAppetiteEscalation();
  bindQuantification();
  bindFeedback();
  bindUsers();
  bindAudit();
  bindStructureAdmin();
  bindConfiguration();
  bindControls();
  bindReporting();
  applyRoleLocks();
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeDetail();
      closeRisk();
      closeAppetiteEscalation();
      closeQuantification();
      closeFb();
      return;
    }
    // WCAG 2.2 SC 2.4.3 — trap Tab focus inside an open modal dialog.
    if (e.key === "Tab") {
      const overlays = document.querySelectorAll(".ovl.show");
      const open = overlays[overlays.length - 1]; // topmost (last in DOM) open dialog
      if (!open) return;
      const focusables = Array.from(
        open.querySelectorAll<HTMLElement>(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
        ),
      ).filter((el) => el.offsetParent !== null);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
}

// Modal helpers: move focus into the dialog on open and restore it on close (WCAG 2.2 SC 2.4.3).
// A per-id focus stack supports modals stacked over one another (e.g. quant/appetite over risk detail):
// each modal restores focus to whatever was focused immediately before IT opened.
const modalFocusStack: { id: string; el: HTMLElement | null }[] = [];
function showModal(id: string) {
  const el = document.getElementById(id);
  if (!el || el.classList.contains("show")) return;
  modalFocusStack.push({ id, el: (document.activeElement as HTMLElement) || null });
  el.classList.add("show");
  const focusable = el.querySelector<HTMLElement>(
    'input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])',
  );
  (focusable || el).focus?.();
}
function hideModal(id: string) {
  const el = document.getElementById(id);
  if (!el || !el.classList.contains("show")) return; // no-op when this modal isn't open
  el.classList.remove("show");
  const idx = modalFocusStack.map((e) => e.id).lastIndexOf(id);
  let restore: HTMLElement | null = null;
  if (idx >= 0) {
    restore = modalFocusStack[idx].el;
    modalFocusStack.splice(idx, 1);
  }
  if (restore && document.contains(restore)) restore.focus?.();
}

function bindDetail() {
  $("m-x").addEventListener("click", closeDetail);
  $("m-close").addEventListener("click", closeDetail);
  $("modal").addEventListener("click", (e) => {
    if (e.target === $("modal")) closeDetail();
  });

  // Focus mode: collapsible detail sections + jump chips, so the pane is not a
  // wall of ~11 stacked sections. Click any section header to roll it up/down;
  // the chips jump to (and open) a section; Expand/Collapse all toggles every one.
  const detailModalEl = $("modal");
  const focusNav = $("m-focusnav");
  const detailSections = Array.from(
    detailModalEl.querySelectorAll<HTMLElement>(".detail-section[data-sec]")
  );
  const sectionHeader = (sec: HTMLElement) =>
    sec.querySelector<HTMLElement>(":scope > .actions-head, :scope > .seclab");
  const syncFocusChips = () => {
    detailSections.forEach((sec) => {
      const chip = focusNav.querySelector<HTMLElement>(`[data-target="${sec.dataset.sec}"]`);
      if (chip) chip.classList.toggle("is-open", !sec.classList.contains("collapsed"));
      const head = sectionHeader(sec);
      if (head) head.setAttribute("aria-expanded", String(!sec.classList.contains("collapsed")));
    });
  };
  // Make collapsible section headers keyboard-operable (WCAG 2.1.1 / 4.1.2).
  detailSections.forEach((sec) => {
    const head = sectionHeader(sec);
    if (!head || head.dataset.a11yReady) return;
    head.dataset.a11yReady = "1";
    head.setAttribute("tabindex", "0");
    // Only expose role=button on text-only headers; headers that wrap their own controls (.actions-head)
    // stay a focusable disclosure (no nested button-in-button) and convey state via aria-expanded.
    if (!head.querySelector("button, a, input, select, textarea")) head.setAttribute("role", "button");
    head.addEventListener("keydown", (e) => {
      // Only toggle when the header itself has focus — never hijack Enter/Space of a nested control.
      if (e.target !== head) return;
      const ke = e as KeyboardEvent;
      if (ke.key === "Enter" || ke.key === " ") {
        e.preventDefault();
        sec.classList.toggle("collapsed");
        syncFocusChips();
      }
    });
  });
  if (!focusNav.childElementCount) {
    detailSections.forEach((sec) => {
      const chip = document.createElement("button");
      chip.type = "button";
      chip.className = "chip-btn";
      chip.dataset.target = sec.dataset.sec || "";
      chip.textContent = sec.dataset.secLabel || sec.dataset.sec || "";
      chip.addEventListener("click", () => {
        sec.classList.remove("collapsed");
        syncFocusChips();
        sec.scrollIntoView({ behavior: "smooth", block: "start" });
      });
      focusNav.appendChild(chip);
    });
  }
  detailModalEl.addEventListener("click", (e) => {
    const t = e.target as HTMLElement;
    if (t.closest("button, a, input, select, textarea, label")) return;
    const head = t.closest(".detail-section > .actions-head, .detail-section > .seclab");
    const sec = head?.parentElement;
    if (sec && sec.classList.contains("detail-section")) {
      sec.classList.toggle("collapsed");
      syncFocusChips();
    }
  });
  $("m-expand-all").addEventListener("click", () => {
    detailSections.forEach((s) => s.classList.remove("collapsed"));
    syncFocusChips();
  });
  $("m-collapse-all").addEventListener("click", () => {
    detailSections.forEach((s) => s.classList.add("collapsed"));
    syncFocusChips();
  });
  syncFocusChips();
  $("m-addbtn").addEventListener("click", () => {
    editIdx = -1;
    clearActForm();
    $("m-asave").textContent = "Add action";
    $("m-addform").style.display = "block";
    $("m-atask").focus();
  });
  $("m-acancel").addEventListener("click", () => {
    $("m-addform").style.display = "none";
  });
  $("m-asave").addEventListener("click", () => void saveActionFromForm());
  $("m-aprogress").addEventListener("click", () => void recordActionProgressFromForm());
  $("m-draft").addEventListener("click", draftPlannerEmail);
  $("m-quant-open").addEventListener("click", () => void openQuantification());
  $("m-appetite-open").addEventListener("click", () => void openAppetiteEscalation());
  $("m-controls-open").addEventListener("click", () => navTo("controls"));
  $("m-config-open").addEventListener("click", () => navTo("configuration"));
  $("m-timeline-refresh").addEventListener("click", () => void refreshRiskTimelineForDetail());
  $("m-indicator-new").addEventListener("click", () => {
    indicatorEditId = "";
    renderIndicatorAdmin();
    setIndicatorMessage("");
  });
  $("m-indicators").addEventListener("click", (event) => {
    const editButton = (event.target as HTMLElement).closest("[data-indicator-edit]") as HTMLElement | null;
    const eventButton = (event.target as HTMLElement).closest("[data-indicator-event]") as HTMLElement | null;
    if (editButton) {
      indicatorEditId = editButton.dataset.indicatorEdit || "";
      renderIndicatorAdmin();
      setIndicatorMessage("");
    }
    if (eventButton) {
      indicatorEditId = eventButton.dataset.indicatorEvent || "";
      renderIndicatorAdmin();
      setIndicatorMessage("");
      $<HTMLSelectElement>("mi-event-type").value = "threshold_breach";
    }
  });
  $("m-indicator-admin").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("button") as HTMLElement | null;
    if (!button) return;
    if (button.id === "mi-clear") {
      indicatorEditId = "";
      renderIndicatorAdmin();
      setIndicatorMessage("");
    }
    if (button.id === "mi-save") void saveIndicatorFromDetail();
    if (button.id === "mi-retire") void retireIndicatorFromDetail();
    if (button.id === "mi-event-save") void recordIndicatorEventFromDetail();
  });
  $("m-edit").addEventListener("click", () => {
    if (curD) openRiskForm(curD);
  });
  $("m-delete").addEventListener("click", () => void deleteCurrentRisk());
}

function bindAppetiteEscalation() {
  $("appetite-x").addEventListener("click", closeAppetiteEscalation);
  $("appetite-cancel").addEventListener("click", closeAppetiteEscalation);
  $("appetitemodal").addEventListener("click", (e) => {
    if (e.target === $("appetitemodal")) closeAppetiteEscalation();
  });
  $("appetite-save-assessment").addEventListener("click", () => void saveAppetiteAssessmentFromModal(false));
  $("appetite-record-event").addEventListener("click", () => void saveAppetiteAssessmentFromModal(true));
}

async function openAppetiteEscalation() {
  if (!curD) return;
  try {
    appetiteModalRiskId = curD.id;
    const detail = await loadRiskAppetite(curD.id);
    appetiteModalDetail = detail;
    fillAppetiteModal(detail);
    showModal("appetitemodal");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function closeAppetiteEscalation() {
  hideModal("appetitemodal");
  appetiteModalRiskId = "";
  appetiteModalDetail = null;
}

function fillAppetiteModal(detail: RiskAppetiteDetail) {
  const assessment = detail.assessment;
  $("appetite-risk-sub").textContent = `${assessment.risk_id} - ${assessment.title}`;
  setValue("appetite-status", String(assessment.appetite_status || "within_appetite"));
  setValue("appetite-assessment-status", String(assessment.assessment_status || "open"));
  setValue("appetite-level", String(assessment.escalation_level || ""));
  setValue("appetite-forum", String(assessment.escalation_forum || ""));
  setValue("appetite-due", dateValue(assessment.decision_due_date));
  setValue("appetite-review", dateValue(assessment.next_review_due));
  setValue("appetite-decision", String(assessment.decision_required || ""));
  setValue("appetite-note", String(assessment.note || ""));
  setValue("appetite-event-type", "reviewed");
  setValue("appetite-event-due", dateValue(assessment.decision_due_date));
  setValue("appetite-event-decision", assessment.escalation_required ? "Governance review required" : "Appetite position reviewed");
  setValue("appetite-event-note", "");
  renderAppetiteHistory(detail.events);
}

function renderAppetiteHistory(events: RiskEscalationEvent[]) {
  $("appetite-event-history").innerHTML = events.length
    ? events
        .slice(0, 6)
        .map((event) => `<div class="appetite-history-row"><b>${esc(appetiteEventLabel(event.event_type))}</b><span>${esc(event.decision || "-")}</span><small>${esc(event.escalation_forum || "")} · ${fmtDateTime(event.created_at)}</small></div>`)
        .join("")
    : '<div class="muted">No escalation events recorded yet.</div>';
}

async function saveAppetiteAssessmentFromModal(recordEvent: boolean) {
  if (!appetiteModalRiskId || !appetiteModalDetail) return;
  try {
    const assessmentInput: RiskAppetiteAssessmentInput = {
      appetiteStatus: value("appetite-status") as RiskAppetiteStatus,
      thresholdId: String(appetiteModalDetail.assessment.threshold_id || ""),
      escalationLevel: value("appetite-level"),
      escalationForum: value("appetite-forum"),
      decisionRequired: value("appetite-decision"),
      decisionDueDate: value("appetite-due"),
      nextReviewDue: value("appetite-review"),
      status: value("appetite-assessment-status") as RiskAppetiteAssessmentInput["status"],
      note: value("appetite-note"),
    };
    const saved = await saveRiskAppetiteAssessment(appetiteModalRiskId, assessmentInput);
    appetiteModalDetail = saved;
    if (recordEvent) {
      const eventInput: RiskEscalationEventInput = {
        eventType: value("appetite-event-type") as RiskEscalationEventType,
        escalationLevel: value("appetite-level"),
        escalationForum: value("appetite-forum"),
        decision: value("appetite-event-decision"),
        note: value("appetite-event-note"),
        dueDate: value("appetite-event-due"),
      };
      appetiteModalDetail = await recordRiskEscalationEvent(appetiteModalRiskId, eventInput);
    }
    upsertRiskAppetiteRow(appetiteModalDetail.assessment);
    mergeRiskEscalationEvents(appetiteModalRiskId, appetiteModalDetail.events);
    fillAppetiteModal(appetiteModalDetail);
    renderOpenRiskDetailSupplements();
    renderTable();
    renderReportSuite();
    renderQraWorkbench();
    toast(recordEvent ? "Escalation event recorded" : "Appetite assessment saved");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function bindQuantification() {
  $("q-x").addEventListener("click", closeQuantification);
  $("q-cancel").addEventListener("click", closeQuantification);
  $("quantmodal").addEventListener("click", (e) => {
    if (e.target === $("quantmodal")) closeQuantification();
  });
  document.querySelectorAll("[data-exposure-state]").forEach((button) => {
    button.addEventListener("click", () => {
      syncActiveExposureStateFromForm();
      syncActiveExposureStateEvidenceFromForm();
      activeExposureState = ((button as HTMLElement).dataset.exposureState || "current") as ExposureStateKey;
      fillExposureStateFields(activeExposureState);
      fillExposureStateEvidenceFields(activeExposureState);
      renderExposureStateTabs();
      renderQuantDerivedFromForm();
    });
  });
  [
    "q-prob",
    "q-dist",
    "q-cost-low",
    "q-cost-ml",
    "q-cost-high",
    "q-sch-low",
    "q-sch-ml",
    "q-sch-high",
    "q-state-quality",
    "q-state-confidence",
    "q-state-basis",
    "q-effective-from",
    "q-effective-to",
    "q-state-evidence",
    "q-quality",
    "q-inclusion",
  ].forEach((id) => $(id).addEventListener("input", renderQuantDerivedFromForm));
  $("q-state-evidence").addEventListener("input", syncActiveExposureStateEvidenceFromForm);
  $("q-governance").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-quant-workflow]") as HTMLElement | null;
    if (!button) return;
    void runQuantificationWorkflow(button.dataset.quantWorkflow || "");
  });
  $("q-save").addEventListener("click", () => void saveQuantificationFromForm());
}

async function openQuantification() {
  if (!curD) return;
  $("q-error").style.display = "none";
  $("q-risk-sub").textContent = `${curD.id} - loading quantitative data...`;
  $("q-derived").innerHTML = '<div class="muted" style="font-size:13px">Loading quantification record...</div>';
  showModal("quantmodal");
  try {
    const [result, stateEvidence] = await Promise.all([loadRiskQuantification(curD.id), loadRiskExposureStateEvidence(curD.id)]);
    quantificationDraft = result.quantification;
    quantificationEvidenceLinks = stateEvidence.items;
    quantificationEvidenceDraft = exposureStateEvidenceDraftFromLinks(stateEvidence.items);
    fillQuantificationForm(result.quantification);
    applyRoleLocks();
  } catch (err) {
    $("q-error").textContent = errorMessage(err);
    $("q-error").style.display = "block";
  }
}

function fillQuantificationForm(record: RiskQuantification) {
  quantificationDraft = normalisedQuantificationDraft(record);
  activeExposureState = "current";
  $("q-risk-sub").textContent = `${record.riskId} - ${record.title}`;
  $("q-project").innerHTML = [
    `<span>${record.projectCode ? `${esc(record.projectCode)} - ${esc(record.projectName)}` : "No project mapping"}</span>`,
    record.packageCode ? `<span>${esc(record.packageCode)} - ${esc(record.packageName)}</span>` : "",
  ]
    .filter(Boolean)
    .join("");
  setValue("q-inclusion", record.qraInclusionStatus);
  setValue("q-quality", record.dataQualityStatus);
  setValue("q-exclusion", record.qraExclusionReason);
  setValue("q-wbs", record.wbsCode);
  setValue("q-cbs", record.cbsCode);
  setValue("q-activity", record.scheduleActivityId);
  setValue("q-window-start", record.riskWindowStart);
  setValue("q-window-end", record.riskWindowEnd);
  setValue("q-correlation", record.correlationGroup);
  setValue("q-notes", record.quantificationNotes);
  fillExposureStateFields(activeExposureState);
  fillExposureStateEvidenceFields(activeExposureState);
  renderExposureStateTabs();
  renderQuantDerivedFromForm();
  renderQuantGovernance(record);
}

function renderQuantDerivedFromForm() {
  syncActiveExposureStateFromForm();
  const payload = quantificationPayloadFromForm();
  const currentCost = exposureExpectedCost(payload.exposureStates.current);
  const currentSchedule = exposureExpectedSchedule(payload.exposureStates.current);
  const targetCost = exposureExpectedCost(payload.exposureStates.target);
  const targetSchedule = exposureExpectedSchedule(payload.exposureStates.target);
  const costReduction = currentCost == null || targetCost == null ? null : currentCost - targetCost;
  const scheduleReduction = currentSchedule == null || targetSchedule == null ? null : currentSchedule - targetSchedule;
  const currentComplete = exposureHasCostOrSchedule(payload.exposureStates.current);
  const targetComplete = exposureHasCostOrSchedule(payload.exposureStates.target);
  const ready = payload.qraInclusionStatus === "excluded" || (payload.dataQualityStatus === "ready" && currentComplete && targetComplete && payload.exposureStates.current.dataQualityStatus === "ready" && payload.exposureStates.target.dataQualityStatus === "ready" && Boolean(payload.wbsCode && payload.cbsCode && payload.scheduleActivityId));
  $("q-derived").innerHTML = `
    <div class="quant-metric"><span>Current residual</span><b>${currentCost == null ? "-" : `£${currentCost.toFixed(1)}k`}</b><small>${currentSchedule == null ? "-" : `${currentSchedule.toFixed(1)}d`}</small></div>
    <div class="quant-metric"><span>Target / forecast</span><b>${targetCost == null ? "-" : `£${targetCost.toFixed(1)}k`}</b><small>${targetSchedule == null ? "-" : `${targetSchedule.toFixed(1)}d`}</small></div>
    <div class="quant-metric"><span>Forecast reduction</span><b>${costReduction == null ? "-" : `£${costReduction.toFixed(1)}k`}</b><small>${scheduleReduction == null ? "-" : `${scheduleReduction.toFixed(1)}d`}</small></div>
    <div class="quant-metric"><span>QRA readiness</span>${statusToken(ready ? "Ready" : "Needs work", ready ? "green" : "amber")}<small>${activeExposureLabel()} active</small></div>`;
  renderExposureStateTabs();
}

function renderQuantGovernance(record: RiskQuantification) {
  const governance = record.governance || {
    workflowStatus: "draft",
    activeVersionId: "",
    activeVersionNo: null,
    activeVersionStatus: "",
    approvedVersionId: "",
    approvedVersionNo: null,
    submittedAt: "",
    submittedByName: "",
    approvedAt: "",
    approvedByName: "",
    challengedAt: "",
    challengedByName: "",
    rejectedAt: "",
    rejectedByName: "",
    decisionNote: "",
    latestAttestationId: "",
    latestAttestationStatement: "",
    latestAttestationHash: "",
    latestAttestationAt: "",
    latestAttestedByName: "",
    latestAttestedByRole: "",
    updatedAt: "",
    events: [],
  };
  const status = governance.workflowStatus || "draft";
  const canManage = hasPermissionUi("qra.manage");
  const versionText = governance.activeVersionNo ? `v${governance.activeVersionNo}` : "No version";
  const approvedText = governance.approvedVersionNo ? `Approved v${governance.approvedVersionNo}` : "No approved version";
  const byline = governance.approvedAt
    ? `Approved by ${governance.approvedByName || "reviewer"} ${fmtDateTime(governance.approvedAt)}`
    : governance.submittedAt
      ? `Submitted by ${governance.submittedByName || "reviewer"} ${fmtDateTime(governance.submittedAt)}`
      : "Not yet submitted for QRA governance review";
  const events = (governance.events || [])
    .slice(0, 4)
    .map(
      (event) =>
        `<li><b>${esc(workflowVerbPast(event.action))}${event.versionNo ? ` v${event.versionNo}` : ""}</b><span>${esc(event.createdByName || "System")} · ${fmtDateTime(event.createdAt)}</span>${event.note ? `<small>${esc(event.note)}</small>` : ""}</li>`,
    )
    .join("");
  const actions = [
    { action: "submit", label: "Submit", enabled: ["draft", "challenged", "rejected"].includes(status) },
    { action: "approve", label: "Approve", enabled: status === "submitted" },
    { action: "challenge", label: "Challenge", enabled: status === "submitted" || status === "approved" },
    { action: "reject", label: "Reject", enabled: status === "submitted" || status === "challenged" },
  ];

  $("q-governance").innerHTML = `
    <div class="quant-governance-main">
      <div>
        <span>Quantification governance</span>
        <b>${statusToken(workflowStatusLabel(status), workflowTone(status))}</b>
        <small>${esc(byline)}</small>
      </div>
      <div>
        <span>Active version</span>
        <b>${esc(versionText)}</b>
        <small>${esc(approvedText)}</small>
      </div>
      <div>
        <span>Decision note</span>
        <b>${esc(governance.decisionNote || "No decision note")}</b>
        <small>QRA handoff requires approved quantitative data</small>
      </div>
    </div>
    <div class="quant-governance-actions">
      ${actions.map((item) => `<button class="${item.action === "approve" ? "btnp" : "btn"}" data-quant-workflow="${item.action}" ${canManage && item.enabled ? "" : "disabled"}>${item.label}</button>`).join("")}
    </div>
    <ul class="quant-event-list">${events || '<li><span>No workflow events yet</span></li>'}</ul>`;
  renderApprovalAttestation(record);
}

function renderApprovalAttestation(record: RiskQuantification) {
  if (!document.getElementById("q-attestation")) return;
  const governance = record.governance;
  const versionText = governance.activeVersionNo ? `version ${governance.activeVersionNo}` : "the active version";
  const statement = `I attest that ${record.riskId} quantitative risk data ${versionText} has been reviewed for QRA handoff, including current residual and target / forecast probability, impact range, mapping, state evidence and assumptions.`;
  setValue("q-attestation-statement", statement);
  const latest = governance.latestAttestationId
    ? `<b>Signed ${fmtDateTime(governance.latestAttestationAt)}</b><span>${esc(governance.latestAttestedByName || "Reviewer")} · ${esc(governance.latestAttestedByRole || "")}</span><small>${esc((governance.latestAttestationHash || "").slice(0, 16))}</small>`
    : '<span class="muted">No approval attestation signed yet.</span>';
  $("q-attestation-latest").innerHTML = latest;
  const needsApprovalAttestation = governance.workflowStatus === "submitted";
  $<HTMLInputElement>("q-attest").checked = false;
  $("q-attestation").classList.toggle("attention", needsApprovalAttestation);
}

function workflowStatusLabel(status: string) {
  if (status === "draft") return "Draft";
  if (status === "submitted") return "Submitted";
  if (status === "approved") return "Approved";
  if (status === "challenged") return "Challenged";
  if (status === "rejected") return "Rejected";
  return status || "Draft";
}

function workflowTone(status: string) {
  if (status === "approved") return "green";
  if (status === "submitted") return "blue";
  if (status === "challenged") return "amber";
  if (status === "rejected") return "red";
  return "neutral";
}

function workflowVerbPast(action: string) {
  if (action === "submit") return "submitted";
  if (action === "approve") return "approved";
  if (action === "challenge") return "challenged";
  if (action === "reject") return "rejected";
  if (action === "save") return "saved";
  return action;
}

async function saveQuantificationFromForm() {
  if (!curD) return;
  $("q-error").style.display = "none";
  const payload = quantificationPayloadFromForm();
  syncActiveExposureStateEvidenceFromForm();
  const localError = validateQuantificationPayload(payload);
  if (localError) {
    $("q-error").textContent = localError;
    $("q-error").style.display = "block";
    return;
  }
  try {
    const result = await saveRiskQuantification(curD.id, payload);
    const stateEvidence = await saveRiskExposureStateEvidence(curD.id, exposureStateEvidencePayloads());
    quantificationDraft = result.quantification;
    quantificationEvidenceLinks = stateEvidence.items;
    quantificationEvidenceDraft = exposureStateEvidenceDraftFromLinks(stateEvidence.items);
    fillQuantificationForm(result.quantification);
    setValue("q-workflow-note", "");
    [qraReadinessRows, qraExportRows, qraExposureStateRows] = await Promise.all([loadQraReadiness().then((qra) => qra.rows), loadQraExport("ready").then((qra) => qra.rows), loadQraExposureStates().then((qra) => qra.rows)]);
    renderOpenRiskDetailSupplements();
    renderControlCentre();
    renderQraWorkbench();
    renderReporting();
    toast("Quantitative risk data saved");
  } catch (err) {
    $("q-error").textContent = errorMessage(err);
    $("q-error").style.display = "block";
  }
}

async function runQuantificationWorkflow(action: string) {
  if (!curD || !["submit", "approve", "challenge", "reject"].includes(action)) return;
  $("q-error").style.display = "none";
  try {
    const note = value("q-workflow-note");
    let result: { quantification: RiskQuantification };
    if (action === "submit") result = await submitRiskQuantification(curD.id, note);
    else if (action === "approve") {
      if (!$<HTMLInputElement>("q-attest").checked) {
        $("q-error").textContent = "Approval attestation is required before QRA handoff approval.";
        $("q-error").style.display = "block";
        return;
      }
      result = await approveRiskQuantification(curD.id, note, true, value("q-attestation-statement"));
    } else if (action === "challenge") result = await challengeRiskQuantification(curD.id, note);
    else result = await rejectRiskQuantification(curD.id, note);
    quantificationDraft = result.quantification;
    fillQuantificationForm(result.quantification);
    setValue("q-workflow-note", "");
    [qraReadinessRows, qraExportRows, qraExposureStateRows] = await Promise.all([loadQraReadiness().then((qra) => qra.rows), loadQraExport("ready").then((qra) => qra.rows), loadQraExposureStates().then((qra) => qra.rows)]);
    renderOpenRiskDetailSupplements();
    renderControlCentre();
    renderQraWorkbench();
    renderReporting();
    toast(`Quantification ${workflowVerbPast(action)}`);
  } catch (err) {
    $("q-error").textContent = errorMessage(err);
    $("q-error").style.display = "block";
  }
}

function closeQuantification() {
  hideModal("quantmodal");
}

function quantificationPayloadFromForm(): RiskQuantificationInput {
  syncActiveExposureStateFromForm();
  const exposureStates = exposureStatePayloads();
  const current = exposureStates.current;
  return {
    qraInclusionStatus: value("q-inclusion") as RiskQuantificationInput["qraInclusionStatus"],
    qraExclusionReason: value("q-exclusion"),
    wbsCode: value("q-wbs"),
    cbsCode: value("q-cbs"),
    scheduleActivityId: value("q-activity"),
    probabilityPct: current.probabilityPct,
    costLow: current.costLow,
    costMostLikely: current.costMostLikely,
    costHigh: current.costHigh,
    scheduleLowDays: current.scheduleLowDays,
    scheduleMostLikelyDays: current.scheduleMostLikelyDays,
    scheduleHighDays: current.scheduleHighDays,
    distributionType: current.distributionType,
    riskWindowStart: value("q-window-start"),
    riskWindowEnd: value("q-window-end"),
    correlationGroup: value("q-correlation"),
    dataQualityStatus: value("q-quality") as RiskQuantificationInput["dataQualityStatus"],
    quantificationNotes: value("q-notes"),
    exposureStates,
  };
}

function validateQuantificationPayload(payload: RiskQuantificationInput) {
  for (const stateDef of EXPOSURE_STATE_DEFS) {
    const state = payload.exposureStates[stateDef.key];
    if (state.probabilityPct != null && (state.probabilityPct <= 0 || state.probabilityPct > 100)) return `${stateDef.label} probability must be greater than 0 and no more than 100.`;
    if (!orderedRange(state.costLow, state.costMostLikely, state.costHigh)) return `${stateDef.label} cost range must be ordered low <= most likely <= high.`;
    if (!orderedRange(state.scheduleLowDays, state.scheduleMostLikelyDays, state.scheduleHighDays)) return `${stateDef.label} schedule range must be ordered low <= most likely <= high.`;
    if (state.effectiveFrom && state.effectiveTo && state.effectiveFrom > state.effectiveTo) return `${stateDef.label} effective from must be before effective to.`;
  }
  if (payload.qraInclusionStatus !== "excluded" && payload.dataQualityStatus === "ready") {
    const current = payload.exposureStates.current;
    const target = payload.exposureStates.target;
    const missing = [
      !current.probabilityPct ? "current residual probability" : "",
      !exposureHasCostOrSchedule(current) ? "current residual cost or schedule range" : "",
      current.dataQualityStatus !== "ready" ? "current residual data quality" : "",
      !target.probabilityPct ? "target / forecast probability" : "",
      !exposureHasCostOrSchedule(target) ? "target / forecast cost or schedule range" : "",
      target.dataQualityStatus !== "ready" ? "target / forecast data quality" : "",
      !payload.wbsCode ? "WBS code" : "",
      !payload.cbsCode ? "CBS code" : "",
      !payload.scheduleActivityId ? "schedule activity" : "",
    ].filter(Boolean);
    if (missing.length) return `Cannot mark ready. Missing: ${missing.join(", ")}.`;
  }
  return "";
}

function normalisedQuantificationDraft(record: RiskQuantification): RiskQuantification {
  return {
    ...record,
    exposureStates: {
      inherent: record.exposureStates?.inherent || emptyExposureState("inherent"),
      current: record.exposureStates?.current || currentExposureStateFromLegacy(record),
      target: record.exposureStates?.target || emptyExposureState("target"),
      post_mitigation: record.exposureStates?.post_mitigation || emptyExposureState("post_mitigation"),
    },
  };
}

function fillExposureStateFields(key: ExposureStateKey) {
  const state = quantificationDraft?.exposureStates[key] || emptyExposureState(key);
  setValue("q-prob", numberText(state.probabilityPct));
  setValue("q-dist", state.distributionType || "triangular");
  setValue("q-state-quality", state.dataQualityStatus || "incomplete");
  setValue("q-state-confidence", state.confidenceLevel || "");
  setValue("q-cost-low", numberText(state.costLow));
  setValue("q-cost-ml", numberText(state.costMostLikely));
  setValue("q-cost-high", numberText(state.costHigh));
  setValue("q-sch-low", numberText(state.scheduleLowDays));
  setValue("q-sch-ml", numberText(state.scheduleMostLikelyDays));
  setValue("q-sch-high", numberText(state.scheduleHighDays));
  setValue("q-effective-from", state.effectiveFrom || "");
  setValue("q-effective-to", state.effectiveTo || "");
  setValue("q-state-basis", state.basis || "");
}

function fillExposureStateEvidenceFields(key: ExposureStateKey) {
  const links = quantificationEvidenceDraft[key] || [];
  setValue(
    "q-state-evidence",
    links.map((link) => `${link.evidenceCode}, ${link.linkRole}, ${link.notes || ""}`.trim()).join("\n"),
  );
  renderExposureStateEvidenceList(key);
}

function syncActiveExposureStateEvidenceFromForm() {
  if (!document.getElementById("q-state-evidence")) return;
  quantificationEvidenceDraft[activeExposureState] = parseExposureStateEvidenceText(value("q-state-evidence"), activeExposureState);
  renderExposureStateEvidenceList(activeExposureState);
}

function renderExposureStateEvidenceList(key: ExposureStateKey) {
  if (!document.getElementById("q-state-evidence-list")) return;
  const links = quantificationEvidenceDraft[key] || [];
  $("q-state-evidence-count").textContent = `${links.length} linked`;
  $("q-state-evidence-list").innerHTML = links.length
    ? links
        .map((link) => {
          const record = evidenceRecords.find((item) => item.evidence_code === link.evidenceCode);
          return `<div class="quant-state-evidence-row">
            <span>${esc(link.linkRole.replace(/_/g, " "))}</span>
            <b>${esc(link.evidenceCode)}</b>
            <em>${esc(record?.title || link.notes || "Evidence record")}</em>
          </div>`;
        })
        .join("")
    : '<div class="muted">No state evidence linked.</div>';
}

function parseExposureStateEvidenceText(text: string, stateKey: ExposureStateKey): RiskExposureStateEvidenceInput[] {
  const seen = new Set<string>();
  return text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const [evidenceCode = "", linkRole = "basis", ...notes] = line.split(",").map((part) => part.trim());
      return {
        stateKey,
        evidenceCode: evidenceCode.toUpperCase(),
        linkRole: exposureStateEvidenceRole(linkRole),
        notes: notes.join(", ").trim(),
      };
    })
    .filter((link) => {
      const key = `${link.stateKey}|${link.evidenceCode}|${link.linkRole}`;
      if (!link.evidenceCode || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
}

function exposureStateEvidencePayloads() {
  return EXPOSURE_STATE_DEFS.flatMap((state) => quantificationEvidenceDraft[state.key] || []);
}

function exposureStateEvidenceDraftFromLinks(items: RiskExposureStateEvidence[]): Record<ExposureStateKey, RiskExposureStateEvidenceInput[]> {
  const grouped: Record<ExposureStateKey, RiskExposureStateEvidenceInput[]> = {
    inherent: [],
    current: [],
    target: [],
    post_mitigation: [],
  };
  items.forEach((item) => {
    grouped[item.stateKey].push({
      stateKey: item.stateKey,
      evidenceCode: item.evidenceCode,
      linkRole: item.linkRole,
      notes: item.notes,
    });
  });
  return grouped;
}

function exposureStateEvidenceRole(value: string): RiskExposureStateEvidenceInput["linkRole"] {
  const normal = value.toLowerCase().replace(/[\s-]+/g, "_");
  if (["assumption", "decision", "approval", "source", "output", "other"].includes(normal)) return normal as RiskExposureStateEvidenceInput["linkRole"];
  return "basis";
}

function renderExposureStateTabs() {
  const payload = quantificationDraft ? exposureStatePayloads() : null;
  EXPOSURE_STATE_DEFS.forEach((stateDef) => {
    const button = document.getElementById(`q-state-${stateDef.key}`);
    if (!button) return;
    const state = payload?.[stateDef.key];
    button.classList.toggle("active", activeExposureState === stateDef.key);
    button.classList.toggle("complete", Boolean(state && exposureHasCostOrSchedule(state) && state.probabilityPct));
  });
  const active = EXPOSURE_STATE_DEFS.find((state) => state.key === activeExposureState) || EXPOSURE_STATE_DEFS[1];
  const state = payload?.[activeExposureState];
  $("q-state-note").innerHTML = `
    <b>${esc(active.label)}</b>
    <span>${esc(active.note)}</span>
    ${state ? statusToken(state.dataQualityStatus === "ready" ? "State ready" : state.dataQualityStatus === "needs_review" ? "Needs review" : "Incomplete", state.dataQualityStatus === "ready" ? "green" : state.dataQualityStatus === "needs_review" ? "amber" : "neutral") : ""}`;
}

function syncActiveExposureStateFromForm() {
  if (!quantificationDraft || !document.getElementById("q-prob")) return;
  quantificationDraft.exposureStates[activeExposureState] = {
    ...emptyExposureState(activeExposureState),
    ...(quantificationDraft.exposureStates[activeExposureState] || {}),
    probabilityPct: numberField("q-prob"),
    costLow: numberField("q-cost-low"),
    costMostLikely: numberField("q-cost-ml"),
    costHigh: numberField("q-cost-high"),
    scheduleLowDays: numberField("q-sch-low"),
    scheduleMostLikelyDays: numberField("q-sch-ml"),
    scheduleHighDays: numberField("q-sch-high"),
    distributionType: value("q-dist") || "triangular",
    dataQualityStatus: value("q-state-quality") as RiskExposureState["dataQualityStatus"],
    confidenceLevel: value("q-state-confidence"),
    basis: value("q-state-basis"),
    effectiveFrom: value("q-effective-from"),
    effectiveTo: value("q-effective-to"),
  };
}

function exposureStatePayloads(): Record<ExposureStateKey, RiskExposureStateInput> {
  return {
    inherent: exposureStatePayload(quantificationDraft?.exposureStates.inherent || emptyExposureState("inherent")),
    current: exposureStatePayload(quantificationDraft?.exposureStates.current || emptyExposureState("current")),
    target: exposureStatePayload(quantificationDraft?.exposureStates.target || emptyExposureState("target")),
    post_mitigation: exposureStatePayload(quantificationDraft?.exposureStates.post_mitigation || emptyExposureState("post_mitigation")),
  };
}

function exposureStatePayload(state: RiskExposureState): RiskExposureStateInput {
  return {
    probabilityPct: state.probabilityPct,
    costLow: state.costLow,
    costMostLikely: state.costMostLikely,
    costHigh: state.costHigh,
    scheduleLowDays: state.scheduleLowDays,
    scheduleMostLikelyDays: state.scheduleMostLikelyDays,
    scheduleHighDays: state.scheduleHighDays,
    distributionType: state.distributionType || "triangular",
    dataQualityStatus: state.dataQualityStatus || "incomplete",
    confidenceLevel: state.confidenceLevel || "",
    basis: state.basis || "",
    effectiveFrom: state.effectiveFrom || "",
    effectiveTo: state.effectiveTo || "",
  };
}

function emptyExposureState(key: ExposureStateKey): RiskExposureState {
  const def = EXPOSURE_STATE_DEFS.find((state) => state.key === key);
  return {
    stateKey: key,
    label: def?.label || key,
    probabilityPct: null,
    costLow: null,
    costMostLikely: null,
    costHigh: null,
    scheduleLowDays: null,
    scheduleMostLikelyDays: null,
    scheduleHighDays: null,
    distributionType: "triangular",
    dataQualityStatus: "incomplete",
    confidenceLevel: "",
    basis: "",
    effectiveFrom: "",
    effectiveTo: "",
    updatedAt: "",
    derived: {
      costRangeComplete: false,
      scheduleRangeComplete: false,
      expectedCost: null,
      expectedScheduleDays: null,
    },
  };
}

function currentExposureStateFromLegacy(record: RiskQuantification): RiskExposureState {
  return {
    ...emptyExposureState("current"),
    probabilityPct: record.probabilityPct,
    costLow: record.costLow,
    costMostLikely: record.costMostLikely,
    costHigh: record.costHigh,
    scheduleLowDays: record.scheduleLowDays,
    scheduleMostLikelyDays: record.scheduleMostLikelyDays,
    scheduleHighDays: record.scheduleHighDays,
    distributionType: record.distributionType || "triangular",
    dataQualityStatus: record.dataQualityStatus || "incomplete",
    basis: record.quantificationNotes || "",
    updatedAt: record.updatedAt || "",
  };
}

function activeExposureLabel() {
  return EXPOSURE_STATE_DEFS.find((state) => state.key === activeExposureState)?.short || "Current";
}

function exposureHasCostOrSchedule(state: RiskExposureStateInput) {
  return rangeComplete(state.costLow, state.costMostLikely, state.costHigh) || rangeComplete(state.scheduleLowDays, state.scheduleMostLikelyDays, state.scheduleHighDays);
}

function exposureExpectedCost(state: RiskExposureStateInput) {
  return exposureExpected(state.costLow, state.costMostLikely, state.costHigh, state.probabilityPct);
}

function exposureExpectedSchedule(state: RiskExposureStateInput) {
  return exposureExpected(state.scheduleLowDays, state.scheduleMostLikelyDays, state.scheduleHighDays, state.probabilityPct);
}

function exposureExpected(low: number | null, mostLikely: number | null, high: number | null, probabilityPct: number | null) {
  const mean = triangularMean(low, mostLikely, high);
  if (mean == null || probabilityPct == null) return null;
  return mean * (probabilityPct / 100);
}

function bindRiskForm() {
  ["rm-lpre", "rm-ipre", "rm-lpost", "rm-ipost"].forEach((id) => $(id).addEventListener("change", rmPreview));
  $("rm-x").addEventListener("click", closeRisk);
  $("rm-cancel").addEventListener("click", closeRisk);
  $("riskmodal").addEventListener("click", (e) => {
    if (e.target === $("riskmodal")) closeRisk();
  });
  $("rm-save").addEventListener("click", () => void saveRiskForm());
}

function bindFeedback() {
  document.querySelectorAll("#fb-sent button").forEach((b) => {
    b.addEventListener("click", () => {
      document.querySelectorAll("#fb-sent button").forEach((x) => x.classList.remove("sel"));
      b.classList.add("sel");
      fbSent = (b as HTMLElement).dataset.s || "";
    });
  });
  $("fabFeedback").addEventListener("click", openFb);
  $("fb-x").addEventListener("click", closeFb);
  $("fb-cancel").addEventListener("click", closeFb);
  $("fb-done").addEventListener("click", closeFb);
  $("fbmodal").addEventListener("click", (e) => {
    if (e.target === $("fbmodal")) closeFb();
  });
  $("fb-send").addEventListener("click", () => void submitFeedback());
}

function bindUsers() {
  $("user-save").addEventListener("click", () => void saveUserForm());
  $("user-clear").addEventListener("click", clearUserForm);
  $("package-grant-save").addEventListener("click", () => void savePackageGrantFromAdmin());
  $("retention-save").addEventListener("click", () => void saveRetentionFromAdmin());
  $("security-save").addEventListener("click", () => void saveSecurityControlFromAdmin());
  $("backup-save").addEventListener("click", () => void recordBackupFromAdmin());
}

function bindAudit() {
  $("audit-refresh").addEventListener("click", () => void refreshAudit());
  $("audit-export").addEventListener("click", exportAuditCsv);
}

function bindStructureAdmin() {
  $("tax-save").addEventListener("click", () => void saveTaxonomyFromForm());
  $("tax-clear").addEventListener("click", clearTaxonomyForm);
  $("tax-import-btn").addEventListener("click", () => void importTaxonomyFromCsv());
  $("tax-sample").addEventListener("click", fillTaxonomyImportSample);
  ["tax-filter", "tax-search"].forEach((id) => $(id).addEventListener("input", renderStructureAdmin));
  $("taxonomyList").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-tax-action]") as HTMLElement | null;
    if (!button) return;
    const id = button.dataset.taxItemId || "";
    const action = button.dataset.taxAction || "";
    if (action === "edit") fillTaxonomyForm(id);
    if (action === "deactivate") void deactivateTaxonomyFromView(id);
  });
}

function bindControls() {
  $("controls-refresh").addEventListener("click", () => void refreshControls());
  ["control-search", "control-effect-filter"].forEach((id) => $(id).addEventListener("input", renderControlLibrary));
  $("control-save").addEventListener("click", () => void saveControlFromForm());
  $("control-clear").addEventListener("click", clearControlForm);
  $("control-deactivate").addEventListener("click", () => void deactivateControlFromForm());
  $("rc-save").addEventListener("click", () => void saveRiskControlFromForm());
  $("assure-save").addEventListener("click", () => void saveAssuranceFromForm());
  $("obl-save").addEventListener("click", () => void saveObligationFromForm());
  $("samp-save").addEventListener("click", () => void saveSamplingPlanFromView());
  $("esc-save").addEventListener("click", () => void raiseEscalationFromView());
  $("samplingPlanList").addEventListener("click", (event) => {
    const b = (event.target as HTMLElement).closest("[data-sampling-delete]") as HTMLElement | null;
    if (b) void deleteSamplingPlanFromView(b.dataset.samplingDelete || "");
  });
  $("escalationQueue").addEventListener("click", (event) => {
    const ack = (event.target as HTMLElement).closest("[data-escalation-ack]") as HTMLElement | null;
    if (ack) { void setEscalationStatusFromView(ack.dataset.escalationAck || "", "acknowledged"); return; }
    const res = (event.target as HTMLElement).closest("[data-escalation-resolve]") as HTMLElement | null;
    if (res) void setEscalationStatusFromView(res.dataset.escalationResolve || "", "resolved");
  });
  $("controlList").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-control-action]") as HTMLElement | null;
    if (!button) return;
    const id = button.dataset.controlId || "";
    const action = button.dataset.controlAction || "";
    if (action === "edit") fillControlForm(id);
    if (action === "deactivate") void deactivateControlFromList(id);
  });
  $("controlCoverageHeatmap").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-risk-open]") as HTMLElement | null;
    if (!button) return;
    openById(button.dataset.riskOpen || "");
  });
  $("bowtiePanel").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-risk-control-delete]") as HTMLElement | null;
    if (!button) return;
    void deleteRiskControlFromView(button.dataset.riskControlDelete || "");
  });
  // Keyboard-operable alternative to drag-and-drop (WCAG 2.1.1): move a control link via the select.
  $("bowtiePanel").addEventListener("change", (event) => {
    const select = (event.target as HTMLElement).closest("[data-rc-move]") as HTMLSelectElement | null;
    if (!select) return;
    void moveRiskControlSide(select.dataset.rcMove || "", select.value as BowtieSide);
  });
  wireBowtieDragAndDrop();
  $("assuranceQueue").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-assurance-delete]") as HTMLElement | null;
    if (!button) return;
    void deleteAssuranceFromView(button.dataset.assuranceDelete || "");
  });
  $("obligationQueue").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-obligation-delete]") as HTMLElement | null;
    if (!button) return;
    void deleteObligationFromView(button.dataset.obligationDelete || "");
  });
}

async function refreshControls(showToast = true) {
  try {
    [controls, riskControls, assuranceTests, controlObligations, samplingPlans, obligationEscalations] = await Promise.all([
      loadControls().then((result) => result.items),
      loadRiskControls().then((result) => result.items),
      loadAssuranceTests().then((result) => result.items),
      loadControlObligations().then((result) => result.items),
      loadSamplingPlans().then((result) => result.items),
      loadObligationEscalations().then((result) => result.items),
    ]);
    renderControls();
    renderControlCentre();
    renderReporting();
    renderOpenRiskDetailSupplements();
    if (showToast) toast("Controls and assurance refreshed");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function renderControls() {
  if (!document.getElementById("controlsKpis")) return;
  const activeControls = controls.filter((control) => control.status === "active");
  const critical = activeControls.filter((control) => control.criticality === "critical");
  const weak = activeControls.filter((control) => control.effectiveness === "ineffective" || control.effectiveness === "untested");
  const failedTests = assuranceTests.filter((test) => test.result === "fail");
  const overdueTests = assuranceTests.filter((test) => test.result === "not_run" && isPast(test.dueDate));
  const overdueObligations = controlObligations.filter((obligation) => obligation.status === "overdue" || (obligation.status === "open" && isPast(obligation.dueDate)));

  $("controlsKpis").innerHTML = [
    `<div class="kpi"><div class="l">Active controls</div><div class="v">${activeControls.length}</div><div class="kpi-note">${critical.length} critical controls</div></div>`,
    `<div class="kpi"><div class="l">Weak / untested</div><div class="v">${weak.length}</div><div class="kpi-note">Ineffective or untested design</div></div>`,
    `<div class="kpi"><div class="l">Assurance exceptions</div><div class="v">${failedTests.length + overdueTests.length}</div><div class="kpi-note">${failedTests.length} failed, ${overdueTests.length} overdue</div></div>`,
    `<div class="kpi"><div class="l">Obligations overdue</div><div class="v">${overdueObligations.length}</div><div class="kpi-note">Statutory, contractual, client or internal</div></div>`,
  ].join("");

  fillControlSelectors();
  renderControlCoverageHeatmap();
  renderControlLibrary();
  renderBowtiePanel();
  renderAssuranceQueue();
  renderObligationQueue();
  renderSamplingPlans();
  renderEscalations();
  applyRoleLocks();
}

function renderSamplingPlans() {
  if (!document.getElementById("samplingPlanList")) return;
  $("samplingPlanList").innerHTML = samplingPlans.length
    ? samplingPlans
        .map((p) => `<div class="obligation-item">
          <div>
            <b>${esc(p.planCode)} · ${esc(p.controlCode)}</b>
            <span>${esc(p.method.replace(/_/g, " "))} · n=${p.sampleSize}/${p.populationSize} · ${p.coverageTargetPct}% target · ${esc(p.frequency || "—")}</span>
            <small>${esc(p.owner || "No owner")} · next ${p.nextSampleDue ? fmtDate(p.nextSampleDue) : "not set"}</small>
          </div>
          <div>${statusToken(p.status, p.status === "active" ? "green" : p.status === "paused" ? "amber" : "neutral")}<button class="lnk danger-link control-admin-only" data-sampling-delete="${escAttr(p.id)}">Delete</button></div>
        </div>`)
        .join("")
    : '<div class="muted">No sampling plans yet — define how each critical control is sampled.</div>';
}

function renderEscalations() {
  if (!document.getElementById("escalationQueue")) return;
  const open = obligationEscalations.filter((e) => e.status !== "resolved").length;
  $("escalationQueue").innerHTML = obligationEscalations.length
    ? obligationEscalations
        .map((e) => `<div class="obligation-item">
          <div>
            <b>${esc(e.escalationCode)} · ${esc(e.level)}</b>
            <span>${esc(e.obligationReference || e.obligationDescription)}</span>
            <small>to ${esc(e.raisedTo || "—")} · due ${e.dueDate ? fmtDate(e.dueDate) : "not set"}${e.reason ? ` · ${esc(e.reason)}` : ""}</small>
          </div>
          <div>${statusToken(e.status, e.status === "open" ? "red" : e.status === "acknowledged" ? "amber" : "green")}
            ${e.status !== "resolved" ? `<button class="lnk control-admin-only" data-escalation-ack="${escAttr(e.id)}">Acknowledge</button><button class="lnk control-admin-only" data-escalation-resolve="${escAttr(e.id)}">Resolve</button>` : ""}
          </div>
        </div>`)
        .join("")
    : '<div class="muted">No escalations raised. Raise one against an overdue obligation.</div>';
  void open;
}

async function saveSamplingPlanFromView() {
  if (!canManageControlsUi()) return;
  const planCode = value("samp-code").trim();
  const controlId = value("samp-control");
  if (!planCode || !controlId) { toast("Plan code and control are required"); return; }
  try {
    await createSamplingPlan({
      planCode,
      controlId,
      method: value("samp-method") as SamplingPlan["method"],
      populationSize: Number(value("samp-population")) || 0,
      sampleSize: Number(value("samp-sample")) || 0,
      frequency: value("samp-frequency"),
      coverageTargetPct: Number(value("samp-coverage")) || 0,
      owner: value("samp-owner"),
      nextSampleDue: value("samp-due"),
      lastSampledAt: "",
      status: "active",
      notes: "",
    });
    ["samp-code", "samp-frequency", "samp-population", "samp-sample", "samp-coverage", "samp-owner", "samp-due"].forEach((id) => setValue(id, ""));
    await refreshControls(false);
    toast("Sampling plan saved");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function deleteSamplingPlanFromView(id: string) {
  if (!id || !canManageControlsUi()) return;
  try {
    await deleteSamplingPlan(id);
    await refreshControls(false);
    toast("Sampling plan deleted");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function raiseEscalationFromView() {
  if (!canManageControlsUi()) return;
  const obligationId = value("esc-obligation");
  if (!obligationId) { toast("Select an obligation"); return; }
  try {
    await raiseObligationEscalation({
      obligationId,
      level: value("esc-level") as ObligationEscalation["level"],
      raisedTo: value("esc-raised-to"),
      reason: value("esc-reason"),
      dueDate: value("esc-due"),
      status: "open",
      resolutionNote: "",
    });
    ["esc-raised-to", "esc-reason", "esc-due"].forEach((id) => setValue(id, ""));
    await refreshControls(false);
    toast("Escalation raised");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function setEscalationStatusFromView(id: string, status: ObligationEscalation["status"]) {
  if (!id || !canManageControlsUi()) return;
  const existing = obligationEscalations.find((e) => e.id === id);
  if (!existing) return;
  try {
    await updateObligationEscalation(id, {
      obligationId: existing.obligationId,
      level: existing.level,
      raisedTo: existing.raisedTo,
      reason: existing.reason,
      dueDate: existing.dueDate,
      status,
      resolutionNote: existing.resolutionNote,
    });
    await refreshControls(false);
    toast(status === "resolved" ? "Escalation resolved" : "Escalation acknowledged");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function renderControlCoverageHeatmap() {
  if (!document.getElementById("controlCoverageHeatmap")) return;
  const activeRisks = risks.filter((risk) => risk.status !== "Closed");
  const rows = activeRisks
    .map((risk) => controlCoverageForRisk(risk))
    .sort((a, b) => coverageSortRank(a.tone) - coverageSortRank(b.tone) || post(b.risk) - post(a.risk) || a.risk.id.localeCompare(b.risk.id));
  const red = rows.filter((row) => row.tone === "red").length;
  const amber = rows.filter((row) => row.tone === "amber").length;
  const green = rows.filter((row) => row.tone === "green").length;
  $("controlCoverageSummary").textContent = `${green} robust · ${amber} needs assurance · ${red} gaps`;
  $("controlCoverageHeatmap").innerHTML = rows.length
    ? rows.map((row) => controlCoverageCardHtml(row)).join("")
    : '<div class="muted">No active risks available for control coverage.</div>';
}

function controlCoverageForRisk(risk: RiskRecord) {
  const links = riskControls.filter((row) => row.riskId === risk.id);
  const bySide: Record<BowtieSide, RiskControl[]> = {
    cause: links.filter((row) => row.bowtieSide === "cause"),
    event: links.filter((row) => row.bowtieSide === "event"),
    effect: links.filter((row) => row.bowtieSide === "effect"),
  };
  const weak = links.filter((row) => row.effectiveness === "ineffective" || row.effectiveness === "untested").length;
  const assuranceExceptions = links.filter((row) => riskControlAssuranceTone(row) === "red").length;
  const missingSides = (["cause", "event", "effect"] as BowtieSide[]).filter((side) => !bySide[side].length);
  const criticalMissing = missingSides.length && post(risk) >= 10;
  const tone = !links.length || criticalMissing || assuranceExceptions ? "red" : missingSides.length || weak ? "amber" : "green";
  const nextTest = links
    .map((row) => row.nextTestDue)
    .filter(Boolean)
    .sort()[0] || "";
  return { risk, links, bySide, weak, assuranceExceptions, missingSides, tone, nextTest };
}

function controlCoverageCardHtml(row: ReturnType<typeof controlCoverageForRisk>) {
  const label = row.tone === "green" ? "Robust coverage" : row.tone === "amber" ? "Needs assurance" : "Coverage gap";
  const sideCells = (["cause", "event", "effect"] as BowtieSide[])
    .map((side) => {
      const sideRows = row.bySide[side];
      const sideTone = controlCoverageSideTone(sideRows);
      return `<span class="coverage-side ${escAttr(side)} tone-${escAttr(sideTone)}"><b>${sideRows.length}</b>${esc(bowtieSideLabel(side))}</span>`;
    })
    .join("");
  const note = row.missingSides.length
    ? `Missing ${row.missingSides.map(bowtieSideLabel).join(", ")}`
    : row.assuranceExceptions
      ? `${row.assuranceExceptions} assurance exception${row.assuranceExceptions === 1 ? "" : "s"}`
      : row.weak
        ? `${row.weak} weak or untested control${row.weak === 1 ? "" : "s"}`
        : "All bow-tie sides controlled";
  return `<button type="button" class="control-coverage-card tone-left-${escAttr(row.tone)}" data-risk-open="${escAttr(row.risk.id)}">
    <div class="coverage-card-head">
      <div><span>${esc(row.risk.id)} · ${esc(row.risk.cat)}</span><b>${esc(row.risk.title)}</b></div>
      ${statusToken(label, row.tone)}
    </div>
    <div class="coverage-side-row">${sideCells}</div>
    <div class="coverage-card-meta">
      <span>${row.links.length} controls</span>
      <span>${row.weak} weak</span>
      <span>${row.assuranceExceptions} exceptions</span>
      <span>${row.nextTest ? `Next ${fmtDate(row.nextTest)}` : "No test date"}</span>
    </div>
    <small>${esc(note)}</small>
  </button>`;
}

function controlCoverageSideTone(rows: RiskControl[]) {
  if (!rows.length) return "red";
  if (rows.some((row) => riskControlAssuranceTone(row) === "red" || row.effectiveness === "ineffective")) return "red";
  if (rows.some((row) => riskControlAssuranceTone(row) === "amber" || row.effectiveness === "untested" || row.effectiveness === "partially_effective")) return "amber";
  return "green";
}

function coverageSortRank(tone: string) {
  if (tone === "red") return 0;
  if (tone === "amber") return 1;
  return 2;
}

function renderControlLibrary() {
  if (!document.getElementById("controlList")) return;
  const query = value("control-search").toLowerCase();
  const effectiveness = value("control-effect-filter");
  const rows = controls
    .filter((control) => (!effectiveness ? true : control.effectiveness === effectiveness))
    .filter((control) => {
      if (!query) return true;
      return [control.code, control.name, control.description, control.owner, control.source, control.controlType, control.criticality, control.effectiveness].join(" ").toLowerCase().includes(query);
    })
    .sort((a, b) => controlSortRank(a) - controlSortRank(b) || a.code.localeCompare(b.code));

  $("controlLibraryCount").textContent = `${rows.length} shown`;
  $("controlList").innerHTML = rows.length
    ? rows.map((control) => controlCardHtml(control)).join("")
    : '<div class="muted">No controls match this view.</div>';
}

function controlCardHtml(control: Control) {
  const linked = riskControls.filter((row) => row.controlId === control.id).length;
  const tests = assuranceTests.filter((test) => test.controlId === control.id);
  const failed = tests.filter((test) => test.result === "fail").length;
  const obligations = controlObligations.filter((obligation) => obligation.controlId === control.id && obligation.status !== "compliant").length;
  return `<div class="control-card${control.status === "inactive" ? " inactive" : ""}">
    <div class="control-card-head">
      <div><span>${esc(control.code)}</span><b>${esc(control.name)}</b></div>
      ${statusToken(effectivenessLabel(control.effectiveness), effectivenessTone(control.effectiveness))}
    </div>
    <p>${esc(control.description || "No design description recorded")}</p>
    <div class="control-card-meta">
      <span>${esc(controlTypeLabel(control.controlType))}</span>
      <span>${esc(criticalityLabel(control.criticality))}</span>
      <span>${esc(control.owner || "No owner")}</span>
      <span>${linked} risk links</span>
      <span>${tests.length} tests</span>
      <span>${obligations} open obligations</span>
    </div>
    <div class="control-card-actions">
      ${failed ? statusToken(`${failed} failed`, "red") : statusToken("No failed tests", "green")}
      <button class="btn" data-control-action="edit" data-control-id="${escAttr(control.id)}">Edit</button>
      <button class="btn" data-control-action="deactivate" data-control-id="${escAttr(control.id)}" ${control.status === "active" ? "" : "disabled"}>Deactivate</button>
    </div>
  </div>`;
}

function renderBowtiePanel() {
  if (!document.getElementById("bowtiePanel")) return;
  const canDrag = canManageControlsUi();
  $("bowtieCount").textContent = `${riskControls.length} control links${canDrag ? " · drag cards to re-author the side" : ""}`;
  const groups: Record<BowtieSide, RiskControl[]> = {
    cause: riskControls.filter((row) => row.bowtieSide === "cause"),
    event: riskControls.filter((row) => row.bowtieSide === "event"),
    effect: riskControls.filter((row) => row.bowtieSide === "effect"),
  };
  $("bowtiePanel").innerHTML = (["cause", "event", "effect"] as BowtieSide[])
    .map((side) => {
      const rows = groups[side]
        .slice()
        .sort((a, b) => controlSortRank(a) - controlSortRank(b) || a.riskId.localeCompare(b.riskId));
      return `<div class="bowtie-column" data-bowtie-side="${escAttr(side)}">
        <div class="bowtie-column-head"><span>${esc(bowtieSideLabel(side))}</span><b>${rows.length}</b></div>
        ${rows
          .map(
            (row) => `<div class="bowtie-item${canDrag ? " draggable" : ""}"${canDrag ? ` draggable="true"` : ""} data-rc-id="${escAttr(row.id)}" data-rc-side="${escAttr(side)}">
              <div><b>${esc(row.riskId)} · ${esc(row.controlCode)}</b><span>${esc(row.controlName)}</span></div>
              <small>${esc(row.riskTitle)}</small>
              <div class="control-card-meta"><span>${esc(controlTypeLabel(row.linkType))}</span><span>${esc(effectivenessLabel(row.effectiveness))}</span><span>${esc(assuranceStatusLabel(row.assuranceStatus))}</span><span>${esc(row.nextTestDue ? fmtDate(row.nextTestDue) : "No test date")}</span></div>
              ${row.coverageNotes ? `<p>${esc(row.coverageNotes)}</p>` : ""}
              <div class="bowtie-item-actions">
                ${canDrag ? `<label class="bowtie-move">Move to <select data-rc-move="${escAttr(row.id)}" aria-label="Move ${escAttr(row.riskId)} ${escAttr(row.controlCode)} to bow-tie side"><option value="cause"${side === "cause" ? " selected" : ""}>Cause</option><option value="event"${side === "event" ? " selected" : ""}>Event</option><option value="effect"${side === "effect" ? " selected" : ""}>Effect</option></select></label>` : ""}
                <button class="lnk danger-link control-admin-only" data-risk-control-delete="${escAttr(row.id)}">Remove link</button>
              </div>
            </div>`,
          )
          .join("") || '<div class="muted" style="font-size:12px">No controls mapped.</div>'}
      </div>`;
    })
    .join("");
}

let draggedRiskControlId = "";

async function moveRiskControlSide(id: string, newSide: BowtieSide) {
  if (!id || !canManageControlsUi()) return;
  const row = riskControls.find((item) => item.id === id);
  if (!row || row.bowtieSide === newSide) return;
  try {
    await updateRiskControl(id, {
      riskId: row.riskId,
      controlCode: row.controlCode,
      bowtieSide: newSide,
      linkType: row.linkType,
      coverageNotes: row.coverageNotes,
      assuranceStatus: row.assuranceStatus,
      nextTestDue: row.nextTestDue,
    });
    await refreshControls(false);
    toast(`Moved ${row.riskId} · ${row.controlCode} to ${bowtieSideLabel(newSide)}`);
  } catch (err) {
    toast(errorMessage(err));
  }
}

function wireBowtieDragAndDrop() {
  const panel = document.getElementById("bowtiePanel");
  if (!panel) return;
  panel.addEventListener("dragstart", (event) => {
    const item = (event.target as HTMLElement).closest("[data-rc-id]") as HTMLElement | null;
    if (!item || !canManageControlsUi()) return;
    draggedRiskControlId = item.dataset.rcId || "";
    item.classList.add("dragging");
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("text/plain", draggedRiskControlId);
    }
  });
  panel.addEventListener("dragend", () => {
    draggedRiskControlId = "";
    panel.querySelectorAll(".bowtie-item.dragging").forEach((el) => el.classList.remove("dragging"));
    panel.querySelectorAll(".bowtie-column.drag-over").forEach((el) => el.classList.remove("drag-over"));
  });
  panel.addEventListener("dragover", (event) => {
    if (!draggedRiskControlId) return;
    const column = (event.target as HTMLElement).closest("[data-bowtie-side]") as HTMLElement | null;
    if (!column) return;
    event.preventDefault();
    if (event.dataTransfer) event.dataTransfer.dropEffect = "move";
    panel.querySelectorAll(".bowtie-column.drag-over").forEach((el) => el.classList.remove("drag-over"));
    column.classList.add("drag-over");
  });
  panel.addEventListener("dragleave", (event) => {
    const column = (event.target as HTMLElement).closest("[data-bowtie-side]") as HTMLElement | null;
    if (column && !column.contains(event.relatedTarget as Node)) column.classList.remove("drag-over");
  });
  panel.addEventListener("drop", (event) => {
    const column = (event.target as HTMLElement).closest("[data-bowtie-side]") as HTMLElement | null;
    if (!column || !draggedRiskControlId) return;
    event.preventDefault();
    const id = draggedRiskControlId;
    const side = (column.dataset.bowtieSide || "event") as BowtieSide;
    column.classList.remove("drag-over");
    void moveRiskControlSide(id, side);
  });
}

function renderAssuranceQueue() {
  if (!document.getElementById("assuranceQueue")) return;
  const rows = assuranceTests
    .slice()
    .sort((a, b) => assuranceSortRank(a) - assuranceSortRank(b) || (a.dueDate || "9999-12-31").localeCompare(b.dueDate || "9999-12-31"));
  const exceptions = rows.filter((test) => test.result === "fail" || (test.result === "not_run" && isPast(test.dueDate)));
  $("assuranceCount").textContent = `${exceptions.length} exceptions`;
  $("assuranceQueue").innerHTML = rows.length
    ? rows
        .slice(0, 12)
        .map(
          (test) => `<div class="assurance-item">
            <div class="assurance-main"><span>${esc(test.riskId)} · ${esc(test.controlCode)}</span><b>${esc(test.testName)}</b><small>${esc(test.owner || "No owner")} · due ${esc(test.dueDate ? fmtDate(test.dueDate) : "not set")}</small></div>
            <div class="assurance-state">${statusToken(assuranceResultLabel(test.result), assuranceResultTone(test.result, test.dueDate))}<button class="lnk danger-link control-admin-only" data-assurance-delete="${escAttr(test.id)}">Delete</button></div>
          </div>`,
        )
        .join("")
    : '<div class="muted">No assurance tests recorded.</div>';
}

function renderObligationQueue() {
  if (!document.getElementById("obligationQueue")) return;
  const rows = controlObligations
    .slice()
    .sort((a, b) => obligationSortRank(a) - obligationSortRank(b) || (a.dueDate || "9999-12-31").localeCompare(b.dueDate || "9999-12-31"));
  $("obligationQueue").innerHTML = rows.length
    ? rows
        .map(
          (obligation) => `<div class="obligation-item">
            <div><span>${esc(obligation.controlCode)} · ${esc(obligationTypeLabel(obligation.obligationType))}</span><b>${esc(obligation.description)}</b><small>${esc(obligation.reference || "No reference")} · ${esc(obligation.owner || "No owner")} · ${esc(obligation.dueDate ? fmtDate(obligation.dueDate) : "no date")}</small></div>
            <div>${statusToken(obligationStatusLabel(obligation.status), obligationTone(obligation.status, obligation.dueDate))}<button class="lnk danger-link control-admin-only" data-obligation-delete="${escAttr(obligation.id)}">Delete</button></div>
          </div>`,
        )
        .join("")
    : '<div class="muted">No control obligations recorded.</div>';
}

function fillControlSelectors() {
  const riskOptions = risks
    .filter((risk) => risk.status !== "Closed")
    .map((risk) => `<option value="${escAttr(risk.id)}">${esc(risk.id)} - ${esc(risk.title)}</option>`)
    .join("");
  const activeControlOptions = controls
    .filter((control) => control.status === "active")
    .map((control) => `<option value="${escAttr(control.id)}">${esc(control.code)} - ${esc(control.name)}</option>`)
    .join("");
  const riskControlOptions = riskControls
    .map((row) => `<option value="${escAttr(row.id)}">${esc(row.riskId)} - ${esc(row.controlCode)} (${esc(bowtieSideLabel(row.bowtieSide))})</option>`)
    .join("");
  setOptions("rc-risk", riskOptions || '<option value="">No active risks</option>');
  setOptions("rc-control", activeControlOptions || '<option value="">No active controls</option>');
  setOptions("assure-risk-control", riskControlOptions || '<option value="">No risk-control links</option>');
  setOptions("obl-control", activeControlOptions || '<option value="">No active controls</option>');
  setOptions("samp-control", activeControlOptions || '<option value="">No active controls</option>');
  const obligationOptions = controlObligations
    .map((o) => `<option value="${escAttr(o.id)}">${esc(o.controlCode)} - ${esc(o.reference || o.description)}</option>`)
    .join("");
  setOptions("esc-obligation", obligationOptions || '<option value="">No obligations</option>');
}

function setOptions(id: string, html: string) {
  const select = $<HTMLSelectElement>(id);
  const current = select.value;
  select.innerHTML = html;
  if (Array.from(select.options).some((option) => option.value === current)) select.value = current;
}

async function saveControlFromForm() {
  if (!canManageControlsUi()) return;
  const payload = controlPayloadFromForm();
  if (!payload.code || !payload.name) {
    toast("Control code and name are required");
    return;
  }
  try {
    const id = value("control-id");
    if (id) await updateControl(id, payload);
    else await createControl(payload);
    clearControlForm();
    await refreshControls(false);
    toast(id ? "Control updated" : "Control created");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function controlPayloadFromForm(): ControlInput {
  return {
    code: value("control-code"),
    name: value("control-name"),
    description: value("control-description"),
    controlType: value("control-type") as ControlInput["controlType"],
    owner: value("control-owner"),
    criticality: value("control-criticality") as ControlInput["criticality"],
    effectiveness: value("control-effectiveness") as ControlInput["effectiveness"],
    status: value("control-status") as ControlInput["status"],
    source: value("control-source"),
  };
}

function fillControlForm(id: string) {
  const control = controls.find((item) => item.id === id);
  if (!control) return;
  setValue("control-id", control.id);
  setValue("control-code", control.code);
  setValue("control-name", control.name);
  setValue("control-description", control.description);
  setValue("control-type", control.controlType);
  setValue("control-owner", control.owner);
  setValue("control-criticality", control.criticality);
  setValue("control-effectiveness", control.effectiveness);
  setValue("control-status", control.status);
  setValue("control-source", control.source);
  $("control-code").focus();
}

function clearControlForm() {
  setValue("control-id", "");
  setValue("control-code", "");
  setValue("control-name", "");
  setValue("control-description", "");
  setValue("control-type", "preventive");
  setValue("control-owner", "");
  setValue("control-criticality", "key");
  setValue("control-effectiveness", "untested");
  setValue("control-status", "active");
  setValue("control-source", "");
}

async function deactivateControlFromForm() {
  const id = value("control-id");
  if (!id) return;
  await deactivateControlFromList(id);
}

async function deactivateControlFromList(id: string) {
  if (!id || !canManageControlsUi()) return;
  try {
    await deactivateControl(id);
    clearControlForm();
    await refreshControls(false);
    toast("Control deactivated");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function saveRiskControlFromForm() {
  if (!canManageControlsUi()) return;
  const control = controls.find((item) => item.id === value("rc-control"));
  const payload: RiskControlInput = {
    riskId: value("rc-risk"),
    controlId: value("rc-control"),
    controlCode: control?.code || "",
    bowtieSide: value("rc-side") as BowtieSide,
    linkType: value("rc-link-type") as ControlType,
    coverageNotes: value("rc-notes"),
    assuranceStatus: value("rc-assurance") as AssuranceStatus,
    nextTestDue: value("rc-next-test"),
  };
  try {
    await createRiskControl(payload);
    setValue("rc-notes", "");
    setValue("rc-next-test", "");
    await refreshControls(false);
    toast("Control linked to risk");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function saveAssuranceFromForm() {
  if (!canManageControlsUi()) return;
  const payload: AssuranceTestInput = {
    riskControlId: value("assure-risk-control"),
    testName: value("assure-name"),
    testType: value("assure-type") as AssuranceTestInput["testType"],
    owner: value("assure-owner"),
    dueDate: value("assure-due"),
    completedAt: value("assure-completed"),
    result: value("assure-result") as AssuranceTestInput["result"],
    evidenceRef: value("assure-evidence"),
    notes: value("assure-notes"),
  };
  if (!payload.riskControlId || !payload.testName) {
    toast("Risk control and test name are required");
    return;
  }
  try {
    await createAssuranceTest(payload);
    setValue("assure-name", "");
    setValue("assure-evidence", "");
    setValue("assure-notes", "");
    await refreshControls(false);
    toast("Assurance test saved");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function saveObligationFromForm() {
  if (!canManageControlsUi()) return;
  const control = controls.find((item) => item.id === value("obl-control"));
  const payload: ControlObligationInput = {
    controlId: value("obl-control"),
    controlCode: control?.code || "",
    obligationType: value("obl-type") as ControlObligationInput["obligationType"],
    reference: value("obl-reference"),
    description: value("obl-description"),
    owner: value("obl-owner"),
    frequency: value("obl-frequency"),
    dueDate: value("obl-due"),
    status: value("obl-status") as ControlObligationInput["status"],
  };
  if (!payload.controlId || !payload.description) {
    toast("Control and obligation description are required");
    return;
  }
  try {
    await createControlObligation(payload);
    setValue("obl-description", "");
    setValue("obl-reference", "");
    await refreshControls(false);
    toast("Obligation saved");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function deleteRiskControlFromView(id: string) {
  if (!id || !canManageControlsUi()) return;
  try {
    await deleteRiskControl(id);
    await refreshControls(false);
    toast("Risk-control link removed");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function deleteAssuranceFromView(id: string) {
  if (!id || !canManageControlsUi()) return;
  try {
    await deleteAssuranceTest(id);
    await refreshControls(false);
    toast("Assurance test deleted");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function deleteObligationFromView(id: string) {
  if (!id || !canManageControlsUi()) return;
  try {
    await deleteControlObligation(id);
    await refreshControls(false);
    toast("Obligation deleted");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function bindReporting() {
  $("reporting-refresh").addEventListener("click", () => void refreshReporting());
  $("rp-create").addEventListener("click", () => void createPeriodFromForm());
  $("rr-log").addEventListener("click", () => void logReportRunFromForm());
  $("rt-save").addEventListener("click", () => void saveReportTemplateFromForm());
  $("rt-clear").addEventListener("click", clearReportTemplateForm);
  $("rl-save").addEventListener("click", () => void saveReportLayoutFromForm());
  $("rl-clear").addEventListener("click", clearReportLayoutForm);
  $("rl-seed").addEventListener("click", seedReportLayoutFromTemplate);
  $("rl-template").addEventListener("change", seedReportLayoutFromTemplate);
  $("rdl-save").addEventListener("click", () => void saveReportDistributionListFromForm());
  $("rdl-clear").addEventListener("click", clearReportDistributionListForm);
  $("rs-save").addEventListener("click", () => void saveReportScheduleFromForm());
  $("rs-clear").addEventListener("click", clearReportScheduleForm);
  $("rs-run").addEventListener("click", () => void runReportScheduleFromView());
  $("rs-dispatch-due").addEventListener("click", () => void dispatchDueSchedulesFromView());
  $("notification-dispatch-due").addEventListener("click", () => void dispatchDueNotificationsFromView());
  $("notificationEventList").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-notification-action]") as HTMLElement | null;
    if (!button) return;
    void updateNotificationEventFromView(button.dataset.notificationId || "", button.dataset.notificationAction || "");
  });
  $("rs-template").addEventListener("change", renderScheduleTemplateOptions);
  $("pack-template").addEventListener("change", () => renderReportPackGenerator());
  $("pack-generate").addEventListener("click", () => void generateReportPackFromForm());
  $("reportTemplates").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-report-template-action]") as HTMLElement | null;
    if (!button) return;
    const id = button.dataset.reportTemplateId || "";
    const action = button.dataset.reportTemplateAction || "";
    if (action === "edit") fillReportTemplateForm(id);
    if (action === "use") void logReportPackFromTemplate(id);
    if (action === "deactivate") void deactivateTemplateFromView(id);
  });
  $("reportLayouts").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-report-layout-action]") as HTMLElement | null;
    if (!button) return;
    const id = button.dataset.reportLayoutId || "";
    const action = button.dataset.reportLayoutAction || "";
    if (action === "edit") fillReportLayoutForm(id);
    if (action === "use") seedReportPackLayout(id);
    if (action === "retire") void retireLayoutFromView(id);
  });
  $("reportDistributionLists").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-report-distribution-action]") as HTMLElement | null;
    if (!button) return;
    const id = button.dataset.reportDistributionId || "";
    const action = button.dataset.reportDistributionAction || "";
    if (action === "edit") fillReportDistributionListForm(id);
    if (action === "retire") void retireDistributionListFromView(id);
  });
  $("reportSchedules").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-report-schedule-action]") as HTMLElement | null;
    if (!button) return;
    const id = button.dataset.reportScheduleId || "";
    const action = button.dataset.reportScheduleAction || "";
    if (action === "edit") fillReportScheduleForm(id);
    if (action === "run") void runReportScheduleFromView(id);
    if (action === "retire") void retireScheduleFromView(id);
  });
  $("reportDeliveryJobs").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-delivery-send-id]") as HTMLElement | null;
    if (!button) return;
    void dryRunReportDeliveryFromView(button.dataset.deliverySendId || "");
  });
  $("reportPacks").addEventListener("click", (event) => {
    const issueButton = (event.target as HTMLElement).closest("[data-pack-issue-id]") as HTMLElement | null;
    if (issueButton) {
      void issueReportPackFromView(issueButton.dataset.packIssueId || "");
      return;
    }
    const button = (event.target as HTMLElement).closest("[data-pack-template-id]") as HTMLElement | null;
    if (!button) return;
    seedReportPackForm(button.dataset.packTemplateId || "");
  });
}

function renderAll() {
  fillFcat();
  fillCatSelect($<HTMLSelectElement>("rm-cat"));
  fillScale($<HTMLSelectElement>("rm-lpre"), LIKE);
  fillScale($<HTMLSelectElement>("rm-ipre"), IMP);
  fillScale($<HTMLSelectElement>("rm-lpost"), LIKE);
  fillScale($<HTMLSelectElement>("rm-ipost"), IMP);
  renderPermissionMatrix();
  renderUsers();
  renderAudit();
  renderStructureAdmin();
  renderControls();
  renderConfiguration();
  renderCats();
  renderScales();
  renderLegend();
  renderControlCentre();
  renderProgrammeItems();
  renderImports();
  renderEvidence();
  renderQraWorkbench();
  renderSrsIntegration();
  renderTable();
  renderDash();
  renderReviews();
  renderReporting();
}

function renderPermissionMatrix() {
  const matrix = document.getElementById("permissionMatrix");
  const summary = document.getElementById("permissionSummary");
  if (!matrix || !summary || !session) return;
  const permissions = session.permissionMatrix || [];
  const granted = permissions.filter((item) => item.granted);
  const grouped = permissions.reduce<Record<string, typeof permissions>>((acc, item) => {
    (acc[item.module] ||= []).push(item);
    return acc;
  }, {});
  summary.innerHTML = `
    <div><b>${esc(session.user.role)}</b><span>${granted.length}/${permissions.length} permissions granted for ${esc(session.user.name)}</span></div>
    <div>${statusToken(canAdminUi() ? "Tenant admin" : "Role scoped", canAdminUi() ? "green" : "blue")}</div>`;
  matrix.innerHTML = `
    <thead><tr><th>Module</th><th>Permission</th><th>Status</th></tr></thead>
    <tbody>
      ${Object.entries(grouped)
        .map(([moduleName, rows]) =>
          rows
            .map(
              (row, index) => `<tr>
                <td>${index === 0 ? esc(moduleName) : ""}</td>
                <td><b>${esc(row.key)}</b><small>${esc(row.label)}</small></td>
                <td>${statusToken(row.granted ? "Granted" : "Denied", row.granted ? "green" : "neutral")}</td>
              </tr>`,
            )
            .join(""),
        )
        .join("")}
    </tbody>`;
}

function renderUsers() {
  const tb = $("usersTb");
  if (!canAdminUi()) {
    tb.innerHTML = '<tr><td colspan="5" class="muted">Admin role required to manage tenant users.</td></tr>';
    return;
  }

  tb.innerHTML = users
    .map((user) => {
      const status = user.active ? '<span class="pill o-managed">Active</span>' : '<span class="pill o-closed">Inactive</span>';
      const self = user.id === session?.user.id;
      const action =
        user.active && !self
          ? `<button class="lnk" data-user-edit="${escAttr(user.id)}">Edit</button><button class="lnk danger" data-user-deactivate="${escAttr(user.id)}">Deactivate</button>`
          : `<button class="lnk" data-user-edit="${escAttr(user.id)}">Edit</button>`;
      return `<tr><td>${esc(user.name)}</td><td>${esc(user.email)}</td><td>${esc(user.role)}</td><td>${status}</td><td>${action}</td></tr>`;
    })
    .join("");

  tb.querySelectorAll("[data-user-edit]").forEach((button) => {
    button.addEventListener("click", () => editUser((button as HTMLElement).dataset.userEdit || ""));
  });
  tb.querySelectorAll("[data-user-deactivate]").forEach((button) => {
    button.addEventListener("click", () => void deactivateUserFromAdmin((button as HTMLElement).dataset.userDeactivate || ""));
  });
  renderPackageGrants();
}

function renderPackageGrants() {
  if (!document.getElementById("packageGrantsTb")) return;
  const userSelect = $<HTMLSelectElement>("package-grant-user");
  const grantableUsers = users.filter((user) => user.role !== "Admin" && user.active);
  const currentUser = userSelect.value;
  userSelect.innerHTML = grantableUsers.length
    ? grantableUsers.map((user) => `<option value="${escAttr(user.id)}">${esc(user.name)} · ${esc(user.role)}</option>`).join("")
    : '<option value="">No non-admin users</option>';
  if (grantableUsers.some((user) => user.id === currentUser)) userSelect.value = currentUser;
  const packageSelect = $<HTMLSelectElement>("package-grant-package");
  const currentPackage = packageSelect.value;
  packageSelect.innerHTML = packageOptions.length
    ? packageOptions.map((pkg) => `<option value="${escAttr(pkg.package_code)}">${esc(pkg.package_code)}${pkg.package_name ? ` · ${esc(pkg.package_name)}` : ""}</option>`).join("")
    : '<option value="">No packages defined</option>';
  if (packageOptions.some((pkg) => pkg.package_code === currentPackage)) packageSelect.value = currentPackage;

  const tb = $("packageGrantsTb");
  tb.innerHTML = packageGrants.length
    ? packageGrants
        .map((grant) => `<tr>
          <td><b>${esc(grant.user_name)}</b><small>${esc(grant.user_email)} · ${esc(grant.user_role)}</small></td>
          <td>${esc(grant.package_code)}</td>
          <td>${statusToken(grant.access_level, grant.access_level === "contribute" ? "blue" : "neutral")}</td>
          <td>${esc(grant.notes)}</td>
          <td><button class="lnk danger" data-grant-revoke="${escAttr(grant.grant_id)}">Revoke</button></td>
        </tr>`)
        .join("")
    : '<tr><td colspan="5" class="muted">No package grants — all non-admin users currently have full tenant access.</td></tr>';
  tb.querySelectorAll("[data-grant-revoke]").forEach((button) => {
    button.addEventListener("click", () => void revokePackageGrantFromAdmin((button as HTMLElement).dataset.grantRevoke || ""));
  });
  renderCompliance();
  renderIntegrations();
}

function integrationStatusTone(status: string) {
  if (status === "verified") return "green";
  if (status === "configured") return "blue";
  if (status === "scoped_out") return "amber";
  return "neutral";
}
function integrationStatusLabel(status: string) {
  return status.replace(/_/g, " ");
}

function renderIntegrations() {
  if (!document.getElementById("integrationsCard")) return;
  const verified = integrationSettings.filter((i) => i.status === "verified").length;
  const scopedOut = integrationSettings.filter((i) => i.status === "scoped_out").length;
  const pending = integrationSettings.filter((i) => i.status === "not_configured").length;
  $("integrationKpis").innerHTML = [
    { label: "Integrations governed", value: integrationSettings.length, sub: "register" },
    { label: "Verified", value: verified, sub: "readiness attested" },
    { label: "Scoped out", value: scopedOut, sub: "with evidence" },
    { label: "Pending config", value: pending, sub: pending ? "needs disposition" : "all dispositioned" },
  ]
    .map((kpi) => `<div><b>${esc(String(kpi.value))}</b><span>${esc(kpi.label)}</span><small>${esc(kpi.sub)}</small></div>`)
    .join("");

  const statusOptions = (current: string) =>
    (["not_configured", "configured", "verified", "scoped_out"] as const)
      .map((s) => `<option value="${s}"${s === current ? " selected" : ""}>${integrationStatusLabel(s)}</option>`)
      .join("");

  $("integrationList").innerHTML = integrationSettings
    .map((i) => {
      const k = escAttr(i.integration_key);
      return `<div class="integration-row" data-integration-key="${k}">
        <div class="integration-head">
          <div><b>${esc(i.display_name)}</b><span class="integration-cat">${esc(i.category)} · ${esc(i.provider || "no provider")}</span></div>
          ${statusToken(integrationStatusLabel(i.status), integrationStatusTone(i.status))}
        </div>
        <p class="integration-dep">${esc(i.dependency || "")}</p>
        ${i.evidence_ref ? `<p class="integration-evidence"><b>Evidence:</b> ${esc(i.evidence_ref)}</p>` : ""}
        ${i.last_verified_at ? `<p class="integration-verify">Last attested ${fmtDateTime(i.last_verified_at)}${i.last_verified_by_name ? ` by ${esc(i.last_verified_by_name)}` : ""} — ${esc(i.verification_note)}</p>` : ""}
        <div class="integration-edit">
          <label>Disposition<select id="intg-status-${k}">${statusOptions(i.status)}</select></label>
          <label>Owner<input id="intg-owner-${k}" value="${escAttr(i.owner)}" placeholder="Accountable owner"/></label>
          <label class="integration-wide">Config (JSON)<textarea id="intg-config-${k}" class="integration-config" spellcheck="false">${esc(i.config_json)}</textarea></label>
          <label class="integration-wide">Scope-out reason<input id="intg-scope-${k}" value="${escAttr(i.scope_out_reason)}" placeholder="Required when scoped out"/></label>
          <label class="integration-wide">Evidence pointer<input id="intg-evidence-${k}" value="${escAttr(i.evidence_ref)}" placeholder="Shipped interface / doc"/></label>
        </div>
        <div class="integration-actions">
          <button class="btn" data-integration-verify="${k}">Attest readiness</button>
          <button class="btnp" data-integration-save="${k}">Save disposition</button>
        </div>
      </div>`;
    })
    .join("");

  $("integrationList").querySelectorAll("[data-integration-save]").forEach((b) =>
    b.addEventListener("click", () => void saveIntegrationFromAdmin((b as HTMLElement).dataset.integrationSave || "")),
  );
  $("integrationList").querySelectorAll("[data-integration-verify]").forEach((b) =>
    b.addEventListener("click", () => void verifyIntegrationFromAdmin((b as HTMLElement).dataset.integrationVerify || "")),
  );
  applyRoleLocks();
}

async function saveIntegrationFromAdmin(key: string) {
  if (!key || !canAdminUi()) return;
  const existing = integrationSettings.find((i) => i.integration_key === key);
  if (!existing) return;
  try {
    const result = await saveIntegration(key, {
      displayName: existing.display_name,
      category: existing.category,
      status: value(`intg-status-${key}`) as IntegrationSetting["status"],
      provider: existing.provider,
      configJson: value(`intg-config-${key}`) || "{}",
      owner: value(`intg-owner-${key}`),
      dependency: existing.dependency,
      scopeOutReason: value(`intg-scope-${key}`),
      evidenceRef: value(`intg-evidence-${key}`),
      notes: existing.notes,
    });
    integrationSettings = result.settings;
    renderIntegrations();
    $("integration-note").textContent = `Saved disposition for ${existing.display_name}.`;
    toast("Integration disposition saved");
  } catch (err) {
    $("integration-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

async function verifyIntegrationFromAdmin(key: string) {
  if (!key || !canAdminUi()) return;
  try {
    const result = await verifyIntegration(key);
    integrationSettings = result.settings;
    renderIntegrations();
    $("integration-note").textContent = result.ok ? `Readiness attested for ${result.setting?.display_name || key}.` : result.note;
    toast(result.ok ? "Readiness attested" : "Readiness not attested");
  } catch (err) {
    $("integration-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

function complianceStatusTone(status: string) {
  if (status === "implemented" || status === "restore_tested" || status === "verified" || status === "active") return "green";
  if (status === "partial" || status === "recorded") return "amber";
  if (status === "failed") return "red";
  if (status === "not_applicable" || status === "retired") return "neutral";
  return "blue";
}

function renderCompliance() {
  if (!document.getElementById("complianceCard")) return;
  const activeRet = retentionPolicies.filter((p) => p.status === "active").length;
  const implemented = securityControls.filter((c) => c.status === "implemented").length;
  const openControls = securityControls.filter((c) => c.status === "planned" || c.status === "partial").length;
  const restoreTested = backupManifests.filter((b) => b.status === "restore_tested").length;
  $("complianceKpis").innerHTML = [
    { label: "Retention policies", value: activeRet, sub: "active" },
    { label: "Controls implemented", value: implemented, sub: `${openControls} open` },
    { label: "Backups recorded", value: backupManifests.length, sub: `${restoreTested} restore-tested` },
    { label: "Security controls", value: securityControls.length, sub: "in register" },
  ]
    .map((kpi) => `<div><b>${esc(String(kpi.value))}</b><span>${esc(kpi.label)}</span><small>${esc(kpi.sub)}</small></div>`)
    .join("");

  $("retentionTb").innerHTML = retentionPolicies.length
    ? retentionPolicies
        .map((p) => `<tr>
          <td><b>${esc(p.data_category)}</b><small>${esc(p.policy_key)}</small></td>
          <td>${p.retention_months}</td>
          <td>${esc(p.owner)}</td>
          <td>${esc(p.basis)}</td>
          <td>${statusToken(p.status, complianceStatusTone(p.status))}</td>
          <td>${p.status === "active" ? `<button class="lnk danger" data-retention-retire="${escAttr(p.retention_policy_id)}">Retire</button>` : ""}</td>
        </tr>`)
        .join("")
    : '<tr><td colspan="6" class="muted">No retention policies yet.</td></tr>';
  $("retentionTb").querySelectorAll("[data-retention-retire]").forEach((b) => b.addEventListener("click", () => void retireRetentionFromAdmin((b as HTMLElement).dataset.retentionRetire || "")));

  $("securityTb").innerHTML = securityControls.length
    ? securityControls
        .map((c) => `<tr>
          <td><b>${esc(c.control_ref)}</b></td>
          <td>${esc(c.domain)}</td>
          <td>${esc(c.title)}<small>${esc(c.evidence_ref)}</small></td>
          <td>${statusToken(c.status.replace(/_/g, " "), complianceStatusTone(c.status))}</td>
          <td>${esc(c.owner)}</td>
        </tr>`)
        .join("")
    : '<tr><td colspan="5" class="muted">No security controls yet.</td></tr>';

  $("backupTb").innerHTML = backupManifests.length
    ? backupManifests
        .map((b) => `<tr>
          <td>${fmtDateTime(b.created_at)}</td>
          <td>${esc(b.storage_location)}<small>${esc(b.checksum)} · ${b.table_count} tables</small></td>
          <td>${statusToken(b.status.replace(/_/g, " "), complianceStatusTone(b.status))}</td>
          <td>${esc(b.performed_by)}</td>
        </tr>`)
        .join("")
    : '<tr><td colspan="4" class="muted">No backup evidence recorded yet.</td></tr>';
}

async function saveRetentionFromAdmin() {
  if (!canAdminUi()) return;
  const payload: RetentionPolicyInput = {
    policyKey: value("retention-key"),
    dataCategory: value("retention-category"),
    retentionMonths: Number(value("retention-months") || 0),
    basis: value("retention-basis"),
    disposalMethod: "",
    owner: value("retention-owner"),
    reviewDue: "",
    status: "active",
    notes: "",
  };
  if (!payload.policyKey || !payload.dataCategory) {
    $("compliance-note").textContent = "Policy key and data category are required.";
    return;
  }
  try {
    const result = await createRetentionPolicy(payload);
    retentionPolicies = result.policies;
    ["retention-key", "retention-category", "retention-months", "retention-owner", "retention-basis"].forEach((id) => setValue(id, ""));
    renderCompliance();
    $("compliance-note").textContent = "Retention policy added.";
    toast("Retention policy added");
  } catch (err) {
    $("compliance-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

async function retireRetentionFromAdmin(id: string) {
  if (!canAdminUi() || !id) return;
  try {
    const result = await retireRetentionPolicy(id);
    retentionPolicies = result.policies;
    renderCompliance();
    $("compliance-note").textContent = "Retention policy retired.";
  } catch (err) {
    $("compliance-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

async function saveSecurityControlFromAdmin() {
  if (!canAdminUi()) return;
  const payload: SecurityControlInput = {
    controlRef: value("security-ref"),
    domain: value("security-domain"),
    title: value("security-title"),
    status: (value("security-status") || "planned") as SecurityControlInput["status"],
    owner: value("security-owner"),
    evidenceRef: "",
    lastReview: "",
    reviewDue: "",
    notes: "",
  };
  if (!payload.controlRef || !payload.title) {
    $("compliance-note").textContent = "Control reference and title are required.";
    return;
  }
  try {
    const result = await createSecurityControl(payload);
    securityControls = result.controls;
    ["security-ref", "security-domain", "security-title", "security-owner"].forEach((id) => setValue(id, ""));
    renderCompliance();
    $("compliance-note").textContent = "Security control added.";
    toast("Security control added");
  } catch (err) {
    $("compliance-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

async function recordBackupFromAdmin() {
  if (!canAdminUi()) return;
  const payload: BackupManifestInput = {
    backupScope: "full",
    storageLocation: value("backup-location"),
    checksum: value("backup-checksum"),
    tableCount: 0,
    rowCount: 0,
    status: (value("backup-status") || "recorded") as BackupManifestInput["status"],
    performedBy: value("backup-performer"),
    restoreTestedAt: "",
    notes: "",
  };
  if (!payload.storageLocation) {
    $("compliance-note").textContent = "Storage location is required to record a backup.";
    return;
  }
  try {
    const result = await recordBackupManifest(payload);
    backupManifests = result.manifests;
    ["backup-location", "backup-checksum", "backup-performer"].forEach((id) => setValue(id, ""));
    renderCompliance();
    $("compliance-note").textContent = "Backup evidence recorded.";
    toast("Backup recorded");
  } catch (err) {
    $("compliance-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

async function savePackageGrantFromAdmin() {
  if (!canAdminUi()) return;
  const payload: PackageAccessGrantInput = {
    userId: value("package-grant-user"),
    packageCode: value("package-grant-package"),
    accessLevel: (value("package-grant-level") || "contribute") as PackageAccessGrantInput["accessLevel"],
    notes: value("package-grant-notes"),
  };
  if (!payload.userId || !payload.packageCode) {
    $("package-grant-note").textContent = "Select a user and a package to grant access.";
    return;
  }
  try {
    const result = await createPackageGrant(payload);
    packageGrants = result.grants;
    setValue("package-grant-notes", "");
    renderPackageGrants();
    $("package-grant-note").textContent = "Package access granted.";
    toast("Package access granted");
  } catch (err) {
    $("package-grant-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

async function revokePackageGrantFromAdmin(id: string) {
  if (!canAdminUi() || !id) return;
  try {
    const result = await revokePackageGrant(id);
    packageGrants = result.grants;
    renderPackageGrants();
    $("package-grant-note").textContent = "Package grant revoked.";
    toast("Package grant revoked");
  } catch (err) {
    $("package-grant-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

function editUser(id: string) {
  const user = users.find((item) => item.id === id);
  if (!user) return;
  setValue("user-id", user.id);
  setValue("user-name", user.name);
  setValue("user-email", user.email);
  setValue("user-role", user.role);
  $<HTMLInputElement>("user-active").checked = user.active;
  $("user-save").textContent = "Save changes";
  $("user-name").focus();
}

function clearUserForm() {
  setValue("user-id", "");
  setValue("user-name", "");
  setValue("user-email", "");
  setValue("user-role", "Viewer");
  $<HTMLInputElement>("user-active").checked = true;
  $("user-save").textContent = "Save user";
}

async function saveUserForm() {
  const input: UserInput = {
    name: value("user-name"),
    email: value("user-email").toLowerCase(),
    role: value("user-role") as UserInput["role"],
    active: $<HTMLInputElement>("user-active").checked,
  };
  if (!input.name || !input.email) {
    toast("Name and email are required");
    return;
  }

  try {
    const id = value("user-id");
    const result = id ? await updateUser(id, input) : await createUser(input);
    users = result.users;
    renderUsers();
    clearUserForm();
    toast("User saved");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function deactivateUserFromAdmin(id: string) {
  if (!id) return;
  const user = users.find((item) => item.id === id);
  const ok = await confirmDestructive({
    title: "Deactivate user?",
    message: `${user ? `${user.name} (${user.email})` : "This user"} will lose access to this tenant. Existing audit history is retained.`,
    confirmLabel: "Deactivate user",
  });
  if (!ok) return;
  try {
    const result = await deactivateUser(id);
    users = result.users;
    renderUsers();
    clearUserForm();
    toast("User deactivated");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function renderAudit() {
  const tb = $("auditTb");
  if (!canAdminUi()) {
    tb.innerHTML = '<tr><td colspan="5" class="muted">Admin role required to view audit history.</td></tr>';
    return;
  }

  if (!auditEntries.length) {
    tb.innerHTML = '<tr><td colspan="5" class="muted">No tenant changes have been recorded yet.</td></tr>';
    return;
  }

  tb.innerHTML = auditEntries
    .map((entry) => {
      const record = `${entry.entityType} ${entry.entityId}`;
      return `<tr><td class="muted">${esc(fmtDateTime(entry.createdAt))}</td><td>${esc(entry.userName)}<div class="muted" style="font-size:11px">${esc(entry.userEmail)}</div></td><td><span class="pill o-open">${esc(entry.action)}</span></td><td>${esc(record)}</td><td class="muted">${esc(auditSummary(entry))}</td></tr>`;
    })
    .join("");
}

async function refreshAudit() {
  if (!canAdminUi()) return;
  try {
    auditEntries = (await loadAudit()).audit;
    renderAudit();
    toast("Audit trail refreshed");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function renderStructureAdmin() {
  if (!document.getElementById("taxonomyList")) return;
  if (!canAdminUi()) {
    $("taxonomyList").innerHTML = '<div class="muted">Admin role required to manage programme structure and taxonomies.</div>';
    return;
  }

  const typeCounts = TAXONOMY_TYPE_DEFS.map((def) => ({
    ...def,
    count: taxonomyItems.filter((item) => item.taxonomyType === def.key && item.status === "active").length,
  }));
  const projectCodes = new Set(qraReadinessRows.map((row) => rowString(row, "project_code")).filter(Boolean));
  const packageCodes = new Set(qraReadinessRows.map((row) => rowString(row, "package_code")).filter(Boolean));
  $("taxonomySummary").textContent = `${taxonomyItems.filter((item) => item.status === "active").length} active items`;
  $("structureKpis").innerHTML = [
    `<div><b>${projectCodes.size}</b><span>Projects mapped</span></div>`,
    `<div><b>${packageCodes.size}</b><span>Packages mapped</span></div>`,
    ...typeCounts.map((item) => `<div><b>${item.count}</b><span>${item.label}</span></div>`),
  ].join("");

  const filter = value("tax-filter") as TaxonomyType | "";
  const query = value("tax-search").toLowerCase();
  const rows = taxonomyItems
    .filter((item) => (!filter ? true : item.taxonomyType === filter))
    .filter((item) => {
      if (!query) return true;
      return [item.taxonomyType, item.code, item.name, item.parentCode, item.parentName, item.owner, item.description].join(" ").toLowerCase().includes(query);
    })
    .sort((a, b) => taxonomyTypeRank(a.taxonomyType) - taxonomyTypeRank(b.taxonomyType) || a.sortOrder - b.sortOrder || a.code.localeCompare(b.code));

  $("taxonomyList").innerHTML = rows.length ? rows.map((item) => taxonomyItemHtml(item)).join("") : '<div class="muted">No taxonomy items match this view.</div>';
}

function taxonomyItemHtml(item: TaxonomyItem) {
  return `<div class="taxonomy-item${item.status === "inactive" ? " inactive" : ""}">
    <div class="taxonomy-head">
      <div><span>${esc(taxonomyLabel(item.taxonomyType))}</span><b>${esc(item.code)} · ${esc(item.name)}</b></div>
      ${statusToken(item.status === "active" ? "Active" : "Inactive", item.status === "active" ? "green" : "neutral")}
    </div>
    <div class="taxonomy-meta">
      ${item.parentCode ? `<span>Parent ${esc(item.parentCode)}</span>` : "<span>Top level</span>"}
      ${item.owner ? `<span>${esc(item.owner)}</span>` : "<span>No owner</span>"}
      <span>Sort ${item.sortOrder}</span>
    </div>
    ${item.description ? `<p>${esc(item.description)}</p>` : ""}
    <div class="taxonomy-actions">
      <button class="btn" data-tax-action="edit" data-tax-item-id="${escAttr(item.id)}">Edit</button>
      <button class="btn" data-tax-action="deactivate" data-tax-item-id="${escAttr(item.id)}" ${item.status === "active" ? "" : "disabled"}>Deactivate</button>
    </div>
  </div>`;
}

async function saveTaxonomyFromForm() {
  if (!canAdminUi()) return;
  const payload = taxonomyPayloadFromForm();
  const id = value("tax-id");
  try {
    if (id) await updateTaxonomyItem(id, payload);
    else await createTaxonomyItem(payload);
    taxonomyItems = (await loadTaxonomyItems()).items;
    clearTaxonomyForm();
    renderStructureAdmin();
    toast(id ? "Taxonomy item updated" : "Taxonomy item created");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function taxonomyPayloadFromForm(): TaxonomyItemInput {
  return {
    taxonomyType: value("tax-type") as TaxonomyType,
    code: value("tax-code"),
    name: value("tax-name"),
    parentCode: value("tax-parent"),
    description: value("tax-description"),
    owner: value("tax-owner"),
    status: value("tax-status") as TaxonomyItemInput["status"],
    sortOrder: Number.parseInt(value("tax-sort"), 10) || 0,
  };
}

function fillTaxonomyForm(id: string) {
  const item = taxonomyItems.find((row) => row.id === id);
  if (!item) return;
  setValue("tax-id", item.id);
  setValue("tax-type", item.taxonomyType);
  setValue("tax-status", item.status);
  setValue("tax-code", item.code);
  setValue("tax-parent", item.parentCode);
  setValue("tax-name", item.name);
  setValue("tax-owner", item.owner);
  setValue("tax-sort", String(item.sortOrder));
  setValue("tax-description", item.description);
  $("tax-code").focus();
}

function clearTaxonomyForm() {
  setValue("tax-id", "");
  setValue("tax-type", "rbs");
  setValue("tax-status", "active");
  setValue("tax-code", "");
  setValue("tax-parent", "");
  setValue("tax-name", "");
  setValue("tax-owner", "");
  setValue("tax-sort", "0");
  setValue("tax-description", "");
}

async function deactivateTaxonomyFromView(id: string) {
  if (!canAdminUi()) return;
  try {
    await deactivateTaxonomyItem(id);
    taxonomyItems = (await loadTaxonomyItems()).items;
    renderStructureAdmin();
    toast("Taxonomy item deactivated");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function fillTaxonomyImportSample() {
  setValue(
    "tax-import",
    [
      "type,code,name,parent_code,owner,status,description,sort_order",
      "wbs,10,Example programme workstream,,Programme Controls,active,Top-level imported WBS item,1000",
      "wbs,10.1,Example enabling works,10,Package Manager,active,Child WBS item imported from CSV,1010",
      "cbs,C-EX-100,Example cost account,,Commercial Manager,active,Imported CBS account,100",
    ].join("\n"),
  );
}

async function importTaxonomyFromCsv() {
  if (!canAdminUi()) return;
  const rows = parseTaxonomyCsv(value("tax-import"));
  if (!rows.length) {
    toast("Paste CSV rows before importing");
    return;
  }
  try {
    const result = await importTaxonomyItems(rows);
    taxonomyItems = result.items;
    renderStructureAdmin();
    toast(`Imported ${result.imported.length} taxonomy rows`);
  } catch (err) {
    toast(errorMessage(err));
  }
}

function parseTaxonomyCsv(text: string): TaxonomyItemInput[] {
  const lines = text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
  if (!lines.length) return [];
  const delimiter = detectLineDelimiter(lines[0]);
  const headers = parseCsvLine(lines[0], delimiter).map((header) => header.trim().toLowerCase());
  const index = (names: string[]) => names.map((name) => headers.indexOf(name)).find((item) => item >= 0) ?? -1;
  const typeIndex = index(["type", "taxonomy_type", "taxonomytype"]);
  const codeIndex = index(["code"]);
  const nameIndex = index(["name"]);
  const parentIndex = index(["parent_code", "parentcode", "parent"]);
  const ownerIndex = index(["owner", "function"]);
  const statusIndex = index(["status"]);
  const descriptionIndex = index(["description", "notes"]);
  const sortIndex = index(["sort_order", "sortorder", "sort"]);

  return lines.slice(1).map((line) => {
    const cells = parseCsvLine(line, delimiter);
    return {
      taxonomyType: normaliseTaxonomyType(cells[typeIndex]),
      code: cells[codeIndex] || "",
      name: cells[nameIndex] || "",
      parentCode: parentIndex >= 0 ? cells[parentIndex] || "" : "",
      owner: ownerIndex >= 0 ? cells[ownerIndex] || "" : "",
      status: cells[statusIndex] === "inactive" ? "inactive" : "active",
      description: descriptionIndex >= 0 ? cells[descriptionIndex] || "" : "",
      sortOrder: sortIndex >= 0 ? Number.parseInt(cells[sortIndex] || "0", 10) || 0 : 0,
    };
  });
}

function detectLineDelimiter(headerLine: string) {
  return [",", "\t", ";"]
    .map((delimiter) => ({ delimiter, count: parseCsvLine(headerLine, delimiter).length }))
    .sort((a, b) => b.count - a.count)[0]?.delimiter || ",";
}

function parseCsvLine(line: string, delimiter = ",") {
  const cells: string[] = [];
  let current = "";
  let quoted = false;
  for (let index = 0; index < line.length; index += 1) {
    const char = line[index];
    const next = line[index + 1];
    if (char === '"' && quoted && next === '"') {
      current += '"';
      index += 1;
    } else if (char === '"') {
      quoted = !quoted;
    } else if (char === delimiter && !quoted) {
      cells.push(current.trim());
      current = "";
    } else {
      current += char;
    }
  }
  cells.push(current.trim());
  return cells;
}

function normaliseTaxonomyType(value: string | undefined): TaxonomyType {
  const text = String(value || "").trim().toLowerCase();
  if (text === "wbs" || text === "cbs" || text === "obs") return text;
  return "rbs";
}

function taxonomyLabel(type: string) {
  return TAXONOMY_TYPE_DEFS.find((item) => item.key === type)?.label || type.toUpperCase();
}

function taxonomyTypeRank(type: string) {
  const index = TAXONOMY_TYPE_DEFS.findIndex((item) => item.key === type);
  return index >= 0 ? index : 99;
}

async function refreshReporting(showToast = true) {
  try {
    const [periods, runs, templates, layouts, distributionLists, distributionRecipients, schedules, scheduleRuns, deliveryJobs, deliveryEvents, notifications, packs, packSections, qra, qraExport, qraExposureStates, appetite, escalations, workshopDecisions, indicators, indicatorEvents] = await Promise.all([
      loadReportingPeriods(),
      loadReportRuns(),
      loadReportTemplates(),
      loadReportLayoutVariants(),
      loadReportDistributionLists(),
      loadReportDistributionRecipients(),
      loadReportSchedules(),
      loadReportScheduleRuns(),
      loadReportDeliveryJobs(),
      loadReportDeliveryEvents(),
      loadNotifications(),
      loadReportPacks(),
      loadReportPackSections(),
      loadQraReadiness(),
      loadQraExport("ready"),
      loadQraExposureStates(),
      loadRiskAppetiteAssessments(),
      loadRiskEscalationEvents(),
      loadRiskWorkshopDecisions(),
      loadRiskIndicators(),
      loadRiskIndicatorEvents(),
    ]);
    reportingPeriods = periods.rows;
    reportRuns = runs.rows;
    reportTemplates = templates.rows;
    reportLayoutVariants = layouts.rows;
    reportDistributionLists = distributionLists.rows;
    reportDistributionRecipients = distributionRecipients.rows;
    reportSchedules = schedules.rows;
    reportScheduleRuns = scheduleRuns.rows;
    reportDeliveryJobs = deliveryJobs.rows;
    reportDeliveryEvents = deliveryEvents.rows;
    notificationRules = notifications.rules;
    notificationEvents = notifications.events;
    reportPacks = packs.rows;
    reportPackSections = packSections.rows;
    qraReadinessRows = qra.rows;
    qraExportRows = qraExport.rows;
    qraExposureStateRows = qraExposureStates.rows;
    riskAppetiteRows = appetite.rows;
    riskEscalationEvents = escalations.rows;
    riskWorkshopDecisions = workshopDecisions.rows;
    riskIndicators = indicators.rows;
    riskIndicatorEvents = indicatorEvents.rows;
    renderControlCentre();
    renderQraWorkbench();
    renderReporting();
    renderOpenRiskDetailSupplements();
    if (showToast) toast("Reporting data refreshed");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function refreshProgrammeItems(showToast = true) {
  try {
    programmeItems = (await loadProgrammeItems()).items;
    renderProgrammeItems();
    renderControlCentre();
    if (showToast) toast("Programme intelligence refreshed");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function renderProgrammeItems() {
  if (!document.getElementById("programmeItemList")) return;
  renderProgrammeRiskOptions();
  const filtered = filteredProgrammeItems();
  const active = programmeItems.filter((item) => !["Closed", "Retired"].includes(item.status));
  const opportunities = programmeItems.filter((item) => item.item_type === "opportunity" && item.status !== "Retired");
  const openIssues = programmeItems.filter((item) => item.item_type === "issue" && !["Closed", "Retired"].includes(item.status));
  const depsAssumptions = programmeItems.filter((item) => ["dependency", "assumption"].includes(item.item_type) && !["Closed", "Retired"].includes(item.status));
  const expectedOpportunity = opportunities.reduce((sum, item) => sum + programmeExpectedValue(item), 0);
  $("programmeKpis").innerHTML = [
    { label: "Active items", value: active.length, sub: "non-closed portfolio intelligence" },
    { label: "Opportunities", value: opportunities.length, sub: `expected value £${roundNumber(expectedOpportunity)}k` },
    { label: "Open issues", value: openIssues.length, sub: `${openIssues.filter((item) => item.priority === "Critical").length} critical` },
    { label: "Deps/assumptions", value: depsAssumptions.length, sub: "programme logic under watch" },
  ]
    .map((kpi) => `<div><b>${esc(String(kpi.value))}</b><span>${esc(kpi.label)}</span><small>${esc(kpi.sub)}</small></div>`)
    .join("");

  $("programmeItemList").innerHTML = filtered.length
    ? filtered
        .sort((a, b) => programmeRank(a) - programmeRank(b) || a.code.localeCompare(b.code))
        .map((item) => `<div class="programme-item-card${item.status === "Retired" ? " inactive" : ""}" data-programme-card="${escAttr(item.code)}">
          <div class="programme-item-head">
            <div><span>${esc(programmeTypeLabel(item.item_type))}</span><b>${esc(item.code)} · ${esc(item.title)}</b></div>
            ${statusToken(item.priority, item.priority === "Critical" ? "red" : item.priority === "High" ? "amber" : item.priority === "Medium" ? "blue" : "neutral")}
          </div>
          <p>${esc(item.description || "No description")}</p>
          <div class="report-pack-meta">
            <span>${esc(item.status)}</span>
            <span>${esc(item.owner)}</span>
            ${item.linked_risk_code ? `<span>${esc(item.linked_risk_code)}</span>` : ""}
            ${item.review_due ? `<span>${esc(reviewLabel(item.review_due))}</span>` : ""}
          </div>
          <div class="programme-item-metrics">
            <span>Value ${programmeRangeLabel(item.value_low, item.value_most_likely, item.value_high)}</span>
            <span>Schedule ${programmeRangeLabel(item.schedule_low_days, item.schedule_most_likely_days, item.schedule_high_days)}d</span>
            <span>p/conf ${item.probability_pct ?? "n/a"}%</span>
          </div>
          ${item.decision_required ? `<div class="programme-decision">${esc(item.decision_required)}</div>` : ""}
          <div class="report-template-actions">
            <button class="btnp" data-programme-action="edit" data-programme-code="${escAttr(item.code)}">Edit</button>
            <button class="btn" data-programme-action="retire" data-programme-code="${escAttr(item.code)}" ${item.status === "Retired" ? "disabled" : ""}>Retire</button>
          </div>
        </div>`)
        .join("")
    : '<div class="muted">No programme intelligence items match the filters.</div>';
  applyRoleLocks();
}

function filteredProgrammeItems() {
  const q = value("programme-search").toLowerCase();
  const type = value("programme-type-filter");
  const status = value("programme-status-filter");
  return programmeItems.filter((item) => {
    if (type && item.item_type !== type) return false;
    if (status && item.status !== status) return false;
    if (!q) return true;
    return [item.code, item.title, item.description, item.owner, item.category, item.linked_risk_code, item.linked_risk_title, item.decision_required]
      .join(" ")
      .toLowerCase()
      .includes(q);
  });
}

function renderProgrammeRiskOptions() {
  const select = document.getElementById("pi-linked-risk") as HTMLSelectElement | null;
  if (!select) return;
  const current = select.value;
  select.innerHTML = '<option value="">No linked risk</option>' + risks.map((risk) => `<option value="${escAttr(risk.id)}">${esc(risk.id)} - ${esc(risk.title)}</option>`).join("");
  if (risks.some((risk) => risk.id === current)) select.value = current;
}

function programmeItemPayloadFromForm(): ProgrammeItemInput {
  const n = (id: string) => {
    const raw = value(id);
    if (raw === "") return null;
    const num = Number(raw);
    return Number.isFinite(num) ? num : null;
  };
  return {
    code: value("pi-code") || undefined,
    itemType: value("pi-type") as ProgrammeItemType,
    title: value("pi-title"),
    description: value("pi-description"),
    category: value("pi-category"),
    owner: value("pi-owner"),
    status: value("pi-status") as ProgrammeItemStatus,
    priority: value("pi-priority") as ProgrammeItemPriority,
    linkedRiskCode: value("pi-linked-risk"),
    linkedPackageCode: value("pi-package"),
    wbsCode: value("pi-wbs"),
    cbsCode: value("pi-cbs"),
    obsOwner: value("pi-obs"),
    probabilityPct: n("pi-prob"),
    valueLow: n("pi-value-low"),
    valueMostLikely: n("pi-value-ml"),
    valueHigh: n("pi-value-high"),
    scheduleLowDays: n("pi-sch-low"),
    scheduleMostLikelyDays: n("pi-sch-ml"),
    scheduleHighDays: n("pi-sch-high"),
    responseStrategy: value("pi-response"),
    decisionRequired: value("pi-decision"),
    triggerDate: value("pi-trigger"),
    targetDate: value("pi-target"),
    reviewDue: value("pi-review"),
  };
}

async function saveProgrammeItemFromForm() {
  if (!canManageProgrammeItemsUi()) return;
  const currentCode = value("pi-current-code");
  const payload = programmeItemPayloadFromForm();
  if (!payload.title) {
    $("pi-title").focus();
    return;
  }
  try {
    if (currentCode) await updateProgrammeItem(currentCode, payload);
    else await createProgrammeItem(payload);
    clearProgrammeItemForm();
    await refreshProgrammeItems(false);
    toast(currentCode ? "Programme item updated" : "Programme item created");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function fillProgrammeItemForm(code: string) {
  const item = programmeItems.find((row) => row.code === code);
  if (!item) return;
  setValue("pi-current-code", item.code);
  setValue("pi-code", item.code);
  setValue("pi-type", item.item_type);
  setValue("pi-title", item.title);
  setValue("pi-description", item.description);
  setValue("pi-category", item.category);
  setValue("pi-owner", item.owner);
  setValue("pi-status", item.status);
  setValue("pi-priority", item.priority);
  setValue("pi-linked-risk", item.linked_risk_code);
  setValue("pi-package", item.linked_package_code);
  setValue("pi-wbs", item.wbs_code);
  setValue("pi-cbs", item.cbs_code);
  setValue("pi-obs", item.obs_owner);
  setValue("pi-prob", item.probability_pct === null ? "" : String(item.probability_pct));
  setValue("pi-value-low", item.value_low === null ? "" : String(item.value_low));
  setValue("pi-value-ml", item.value_most_likely === null ? "" : String(item.value_most_likely));
  setValue("pi-value-high", item.value_high === null ? "" : String(item.value_high));
  setValue("pi-sch-low", item.schedule_low_days === null ? "" : String(item.schedule_low_days));
  setValue("pi-sch-ml", item.schedule_most_likely_days === null ? "" : String(item.schedule_most_likely_days));
  setValue("pi-sch-high", item.schedule_high_days === null ? "" : String(item.schedule_high_days));
  setValue("pi-response", item.response_strategy);
  setValue("pi-decision", item.decision_required);
  setValue("pi-trigger", item.trigger_date);
  setValue("pi-target", item.target_date);
  setValue("pi-review", item.review_due);
  $("pi-title").focus();
}

function clearProgrammeItemForm() {
  setValue("pi-current-code", "");
  setValue("pi-code", "");
  setValue("pi-type", "opportunity");
  setValue("pi-title", "");
  setValue("pi-description", "");
  setValue("pi-category", "");
  setValue("pi-owner", "");
  setValue("pi-status", "Proposed");
  setValue("pi-priority", "Medium");
  setValue("pi-linked-risk", "");
  setValue("pi-package", "");
  setValue("pi-wbs", "");
  setValue("pi-cbs", "");
  setValue("pi-obs", "");
  ["pi-prob", "pi-value-low", "pi-value-ml", "pi-value-high", "pi-sch-low", "pi-sch-ml", "pi-sch-high", "pi-trigger", "pi-target", "pi-review"].forEach((id) => setValue(id, ""));
  setValue("pi-response", "");
  setValue("pi-decision", "");
}

async function retireProgrammeItemFromView(code = value("pi-current-code")) {
  if (!code || !canManageProgrammeItemsUi()) return;
  try {
    await retireProgrammeItem(code);
    if (value("pi-current-code") === code) clearProgrammeItemForm();
    await refreshProgrammeItems(false);
    toast("Programme item retired");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function canManageProgrammeItemsUi() {
  return hasPermissionUi("programme.manage");
}

function programmeRank(item: ProgrammeItem) {
  const typeRank = ["issue", "dependency", "assumption", "opportunity", "benefit", "incident", "audit_finding"].indexOf(item.item_type);
  const priorityRank = { Critical: 0, High: 1, Medium: 2, Low: 3 }[item.priority] ?? 4;
  const statusRank = item.status === "Retired" || item.status === "Closed" ? 9 : item.status === "Open" || item.status === "Active" ? 0 : 2;
  return statusRank * 100 + priorityRank * 10 + (typeRank < 0 ? 8 : typeRank);
}

function programmeTypeLabel(type: string) {
  if (type === "audit_finding") return "Audit finding";
  return type.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
}

function programmeExpectedValue(item: ProgrammeItem) {
  if (item.probability_pct === null || item.value_low === null || item.value_most_likely === null || item.value_high === null) return 0;
  return (item.probability_pct / 100) * ((item.value_low + 4 * item.value_most_likely + item.value_high) / 6);
}

function programmeRangeLabel(low: number | null, ml: number | null, high: number | null) {
  if (low === null && ml === null && high === null) return "n/a";
  return `${low ?? "-"} / ${ml ?? "-"} / ${high ?? "-"}`;
}

function reviewLabel(date: string) {
  const today = todayIso();
  if (date < today) return `Overdue ${fmtDate(date)}`;
  return `Review ${fmtDate(date)}`;
}

async function refreshImports(showToast = true) {
  try {
    const result = await loadImports(activeImportBatchId);
    importBatches = result.batches;
    importRows = result.rows;
    importMappingProfiles = (await loadImportMappingProfiles().catch(() => ({ profiles: importMappingProfiles }))).profiles;
    importValidationRules = (await loadImportValidationRules().catch(() => ({ rules: importValidationRules }))).rules;
    await reloadExportWorkspace({ exportBatchId: activeExportBatchId, reconciliationRunId: activeReconciliationRunId });
    renderImports();
    if (showToast) toast("Import evidence refreshed");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function renderImports() {
  if (!document.getElementById("importBatchList")) return;
  renderImportTemplates();
  renderImportMappingProfiles();
  renderImportFieldMapper();
  renderImportValidationRules();
  renderExportReconciliation();
  renderSchedule();
  renderCost();
  const totalRows = importBatches.reduce((sum, batch) => sum + batch.total_rows, 0);
  const rejected = importBatches.reduce((sum, batch) => sum + batch.rejected_rows, 0);
  const warnings = importBatches.reduce((sum, batch) => sum + batch.warning_rows, 0);
  const committed = importBatches.filter((batch) => batch.commit_mode === "commit").length;
  $("importKpis").innerHTML = [
    { label: "Import batches", value: importBatches.length, sub: `${committed} committed` },
    { label: "Rows processed", value: totalRows, sub: "source register rows" },
    { label: "Rejected", value: rejected, sub: rejected ? "fix before pilot load" : "none in current evidence" },
    { label: "Warnings", value: warnings, sub: "accepted with data-quality notes" },
  ]
    .map((kpi) => `<div><b>${esc(String(kpi.value))}</b><span>${esc(kpi.label)}</span><small>${esc(kpi.sub)}</small></div>`)
    .join("");

  $("importBatchCount").textContent = `${importBatches.length} batches`;
  $("importBatchList").innerHTML = importBatches.length
    ? importBatches
        .map((batch) => `<div class="import-batch-card${batch.import_batch_id === activeImportBatchId ? " active" : ""}" data-import-batch-id="${escAttr(batch.import_batch_id)}">
          <div class="programme-item-head">
            <div><span>${esc(importTargetLabel(batch.target_type))}</span><b>${esc(batch.file_name)}</b></div>
            ${statusToken(batch.status.replace(/_/g, " "), importBatchTone(batch.status))}
          </div>
          <div class="report-pack-meta">
            <span>${esc(batch.source_system)}</span>
            <span>${esc(batch.commit_mode === "commit" ? "Committed" : "Validated")}</span>
            <span>${fmtDateTime(batch.completed_at || batch.created_at)}</span>
          </div>
          <div class="import-batch-metrics">
            <span>${batch.accepted_rows}/${batch.total_rows} accepted</span>
            <span>${batch.warning_rows} warnings</span>
            <span>${batch.rejected_rows} rejected</span>
          </div>
        </div>`)
        .join("")
    : '<div class="muted">No import batches yet.</div>';

  const rows = activeImportBatchId ? importRows.filter((row) => row.import_batch_id === activeImportBatchId) : importRows.slice(0, 50);
  $("importRowCount").textContent = activeImportBatchId ? `${rows.length} rows in selected batch` : `${Math.min(importRows.length, 50)} recent rows`;
  $("importRowList").innerHTML = rows.length
    ? rows
        .map((row) => {
          const review = importRowReview(row);
          return `<div class="import-row-card ${row.status}">
            <div>
              <b>Row ${row.row_number} · ${esc(row.object_type || "object")}</b>
              <span>${esc(row.message)}</span>
              ${importReviewHtml(row, review)}
              ${importValidationIssuesHtml(row)}
              ${importRowResolutionHtml(row, review)}
            </div>
            <div class="import-row-meta">
              ${statusToken(row.status, importRowTone(row.status))}
              <span>${esc(row.action)}</span>
              ${review ? statusToken(`review ${importReviewActionLabel(review.recommendedAction).toLowerCase()}`, importReviewActionTone(review.recommendedAction)) : ""}
              ${row.created_object_code ? `<span>${esc(row.created_object_code)}</span>` : ""}
              ${row.source_code ? `<span>${esc(row.source_code)}</span>` : ""}
            </div>
          </div>`;
        })
        .join("")
    : '<div class="muted">Select a batch or run an import to see row evidence.</div>';
  applyRoleLocks();
}

function importRowReview(row: ImportRow): ImportReviewMetadata | null {
  const payload = safeParse<ImportRowPayload>(row.payload_json);
  const review = payload?.import_review;
  if (!review || typeof review !== "object") return null;
  return {
    sourceHeadings: arrayOfStrings(review.sourceHeadings),
    mappedFields: arrayOfStrings(review.mappedFields),
    unmappedHeadings: arrayOfStrings(review.unmappedHeadings),
    duplicateCandidates: Array.isArray(review.duplicateCandidates) ? review.duplicateCandidates : [],
    recommendedAction: importReviewAction(review.recommendedAction),
    qualityFlags: arrayOfStrings(review.qualityFlags),
    resolutionHint: String(review.resolutionHint || ""),
  };
}

function importRowValidationIssues(row: ImportRow): ImportValidationIssue[] {
  const payload = safeParse<ImportRowPayload>(row.payload_json);
  const issues = payload?.import_validation_issues;
  if (!Array.isArray(issues)) return [];
  return issues
    .map((issue) => {
      const severity: ImportValidationIssue["severity"] = issue.severity === "error" || issue.severity === "warning" ? issue.severity : "info";
      return {
        ruleId: String(issue.ruleId || ""),
        severity,
        fieldName: String(issue.fieldName || ""),
        issue: String(issue.issue || ""),
        recommendation: String(issue.recommendation || ""),
      };
    })
    .filter((issue) => issue.ruleId && issue.issue);
}

function importValidationIssuesHtml(row: ImportRow) {
  const issues = importRowValidationIssues(row);
  if (!issues.length) return "";
  const errors = issues.filter((issue) => issue.severity === "error").length;
  const warnings = issues.filter((issue) => issue.severity === "warning").length;
  const infos = issues.filter((issue) => issue.severity === "info").length;
  return `<div class="import-validation-issues" data-import-validation-row="${escAttr(row.import_row_id)}">
    <div class="import-validation-head">
      <b>Validation issues</b>
      ${errors ? statusToken(`${errors} error${errors === 1 ? "" : "s"}`, "red") : ""}
      ${warnings ? statusToken(`${warnings} warning${warnings === 1 ? "" : "s"}`, "amber") : ""}
      ${infos ? statusToken(`${infos} info`, "blue") : ""}
    </div>
    <div class="import-validation-list">
      ${issues
        .slice(0, 6)
        .map((issue) => `<div class="${escAttr(issue.severity)}">
          ${statusToken(issue.severity, importValidationIssueTone(issue.severity))}
          <div><b>${esc(issue.fieldName || issue.ruleId)}</b><span>${esc(issue.issue)}</span><small>${esc(issue.recommendation)}</small></div>
        </div>`)
        .join("")}
    </div>
  </div>`;
}

function importValidationIssueTone(severity: ImportValidationIssue["severity"]) {
  if (severity === "error") return "red";
  if (severity === "warning") return "amber";
  return "blue";
}

function importReviewHtml(row: ImportRow, review: ImportReviewMetadata | null) {
  if (!review) return "";
  const duplicates = review.duplicateCandidates || [];
  const flags = review.qualityFlags || [];
  const unmapped = review.unmappedHeadings || [];
  const duplicateHtml = duplicates.length
    ? `<div class="import-review-duplicates">
        ${duplicates
          .map((candidate) => `<div><b>${esc(candidate.code || "candidate")}</b><span>${esc(candidate.title || "Untitled")} · ${esc(importDuplicateMatchLabel(candidate.matchType))} · ${Number(candidate.score || 0)}%</span><small>${esc(candidate.guidance || "")}</small></div>`)
          .join("")}
      </div>`
    : "";
  const flagsHtml = flags.length
    ? `<div class="import-review-flags">${flags.slice(0, 6).map((flag) => `<span>${esc(flag)}</span>`).join("")}</div>`
    : "";
  const unmappedHtml = unmapped.length
    ? `<div class="import-review-unmapped"><b>Unmapped</b><span>${esc(unmapped.slice(0, 8).join(", "))}${unmapped.length > 8 ? "..." : ""}</span></div>`
    : "";
  return `<div class="import-review" data-import-review-row="${escAttr(row.import_row_id)}">
    <div class="import-review-head">
      ${statusToken(importReviewActionLabel(review.recommendedAction), importReviewActionTone(review.recommendedAction))}
      <span>${review.mappedFields.length} mapped fields</span>
      <span>${review.sourceHeadings.length} source headings</span>
      ${duplicates.length ? `<span>${duplicates.length} duplicate candidate${duplicates.length === 1 ? "" : "s"}</span>` : ""}
    </div>
    ${review.resolutionHint ? `<p>${esc(review.resolutionHint)}</p>` : ""}
    ${duplicateHtml}
    ${flagsHtml}
    ${unmappedHtml}
  </div>`;
}

function importRowResolutionHtml(row: ImportRow, review: ImportReviewMetadata | null) {
  const selected = row.resolution_decision || importResolutionSuggestedDecision(row, review);
  const target = row.resolution_target_code || importResolutionSuggestedTarget(row, review);
  const note = row.resolution_note || "";
  const resolved = Boolean(row.resolution_decision);
  return `<div class="import-resolution ${resolved ? "resolved" : "pending"}" data-import-resolution-row="${escAttr(row.import_row_id)}">
    <div class="import-resolution-head">
      <b>${resolved ? "Resolution decision" : "Resolve source row"}</b>
      ${resolved ? statusToken(importResolutionDecisionLabel(row.resolution_decision), importResolutionDecisionTone(row.resolution_decision)) : statusToken("Decision needed", "amber")}
      ${row.resolution_by_name ? `<span>${esc(row.resolution_by_name)} · ${fmtDateTime(row.resolution_updated_at)}</span>` : ""}
    </div>
    <div class="import-resolution-grid">
      <div class="field"><label>Decision</label><select data-import-resolution-decision="${escAttr(row.import_row_id)}">
        <option value="">Decision required</option>
        ${(["create", "update", "merge", "skip", "reject"] as ImportResolutionDecision[]).map((decision) => `<option value="${decision}" ${selected === decision ? "selected" : ""}>${esc(importResolutionDecisionLabel(decision))}</option>`).join("")}
      </select></div>
      <div class="field"><label>Target code</label><input data-import-resolution-target="${escAttr(row.import_row_id)}" value="${escAttr(target)}" placeholder="Required for update / merge"/></div>
      <div class="field import-resolution-note"><label>Decision note</label><input data-import-resolution-note="${escAttr(row.import_row_id)}" value="${escAttr(note)}" placeholder="Basis for create, update, merge, skip or reject"/></div>
      <button class="btn" data-import-resolution-save="${escAttr(row.import_row_id)}">Save decision</button>
    </div>
  </div>`;
}

function importResolutionSuggestedDecision(row: ImportRow, review: ImportReviewMetadata | null): ImportResolutionDecision | "" {
  if (row.status === "rejected" || row.action === "reject") return "reject";
  if (review?.recommendedAction === "update") return "update";
  if (review?.recommendedAction === "create") return "create";
  if (review?.recommendedAction === "reject") return "reject";
  return "";
}

function importResolutionSuggestedTarget(row: ImportRow, review: ImportReviewMetadata | null) {
  if (row.resolution_target_code) return row.resolution_target_code;
  if (row.created_object_code) return row.created_object_code;
  const exact = review?.duplicateCandidates.find((candidate) => candidate.matchType === "existing_code" || candidate.matchType === "existing_title");
  return exact?.code || row.source_code || "";
}

function importResolutionDecisionLabel(decision: string) {
  if (decision === "update") return "Update existing";
  if (decision === "merge") return "Merge duplicate";
  if (decision === "skip") return "Skip row";
  if (decision === "reject") return "Reject row";
  return "Create new";
}

function importResolutionDecisionTone(decision: string) {
  if (decision === "update") return "blue";
  if (decision === "merge" || decision === "skip") return "amber";
  if (decision === "reject") return "red";
  return "green";
}

async function saveImportRowResolutionFromView(rowId: string) {
  if (!canManageImportsUi() || !rowId) return;
  const decision = (document.querySelector<HTMLSelectElement>(`[data-import-resolution-decision="${cssEscape(rowId)}"]`)?.value || "") as ImportResolutionDecision | "";
  const targetCode = document.querySelector<HTMLInputElement>(`[data-import-resolution-target="${cssEscape(rowId)}"]`)?.value || "";
  const note = document.querySelector<HTMLInputElement>(`[data-import-resolution-note="${cssEscape(rowId)}"]`)?.value || "";
  if (!decision) {
    $("import-note").textContent = "Choose a row resolution decision before saving.";
    return;
  }
  const payload: ImportRowResolutionInput = { decision, targetCode, note };
  try {
    const result = await resolveImportRow(rowId, payload);
    importRows = importRows.map((row) => (row.import_row_id === result.row.import_row_id ? result.row : row));
    renderImports();
    $("import-note").textContent = `Saved row ${result.row.row_number} resolution: ${importResolutionDecisionLabel(result.row.resolution_decision)}.`;
  } catch (err) {
    $("import-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

function arrayOfStrings(value: unknown) {
  return Array.isArray(value) ? value.map((item) => String(item)).filter(Boolean) : [];
}

function importReviewAction(action: unknown): ImportReviewRecommendedAction {
  return action === "update" || action === "review" || action === "reject" ? action : "create";
}

function importReviewActionLabel(action: ImportReviewRecommendedAction) {
  if (action === "update") return "Recommended update";
  if (action === "review") return "Needs review";
  if (action === "reject") return "Reject row";
  return "Recommended create";
}

function importReviewActionTone(action: ImportReviewRecommendedAction) {
  if (action === "update") return "blue";
  if (action === "review") return "amber";
  if (action === "reject") return "red";
  return "green";
}

function importDuplicateMatchLabel(matchType: string) {
  if (matchType === "existing_code") return "existing code";
  if (matchType === "existing_title") return "existing title";
  if (matchType === "fuzzy_title") return "similar title";
  if (matchType === "batch_code") return "batch code";
  if (matchType === "batch_title") return "batch title";
  return "possible duplicate";
}

function renderImportMappingProfiles() {
  if (!document.getElementById("import-mapping-profile-select")) return;
  const target = value("import-target") as ImportTargetType;
  const select = $<HTMLSelectElement>("import-mapping-profile-select");
  const current = select.value;
  const profiles = importMappingProfiles.filter((profile) => profile.target_type === target);
  select.innerHTML = [
    '<option value="">New profile / unsaved mapping</option>',
    ...profiles.map((profile) => `<option value="${escAttr(profile.import_mapping_profile_id)}">${esc(profile.profile_name)}${profile.status === "retired" ? " (retired)" : ""} · ${profile.mapping_count} fields</option>`),
  ].join("");
  select.value = profiles.some((profile) => profile.import_mapping_profile_id === current) ? current : "";
  const active = profiles.filter((profile) => profile.status === "active").length;
  const retired = profiles.length - active;
  $("importMappingProfileSummary").textContent = `${active} active ${importTargetLabel(target).toLowerCase()} profile${active === 1 ? "" : "s"}${retired ? ` · ${retired} retired` : ""}`;
  setDisabled("import-mapping-profile-load", !select.value);
  setDisabled("import-mapping-profile-retire", !select.value || selectedImportMappingProfile()?.status === "retired");
}

function selectedImportMappingProfile() {
  const id = value("import-mapping-profile-select");
  return importMappingProfiles.find((profile) => profile.import_mapping_profile_id === id) || null;
}

function fillSelectedImportMappingProfile() {
  const profile = selectedImportMappingProfile();
  if (!profile) {
    setValue("import-mapping-profile-name", "");
    setValue("import-mapping-profile-notes", "");
    renderImportMappingProfiles();
    return;
  }
  setValue("import-mapping-profile-name", profile.profile_name);
  setValue("import-mapping-profile-notes", profile.notes);
  if (profile.source_system) setValue("import-source", profile.source_system);
  $("importMappingProfileSummary").textContent = `${profile.status === "retired" ? "Retired" : "Active"} profile · ${profile.mapping_count} mapped fields · updated ${fmtDateTime(profile.updated_at)}`;
  setDisabled("import-mapping-profile-load", false);
  setDisabled("import-mapping-profile-retire", profile.status === "retired");
}

function loadSelectedImportMappingProfile() {
  const profile = selectedImportMappingProfile();
  if (!profile) {
    $("import-note").textContent = "Choose a saved mapping profile to load.";
    return;
  }
  if (profile.target_type !== value("import-target")) {
    setValue("import-target", profile.target_type);
    seedImportSample();
  }
  if (profile.source_system) setValue("import-source", profile.source_system);
  setValue("import-mapping-profile-name", profile.profile_name);
  setValue("import-mapping-profile-notes", profile.notes);
  const applied = applyImportMappingEntries(profile.mappings);
  $("import-note").textContent = applied
    ? `Loaded ${profile.profile_name}: ${applied} field mappings applied. Review headings, then apply mappings before validate-only.`
    : "Paste or load rows before applying the saved profile.";
  renderImportMappingProfiles();
}

async function saveImportMappingProfileFromView() {
  if (!canManageImportsUi()) return;
  const info = importCsvHeaderInfo();
  if (!info) {
    $("import-note").textContent = "Paste or load CSV rows before saving a mapping profile.";
    return;
  }
  const mappings = currentImportMappingEntries();
  if (!mappings.length) {
    $("import-note").textContent = "Map at least one source heading before saving a profile.";
    return;
  }
  const targetFields = mappings.map((mapping) => mapping.targetField);
  const duplicates = duplicateValues(targetFields);
  if (duplicates.length) {
    $("import-note").textContent = `Resolve duplicate target mappings before saving: ${duplicates.join(", ")}.`;
    return;
  }
  const existing = selectedImportMappingProfile();
  const payload: ImportMappingProfileInput = {
    profileName: value("import-mapping-profile-name") || existing?.profile_name || `${value("import-source") || "Client"} ${importTargetLabel(value("import-target")).toLowerCase()} mapping`,
    targetType: value("import-target") as ImportTargetType,
    sourceSystem: value("import-source") || existing?.source_system || "Client supplied register",
    delimiter: info.delimiter,
    mappings,
    notes: value("import-mapping-profile-notes"),
    status: "active",
  };
  try {
    const result = existing
      ? await updateImportMappingProfile(existing.import_mapping_profile_id, payload)
      : await createImportMappingProfile(payload);
    upsertImportMappingProfile(result.profile);
    renderImportMappingProfiles();
    setValue("import-mapping-profile-select", result.profile.import_mapping_profile_id);
    fillSelectedImportMappingProfile();
    $("import-note").textContent = `Saved mapping profile ${result.profile.profile_name} with ${result.profile.mapping_count} fields.`;
  } catch (err) {
    $("import-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

async function retireSelectedImportMappingProfile() {
  if (!canManageImportsUi()) return;
  const profile = selectedImportMappingProfile();
  if (!profile) {
    $("import-note").textContent = "Choose a saved mapping profile to retire.";
    return;
  }
  try {
    const result = await retireImportMappingProfile(profile.import_mapping_profile_id);
    upsertImportMappingProfile(result.profile);
    renderImportMappingProfiles();
    setValue("import-mapping-profile-select", result.profile.import_mapping_profile_id);
    fillSelectedImportMappingProfile();
    $("import-note").textContent = `Retired mapping profile ${result.profile.profile_name}.`;
  } catch (err) {
    $("import-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

function upsertImportMappingProfile(profile: ImportMappingProfile) {
  importMappingProfiles = [profile, ...importMappingProfiles.filter((item) => item.import_mapping_profile_id !== profile.import_mapping_profile_id)];
}

function renderImportValidationRules() {
  if (!document.getElementById("importValidationRuleList")) return;
  renderImportValidationRuleFields();
  const currentTarget = value("import-target") as ImportTargetType;
  const rows = importValidationRules
    .filter((rule) => rule.target_type === "all" || rule.target_type === currentTarget)
    .sort((a, b) => importValidationRuleStatusRank(a) - importValidationRuleStatusRank(b) || a.sort_order - b.sort_order || a.name.localeCompare(b.name));
  const active = rows.filter((rule) => rule.status === "active").length;
  const errors = rows.filter((rule) => rule.status === "active" && rule.severity === "error").length;
  $("importValidationRuleSummary").textContent = `${active} active ${importTargetLabel(currentTarget).toLowerCase()} rules${errors ? ` · ${errors} blocking` : ""}`;
  $("importValidationRuleList").innerHTML = rows.length
    ? rows
        .map((rule) => `<div class="import-validation-rule-card${value("import-validation-rule-id") === rule.import_validation_rule_id ? " active" : ""}" data-import-validation-rule-id="${escAttr(rule.import_validation_rule_id)}">
          <div class="programme-item-head">
            <div><span>${esc(importValidationRuleTargetLabel(rule.target_type))} · ${esc(importValidationRuleCheckLabel(rule.check_type))}</span><b>${esc(rule.name)}</b></div>
            ${statusToken(rule.severity, importValidationIssueTone(rule.severity))}
          </div>
          <div class="report-pack-meta">
            <span>${esc(rule.rule_key)}</span>
            <span>${esc(importValidationRuleFieldsLabel(rule))}</span>
            ${rule.source_system_pattern ? `<span>${esc(rule.source_system_pattern)}</span>` : ""}
            <span>${esc(rule.status)}</span>
          </div>
          <div class="evidence-card-summary">${esc(rule.issue)}</div>
        </div>`)
        .join("")
    : '<div class="muted">No validation rules match the selected import target.</div>';
  setDisabled("import-validation-rule-retire", !value("import-validation-rule-id"));
}

function renderImportValidationRuleFields() {
  if (!document.getElementById("import-validation-rule-field")) return;
  const target = value("import-validation-rule-target") || value("import-target") || "risks";
  const specs = target === "programme_items"
    ? PROGRAMME_IMPORT_FIELD_SPECS
    : target === "all"
      ? [...RISK_IMPORT_FIELD_SPECS, ...PROGRAMME_IMPORT_FIELD_SPECS.filter((item) => !RISK_IMPORT_FIELD_SPECS.some((risk) => risk.field === item.field))]
      : RISK_IMPORT_FIELD_SPECS;
  const field = value("import-validation-rule-field");
  $("import-validation-rule-field").innerHTML = specs.map((item) => `<option value="${escAttr(item.field)}">${esc(item.label)}</option>`).join("");
  setValue("import-validation-rule-field", specs.some((item) => item.field === field) ? field : specs[0]?.field || "");
}

function fillImportValidationRuleForm(id: string) {
  const rule = importValidationRules.find((item) => item.import_validation_rule_id === id);
  if (!rule) return;
  setValue("import-validation-rule-id", rule.import_validation_rule_id);
  setValue("import-validation-rule-key", rule.rule_key);
  setValue("import-validation-rule-target", rule.target_type);
  setValue("import-validation-rule-check", rule.check_type);
  renderImportValidationRuleFields();
  setValue("import-validation-rule-field", rule.field_name || rule.fieldNames[0] || "");
  setValue("import-validation-rule-extra", importValidationRuleExtraValue(rule));
  setValue("import-validation-rule-severity", rule.severity);
  setValue("import-validation-rule-name", rule.name);
  setValue("import-validation-rule-source", rule.source_system_pattern);
  setValue("import-validation-rule-status", rule.status);
  setValue("import-validation-rule-issue", rule.issue);
  setValue("import-validation-rule-recommendation", rule.recommendation);
  $("import-validation-rule-note").textContent = `Updated ${fmtDateTime(rule.updated_at)} by ${rule.updated_by_name || "System"}.`;
  renderImportValidationRules();
}

function clearImportValidationRuleForm() {
  setValue("import-validation-rule-id", "");
  setValue("import-validation-rule-key", "");
  setValue("import-validation-rule-target", value("import-target") || "risks");
  setValue("import-validation-rule-check", "required_field");
  renderImportValidationRuleFields();
  setValue("import-validation-rule-extra", "");
  setValue("import-validation-rule-severity", "warning");
  setValue("import-validation-rule-name", "");
  setValue("import-validation-rule-source", value("import-source"));
  setValue("import-validation-rule-status", "active");
  setValue("import-validation-rule-issue", "");
  setValue("import-validation-rule-recommendation", "");
  $("import-validation-rule-note").textContent = "";
  renderImportValidationRules();
}

function importValidationRulePayloadFromForm(): ImportValidationRuleInput {
  const checkType = value("import-validation-rule-check") as ImportValidationRuleCheckType;
  const extra = value("import-validation-rule-extra");
  return {
    ruleKey: value("import-validation-rule-key"),
    targetType: value("import-validation-rule-target") as ImportValidationRuleInput["targetType"],
    checkType,
    fieldName: value("import-validation-rule-field"),
    fieldNames: checkType === "required_all" ? commaList(extra || value("import-validation-rule-field")) : [],
    allowedValues: checkType === "allowed_values" ? commaList(extra) : [],
    thresholdValue: checkType === "numeric_min" || checkType === "numeric_max" ? Number(extra) : null,
    severity: value("import-validation-rule-severity") as ImportValidationRuleInput["severity"],
    name: value("import-validation-rule-name"),
    issue: value("import-validation-rule-issue"),
    recommendation: value("import-validation-rule-recommendation"),
    sourceSystemPattern: value("import-validation-rule-source"),
    status: value("import-validation-rule-status") as ImportValidationRuleInput["status"],
    sortOrder: importValidationRules.length + 10,
  };
}

async function saveImportValidationRuleFromView() {
  if (!canManageImportsUi()) return;
  const id = value("import-validation-rule-id");
  const payload = importValidationRulePayloadFromForm();
  if (!payload.ruleKey || !payload.name) {
    $("import-validation-rule-name").focus();
    return;
  }
  try {
    const result = id ? await updateImportValidationRule(id, payload) : await createImportValidationRule(payload);
    upsertImportValidationRule(result.rule);
    fillImportValidationRuleForm(result.rule.import_validation_rule_id);
    $("import-validation-rule-note").textContent = id ? "Validation rule updated." : "Validation rule created.";
    toast(id ? "Validation rule updated" : "Validation rule created");
  } catch (err) {
    $("import-validation-rule-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

async function retireImportValidationRuleFromView() {
  if (!canManageImportsUi()) return;
  const id = value("import-validation-rule-id");
  if (!id) return;
  try {
    const result = await retireImportValidationRule(id);
    upsertImportValidationRule(result.rule);
    fillImportValidationRuleForm(result.rule.import_validation_rule_id);
    $("import-validation-rule-note").textContent = `Retired validation rule ${result.rule.name}.`;
    toast("Validation rule retired");
  } catch (err) {
    $("import-validation-rule-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

function upsertImportValidationRule(rule: ImportValidationRule) {
  importValidationRules = [rule, ...importValidationRules.filter((item) => item.import_validation_rule_id !== rule.import_validation_rule_id)];
}

function importValidationRuleStatusRank(rule: ImportValidationRule) {
  if (rule.status !== "active") return 9;
  if (rule.severity === "error") return 0;
  if (rule.severity === "warning") return 1;
  return 2;
}

function importValidationRuleCheckLabel(checkType: ImportValidationRuleCheckType) {
  return checkType.replace(/_/g, " ");
}

function importValidationRuleTargetLabel(target: ImportValidationRule["target_type"]) {
  if (target === "risks") return "Risks";
  if (target === "programme_items") return "Programme intelligence";
  return "All imports";
}

function importValidationRuleFieldsLabel(rule: ImportValidationRule) {
  if (rule.check_type === "required_all") return rule.fieldNames.join(", ");
  if (rule.check_type === "allowed_values") return `${rule.field_name}: ${rule.allowedValues.join(", ")}`;
  if (rule.check_type === "numeric_min" || rule.check_type === "numeric_max") return `${rule.field_name}: ${rule.threshold_value ?? ""}`;
  return rule.field_name;
}

function importValidationRuleExtraValue(rule: ImportValidationRule) {
  if (rule.check_type === "required_all") return rule.fieldNames.join(", ");
  if (rule.check_type === "allowed_values") return rule.allowedValues.join(", ");
  if (rule.check_type === "numeric_min" || rule.check_type === "numeric_max") return rule.threshold_value === null ? "" : String(rule.threshold_value);
  return "";
}

function commaList(value: string) {
  return value.split(",").map((item) => item.trim()).filter(Boolean);
}

function currentImportMappingEntries(): ImportMappingEntry[] {
  const info = importCsvHeaderInfo();
  if (!info) return [];
  let selects = Array.from(document.querySelectorAll<HTMLSelectElement>("[data-import-map-index]"));
  if (selects.length !== info.headers.length) {
    renderImportFieldMapper();
    selects = Array.from(document.querySelectorAll<HTMLSelectElement>("[data-import-map-index]"));
  }
  return info.headers
    .map((header, index) => ({
      sourceHeading: header.trim(),
      targetField: selects.find((select) => Number(select.dataset.importMapIndex || "-1") === index)?.value || "",
    }))
    .filter((mapping) => mapping.sourceHeading && mapping.targetField);
}

function applyImportMappingEntries(mappings: ImportMappingEntry[]) {
  const info = importCsvHeaderInfo();
  if (!info) return 0;
  renderImportFieldMapper();
  const byHeading = new Map(mappings.map((mapping) => [normaliseImportHeading(mapping.sourceHeading), mapping.targetField]));
  let applied = 0;
  document.querySelectorAll<HTMLSelectElement>("[data-import-map-index]").forEach((select) => {
    const index = Number(select.dataset.importMapIndex || "-1");
    const heading = normaliseImportHeading(info.headers[index] || select.dataset.importMapHeading || "");
    const targetField = byHeading.get(heading) || "";
    if (targetField) {
      select.value = targetField;
      applied += 1;
    }
  });
  renderImportFieldMapper();
  return applied;
}

type ImportFieldSpec = {
  field: string;
  label: string;
  aliases: string[];
  required?: boolean;
};

const RISK_IMPORT_FIELD_SPECS: ImportFieldSpec[] = [
  { field: "code", label: "Risk code / reference", required: true, aliases: ["code", "risk_id", "risk_code", "risk_ref", "risk_reference", "risk_number", "reference", "id"] },
  { field: "title", label: "Risk title", required: true, aliases: ["title", "risk", "risk_title", "risk_name", "name", "description", "risk_description", "event_description"] },
  { field: "category", label: "Category / RBS", aliases: ["category", "cat", "rbs", "risk_category", "risk_type", "risk_group", "risk_breakdown_structure"] },
  { field: "owner", label: "Owner", aliases: ["owner", "risk_owner", "responsible", "risk_manager", "action_owner"] },
  { field: "status", label: "Status", aliases: ["status", "risk_status", "state"] },
  { field: "cause", label: "Cause", aliases: ["cause", "risk_cause", "source_cause", "threat", "threats"] },
  { field: "event", label: "Event", aliases: ["event", "risk_event", "event_description", "uncertain_event"] },
  { field: "effect", label: "Effect / consequence", aliases: ["effect", "risk_effect", "impact_description", "consequence", "consequences"] },
  { field: "strategy", label: "Response strategy", aliases: ["strategy", "mitigation", "response_strategy", "mitigation_strategy", "response_plan", "treatment"] },
  { field: "lpre", label: "Pre likelihood", aliases: ["lpre", "likelihood_pre", "pre_likelihood", "pre_mitigation_likelihood", "inherent_likelihood", "initial_likelihood"] },
  { field: "ipre", label: "Pre impact", aliases: ["ipre", "impact_pre", "pre_impact", "pre_mitigation_impact", "inherent_impact", "initial_impact"] },
  { field: "lpost", label: "Current likelihood", aliases: ["lpost", "likelihood_post", "residual_likelihood", "post_likelihood", "post_mitigation_likelihood", "current_likelihood"] },
  { field: "ipost", label: "Current impact", aliases: ["ipost", "impact_post", "residual_impact", "post_impact", "post_mitigation_impact", "current_impact"] },
  { field: "previous_residual", label: "Previous residual score", aliases: ["previous_residual", "prev", "previous_score", "previous_rating", "prior_residual_score"] },
  { field: "exposure", label: "Residual exposure", aliases: ["exposure", "cost_exposure", "residual_exposure", "residual_exposure_k", "exposure_k", "emv", "expected_value"] },
  { field: "review_due", label: "Review due", aliases: ["review_due", "due", "review_date", "next_review", "next_review_date", "review_due_date"] },
];

const PROGRAMME_IMPORT_FIELD_SPECS: ImportFieldSpec[] = [
  { field: "code", label: "Item code / reference", required: true, aliases: ["code", "item_code", "item_ref", "object_id", "reference", "id"] },
  { field: "item_type", label: "Object type", required: true, aliases: ["item_type", "type", "object_type", "raid_type", "register_type"] },
  { field: "title", label: "Title", required: true, aliases: ["title", "item", "description", "risk", "name", "item_name", "summary"] },
  { field: "description", label: "Description", aliases: ["description", "notes", "basis", "commentary", "assumption"] },
  { field: "category", label: "Category / theme", aliases: ["category", "cat", "rbs", "risk_category", "theme"] },
  { field: "owner", label: "Owner", aliases: ["owner", "lead", "risk_owner", "responsible", "accountable_owner"] },
  { field: "status", label: "Status", aliases: ["status", "state", "item_status"] },
  { field: "priority", label: "Priority", aliases: ["priority", "rating", "severity", "criticality"] },
  { field: "linked_risk_code", label: "Linked risk", aliases: ["linked_risk_code", "risk_code", "risk_id", "risk_ref", "linked_risk_ref"] },
  { field: "linked_package_code", label: "Package", aliases: ["linked_package_code", "package_code", "package"] },
  { field: "wbs_code", label: "WBS", aliases: ["wbs_code", "wbs"] },
  { field: "cbs_code", label: "CBS", aliases: ["cbs_code", "cbs"] },
  { field: "obs_owner", label: "OBS / function", aliases: ["obs_owner", "obs", "function"] },
  { field: "probability_pct", label: "Probability %", aliases: ["probability_pct", "probability", "prob", "likelihood_pct"] },
  { field: "value_low", label: "Value low", aliases: ["value_low", "cost_low", "low"] },
  { field: "value_most_likely", label: "Value most likely", aliases: ["value_most_likely", "cost_most_likely", "most_likely", "ml"] },
  { field: "value_high", label: "Value high", aliases: ["value_high", "cost_high", "high"] },
  { field: "schedule_low_days", label: "Schedule low", aliases: ["schedule_low_days", "schedule_low", "days_low"] },
  { field: "schedule_most_likely_days", label: "Schedule most likely", aliases: ["schedule_most_likely_days", "schedule_most_likely", "days_most_likely", "days_ml"] },
  { field: "schedule_high_days", label: "Schedule high", aliases: ["schedule_high_days", "schedule_high", "days_high"] },
  { field: "response_strategy", label: "Response strategy", aliases: ["response_strategy", "response", "mitigation"] },
  { field: "decision_required", label: "Decision required", aliases: ["decision_required", "decision", "decision_needed"] },
  { field: "trigger_date", label: "Trigger date", aliases: ["trigger_date", "trigger"] },
  { field: "target_date", label: "Target date", aliases: ["target_date", "target"] },
  { field: "review_due", label: "Review due", aliases: ["review_due", "review_due_date", "review_date", "next_review", "next_review_date", "due"] },
];

function renderImportFieldMapper() {
  if (!document.getElementById("importMappingGrid")) return;
  const info = importCsvHeaderInfo();
  if (!info) {
    $("importMappingSummary").textContent = "Paste or load rows to review headings";
    $("importMappingGrid").innerHTML = '<div class="muted">No header row detected yet.</div>';
    return;
  }
  const specs = importFieldSpecs(value("import-target") as ImportTargetType);
  const previous = new Map(
    Array.from(document.querySelectorAll<HTMLSelectElement>("[data-import-map-index]"))
      .map((select) => [`${select.dataset.importMapIndex || ""}:${select.dataset.importMapHeading || ""}`, select.value]),
  );
  const mappedRows = info.headers.map((header, index) => {
    const normalised = normaliseImportHeading(header);
    const auto = importSpecForHeading(normalised, specs);
    const previousValue = previous.get(`${index}:${normalised}`);
    const selected = previousValue !== undefined ? previousValue : auto?.field || "";
    return { header, index, normalised, auto, selected };
  });
  const mapped = mappedRows.filter((row) => row.selected).length;
  const duplicateTargets = duplicateValues(mappedRows.map((row) => row.selected).filter(Boolean));
  const unmapped = mappedRows.length - mapped;
  $("importMappingSummary").textContent = `${mapped}/${mappedRows.length} headings mapped · ${unmapped} unmapped · ${delimiterLabel(info.delimiter)}${duplicateTargets.length ? ` · ${duplicateTargets.length} duplicate target` : ""}`;
  $("importMappingGrid").innerHTML = mappedRows
    .map((row) => {
      const tone = duplicateTargets.includes(row.selected) ? "red" : row.selected ? row.auto?.field === row.selected ? "green" : "blue" : "amber";
      return `<div class="import-mapping-row ${tone}">
        <div><b>${esc(row.header || `Column ${row.index + 1}`)}</b><span>${row.auto ? `Auto: ${esc(row.auto.label)}` : "Manual mapping required"}</span></div>
        <select data-import-map-index="${row.index}" data-import-map-heading="${escAttr(row.normalised)}">
          <option value="">Ignore / unmapped</option>
          ${specs.map((spec) => `<option value="${escAttr(spec.field)}" ${row.selected === spec.field ? "selected" : ""}>${esc(spec.label)}${spec.required ? " *" : ""}</option>`).join("")}
        </select>
        ${statusToken(duplicateTargets.includes(row.selected) ? "Duplicate target" : row.selected ? row.auto?.field === row.selected ? "Mapped" : "Manual" : "Unmapped", tone)}
      </div>`;
    })
    .join("");
}

function applyImportFieldMappings() {
  if (!canManageImportsUi()) return;
  const info = importCsvHeaderInfo();
  if (!info) {
    $("import-note").textContent = "Paste or load CSV rows before applying mappings.";
    return;
  }
  const selects = Array.from(document.querySelectorAll<HTMLSelectElement>("[data-import-map-index]"));
  if (selects.length !== info.headers.length) renderImportFieldMapper();
  const mappingByIndex = new Map(selects.map((select) => [Number(select.dataset.importMapIndex || "-1"), select.value]));
  const selectedTargets = info.headers.map((_, index) => mappingByIndex.get(index) || "").filter(Boolean);
  const duplicates = duplicateValues(selectedTargets);
  if (duplicates.length) {
    $("import-note").textContent = `Resolve duplicate target mappings before applying: ${duplicates.join(", ")}.`;
    renderImportFieldMapper();
    return;
  }
  const rewrittenRows = info.lines.map((line, lineIndex) => {
    const cells = parseCsvLine(line, info.delimiter);
    const output = lineIndex === 0 ? info.headers.map((header, index) => mappingByIndex.get(index) || header) : cells;
    return output.map((cell) => delimitedImportCell(cell, info.delimiter)).join(info.delimiter);
  });
  setValue("import-csv", rewrittenRows.join("\n"));
  $("import-note").textContent = `Applied ${selectedTargets.length} field mappings. Run validate-only to review row evidence before commit.`;
  renderImportFieldMapper();
}

function importCsvHeaderInfo() {
  const lines = value("import-csv").split(/\r?\n/).filter((line) => line.trim());
  if (!lines.length) return null;
  const delimiter = detectLineDelimiter(lines[0]);
  const headers = parseCsvLine(lines[0], delimiter);
  if (!headers.length) return null;
  return { delimiter, headers, lines };
}

function importFieldSpecs(target: ImportTargetType) {
  return target === "risks" ? RISK_IMPORT_FIELD_SPECS : PROGRAMME_IMPORT_FIELD_SPECS;
}

function importSpecForHeading(heading: string, specs: ImportFieldSpec[]) {
  return specs.find((spec) => spec.field === heading || spec.aliases.includes(heading));
}

function normaliseImportHeading(value: string) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

function delimiterLabel(delimiter: string) {
  if (delimiter === "\t") return "tab-delimited";
  if (delimiter === ";") return "semicolon-delimited";
  return "comma-delimited";
}

function duplicateValues(values: string[]) {
  const seen = new Set<string>();
  const duplicates = new Set<string>();
  for (const value of values) {
    if (seen.has(value)) duplicates.add(value);
    seen.add(value);
  }
  return [...duplicates];
}

function delimitedImportCell(value: string, delimiter: string) {
  const text = String(value ?? "");
  return text.includes(delimiter) || /["\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

const IMPORT_TEMPLATES = [
  {
    key: "soma-risk",
    label: "SOMA canonical risk register",
    targetType: "risks" as ImportTargetType,
    sourceSystem: "SOMA canonical CSV",
    fileName: "soma-risk-register-import.csv",
    help: "Canonical SOMA import with cause, event, effect, C/E/E scoring and review date fields.",
    csv:
      "code,title,category,owner,status,cause,event,effect,strategy,lpre,ipre,lpost,ipost,previous_residual,exposure,review_due\n" +
      "R-900,Bridge package - unexploded utility clash,Programme / schedule,Jo Carter,Open,Utility records incomplete,Uncharted utility clash delays possession,Traffic management and redesign costs increase,Run GPR survey and agree diversion plan,4,4,3,4,12,320,2026-07-15\n",
  },
  {
    key: "arm-risk",
    label: "ARM-style risk export",
    targetType: "risks" as ImportTargetType,
    sourceSystem: "ARM risk export",
    fileName: "arm-risk-export-template.csv",
    help: "Accepts common ARM-style headings such as Risk Ref, Risk Name, Risk Owner, Pre/Post Mitigation Likelihood and Impact.",
    csv:
      "Risk Ref,Risk Name,Risk Category,Risk Owner,Risk Status,Risk Cause,Risk Event,Risk Effect,Mitigation Strategy,Pre Mitigation Likelihood,Pre Mitigation Impact,Post Mitigation Likelihood,Post Mitigation Impact,Previous Score,Residual Exposure K,Next Review Date\n" +
      "ARM-101,Town centre utilities survey access delayed,Programme / schedule,Mark Doyle,Open,Third-party access approvals lag,Survey access window missed,Design freeze moves and cost grows,Escalate access protocol and resequence survey,4,4,3,3,12,210,2026-07-22\n",
  },
  {
    key: "riskhive-risk",
    label: "RiskHive-style risk register",
    targetType: "risks" as ImportTargetType,
    sourceSystem: "RiskHive risk export",
    fileName: "riskhive-risk-register-template.csv",
    help: "Accepts RiskHive-style Risk ID, Risk Title, RBS, Responsible, Current Likelihood/Impact and EMV headings.",
    csv:
      "Risk ID,Risk Title,RBS,Responsible,State,Threat,Uncertain Event,Consequence,Treatment,Inherent Likelihood,Inherent Impact,Current Likelihood,Current Impact,Prior Residual Score,EMV,Review Due Date\n" +
      "RH-204,Schools decant phasing clashes with exam period,Stakeholder / political,Sam Bell,Open,Decant plan not agreed,Exam timetable conflicts with move,Client approval and occupation slip,Agree decant protocol with schools and sponsor,3,5,2,4,15,175,2026-07-09\n",
  },
  {
    key: "safran-qra",
    label: "Safran/QRA candidate risk list",
    targetType: "risks" as ImportTargetType,
    sourceSystem: "Safran / QRA candidate export",
    fileName: "safran-qra-risk-template.csv",
    help: "Accepts schedule/QRA candidate naming with Risk Reference, Risk Description, Responsible and Initial/Current score fields.",
    csv:
      "Risk Reference,Risk Description,Risk Type,Responsible,Status,Source Cause,Event Description,Impact Description,Response Plan,Initial Likelihood,Initial Impact,Current Likelihood,Current Impact,Previous Rating,Expected Value,Review Date\n" +
      "SF-330,Highways steelwork redesign affects fabrication slot,Design,Priya Ahmed,Open,Redesign not frozen,Fabrication slot missed,Programme float erodes and prelims rise,Freeze design assumptions and secure slot,3,4,2,3,12,145,2026-07-18\n",
  },
  {
    key: "raid-programme",
    label: "RAID/programme intelligence register",
    targetType: "programme_items" as ImportTargetType,
    sourceSystem: "Client RAID register",
    fileName: "programme-intelligence-raid-template.csv",
    help: "Loads opportunities, issues, dependencies, assumptions, benefits, incidents and audit findings with risk/package/WBS/CBS mapping.",
    csv:
      "Item Ref,RAID Type,Title,Description,Owner,Item Status,Criticality,Linked Risk Ref,Package,WBS,CBS,Probability,Value Low,Value Most Likely,Value High,Schedule Low Days,Schedule Most Likely Days,Schedule High Days,Response Strategy,Decision Required,Review Due Date\n" +
      "RAID-501,dependency,Planning committee date dependency,Committee slot required for regeneration consent,Mark Doyle,Open,High,R-004,PKG-REG-01,2.3.1,C-REG-120,70,0,25,80,10,20,45,Secure forward plan slot,Confirm committee paper deadline,2026-07-01\n",
  },
];

function renderImportTemplates() {
  if (!document.getElementById("import-template-select")) return;
  const select = $<HTMLSelectElement>("import-template-select");
  const current = select.value || IMPORT_TEMPLATES[0].key;
  select.innerHTML = IMPORT_TEMPLATES.map((template) => `<option value="${escAttr(template.key)}">${esc(template.label)}</option>`).join("");
  select.value = IMPORT_TEMPLATES.some((template) => template.key === current) ? current : IMPORT_TEMPLATES[0].key;
  renderImportTemplateHelp();
}

function selectedImportTemplate() {
  return IMPORT_TEMPLATES.find((template) => template.key === value("import-template-select")) || IMPORT_TEMPLATES[0];
}

function renderImportTemplateHelp() {
  if (!document.getElementById("importTemplateHelp")) return;
  const template = selectedImportTemplate();
  $("importTemplateHelp").innerHTML = `<b>${esc(importTargetLabel(template.targetType))}</b><span>${esc(template.help)}</span>`;
}

function loadSelectedImportTemplate() {
  const template = selectedImportTemplate();
  setValue("import-target", template.targetType);
  setValue("import-source", template.sourceSystem);
  setValue("import-file", template.fileName);
  setValue("import-csv", template.csv);
  renderImportMappingProfiles();
  renderImportFieldMapper();
  $("import-note").textContent = `${template.label} loaded. Validate before committing client data.`;
}

function downloadSelectedImportTemplate() {
  const template = selectedImportTemplate();
  const blob = new Blob([template.csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = template.fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

function loadExcelPasteSample() {
  const template = selectedImportTemplate();
  setValue("import-target", template.targetType);
  setValue("import-source", `Excel paste / ${template.sourceSystem}`);
  setValue("import-file", template.fileName.replace(/\.csv$/i, "-excel-paste.tsv"));
  setValue(
    "import-csv",
    template.csv
      .trim()
      .split(/\r?\n/)
      .map((line) => parseCsvLine(line, ",").join("\t"))
      .join("\n"),
  );
  renderImportMappingProfiles();
  renderImportFieldMapper();
  $("import-note").textContent = `${template.label} loaded as tab-delimited Excel paste. Validate before committing client data.`;
}

function downloadExcelWorkbookPack() {
  const workbook = buildImportWorkbook();
  const blob = new Blob([workbook], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "soma-risk-studio-import-workbook-pack.xlsx";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

function buildImportWorkbook() {
  const sheets = [
    {
      name: "Risks",
      rows: [
        [
          "Risk Ref",
          "Risk Name",
          "Risk Category",
          "Risk Owner",
          "Risk Status",
          "Risk Cause",
          "Risk Event",
          "Risk Effect",
          "Mitigation Strategy",
          "Pre Mitigation Likelihood",
          "Pre Mitigation Impact",
          "Post Mitigation Likelihood",
          "Post Mitigation Impact",
          "Previous Score",
          "Residual Exposure K",
          "Next Review Date",
        ],
        [
          "ARM-101",
          "Town centre utilities survey access delayed",
          "Programme / schedule",
          "Mark Doyle",
          "Open",
          "Third-party access approvals lag",
          "Survey access window missed",
          "Design freeze moves and cost grows",
          "Escalate access protocol and resequence survey",
          "4",
          "4",
          "3",
          "3",
          "12",
          "210",
          "2026-07-22",
        ],
      ],
    },
    {
      name: "Programme intelligence",
      rows: [
        [
          "Item Ref",
          "RAID Type",
          "Title",
          "Description",
          "Owner",
          "Item Status",
          "Criticality",
          "Linked Risk Ref",
          "Package",
          "WBS",
          "CBS",
          "Probability",
          "Value Low",
          "Value Most Likely",
          "Value High",
          "Schedule Low Days",
          "Schedule Most Likely Days",
          "Schedule High Days",
          "Response Strategy",
          "Decision Required",
          "Review Due Date",
        ],
        [
          "RAID-501",
          "dependency",
          "Planning committee date dependency",
          "Committee slot required for regeneration consent",
          "Mark Doyle",
          "Open",
          "High",
          "R-004",
          "PKG-REG-01",
          "2.3.1",
          "C-REG-120",
          "70",
          "0",
          "25",
          "80",
          "10",
          "20",
          "45",
          "Secure forward plan slot",
          "Confirm committee paper deadline",
          "2026-07-01",
        ],
      ],
    },
    {
      name: "Mapping notes",
      rows: [
        ["Topic", "Guidance"],
        ["Workflow", "Populate one sheet, copy the used range from Excel, paste into Data intake and validate before commit."],
        ["Risk aliases", "ARM, RiskHive and Safran-style headings such as Risk Ref, Risk Name, Responsible, Pre/Post Mitigation Likelihood and EMV are accepted."],
        ["RAID aliases", "Item Ref, RAID Type, Item Status, Criticality, Linked Risk Ref, WBS, CBS and value/schedule ranges are accepted."],
        ["Dates", "Use ISO date format YYYY-MM-DD where possible."],
        ["Governance", "Use validate-only mode first; committed rows create or update records and write import-batch evidence."],
      ],
    },
  ];
  return createXlsx(sheets);
}

function createXlsx(sheets: Array<{ name: string; rows: string[][] }>) {
  const files = [
    { path: "[Content_Types].xml", text: xlsxContentTypes(sheets.length) },
    { path: "_rels/.rels", text: xlsxRootRels() },
    { path: "xl/workbook.xml", text: xlsxWorkbook(sheets) },
    { path: "xl/_rels/workbook.xml.rels", text: xlsxWorkbookRels(sheets.length) },
    { path: "xl/styles.xml", text: xlsxStyles() },
    ...sheets.map((sheet, index) => ({ path: `xl/worksheets/sheet${index + 1}.xml`, text: xlsxSheet(sheet.rows) })),
  ];
  return zipStore(files.map((file) => ({ path: file.path, data: utf8Bytes(file.text) })));
}

function xlsxContentTypes(sheetCount: number) {
  const sheets = Array.from({ length: sheetCount }, (_, index) => `<Override PartName="/xl/worksheets/sheet${index + 1}.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>`).join("");
  return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/><Default Extension="xml" ContentType="application/xml"/><Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/><Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>${sheets}</Types>`;
}

function xlsxRootRels() {
  return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/></Relationships>`;
}

function xlsxWorkbook(sheets: Array<{ name: string }>) {
  return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?><workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"><sheets>${sheets.map((sheet, index) => `<sheet name="${xmlEscape(sheet.name)}" sheetId="${index + 1}" r:id="rId${index + 1}"/>`).join("")}</sheets></workbook>`;
}

function xlsxWorkbookRels(sheetCount: number) {
  const sheetRels = Array.from({ length: sheetCount }, (_, index) => `<Relationship Id="rId${index + 1}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet${index + 1}.xml"/>`).join("");
  return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">${sheetRels}<Relationship Id="rId${sheetCount + 1}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/></Relationships>`;
}

function xlsxStyles() {
  return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?><styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"><fonts count="1"><font><sz val="11"/><name val="Calibri"/></font></fonts><fills count="1"><fill><patternFill patternType="none"/></fill></fills><borders count="1"><border/></borders><cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs><cellXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/></cellXfs><cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles></styleSheet>`;
}

function xlsxSheet(rows: string[][]) {
  const sheetRows = rows
    .map((row, rowIndex) => `<row r="${rowIndex + 1}">${row.map((cell, columnIndex) => `<c r="${columnName(columnIndex + 1)}${rowIndex + 1}" t="inlineStr"><is><t>${xmlEscape(cell)}</t></is></c>`).join("")}</row>`)
    .join("");
  return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?><worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"><sheetData>${sheetRows}</sheetData></worksheet>`;
}

function columnName(index: number) {
  let name = "";
  let value = index;
  while (value > 0) {
    const mod = (value - 1) % 26;
    name = String.fromCharCode(65 + mod) + name;
    value = Math.floor((value - mod) / 26);
  }
  return name;
}

function zipStore(files: Array<{ path: string; data: Uint8Array }>) {
  const localParts: Uint8Array[] = [];
  const centralParts: Uint8Array[] = [];
  let offset = 0;
  for (const file of files) {
    const pathBytes = utf8Bytes(file.path);
    const crc = crc32(file.data);
    const local = new Uint8Array(30 + pathBytes.length + file.data.length);
    const localView = new DataView(local.buffer);
    localView.setUint32(0, 0x04034b50, true);
    localView.setUint16(4, 20, true);
    localView.setUint16(6, 0, true);
    localView.setUint16(8, 0, true);
    localView.setUint16(10, 0, true);
    localView.setUint16(12, 0, true);
    localView.setUint32(14, crc, true);
    localView.setUint32(18, file.data.length, true);
    localView.setUint32(22, file.data.length, true);
    localView.setUint16(26, pathBytes.length, true);
    local.set(pathBytes, 30);
    local.set(file.data, 30 + pathBytes.length);
    localParts.push(local);

    const central = new Uint8Array(46 + pathBytes.length);
    const centralView = new DataView(central.buffer);
    centralView.setUint32(0, 0x02014b50, true);
    centralView.setUint16(4, 20, true);
    centralView.setUint16(6, 20, true);
    centralView.setUint16(8, 0, true);
    centralView.setUint16(10, 0, true);
    centralView.setUint16(12, 0, true);
    centralView.setUint16(14, 0, true);
    centralView.setUint32(16, crc, true);
    centralView.setUint32(20, file.data.length, true);
    centralView.setUint32(24, file.data.length, true);
    centralView.setUint16(28, pathBytes.length, true);
    centralView.setUint16(30, 0, true);
    centralView.setUint16(32, 0, true);
    centralView.setUint16(34, 0, true);
    centralView.setUint16(36, 0, true);
    centralView.setUint32(38, 0, true);
    centralView.setUint32(42, offset, true);
    central.set(pathBytes, 46);
    centralParts.push(central);
    offset += local.length;
  }
  const centralSize = centralParts.reduce((sum, part) => sum + part.length, 0);
  const end = new Uint8Array(22);
  const endView = new DataView(end.buffer);
  endView.setUint32(0, 0x06054b50, true);
  endView.setUint16(8, files.length, true);
  endView.setUint16(10, files.length, true);
  endView.setUint32(12, centralSize, true);
  endView.setUint32(16, offset, true);
  return concatBytes([...localParts, ...centralParts, end]);
}

function crc32(data: Uint8Array) {
  let crc = 0xffffffff;
  for (const byte of data) {
    crc ^= byte;
    for (let bit = 0; bit < 8; bit += 1) crc = (crc >>> 1) ^ (0xedb88320 & -(crc & 1));
  }
  return (crc ^ 0xffffffff) >>> 0;
}

function utf8Bytes(value: string) {
  return new TextEncoder().encode(value);
}

function concatBytes(parts: Uint8Array[]) {
  const output = new Uint8Array(parts.reduce((sum, part) => sum + part.length, 0));
  let offset = 0;
  for (const part of parts) {
    output.set(part, offset);
    offset += part.length;
  }
  return output;
}

function xmlEscape(value: string) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

async function selectImportBatch(batchId: string) {
  activeImportBatchId = batchId;
  try {
    const result = await loadImports(batchId);
    importBatches = result.batches;
    importRows = result.rows;
    renderImports();
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function runImportFromView(commit: boolean) {
  if (!canManageImportsUi()) return;
  const payload = importPayloadFromForm(commit);
  if (!payload.csv.trim()) {
    $("import-csv").focus();
    return;
  }
  try {
    const result = await processImport(payload);
    activeImportBatchId = result.batch.import_batch_id;
    const refreshed = await loadImports(activeImportBatchId);
    importBatches = refreshed.batches;
    importRows = refreshed.rows;
    if (payload.commit) {
      risks = (await loadRisks()).risks;
      programmeItems = (await loadProgrammeItems()).items;
      renderProgrammeItems();
      renderTable();
      renderControlCentre();
    }
    renderImports();
    $("import-note").textContent = `${payload.commit ? "Import committed" : "Validation complete"}: ${result.batch.accepted_rows}/${result.batch.total_rows} accepted, ${result.batch.rejected_rows} rejected, ${result.batch.warning_rows} warnings.`;
  } catch (err) {
    $("import-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

function importPayloadFromForm(commit: boolean): ImportBatchInput {
  return {
    targetType: value("import-target") as ImportTargetType,
    sourceSystem: value("import-source") || "Client supplied register",
    fileName: value("import-file") || "register-import.csv",
    csv: value("import-csv"),
    commit,
  };
}

function seedImportSample() {
  const target = value("import-target");
  if (target === "risks") {
    setValue("import-file", "risk-register-import.csv");
    setValue("import-source", "Legacy Excel risk register");
    setValue(
      "import-csv",
      "code,title,category,owner,status,cause,event,effect,strategy,lpre,ipre,lpost,ipost,previous_residual,exposure,review_due\n" +
        "R-003,Oakfield school expansion - DfE funding tranche slips,Funding,Sam Bell,Open,DfE approval delayed,Funding tranche slips,Procurement and mobilisation delayed,Escalate approval route,3,5,3,5,15,410,2026-07-02\n" +
        ",New utilities diversion risk,Programme / schedule,Jo Carter,Open,Survey conflict,Utilities diversion extends,Traffic management costs rise,Validate with utility provider,3,4,3,3,9,180,2026-07-15",
    );
  } else {
    setValue("import-file", "programme-intelligence-import.csv");
    setValue("import-source", "Legacy Excel programme register");
    setValue(
      "import-csv",
      "code,item_type,title,description,owner,status,priority,linked_risk_code,package_code,wbs_code,cbs_code,probability_pct,value_low,value_most_likely,value_high,schedule_low_days,schedule_most_likely_days,schedule_high_days,response_strategy,decision_required,review_due\n" +
        "O-001,opportunity,Oakfield modular procurement opportunity,Existing opportunity updated from source register,Priya Ahmed,Active,High,R-014,PKG-EDU-01,3.4.2,C-EDU-370,55,90,160,260,-55,-35,-20,Market test modular option,Sponsor decision on procurement route,2026-06-28\n" +
        ",incident,Depot temporary traffic incident,Minor traffic incident during depot enabling works,Lee Price,Open,Medium,R-008,PKG-HWY-02,4.2.1,C-HWY-210,100,10,25,60,1,3,7,Close out incident actions,Confirm client notification route,2026-07-03",
    );
  }
  renderImportFieldMapper();
}

function canManageImportsUi() {
  return hasPermissionUi("imports.manage");
}

function importTargetLabel(target: string) {
  return target === "risks" ? "Risks" : "Programme intelligence";
}

function importBatchTone(status: string) {
  if (status === "completed") return "green";
  if (status === "completed_with_rejections") return "amber";
  if (status === "failed") return "red";
  return "blue";
}

function importRowTone(status: string) {
  if (status === "accepted") return "green";
  if (status === "warning") return "amber";
  return "red";
}

async function reloadExportWorkspace(params: { exportBatchId?: string; reconciliationRunId?: string } = {}) {
  const result = await loadExports(params).catch(() => null);
  if (!result) return;
  exportBatches = result.batches;
  exportRows = result.rows;
  exportReconciliations = result.reconciliations;
  exportReconciliationRows = result.reconciliationRows;
  exportReconciliationCommits = result.reconciliationCommits;
  activeExportBatchId = result.activeExportBatchId;
  activeReconciliationRunId = result.activeReconciliationRunId;
}

function renderExportReconciliation() {
  if (!document.getElementById("exportReconciliationPanel")) return;
  const reconciliationTotal = exportBatches.reduce((sum, batch) => sum + batch.reconciliation_count, 0);
  $("exportReconciliationSummary").textContent = `${exportBatches.length} export batch${exportBatches.length === 1 ? "" : "es"} · ${reconciliationTotal} reconciliation${reconciliationTotal === 1 ? "" : "s"}`;
  $("exportBatchCount").textContent = `${exportBatches.length} batches`;
  $("exportBatchList").innerHTML = exportBatches.length
    ? exportBatches
        .map((batch) => `<div class="export-batch-card${batch.export_batch_id === activeExportBatchId ? " active" : ""}" data-export-batch-id="${escAttr(batch.export_batch_id)}">
          <div class="programme-item-head">
            <div><span>${esc(exportTargetLabelText(batch.target_type))} · ${esc(exportScopeLabel(batch.export_scope))}</span><b>${esc(batch.file_name)}</b></div>
            ${statusToken(batch.status, exportBatchStatusTone(batch.status))}
          </div>
          <div class="report-pack-meta">
            <span>${esc(batch.source_system || "Export")}</span>
            <span>${batch.row_count} rows · ${batch.column_count} cols</span>
            <span>${batch.reconciliation_count} reconciliation${batch.reconciliation_count === 1 ? "" : "s"}</span>
            <span>${fmtDateTime(batch.last_reconciled_at || batch.created_at)}</span>
          </div>
        </div>`)
        .join("")
    : '<div class="muted">No export batches yet. Generate an export to create a reconciliation baseline.</div>';

  const activeBatch = exportBatches.find((batch) => batch.export_batch_id === activeExportBatchId) || null;
  setDisabled("export-download", !activeBatch);
  setDisabled("reconcile-load-baseline", !activeBatch);
  setDisabled("export-reconcile", !activeBatch);
  $("exportReconcileTarget").textContent = activeBatch
    ? `Reconciling ${exportTargetLabelText(activeBatch.target_type).toLowerCase()} export ${activeBatch.file_name} (${activeBatch.row_count} baseline rows)`
    : "Generate or select an export batch to reconcile a returned register";

  const activeRun = exportReconciliations.find((run) => run.reconciliation_run_id === activeReconciliationRunId) || exportReconciliations[0] || null;
  $("exportReconcileSummary").textContent = activeRun
    ? `${activeRun.returned_row_count} returned vs ${activeRun.baseline_row_count} baseline rows`
    : "No reconciliation runs yet";
  $("exportReconcileCounts").innerHTML = activeRun
    ? [
        { label: "Matched", value: activeRun.matched_count, tone: "green" },
        { label: "Changed", value: activeRun.changed_count, tone: "amber" },
        { label: "Missing", value: activeRun.missing_count, tone: "red" },
        { label: "New", value: activeRun.new_count, tone: "blue" },
        { label: "Conflict", value: activeRun.conflict_count, tone: "red" },
        { label: "Invalid", value: activeRun.invalid_count, tone: "amber" },
      ]
        .map((count) => `<div class="export-count ${count.value ? count.tone : "muted"}"><b>${count.value}</b><span>${esc(count.label)}</span></div>`)
        .join("")
    : '<div class="muted">Paste a returned CSV and reconcile to produce delta evidence.</div>';

  $("exportReconcileRuns").innerHTML = exportReconciliations.length
    ? exportReconciliations
        .map((run) => `<div class="export-reconcile-run-card${run.reconciliation_run_id === (activeRun?.reconciliation_run_id || "") ? " active" : ""}" data-reconciliation-run-id="${escAttr(run.reconciliation_run_id)}">
          <div class="programme-item-head">
            <div><span>${esc(run.source_system || "Return")}</span><b>${esc(run.file_name)}</b></div>
            ${statusToken(reconcileRunStatusLabel(run.status), reconcileRunStatusTone(run.status))}
          </div>
          <div class="report-pack-meta">
            <span>${run.changed_count} changed</span>
            <span>${run.missing_count} missing</span>
            <span>${run.new_count} new</span>
            <span>${run.conflict_count} conflict</span>
            <span>${fmtDateTime(run.created_at)}</span>
          </div>
        </div>`)
        .join("")
    : "";

  const rows = activeRun ? exportReconciliationRows.filter((row) => row.reconciliation_run_id === activeRun.reconciliation_run_id) : [];
  const pendingCommittable = rows.filter((row) => row.committable);
  $("exportCommitBar").innerHTML = activeRun
    ? `<div class="export-commit-status">
        ${statusToken(reconcileCommitStatusLabel(activeRun.commit_status), reconcileCommitStatusTone(activeRun.commit_status))}
        <span>${activeRun.committed_count} committed${activeRun.skipped_count ? ` · ${activeRun.skipped_count} skipped` : ""}${activeRun.committed_by_name ? ` · ${esc(activeRun.committed_by_name)}` : ""}</span>
      </div>
      <button class="btnp" id="export-commit" ${pendingCommittable.length ? "" : "disabled"}>Commit decisions (${pendingCommittable.length} applicable)</button>`
    : "";
  $("exportReconcileRowList").innerHTML = rows.length
    ? rows.map((row) => exportReconcileRowHtml(row)).join("")
    : activeRun
      ? '<div class="muted">No reconciliation row evidence for this run.</div>'
      : "";
  const commits = activeRun ? exportReconciliationCommits.filter((commit) => commit.reconciliation_run_id === activeRun.reconciliation_run_id) : [];
  $("exportCommitLog").innerHTML = commits.length
    ? `<div class="export-commit-head"><b>Commit log</b><span>${commits.length} decision${commits.length === 1 ? "" : "s"}</span></div>` +
      commits
        .slice(0, 12)
        .map((commit) => `<div class="export-commit-row ${escAttr(commit.result_status)}">
          ${statusToken(commit.result_status, reconcileCommitResultTone(commit.result_status))}
          <div><b>${esc(commit.object_code || commit.result_code || "—")}</b><span>${esc(commit.action)}${commit.result_code && commit.result_code !== commit.object_code ? ` → ${esc(commit.result_code)}` : ""} · ${esc(commit.message)}</span></div>
        </div>`)
        .join("")
    : "";
  if (document.getElementById("export-commit")) {
    $("export-commit").addEventListener("click", () => void commitReconciliationFromView());
  }
  applyRoleLocks();
}

function exportRowCommitDecisionDefault(row: ExportReconciliationRow): ReconciliationCommitDecision {
  if (row.status === "conflict") return "skip";
  return "apply";
}

function exportReconcileRowHtml(row: ExportReconciliationRow) {
  const deltas = row.field_deltas || [];
  const deltaHtml = deltas.length
    ? `<div class="export-delta-list">
        ${deltas
          .slice(0, 8)
          .map((delta) => `<div class="export-delta">
            <b>${esc(delta.label || delta.field)}</b>
            <span class="export-delta-baseline">${esc(delta.baseline || "—")}</span>
            <span class="export-delta-arrow">→</span>
            <span class="export-delta-returned">${esc(delta.returned || "—")}</span>
            ${delta.current && delta.current !== delta.baseline ? `<span class="export-delta-current">system: ${esc(delta.current)}</span>` : ""}
          </div>`)
          .join("")}
      </div>`
    : "";
  const committedBadge = row.commit_status === "committed"
    ? statusToken(`committed${row.committed_object_code ? ` ${row.committed_object_code}` : ""}`, "green")
    : "";
  const commitControl = row.committable
    ? `<div class="export-row-commit">
        <label>Commit</label>
        <select data-commit-decision="${escAttr(row.reconciliation_row_id)}">
          ${(["apply", "skip", row.status === "conflict" ? "override_apply" : ""] as ReconciliationCommitDecision[])
            .filter(Boolean)
            .map((decision) => `<option value="${decision}" ${exportRowCommitDecisionDefault(row) === decision ? "selected" : ""}>${esc(reconcileCommitDecisionLabel(decision))}</option>`)
            .join("")}
        </select>
      </div>`
    : "";
  return `<div class="export-reconcile-row-card ${escAttr(row.status)}">
    <div class="export-reconcile-row-head">
      ${statusToken(reconciliationStatusLabel(row.status), reconciliationStatusTone(row.status))}
      <b>${esc(row.object_code || "(no code)")}</b>
      <span>${esc(row.object_type || "")}</span>
      ${row.changed_field_count ? `<span>${row.changed_field_count} field${row.changed_field_count === 1 ? "" : "s"}</span>` : ""}
      ${committedBadge}
    </div>
    <p>${esc(row.message)}</p>
    ${deltaHtml}
    ${commitControl}
  </div>`;
}

function reconcileCommitDecisionLabel(decision: ReconciliationCommitDecision) {
  if (decision === "skip") return "Skip";
  if (decision === "override_apply") return "Override & apply";
  return "Apply";
}

function reconcileCommitStatusLabel(status: string) {
  if (status === "committed") return "committed";
  if (status === "partially_committed") return "partial";
  return "uncommitted";
}

function reconcileCommitStatusTone(status: string) {
  if (status === "committed") return "green";
  if (status === "partially_committed") return "amber";
  return "blue";
}

function reconcileCommitResultTone(status: string) {
  if (status === "committed") return "green";
  if (status === "failed") return "red";
  return "amber";
}

async function commitReconciliationFromView() {
  if (!canManageImportsUi() || !activeReconciliationRunId) return;
  const selects = Array.from(document.querySelectorAll<HTMLSelectElement>("[data-commit-decision]"));
  const decisions = selects
    .map((select) => ({ reconciliationRowId: select.dataset.commitDecision || "", decision: (select.value || "apply") as ReconciliationCommitDecision }))
    .filter((decision) => decision.reconciliationRowId);
  if (!decisions.length) {
    $("reconcile-note").textContent = "No applicable rows to commit.";
    return;
  }
  try {
    const result = await commitReconciliationRun(activeReconciliationRunId, { decisions, note: value("reconcile-notes") });
    await reloadExportWorkspace({ exportBatchId: activeExportBatchId, reconciliationRunId: activeReconciliationRunId });
    if (result.committed) {
      risks = (await loadRisks()).risks;
      programmeItems = (await loadProgrammeItems().catch(() => ({ items: programmeItems }))).items;
      renderProgrammeItems();
      renderTable();
      renderControlCentre();
    }
    renderExportReconciliation();
    $("reconcile-note").textContent = `Commit complete: ${result.committed} applied, ${result.skipped} skipped, ${result.failed} failed.`;
    toast(`Reconciliation commit: ${result.committed} applied`);
  } catch (err) {
    $("reconcile-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

function exportPayloadFromForm() {
  return {
    targetType: (value("export-target") || "risks") as ExportTargetType,
    exportScope: (value("export-scope") || "active") as ExportScope,
    sourceSystem: value("export-source") || "SOMA Risk Studio export",
    fileName: value("export-file") || `${value("export-target") === "programme_items" ? "programme-intelligence" : "risk-register"}-export.csv`,
    notes: value("export-notes"),
  };
}

async function generateExportFromView() {
  if (!canManageImportsUi()) return;
  try {
    const result = await createExportBatch(exportPayloadFromForm());
    await reloadExportWorkspace({ exportBatchId: result.batch.export_batch_id });
    setValue("reconcile-source", `${result.batch.source_system} return`);
    setValue("reconcile-file", result.batch.file_name.replace(/\.csv$/i, "-returned.csv"));
    renderExportReconciliation();
    $("export-note").textContent = `Export ${result.batch.file_name} generated with ${result.batch.row_count} ${exportTargetLabelText(result.batch.target_type).toLowerCase()} rows and ${result.batch.column_count} columns.`;
    toast("Export generated");
  } catch (err) {
    $("export-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

async function selectExportBatch(batchId: string) {
  if (!batchId) return;
  try {
    await reloadExportWorkspace({ exportBatchId: batchId });
    renderExportReconciliation();
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function selectReconciliationRun(runId: string) {
  if (!runId) return;
  try {
    await reloadExportWorkspace({ exportBatchId: activeExportBatchId, reconciliationRunId: runId });
    renderExportReconciliation();
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function downloadActiveExportCsv() {
  if (!activeExportBatchId) return;
  try {
    const result = await downloadExportBatchCsv(activeExportBatchId);
    triggerCsvDownload(result.fileName, result.text);
    $("export-note").textContent = `Downloaded ${result.fileName}.`;
  } catch (err) {
    $("export-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

async function loadBaselineCsvIntoReconcile() {
  if (!activeExportBatchId) return;
  try {
    const result = await downloadExportBatchCsv(activeExportBatchId);
    setValue("reconcile-csv", result.text);
    $("reconcile-note").textContent = "Loaded the export baseline CSV. Edit, drop or append rows to model a returned register, then reconcile.";
  } catch (err) {
    $("reconcile-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

async function reconcileReturnedExportFromView() {
  if (!canManageImportsUi() || !activeExportBatchId) return;
  const csv = value("reconcile-csv");
  if (!csv.trim()) {
    $("reconcile-csv").focus();
    $("reconcile-note").textContent = "Paste the returned CSV before reconciling.";
    return;
  }
  try {
    const result = await reconcileExportBatch(activeExportBatchId, {
      csv,
      sourceSystem: value("reconcile-source") || "Returned register",
      fileName: value("reconcile-file") || "returned-register.csv",
      notes: value("reconcile-notes"),
    });
    await reloadExportWorkspace({ exportBatchId: activeExportBatchId, reconciliationRunId: result.run.reconciliation_run_id });
    renderExportReconciliation();
    $("reconcile-note").textContent = `Reconciled ${result.run.returned_row_count} returned rows: ${result.run.matched_count} matched, ${result.run.changed_count} changed, ${result.run.missing_count} missing, ${result.run.new_count} new, ${result.run.conflict_count} conflict, ${result.run.invalid_count} invalid.`;
    toast("Reconciliation complete");
  } catch (err) {
    $("reconcile-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

function triggerCsvDownload(fileName: string, text: string) {
  const blob = new Blob([text], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

function exportTargetLabelText(target: string) {
  return target === "programme_items" ? "Programme intelligence" : "Risks";
}

function exportScopeLabel(scope: string) {
  if (scope === "active") return "Active";
  if (scope === "qra_candidates") return "QRA candidates";
  return "All";
}

function exportBatchStatusTone(status: string) {
  return status === "reconciled" ? "green" : "blue";
}

function reconcileRunStatusLabel(status: string) {
  if (status === "completed_with_conflicts") return "conflicts";
  if (status === "completed_with_invalid") return "invalid rows";
  return "completed";
}

function reconcileRunStatusTone(status: string) {
  if (status === "completed_with_conflicts") return "red";
  if (status === "completed_with_invalid") return "amber";
  return "green";
}

function reconciliationStatusLabel(status: string) {
  if (status === "missing_from_return") return "missing";
  if (status === "new_in_return") return "new";
  return status;
}

function reconciliationStatusTone(status: string) {
  if (status === "matched") return "green";
  if (status === "changed") return "amber";
  if (status === "new_in_return") return "blue";
  if (status === "missing_from_return" || status === "conflict") return "red";
  return "amber";
}

function renderSchedule() {
  if (!document.getElementById("scheduleImportPanel")) return;
  const matched = scheduleRiskLinks.filter((l) => l.matched).length;
  const unmatched = scheduleRiskLinks.length - matched;
  const critical = scheduleActivities.filter((a) => a.is_critical).length;
  $("scheduleSummary").textContent = `${scheduleActivities.length} activities · ${matched}/${scheduleRiskLinks.length} risk links matched`;
  $("scheduleKpis").innerHTML = [
    { label: "Activities", value: scheduleActivities.length, sub: `${critical} critical` },
    { label: "Import batches", value: scheduleBatches.length, sub: "P6/MSP" },
    { label: "Risk links matched", value: matched, sub: "to schedule" },
    { label: "Unmatched links", value: unmatched, sub: unmatched ? "reconcile" : "all resolved" },
  ]
    .map((kpi) => `<div><b>${esc(String(kpi.value))}</b><span>${esc(kpi.label)}</span><small>${esc(kpi.sub)}</small></div>`)
    .join("");

  $("scheduleReconList").innerHTML = scheduleRiskLinks.length
    ? `<div class="schedule-recon-head"><b>Schedule-risk reconciliation</b><span>${unmatched} unmatched</span></div>` +
      scheduleRiskLinks
        .slice(0, 20)
        .map((link) => `<div class="schedule-recon-row ${link.matched ? "matched" : "unmatched"}">
          ${statusToken(link.matched ? "matched" : "unmatched", link.matched ? "green" : "amber")}
          <div><b>${esc(link.risk_code)} → ${esc(link.activity_id)}</b><span>${esc(link.matched ? link.activity_name : "Activity not yet imported")}${link.is_critical ? " · critical" : ""}</span></div>
        </div>`)
        .join("")
    : '<div class="muted">No risks reference a schedule activity yet.</div>';

  $("scheduleActivityList").innerHTML = scheduleActivities.length
    ? scheduleActivities
        .slice(0, 30)
        .map((a) => `<div class="schedule-activity-card${a.is_critical ? " critical" : ""}">
          <div><b>${esc(a.activity_id)}</b><span>${esc(a.name)}</span></div>
          <div class="schedule-activity-meta">
            ${a.wbs_code ? `<span>WBS ${esc(a.wbs_code)}</span>` : ""}
            <span>${esc(a.start_date || "?")} → ${esc(a.finish_date || "?")}</span>
            <span>${a.percent_complete}%</span>
            ${a.is_critical ? statusToken("critical", "red") : `<span>float ${a.total_float_days}d</span>`}
            ${a.linked_risk_count ? `<span>${a.linked_risk_count} risk${a.linked_risk_count === 1 ? "" : "s"}</span>` : ""}
          </div>
        </div>`)
        .join("")
    : '<div class="muted">No schedule activities imported yet.</div>';
  applyRoleLocks();
}

function seedScheduleSample() {
  setValue("schedule-source", "Primavera P6 export");
  setValue("schedule-file", "p6-baseline.csv");
  setValue(
    "schedule-csv",
    "Activity ID,Activity Name,WBS,Start,Finish,Original Duration,% Complete,Total Float,Critical\n" +
      "A512-UTIL-030,A512 corridor utility diversions,1.1.2,2026-07-06,2026-09-18,54,20,0,Yes\n" +
      "DEP-FRAME-060,Highways depot steel frame,8.1.5,2026-09-01,2026-12-18,78,0,0,Yes\n" +
      "NEW-ACT-100,New enabling works package,1.2.0,2026-08-01,2026-10-15,52,0,12,No",
  );
  $("schedule-note").textContent = "Sample P6 export loaded. Validate before committing.";
}

async function runScheduleImport(commit: boolean) {
  if (!canManageImportsUi()) return;
  const csv = value("schedule-csv");
  if (!csv.trim()) {
    $("schedule-csv").focus();
    return;
  }
  try {
    const result = await processScheduleImport({
      sourceSystem: value("schedule-source") || "Primavera P6 / MS Project export",
      fileName: value("schedule-file") || "schedule-export.csv",
      csv,
      commit,
    });
    const refreshed = await loadSchedule();
    scheduleBatches = refreshed.batches;
    scheduleActivities = refreshed.activities;
    scheduleRiskLinks = refreshed.riskLinks;
    renderSchedule();
    $("schedule-note").textContent = `${commit ? "Schedule committed" : "Validation complete"}: ${result.batch.accepted_rows}/${result.batch.total_rows} accepted, ${result.batch.rejected_rows} rejected, ${result.batch.matched_risk_count} risk links matched.`;
    toast(commit ? "Schedule imported" : "Schedule validated");
  } catch (err) {
    $("schedule-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

function costStatusTone(status: string) {
  if (status === "covered") return "green";
  if (status === "exposed") return "red";
  if (status === "no_cost_line") return "amber";
  return "neutral";
}
function costStatusLabel(status: string) {
  if (status === "no_cost_line") return "no cost line";
  if (status === "no_risk") return "no risk";
  return status;
}

function renderCost() {
  if (!document.getElementById("costImportPanel")) return;
  const exposed = costReconciliation.filter((r) => r.reconciliation_status === "exposed").length;
  const noCostLine = costReconciliation.filter((r) => r.reconciliation_status === "no_cost_line").length;
  const totalContingency = costLines.reduce((sum, l) => sum + l.contingency, 0);
  const totalExposure = costReconciliation.reduce((sum, r) => sum + r.risk_exposure, 0);
  $("costSummary").textContent = `${costLines.length} cost lines · ${exposed} exposed CBS`;
  $("costKpis").innerHTML = [
    { label: "Cost lines", value: costLines.length, sub: `${costBatches.length} import${costBatches.length === 1 ? "" : "s"}` },
    { label: "Contingency", value: `£${Math.round(totalContingency)}k`, sub: "held" },
    { label: "Risk exposure", value: `£${Math.round(totalExposure)}k`, sub: "mapped" },
    { label: "Exposed CBS", value: exposed, sub: noCostLine ? `${noCostLine} no cost line` : "covered" },
  ]
    .map((kpi) => `<div><b>${esc(String(kpi.value))}</b><span>${esc(kpi.label)}</span><small>${esc(kpi.sub)}</small></div>`)
    .join("");

  $("costReconList").innerHTML = costReconciliation.length
    ? `<div class="schedule-recon-head"><b>Risk-vs-contingency reconciliation</b><span>${exposed} exposed</span></div>` +
      costReconciliation
        .slice(0, 30)
        .map((r) => `<div class="schedule-recon-row ${r.reconciliation_status === "covered" ? "matched" : "unmatched"}">
          ${statusToken(costStatusLabel(r.reconciliation_status), costStatusTone(r.reconciliation_status))}
          <div><b>${esc(r.cbs_code)}${r.description ? ` · ${esc(r.description)}` : ""}</b><span>exposure £${Math.round(r.risk_exposure)}k vs contingency £${Math.round(r.contingency)}k · headroom £${Math.round(r.headroom)}k · ${r.risk_count} risk${r.risk_count === 1 ? "" : "s"}</span></div>
        </div>`)
        .join("")
    : '<div class="muted">No cost lines imported yet.</div>';
  applyRoleLocks();
}

function seedCostSample() {
  setValue("cost-source", "Cost system export");
  setValue("cost-file", "cost-baseline.csv");
  setValue(
    "cost-csv",
    "CBS,WBS,Description,Budget,Committed,Actual,Forecast,Contingency\n" +
      "C-HWY-110,1.1.2,A512 highways works,6200,3000,1200,6300,400\n" +
      "C-EDU-150,3.1.4,Oakfield school capital,8500,2000,900,8800,450\n" +
      "C-NEW-500,9.9.9,New programme cost account,2000,100,0,2000,250",
  );
  $("cost-note").textContent = "Sample cost export loaded. Validate before committing.";
}

async function runCostImport(commit: boolean) {
  if (!canManageImportsUi()) return;
  const csv = value("cost-csv");
  if (!csv.trim()) {
    $("cost-csv").focus();
    return;
  }
  try {
    const result = await processCostImport({
      sourceSystem: value("cost-source") || "Cost system export",
      fileName: value("cost-file") || "cost-export.csv",
      csv,
      commit,
    });
    const refreshed = await loadCost();
    costBatches = refreshed.batches;
    costLines = refreshed.lines;
    costReconciliation = refreshed.reconciliation;
    renderCost();
    $("cost-note").textContent = `${commit ? "Cost committed" : "Validation complete"}: ${result.batch.accepted_rows}/${result.batch.total_rows} accepted, ${result.batch.rejected_rows} rejected.`;
    toast(commit ? "Cost imported" : "Cost validated");
  } catch (err) {
    $("cost-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

async function refreshEvidence(showToast = true) {
  try {
    await reloadEvidenceGovernance();
    renderEvidence();
    if (showToast) toast("Evidence library refreshed");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function reloadEvidenceGovernance(evidenceId = activeEvidenceId, packageId = activeEvidencePackageId) {
  const [result, attachmentResult, packageResult] = await Promise.all([
    loadEvidence(evidenceId),
    loadEvidenceAttachments(evidenceId),
    loadEvidencePackages(packageId),
  ]);
  evidenceRecords = result.items;
  evidenceLinks = result.links;
  evidenceAttachments = attachmentResult.attachments;
  evidencePackages = packageResult.packages;
  evidencePackageItems = packageResult.items;
  if (!activeEvidencePackageId && evidencePackages.length) activeEvidencePackageId = evidencePackages[0].package_id;
}

function renderEvidence() {
  if (!document.getElementById("evidenceList")) return;
  const active = evidenceRecords.filter((item) => item.status === "active").length;
  const linked = evidenceRecords.filter((item) => item.link_count > 0).length;
  const overdue = evidenceRecords.filter((item) => item.review_due && item.review_due < todayIso() && item.status !== "archived").length;
  const restricted = evidenceRecords.filter((item) => item.sensitivity === "restricted" || item.sensitivity === "confidential").length;
  const activeAttachments = evidenceAttachments.filter((item) => item.status === "active").length;
  const sealedPackages = evidencePackages.filter((item) => item.status === "sealed").length;
  $("evidenceKpis").innerHTML = [
    { label: "Evidence records", value: evidenceRecords.length, sub: `${active} active` },
    { label: "Linked records", value: linked, sub: `${evidenceLinks.length} object links` },
    { label: "Attachments", value: evidenceAttachments.length, sub: `${activeAttachments} active` },
    { label: "Evidence packages", value: evidencePackages.length, sub: `${sealedPackages} sealed` },
    { label: "Sensitive", value: restricted, sub: overdue ? `${overdue} overdue review` : "confidential/restricted" },
  ]
    .map((kpi) => `<div><b>${esc(String(kpi.value))}</b><span>${esc(kpi.label)}</span><small>${esc(kpi.sub)}</small></div>`)
    .join("");

  const query = value("evidence-search").toLowerCase();
  const typeFilter = value("evidence-type-filter");
  const statusFilter = value("evidence-status-filter");
  const filtered = evidenceRecords
    .filter((item) => !typeFilter || item.evidence_type === typeFilter)
    .filter((item) => !statusFilter || item.status === statusFilter)
    .filter((item) => {
      if (!query) return true;
      const haystack = [
        item.evidence_code,
        item.title,
        item.reference,
        item.source,
        item.owner,
        item.summary,
        item.tags.join(" "),
        ...evidenceLinks.filter((link) => link.evidence_id === item.evidence_id).map((link) => `${link.entity_type} ${link.entity_id} ${link.link_role}`),
        ...evidenceAttachments.filter((attachment) => attachment.evidence_id === item.evidence_id).map((attachment) => `${attachment.attachment_code} ${attachment.file_name} ${attachment.storage_provider}`),
      ]
        .join(" ")
        .toLowerCase();
      return haystack.includes(query);
    })
    .sort((a, b) => evidenceRank(a) - evidenceRank(b) || a.evidence_code.localeCompare(b.evidence_code));

  $("evidenceList").innerHTML = filtered.length
    ? filtered
        .map((item) => `<div class="evidence-card${item.evidence_id === activeEvidenceId ? " active" : ""}" data-evidence-id="${escAttr(item.evidence_id)}">
          <div class="programme-item-head">
            <div><span>${esc(item.evidence_code)} · ${esc(evidenceTypeLabel(item.evidence_type))}</span><b>${esc(item.title)}</b></div>
            ${statusToken(item.status, evidenceStatusTone(item.status))}
          </div>
          <div class="report-pack-meta">
            <span>${esc(item.owner || "Unassigned")}</span>
            <span>${esc(item.reference || item.source || "No reference")}</span>
            <span>${item.review_due ? esc(reviewLabel(item.review_due)) : "No review due"}</span>
          </div>
          <div class="evidence-card-summary">${esc(item.summary || "No summary captured.")}</div>
          <div class="evidence-card-footer">
            <span>${item.link_count} links</span>
            <span>${item.linked_risk_count} risks</span>
            <span>${item.linked_control_count} controls</span>
            <span>${item.sensitivity}</span>
            <button class="lnk" data-evidence-id="${escAttr(item.evidence_id)}" data-evidence-action="archive">Archive</button>
          </div>
        </div>`)
        .join("")
    : '<div class="muted">No evidence records match the current filters.</div>';

  const links = activeEvidenceId ? evidenceLinks.filter((link) => link.evidence_id === activeEvidenceId) : evidenceLinks.slice(0, 60);
  $("evidenceLinkCount").textContent = activeEvidenceId ? `${links.length} links on selected evidence` : `${Math.min(evidenceLinks.length, 60)} recent links`;
  $("evidenceLinkList").innerHTML = links.length
    ? links
        .map((link) => `<div class="evidence-link-card">
          <div><b>${esc(evidenceEntityLabel(link.entity_type))} · ${esc(link.entity_id)}</b><span>${esc(link.notes || link.evidence_title)}</span></div>
          <div class="import-row-meta">${statusToken(link.link_role.replace(/_/g, " "), "blue")}<span>${esc(link.evidence_code)}</span></div>
        </div>`)
        .join("")
    : '<div class="muted">Select evidence or create links to see traceability.</div>';

  const attachments = activeEvidenceId ? evidenceAttachments.filter((item) => item.evidence_id === activeEvidenceId) : evidenceAttachments.slice(0, 40);
  $("evidenceAttachmentCount").textContent = activeEvidenceId ? `${attachments.length} attachments on selected evidence` : `${Math.min(evidenceAttachments.length, 40)} recent attachments`;
  $("evidenceAttachmentList").innerHTML = attachments.length
    ? attachments
        .map((attachment) => `<div class="evidence-attachment-card">
          <div>
            <b>${esc(attachment.attachment_code)} · ${esc(attachment.file_name)}</b>
            <span>${esc(attachment.storage_uri)}</span>
            <small>${esc(attachment.evidence_code)} · ${esc(attachment.mime_type || attachment.storage_provider)}${attachment.checksum_sha256 ? ` · SHA ${esc(attachment.checksum_sha256.slice(0, 10))}` : ""}</small>
          </div>
          <div class="import-row-meta">
            ${statusToken(attachment.status, attachment.status === "active" ? "green" : attachment.status === "superseded" ? "blue" : "neutral")}
            ${statusToken(attachment.classification, attachment.classification === "restricted" || attachment.classification === "confidential" ? "amber" : "blue")}
            ${attachment.has_bytes ? statusToken("native file", "green") : ""}
            <span>${esc(attachment.version_label || attachment.storage_provider)}</span>
            ${attachment.has_bytes ? `<a class="lnk" href="/api/evidence/attachments/${escAttr(attachment.attachment_id)}/bytes" target="_blank" rel="noreferrer">Download</a>` : ""}
            <button class="lnk evidence-admin-only" data-attachment-action="upload" data-attachment-id="${escAttr(attachment.attachment_id)}">${attachment.has_bytes ? "Replace file" : "Upload file"}</button>
            <button class="lnk evidence-admin-only" data-attachment-action="archive" data-attachment-id="${escAttr(attachment.attachment_id)}">Archive</button>
          </div>
        </div>`)
        .join("")
    : '<div class="muted">Select evidence and register document locators, SharePoint references or object-store metadata.</div>';

  $("evidencePackageCount").textContent = `${evidencePackages.length} packages · ${sealedPackages} sealed`;
  $("evidencePackageList").innerHTML = evidencePackages.length
    ? evidencePackages
        .slice()
        .sort((a, b) => packageRank(a) - packageRank(b) || b.updated_at.localeCompare(a.updated_at))
        .map((pack) => `<div class="evidence-package-card${pack.package_id === activeEvidencePackageId ? " active" : ""}">
          <div>
            <b>${esc(pack.package_code)} · ${esc(pack.title)}</b>
            <span>${esc(pack.purpose)}</span>
            <small>${pack.item_count} evidence · ${pack.attachment_count} attachments${pack.manifest_hash ? ` · ${esc(pack.manifest_hash.slice(0, 12))}` : ""}</small>
          </div>
          <div class="import-row-meta">
            ${statusToken(pack.status, pack.status === "sealed" ? "green" : pack.status === "draft" ? "amber" : "neutral")}
            <span>${esc(pack.sensitivity)}</span>
            <button class="lnk" data-package-action="select" data-package-id="${escAttr(pack.package_id)}">Select</button>
            <button class="lnk" data-package-action="seal" data-package-id="${escAttr(pack.package_id)}" ${pack.status === "sealed" || !canSealEvidencePackagesUi() ? "disabled" : ""}>Seal</button>
          </div>
        </div>`)
        .join("")
    : '<div class="muted">No evidence packages created yet.</div>';

  const packageItems = activeEvidencePackageId ? evidencePackageItems.filter((item) => item.package_id === activeEvidencePackageId) : evidencePackageItems.slice(0, 20);
  $("evidencePackageItemList").innerHTML = packageItems.length
    ? packageItems
        .map((item) => `<div class="evidence-link-card">
          <div><b>${esc(item.evidence_code)} · ${esc(item.evidence_title)}</b><span>${esc(item.notes || item.package_title)}</span></div>
          <div class="import-row-meta">${statusToken(item.link_role.replace(/_/g, " "), "blue")}<span>${item.attachment_count} attachments</span></div>
        </div>`)
        .join("")
    : '<div class="muted">Select or create a package to see included evidence.</div>';
  applyRoleLocks();
}

async function selectEvidence(id: string) {
  activeEvidenceId = id;
  try {
    await reloadEvidenceGovernance(id);
    fillEvidenceForm(id);
    renderEvidence();
  } catch (err) {
    toast(errorMessage(err));
  }
}

function evidenceAttachmentPayloadFromForm(): EvidenceAttachmentInput {
  return {
    attachmentCode: value("attachment-code"),
    fileName: value("attachment-file-name"),
    storageProvider: value("attachment-provider") as EvidenceStorageProvider,
    storageUri: value("attachment-uri"),
    mimeType: value("attachment-mime"),
    fileSizeBytes: Number(value("attachment-size") || 0),
    checksumSha256: value("attachment-checksum"),
    versionLabel: value("attachment-version"),
    classification: value("attachment-classification") as EvidenceSensitivity,
    status: "active",
    notes: value("attachment-notes"),
  };
}

async function saveEvidenceAttachmentFromForm() {
  if (!activeEvidenceId || !canManageEvidenceUi()) {
    toast("Select an evidence record first");
    return;
  }
  const payload = evidenceAttachmentPayloadFromForm();
  if (!payload.fileName || !payload.storageUri) {
    $("attachment-file-name").focus();
    return;
  }
  try {
    await createEvidenceAttachment(activeEvidenceId, payload);
    clearEvidenceAttachmentForm();
    await reloadEvidenceGovernance(activeEvidenceId, activeEvidencePackageId);
    renderEvidence();
    toast("Evidence attachment registered");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function archiveEvidenceAttachmentFromView(id: string) {
  if (!id || !canManageEvidenceUi()) return;
  try {
    await archiveEvidenceAttachment(id);
    await reloadEvidenceGovernance(activeEvidenceId, activeEvidencePackageId);
    renderEvidence();
    toast("Evidence attachment archived");
  } catch (err) {
    toast(errorMessage(err));
  }
}

let uploadTargetAttachmentId = "";
function triggerAttachmentUpload(id: string) {
  if (!id || !canManageEvidenceUi()) return;
  uploadTargetAttachmentId = id;
  const input = $<HTMLInputElement>("attachment-bytes-input");
  input.value = "";
  input.click();
}

async function uploadAttachmentBytesFromUi() {
  const input = $<HTMLInputElement>("attachment-bytes-input");
  const file = input.files && input.files[0];
  if (!file || !uploadTargetAttachmentId || !canManageEvidenceUi()) return;
  const target = uploadTargetAttachmentId;
  uploadTargetAttachmentId = "";
  try {
    await uploadAttachmentBytes(target, file);
    await reloadEvidenceGovernance(activeEvidenceId, activeEvidencePackageId);
    renderEvidence();
    toast(`Stored ${file.name} (${Math.max(1, Math.round(file.size / 1024))} KB) natively`);
  } catch (err) {
    toast(errorMessage(err));
  }
}

function clearEvidenceAttachmentForm() {
  ["attachment-code", "attachment-file-name", "attachment-uri", "attachment-mime", "attachment-size", "attachment-version", "attachment-checksum", "attachment-notes"].forEach((id) => setValue(id, ""));
  setValue("attachment-provider", "sharepoint");
  setValue("attachment-classification", "internal");
}

function evidencePackagePayloadFromForm(): EvidencePackageInput {
  return {
    packageCode: value("package-code"),
    title: value("package-title"),
    purpose: value("package-purpose"),
    status: value("package-status") as EvidencePackage["status"],
    sensitivity: value("package-sensitivity") as EvidenceSensitivity,
    owner: value("package-owner"),
    items: evidencePackageItemsFromText(value("package-items")),
  };
}

async function saveEvidencePackageFromForm() {
  if (!canManageEvidenceUi()) return;
  const payload = evidencePackagePayloadFromForm();
  if (!payload.title || !payload.purpose || !payload.items.length) {
    $("package-title").focus();
    return;
  }
  try {
    const result = await createEvidencePackage(payload);
    activeEvidencePackageId = result.package.package_id;
    await reloadEvidenceGovernance(activeEvidenceId, activeEvidencePackageId);
    fillEvidencePackageForm(activeEvidencePackageId);
    renderEvidence();
    toast("Evidence package created");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function sealEvidencePackageFromView(id = value("evidence-package-id") || activeEvidencePackageId) {
  if (!id || !canManageEvidenceUi()) return;
  try {
    const result = await sealEvidencePackage(id);
    activeEvidencePackageId = result.package.package_id;
    await reloadEvidenceGovernance(activeEvidenceId, activeEvidencePackageId);
    fillEvidencePackageForm(activeEvidencePackageId);
    renderEvidence();
    toast("Evidence package sealed");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function selectEvidencePackage(id: string) {
  activeEvidencePackageId = id;
  fillEvidencePackageForm(id);
  void reloadEvidenceGovernance(activeEvidenceId, id).then(() => {
    fillEvidencePackageForm(id);
    renderEvidence();
  });
}

function evidencePayloadFromForm(): EvidenceInput {
  return {
    evidenceCode: value("evidence-code"),
    title: value("evidence-title"),
    evidenceType: value("evidence-type") as EvidenceType,
    source: value("evidence-source"),
    reference: value("evidence-reference"),
    uri: value("evidence-uri"),
    owner: value("evidence-owner"),
    status: value("evidence-status") as EvidenceStatus,
    sensitivity: value("evidence-sensitivity") as EvidenceSensitivity,
    documentDate: value("evidence-document-date"),
    reviewDue: value("evidence-review-due"),
    summary: value("evidence-summary"),
    tags: value("evidence-tags")
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean),
    links: evidenceLinksFromText(value("evidence-links")),
  };
}

async function saveEvidenceFromForm() {
  if (!canManageEvidenceUi()) return;
  const id = value("evidence-id");
  const payload = evidencePayloadFromForm();
  if (!payload.title) {
    $("evidence-title").focus();
    return;
  }
  try {
    const result = id ? await updateEvidence(id, payload) : await createEvidence(payload);
    activeEvidenceId = result.item.evidence_id;
    await reloadEvidenceGovernance(activeEvidenceId, activeEvidencePackageId);
    fillEvidenceForm(activeEvidenceId);
    renderEvidence();
    $("evidence-note").textContent = id ? "Evidence updated." : "Evidence created.";
    toast(id ? "Evidence updated" : "Evidence created");
  } catch (err) {
    $("evidence-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

function fillEvidenceForm(id: string) {
  const item = evidenceRecords.find((row) => row.evidence_id === id);
  if (!item) return;
  setValue("evidence-id", item.evidence_id);
  setValue("evidence-code", item.evidence_code);
  setValue("evidence-title", item.title);
  setValue("evidence-type", item.evidence_type);
  setValue("evidence-source", item.source);
  setValue("evidence-reference", item.reference);
  setValue("evidence-uri", item.uri);
  setValue("evidence-owner", item.owner);
  setValue("evidence-status", item.status);
  setValue("evidence-sensitivity", item.sensitivity);
  setValue("evidence-document-date", item.document_date);
  setValue("evidence-review-due", item.review_due);
  setValue("evidence-summary", item.summary);
  setValue("evidence-tags", item.tags.join(", "));
  setValue("evidence-links", evidenceLinksToText(evidenceLinks.filter((link) => link.evidence_id === id)));
}

function clearEvidenceForm() {
  activeEvidenceId = "";
  [
    "evidence-id",
    "evidence-code",
    "evidence-title",
    "evidence-source",
    "evidence-reference",
    "evidence-uri",
    "evidence-owner",
    "evidence-document-date",
    "evidence-review-due",
    "evidence-summary",
    "evidence-tags",
    "evidence-links",
  ].forEach((id) => setValue(id, ""));
  $("evidence-note").textContent = "";
  setValue("evidence-type", "document");
  setValue("evidence-status", "active");
  setValue("evidence-sensitivity", "internal");
  renderEvidence();
}

function fillEvidencePackageForm(id: string) {
  const pack = evidencePackages.find((item) => item.package_id === id);
  if (!pack) return;
  setValue("evidence-package-id", pack.package_id);
  setValue("package-code", pack.package_code);
  setValue("package-title", pack.title);
  setValue("package-status", pack.status);
  setValue("package-sensitivity", pack.sensitivity);
  setValue("package-owner", pack.owner);
  setValue("package-purpose", pack.purpose);
  setValue("package-items", evidencePackageItemsToText(evidencePackageItems.filter((item) => item.package_id === id)));
}

function clearEvidencePackageForm() {
  activeEvidencePackageId = "";
  ["evidence-package-id", "package-code", "package-title", "package-owner", "package-purpose", "package-items"].forEach((id) => setValue(id, ""));
  setValue("package-status", "draft");
  setValue("package-sensitivity", "internal");
  renderEvidence();
}

async function archiveEvidenceFromView(id = value("evidence-id")) {
  if (!id || !canManageEvidenceUi()) return;
  try {
    await archiveEvidence(id);
    if (value("evidence-id") === id) clearEvidenceForm();
    await reloadEvidenceGovernance(activeEvidenceId, activeEvidencePackageId);
    renderEvidence();
    toast("Evidence archived");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function evidenceLinksFromText(text: string) {
  return text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const [entityType = "risk", entityId = "", linkRole = "basis", ...notes] = line.split(",").map((part) => part.trim());
      return {
        entityType: evidenceEntityType(entityType),
        entityId,
        linkRole: evidenceLinkRole(linkRole),
        notes: notes.join(", ").trim(),
      };
    })
    .filter((link) => link.entityId);
}

function evidenceLinksToText(links: EvidenceLink[]) {
  return links.map((link) => `${link.entity_type},${link.entity_id},${link.link_role},${link.notes}`).join("\n");
}

function evidencePackageItemsFromText(text: string) {
  return text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line, index) => {
      const [evidenceCode = "", linkRole = "basis", ...notes] = line.split(",").map((part) => part.trim());
      return {
        evidenceCode: evidenceCode.toUpperCase(),
        linkRole: evidenceLinkRole(linkRole),
        notes: notes.join(", ").trim(),
        sortOrder: index + 1,
      };
    })
    .filter((item) => item.evidenceCode);
}

function evidencePackageItemsToText(items: EvidencePackageItem[]) {
  return items
    .slice()
    .sort((a, b) => a.sort_order - b.sort_order || a.evidence_code.localeCompare(b.evidence_code))
    .map((item) => `${item.evidence_code},${item.link_role},${item.notes}`)
    .join("\n");
}

function evidenceRank(item: EvidenceRecord) {
  const statusRank = item.status === "archived" ? 9 : item.status === "superseded" ? 6 : item.status === "draft" ? 2 : 0;
  const reviewRank = item.review_due && item.review_due < todayIso() ? -1 : 0;
  return statusRank + reviewRank;
}

function packageRank(item: EvidencePackage) {
  if (item.status === "draft") return 0;
  if (item.status === "sealed") return 1;
  if (item.status === "superseded") return 6;
  return 9;
}

function evidenceTypeLabel(type: string) {
  if (type === "model_file") return "Model file";
  return type.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
}

function evidenceEntityLabel(type: string) {
  if (type === "programme_item") return "Programme item";
  if (type === "qra_model_run") return "QRA model run";
  if (type === "import_batch") return "Import batch";
  if (type === "report_pack") return "Report pack";
  return evidenceTypeLabel(type);
}

function evidenceStatusTone(status: string) {
  if (status === "active") return "green";
  if (status === "draft") return "amber";
  if (status === "superseded") return "blue";
  return "neutral";
}

function evidenceEntityType(value: string): EvidenceEntityType {
  const normal = value.toLowerCase().replace(/[\s-]+/g, "_");
  if (["programme_item", "control", "risk_control", "assurance_test", "obligation", "qra_model_run", "import_batch", "report_pack"].includes(normal)) return normal as EvidenceEntityType;
  return "risk";
}

function evidenceLinkRole(value: string): EvidenceLinkRole {
  const normal = value.toLowerCase().replace(/[\s-]+/g, "_");
  if (["assumption", "control_evidence", "decision", "approval", "source", "output", "other"].includes(normal)) return normal as EvidenceLinkRole;
  return "basis";
}

function canManageEvidenceUi() {
  return hasPermissionUi("evidence.manage");
}

function canSealEvidencePackagesUi() {
  return hasPermissionUi("evidence.package.seal");
}

function bindConfiguration() {
  $("configuration-refresh").addEventListener("click", () => void refreshConfiguration());
  ["custom-field-search", "custom-field-entity-filter", "custom-field-status-filter"].forEach((id) => $(id).addEventListener("input", renderConfiguration));
  ["workflow-search", "workflow-entity-filter", "workflow-status-filter"].forEach((id) => $(id).addEventListener("input", renderConfiguration));
  $("custom-field-clear").addEventListener("click", clearCustomFieldForm);
  $("custom-field-save").addEventListener("click", () => void saveCustomFieldFromForm());
  $("custom-field-retire").addEventListener("click", () => void retireCustomFieldFromView());
  $("custom-value-save").addEventListener("click", () => void saveCustomFieldValueFromForm());
  $("workflow-definition-clear").addEventListener("click", clearWorkflowDefinitionForm);
  $("workflow-definition-template").addEventListener("click", seedWorkflowDefinitionTemplate);
  $("workflow-definition-save").addEventListener("click", () => void saveWorkflowDefinitionFromForm());
  $("workflow-definition-retire").addEventListener("click", () => void retireWorkflowDefinitionFromView());
  ["wfd-default-state", "wfd-states", "wfd-transitions"].forEach((id) => $(id).addEventListener("input", renderWorkflowDefinitionPreview));
  $("workflow-run-transition").addEventListener("click", () => void runWorkflowTransitionFromForm());
  $("customFieldList").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-custom-field-id]") as HTMLElement | null;
    if (!button) return;
    fillCustomFieldForm(button.dataset.customFieldId || "");
  });
  $("customValueList").addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest("[data-custom-value-id]") as HTMLElement | null;
    if (!button) return;
    fillCustomFieldValueForm(button.dataset.customValueId || "");
  });
  $("workflowInstanceList").addEventListener("click", (event) => {
    const card = (event.target as HTMLElement).closest("[data-workflow-instance-id]") as HTMLElement | null;
    if (!card) return;
    selectWorkflowInstance(card.dataset.workflowInstanceId || "");
  });
  $("workflowDefinitionList").addEventListener("click", (event) => {
    const card = (event.target as HTMLElement).closest("[data-workflow-definition-id]") as HTMLElement | null;
    if (!card) return;
    fillWorkflowDefinitionForm(card.dataset.workflowDefinitionId || "");
  });
}

async function refreshConfiguration(showToast = true) {
  try {
    const [definitions, values, workflows] = await Promise.all([loadCustomFieldDefinitions(), loadCustomFieldValues(), loadWorkflows()]);
    customFieldDefinitions = definitions.items;
    customFieldValues = values.items;
    workflowDefinitions = workflows.definitions;
    workflowInstances = workflows.instances;
    workflowEvents = workflows.events;
    if (!workflowInstances.some((item) => item.workflow_instance_id === activeWorkflowInstanceId)) {
      activeWorkflowInstanceId = workflowInstances[0]?.workflow_instance_id || "";
    }
    if (activeWorkflowDefinitionId && !workflowDefinitions.some((item) => item.workflow_definition_id === activeWorkflowDefinitionId)) {
      activeWorkflowDefinitionId = "";
    }
    renderConfiguration();
    renderOpenRiskDetailSupplements();
    if (showToast) toast("Configuration refreshed");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function renderConfiguration() {
  if (!document.getElementById("configurationKpis")) return;
  const activeFields = customFieldDefinitions.filter((item) => item.status === "active");
  const activeWorkflows = workflowInstances.filter((item) => item.status === "active");
  const overdueWorkflows = workflowInstances.filter((item) => item.status === "active" && item.due_date && isPast(item.due_date)).length;
  const transitionable = workflowInstances.filter((item) => item.status === "active" && item.nextTransitions.length).length;
  $("configurationKpis").innerHTML = [
    { label: "Configured fields", value: activeFields.length, sub: `${customFieldValues.length} captured values` },
    { label: "Workflow definitions", value: workflowDefinitions.filter((item) => item.status === "active").length, sub: "tenant lifecycle models" },
    { label: "Open workflows", value: activeWorkflows.length, sub: `${overdueWorkflows} overdue` },
    { label: "Actionable transitions", value: transitionable, sub: "available from current state" },
  ]
    .map((kpi) => `<div><b>${esc(String(kpi.value))}</b><span>${esc(kpi.label)}</span><small>${esc(kpi.sub)}</small></div>`)
    .join("");
  renderCustomFieldDefinitionOptions();
  renderCustomFieldList();
  renderCustomFieldValues();
  renderWorkflowInstances();
  ensureWorkflowDefinitionFormSeeded();
  renderWorkflowDefinitionPreview();
  renderWorkflowDefinitions();
  renderWorkflowSelected();
  applyRoleLocks();
}

function renderCustomFieldList() {
  const query = value("custom-field-search").toLowerCase();
  const entity = value("custom-field-entity-filter");
  const status = value("custom-field-status-filter");
  const rows = customFieldDefinitions
    .filter((item) => !entity || item.entity_type === entity)
    .filter((item) => !status || item.status === status)
    .filter((item) => {
      if (!query) return true;
      return [item.entity_type, item.field_key, item.label, item.help_text, item.field_type, item.options.join(" ")].join(" ").toLowerCase().includes(query);
    })
    .sort((a, b) => configEntityRank(a.entity_type) - configEntityRank(b.entity_type) || a.sort_order - b.sort_order || a.label.localeCompare(b.label));
  $("customFieldCount").textContent = `${rows.length} shown`;
  $("customFieldList").innerHTML = rows.length
    ? rows
        .map((item) => `<div class="custom-field-card${value("cf-id") === item.custom_field_definition_id ? " active" : ""}" data-custom-field-id="${escAttr(item.custom_field_definition_id)}">
          <div class="programme-item-head">
            <div><span>${esc(configEntityLabel(item.entity_type))} · ${esc(item.field_type)}</span><b>${esc(item.label)}</b></div>
            ${statusToken(item.status, item.status === "active" ? "green" : "neutral")}
          </div>
          <div class="report-pack-meta">
            <span>${esc(item.field_key)}</span>
            <span>${item.required ? "Required" : "Optional"}</span>
            <span>${item.options.length ? `${item.options.length} options` : "No options"}</span>
          </div>
          <div class="evidence-card-summary">${esc(item.help_text || "No help text captured.")}</div>
        </div>`)
        .join("")
    : '<div class="muted">No custom fields match this view.</div>';
}

function renderCustomFieldDefinitionOptions() {
  const current = value("cfv-definition");
  const options = customFieldDefinitions
    .filter((item) => item.status === "active")
    .sort((a, b) => configEntityRank(a.entity_type) - configEntityRank(b.entity_type) || a.sort_order - b.sort_order)
    .map((item) => `<option value="${escAttr(item.custom_field_definition_id)}">${esc(configEntityLabel(item.entity_type))} - ${esc(item.label)}</option>`)
    .join("");
  $("cfv-definition").innerHTML = options || '<option value="">No active fields</option>';
  if (current && customFieldDefinitions.some((item) => item.custom_field_definition_id === current)) setValue("cfv-definition", current);
}

function renderCustomFieldValues() {
  $("customValueCount").textContent = `${customFieldValues.length} values`;
  const rows = customFieldValues
    .slice()
    .sort((a, b) => configEntityRank(a.entity_type) - configEntityRank(b.entity_type) || a.entity_id.localeCompare(b.entity_id) || a.label.localeCompare(b.label))
    .slice(0, 80);
  $("customValueList").innerHTML = rows.length
    ? rows
        .map((item) => `<div class="custom-value-row" data-custom-value-id="${escAttr(item.custom_field_value_id)}">
          <span>${esc(configEntityLabel(item.entity_type))} · ${esc(item.entity_id)}</span>
          <b>${esc(item.label)}</b>
          <em>${esc(item.value_text || "-")}</em>
        </div>`)
        .join("")
    : '<div class="muted">No custom field values have been captured.</div>';
}

function renderWorkflowInstances() {
  const query = value("workflow-search").toLowerCase();
  const entity = value("workflow-entity-filter");
  const status = value("workflow-status-filter");
  const rows = workflowInstances
    .filter((item) => !entity || item.entity_type === entity)
    .filter((item) => !status || item.status === status)
    .filter((item) => {
      if (!query) return true;
      return [item.workflow_name, item.workflow_key, item.entity_type, item.entity_id, item.entity_title, item.current_state_label, item.owner].join(" ").toLowerCase().includes(query);
    })
    .sort((a, b) => workflowStatusRank(a) - workflowStatusRank(b) || String(a.due_date || "9999").localeCompare(String(b.due_date || "9999")));
  $("workflowCount").textContent = `${rows.length} shown`;
  $("workflowInstanceList").innerHTML = rows.length
    ? rows
        .map((item) => `<div class="workflow-card${item.workflow_instance_id === activeWorkflowInstanceId ? " active" : ""}" data-workflow-instance-id="${escAttr(item.workflow_instance_id)}">
          <div class="programme-item-head">
            <div><span>${esc(configEntityLabel(item.entity_type))} · ${esc(item.entity_id)}</span><b>${esc(item.entity_title || item.workflow_name)}</b></div>
            ${statusToken(item.current_state_label, workflowStateTone(item))}
          </div>
          <div class="report-pack-meta">
            <span>${esc(item.workflow_name)}</span>
            <span>${esc(item.owner || "Unassigned")}</span>
            <span>${item.due_date ? esc(reviewLabel(item.due_date)) : "No due date"}</span>
          </div>
          <div class="evidence-card-summary">${esc(item.workflow_description || "No workflow description captured.")}</div>
        </div>`)
        .join("")
    : '<div class="muted">No workflow instances match this view.</div>';
}

function renderWorkflowDefinitions() {
  const query = value("workflow-search").toLowerCase();
  const entity = value("workflow-entity-filter");
  const rows = workflowDefinitions
    .filter((item) => !entity || item.entity_type === entity)
    .filter((item) => {
      if (!query) return true;
      return [item.name, item.workflow_key, item.entity_type, item.description, item.states.map((state) => state.label || state.key).join(" "), item.transitions.map((transition) => transition.label || transition.key).join(" ")]
        .join(" ")
        .toLowerCase()
        .includes(query);
    })
    .sort((a, b) => configEntityRank(a.entity_type) - configEntityRank(b.entity_type) || a.name.localeCompare(b.name));
  $("workflowDefinitionList").innerHTML = rows.length
    ? rows
        .slice()
        .map((item) => `<div class="workflow-definition-card${item.workflow_definition_id === activeWorkflowDefinitionId ? " active" : ""}" data-workflow-definition-id="${escAttr(item.workflow_definition_id)}">
          <div><b>${esc(item.name)}</b><span>${esc(configEntityLabel(item.entity_type))} · ${item.states.length} states · ${item.transitions.length} transitions</span></div>
          <div class="workflow-definition-meta">${statusToken(item.status, item.status === "active" ? "green" : "neutral")}<small>${esc(item.default_state)}</small></div>
        </div>`)
        .join("")
    : '<div class="muted">No workflow definitions configured.</div>';
  const events = activeWorkflowInstanceId ? workflowEvents.filter((event) => event.workflow_instance_id === activeWorkflowInstanceId) : workflowEvents.slice(0, 20);
  $("workflowEventList").innerHTML = events.length
    ? events
        .slice(0, 30)
        .map((event) => `<div class="workflow-event-row">
          <span>${esc(fmtDateTime(event.created_at))}</span>
          <b>${esc(event.from_state || "-")} -> ${esc(event.to_state)}</b>
          <em>${esc(event.decision || event.transition_key)}${event.note ? ` · ${esc(event.note)}` : ""}</em>
        </div>`)
        .join("")
    : '<div class="muted">No workflow events found for the current selection.</div>';
}

function renderWorkflowSelected() {
  const item = workflowInstances.find((row) => row.workflow_instance_id === activeWorkflowInstanceId) || workflowInstances[0];
  if (!item) {
    $("workflowSelectedMeta").textContent = "No workflow selected";
    $("workflowSelectedCard").innerHTML = '<div class="muted">Select a workflow instance to run transitions.</div>';
    $("workflow-transition").innerHTML = '<option value="">No transition</option>';
    return;
  }
  activeWorkflowInstanceId = item.workflow_instance_id;
  $("workflowSelectedMeta").textContent = `${item.entity_type} ${item.entity_id}`;
  $("workflowSelectedCard").innerHTML = `<div class="workflow-selected">
    <div class="programme-item-head"><div><span>${esc(item.workflow_name)}</span><b>${esc(item.entity_title || item.entity_id)}</b></div>${statusToken(item.current_state_label, workflowStateTone(item))}</div>
    <div class="report-pack-meta"><span>${esc(item.owner || "Unassigned")}</span><span>${item.due_date ? esc(reviewLabel(item.due_date)) : "No due date"}</span><span>${esc(item.status)}</span></div>
  </div>`;
  $("workflow-transition").innerHTML = item.nextTransitions.length
    ? item.nextTransitions.map((transition) => `<option value="${escAttr(transition.key)}">${esc(transition.label || transition.key)} -> ${esc(transition.to)}</option>`).join("")
    : '<option value="">No transition available</option>';
  if (!value("workflow-owner")) setValue("workflow-owner", item.owner);
  if (!value("workflow-due")) setValue("workflow-due", item.due_date || "");
}

function clearCustomFieldForm() {
  ["cf-id", "cf-key", "cf-label", "cf-help", "cf-options", "cf-applies"].forEach((id) => setValue(id, ""));
  setValue("cf-entity", "risk");
  setValue("cf-type", "text");
  setValue("cf-status", "active");
  setValue("cf-sort", "0");
  $<HTMLInputElement>("cf-required").checked = false;
  $("custom-field-note").textContent = "";
  renderCustomFieldList();
}

function fillCustomFieldForm(id: string) {
  const item = customFieldDefinitions.find((row) => row.custom_field_definition_id === id);
  if (!item) return;
  setValue("cf-id", item.custom_field_definition_id);
  setValue("cf-entity", item.entity_type);
  setValue("cf-type", item.field_type);
  setValue("cf-key", item.field_key);
  setValue("cf-label", item.label);
  setValue("cf-help", item.help_text);
  setValue("cf-status", item.status);
  setValue("cf-sort", String(item.sort_order || 0));
  setValue("cf-options", item.options.join("\n"));
  setValue("cf-applies", JSON.stringify(item.appliesTo || {}, null, 2));
  $<HTMLInputElement>("cf-required").checked = item.required;
  $("custom-field-note").textContent = "";
  renderCustomFieldList();
}

function customFieldPayloadFromForm(): CustomFieldDefinitionInput {
  return {
    entityType: value("cf-entity") as ConfigEntityType,
    fieldKey: value("cf-key"),
    label: value("cf-label"),
    helpText: value("cf-help"),
    fieldType: value("cf-type") as CustomFieldType,
    required: $<HTMLInputElement>("cf-required").checked,
    options: value("cf-options").split(/\r?\n|,/).map((item) => item.trim()).filter(Boolean),
    appliesTo: parseJsonObject(value("cf-applies")),
    sortOrder: Number.parseInt(value("cf-sort"), 10) || 0,
    status: value("cf-status") as CustomFieldDefinitionInput["status"],
  };
}

async function saveCustomFieldFromForm() {
  if (!canManageConfigurationUi()) return;
  const id = value("cf-id");
  const payload = customFieldPayloadFromForm();
  if (!payload.label) {
    $("cf-label").focus();
    return;
  }
  try {
    const result = id ? await updateCustomFieldDefinition(id, payload) : await createCustomFieldDefinition(payload);
    const index = customFieldDefinitions.findIndex((item) => item.custom_field_definition_id === result.item.custom_field_definition_id);
    if (index >= 0) customFieldDefinitions[index] = result.item;
    else customFieldDefinitions.push(result.item);
    fillCustomFieldForm(result.item.custom_field_definition_id);
    renderConfiguration();
    renderOpenRiskDetailSupplements();
    $("custom-field-note").textContent = id ? "Field definition updated." : "Field definition created.";
    toast(id ? "Custom field updated" : "Custom field created");
  } catch (err) {
    $("custom-field-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

async function retireCustomFieldFromView(id = value("cf-id")) {
  if (!id || !canManageConfigurationUi()) return;
  try {
    const result = await retireCustomFieldDefinition(id);
    const index = customFieldDefinitions.findIndex((item) => item.custom_field_definition_id === result.item.custom_field_definition_id);
    if (index >= 0) customFieldDefinitions[index] = result.item;
    clearCustomFieldForm();
    renderConfiguration();
    renderOpenRiskDetailSupplements();
    toast("Custom field retired");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function fillCustomFieldValueForm(id: string) {
  const item = customFieldValues.find((row) => row.custom_field_value_id === id);
  if (!item) return;
  setValue("cfv-definition", item.custom_field_definition_id);
  setValue("cfv-entity", item.entity_type);
  setValue("cfv-entity-id", item.entity_id);
  setValue("cfv-value", item.value_text);
}

async function saveCustomFieldValueFromForm() {
  if (!canManageConfigurationUi()) return;
  const payload: CustomFieldValueInput = {
    fieldDefinitionId: value("cfv-definition"),
    entityType: value("cfv-entity") as ConfigEntityType,
    entityId: value("cfv-entity-id"),
    valueText: value("cfv-value"),
  };
  if (!payload.fieldDefinitionId || !payload.entityId) {
    $("cfv-entity-id").focus();
    return;
  }
  try {
    const result = await upsertCustomFieldValue(payload);
    const index = customFieldValues.findIndex((item) => item.custom_field_value_id === result.item.custom_field_value_id);
    if (index >= 0) customFieldValues[index] = result.item;
    else customFieldValues.push(result.item);
    renderConfiguration();
    renderOpenRiskDetailSupplements();
    toast("Custom field value saved");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function clearWorkflowDefinitionForm() {
  activeWorkflowDefinitionId = "";
  setValue("wfd-id", "");
  setValue("wfd-entity", "risk");
  setValue("wfd-status", "active");
  setValue("wfd-default-state", "");
  setValue("wfd-key", "");
  setValue("wfd-name", "");
  setValue("wfd-description", "");
  setValue("wfd-states", JSON.stringify(MAJOR_RISK_WORKFLOW_TEMPLATE.states, null, 2));
  setValue("wfd-transitions", JSON.stringify(MAJOR_RISK_WORKFLOW_TEMPLATE.transitions, null, 2));
  $("workflow-definition-note").textContent = "";
  renderWorkflowDefinitionPreview();
  renderWorkflowDefinitions();
}

function ensureWorkflowDefinitionFormSeeded() {
  if (!document.getElementById("wfd-states")) return;
  if (value("wfd-id") || value("wfd-states") || value("wfd-transitions")) return;
  setValue("wfd-entity", MAJOR_RISK_WORKFLOW_TEMPLATE.entityType);
  setValue("wfd-status", MAJOR_RISK_WORKFLOW_TEMPLATE.status);
  setValue("wfd-default-state", MAJOR_RISK_WORKFLOW_TEMPLATE.defaultState);
  setValue("wfd-key", MAJOR_RISK_WORKFLOW_TEMPLATE.workflowKey);
  setValue("wfd-name", MAJOR_RISK_WORKFLOW_TEMPLATE.name);
  setValue("wfd-description", MAJOR_RISK_WORKFLOW_TEMPLATE.description);
  setValue("wfd-states", JSON.stringify(MAJOR_RISK_WORKFLOW_TEMPLATE.states, null, 2));
  setValue("wfd-transitions", JSON.stringify(MAJOR_RISK_WORKFLOW_TEMPLATE.transitions, null, 2));
  renderWorkflowDefinitionPreview();
}

function seedWorkflowDefinitionTemplate() {
  const template = workflowTemplateByKey(value("workflow-template-select")) || WORKFLOW_TEMPLATES[0];
  const definition = cloneWorkflowDefinitionInput(template.definition);
  activeWorkflowDefinitionId = "";
  setValue("wfd-id", "");
  setValue("wfd-entity", definition.entityType);
  setValue("wfd-status", definition.status);
  setValue("wfd-default-state", definition.defaultState);
  setValue("wfd-key", definition.workflowKey);
  setValue("wfd-name", definition.name);
  setValue("wfd-description", definition.description);
  setValue("wfd-states", JSON.stringify(definition.states, null, 2));
  setValue("wfd-transitions", JSON.stringify(definition.transitions, null, 2));
  $("workflow-definition-note").textContent = "Template loaded. Adjust the key before creating another active workflow for the same object.";
  renderWorkflowDefinitionPreview();
  renderWorkflowDefinitions();
}

function fillWorkflowDefinitionForm(id: string) {
  const item = workflowDefinitions.find((row) => row.workflow_definition_id === id);
  if (!item) return;
  activeWorkflowDefinitionId = item.workflow_definition_id;
  setValue("wfd-id", item.workflow_definition_id);
  setValue("wfd-entity", item.entity_type);
  setValue("wfd-status", item.status);
  setValue("wfd-default-state", item.default_state);
  setValue("wfd-key", item.workflow_key);
  setValue("wfd-name", item.name);
  setValue("wfd-description", item.description);
  setValue("wfd-states", JSON.stringify(item.states, null, 2));
  setValue("wfd-transitions", JSON.stringify(item.transitions, null, 2));
  $("workflow-definition-note").textContent = "";
  renderWorkflowDefinitionPreview();
  renderWorkflowDefinitions();
}

function renderWorkflowDefinitionPreview() {
  if (!document.getElementById("workflowDefinitionPreview")) return;
  const states = parseJsonArray<WorkflowDefinitionInput["states"][number]>(value("wfd-states"))
    .slice()
    .sort((a, b) => Number(a.sortOrder || 0) - Number(b.sortOrder || 0));
  const transitions = parseJsonArray<WorkflowDefinitionInput["transitions"][number]>(value("wfd-transitions"));
  const defaultState = value("wfd-default-state");
  if (!states.length) {
    $("workflowDefinitionPreview").innerHTML = '<div class="workflow-preview-empty">No states to preview yet.</div>';
    return;
  }
  const stateKeys = new Set(states.map((state) => state.key));
  const warnings = [
    defaultState && !stateKeys.has(defaultState) ? `Default state is not in the state list: ${defaultState}` : "",
    ...transitions
      .filter((transition) => transition.to && !stateKeys.has(transition.to))
      .map((transition) => `Transition ${transition.key || "(unnamed)"} targets unknown state ${transition.to}`),
    ...transitions
      .flatMap((transition) => (transition.from || []).filter((from) => !stateKeys.has(from)).map((from) => `Transition ${transition.key || "(unnamed)"} starts from unknown state ${from}`)),
  ].filter(Boolean);
  const stateHtml = states
    .map((state, index) => {
      const outgoing = transitions.filter((transition) => !transition.from?.length || transition.from.includes(state.key));
      return `<div class="workflow-preview-node${state.key === defaultState ? " default" : ""}${state.terminal ? " terminal" : ""}">
        <div class="workflow-preview-node-head">
          <span>${String(index + 1).padStart(2, "0")}</span>
          <b>${esc(state.label || state.key)}</b>
          ${state.key === defaultState ? statusToken("default", "blue") : ""}
          ${state.terminal ? statusToken("terminal", "green") : ""}
        </div>
        <small>${esc(state.key)} · ${esc(state.category || "open")}</small>
        <div class="workflow-preview-transitions">
          ${outgoing.length ? outgoing.map((transition) => `<em>${esc(transition.label || transition.key)} -> ${esc(transition.to)}</em>`).join("") : "<em>No outgoing transition</em>"}
        </div>
      </div>`;
    })
    .join("");
  $("workflowDefinitionPreview").innerHTML = `
    <div class="workflow-preview-head"><b>State map preview</b><span>${states.length} states · ${transitions.length} transitions</span></div>
    ${warnings.length ? `<div class="workflow-preview-warnings">${warnings.map((warning) => `<span>${esc(warning)}</span>`).join("")}</div>` : ""}
    <div class="workflow-preview-map">${stateHtml}</div>`;
}

function workflowTemplateByKey(key: string) {
  return WORKFLOW_TEMPLATES.find((item) => item.key === key);
}

function cloneWorkflowDefinitionInput(input: WorkflowDefinitionInput): WorkflowDefinitionInput {
  return JSON.parse(JSON.stringify(input)) as WorkflowDefinitionInput;
}

function workflowDefinitionPayloadFromForm(): WorkflowDefinitionInput {
  return {
    entityType: value("wfd-entity") as ConfigEntityType,
    workflowKey: value("wfd-key"),
    name: value("wfd-name"),
    description: value("wfd-description"),
    defaultState: value("wfd-default-state"),
    states: parseJsonArray<WorkflowDefinitionInput["states"][number]>(value("wfd-states")),
    transitions: parseJsonArray<WorkflowDefinitionInput["transitions"][number]>(value("wfd-transitions")),
    status: value("wfd-status") as WorkflowDefinitionInput["status"],
  };
}

async function saveWorkflowDefinitionFromForm() {
  if (!canManageConfigurationUi()) return;
  const id = value("wfd-id");
  const payload = workflowDefinitionPayloadFromForm();
  if (!payload.name) {
    $("wfd-name").focus();
    return;
  }
  try {
    const result = id ? await updateWorkflowDefinition(id, payload) : await createWorkflowDefinition(payload);
    const index = workflowDefinitions.findIndex((item) => item.workflow_definition_id === result.item.workflow_definition_id);
    if (index >= 0) workflowDefinitions[index] = result.item;
    else workflowDefinitions.push(result.item);
    fillWorkflowDefinitionForm(result.item.workflow_definition_id);
    renderConfiguration();
    renderOpenRiskDetailSupplements();
    $("workflow-definition-note").textContent = id ? "Workflow definition updated." : "Workflow definition created.";
    toast(id ? "Workflow definition updated" : "Workflow definition created");
  } catch (err) {
    $("workflow-definition-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

async function retireWorkflowDefinitionFromView(id = value("wfd-id")) {
  if (!id || !canManageConfigurationUi()) return;
  try {
    const result = await retireWorkflowDefinition(id);
    const index = workflowDefinitions.findIndex((item) => item.workflow_definition_id === result.item.workflow_definition_id);
    if (index >= 0) workflowDefinitions[index] = result.item;
    clearWorkflowDefinitionForm();
    renderConfiguration();
    renderOpenRiskDetailSupplements();
    toast("Workflow definition retired");
  } catch (err) {
    $("workflow-definition-note").textContent = errorMessage(err);
    toast(errorMessage(err));
  }
}

function selectWorkflowInstance(id: string) {
  activeWorkflowInstanceId = id;
  setValue("workflow-owner", "");
  setValue("workflow-due", "");
  setValue("workflow-note", "");
  setValue("workflow-decision", "");
  renderConfiguration();
}

async function runWorkflowTransitionFromForm() {
  if (!canManageConfigurationUi() || !activeWorkflowInstanceId) return;
  const payload: WorkflowTransitionInput = {
    transitionKey: value("workflow-transition"),
    decision: value("workflow-decision"),
    note: value("workflow-note"),
    owner: value("workflow-owner"),
    dueDate: value("workflow-due"),
  };
  if (!payload.transitionKey) return;
  try {
    await transitionWorkflow(activeWorkflowInstanceId, payload);
    await refreshConfiguration(false);
    toast("Workflow transitioned");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function configEntityLabel(type: string) {
  return CONFIG_ENTITY_DEFS.find((item) => item.key === type)?.label || evidenceTypeLabel(type);
}

function configEntityRank(type: string) {
  const index = CONFIG_ENTITY_DEFS.findIndex((item) => item.key === type);
  return index >= 0 ? index : 99;
}

function workflowStatusRank(item: WorkflowInstance) {
  if (item.status === "active" && item.due_date && isPast(item.due_date)) return 0;
  if (item.status === "active") return 1;
  if (item.status === "completed") return 3;
  return 4;
}

function workflowStateTone(item: WorkflowInstance) {
  if (item.status === "completed") return "green";
  if (item.status === "cancelled") return "neutral";
  if (item.due_date && isPast(item.due_date)) return "red";
  if (/decision|response|review|assess/i.test(item.current_state)) return "amber";
  return "blue";
}

function canManageConfigurationUi() {
  return hasPermissionUi("configuration.manage");
}

function renderControlCentre() {
  if (!document.getElementById("controlBand")) return;
  const active = risks.filter((d) => d.status !== "Closed");
  const highCritical = active.filter((d) => isRed(post(d)));
  const critical = active.filter((d) => levelFor(post(d)) === "critical").length;
  const exposure = active.reduce((sum, risk) => sum + risk.exp, 0);
  const overdue = active.filter((d) => reviewState(d.due) === "overdue").length;
  const dueSoon = active.filter((d) => reviewState(d.due) === "soon").length;
  const openActions = active.reduce((sum, risk) => sum + risk.actions.filter((action) => action.status !== "Done").length, 0);
  const qraRows = qraReadinessRows.length ? qraReadinessRows : active.filter(qraCandidate).map((risk) => riskReadiness(risk));
  const qraReady = qraRows.filter((row) => row.readiness_status === "Ready").length;
  const qraTotal = qraRows.length;
  const qraPct = qraTotal ? Math.round((qraReady / qraTotal) * 100) : 0;
  const appetiteBreaches = riskAppetiteRows.filter((row) => row.escalation_required || row.appetite_status === "breach" || row.appetite_status === "critical_breach");
  const appetiteCritical = appetiteBreaches.filter((row) => row.appetite_status === "critical_breach").length;
  const overdueEscalations = riskAppetiteRows.filter((row) => row.decision_due_status === "Overdue" && row.assessment_status !== "closed" && row.assessment_status !== "waived").length;
  const activeControls = controls.filter((control) => control.status === "active");
  const weakControls = activeControls.filter((control) => control.effectiveness === "ineffective" || control.effectiveness === "untested").length;
  const assuranceExceptions = assuranceTests.filter((test) => test.result === "fail" || (test.result === "not_run" && isPast(test.dueDate))).length;
  const openPeriods = reportingPeriods.filter((period) => period.status === "open").length;
  const closedPeriods = reportingPeriods.filter((period) => period.status === "closed").length;
  const latestRun = reportRuns.slice().sort((a, b) => new Date(b.generated_at).getTime() - new Date(a.generated_at).getTime())[0];

  $("controlBand").innerHTML = `
    <div>
      <div class="eyebrow">Major projects / programme mode</div>
      <h2>${esc(session?.tenant.programmeName || "Programme risk")}</h2>
      <div class="band-meta">
        <span>${active.length} active risks</span>
        <span>${highCritical.length} high / critical</span>
        <span>${openActions} open mitigation actions</span>
        <span>${appetiteBreaches.length} appetite breaches</span>
        <span>${weakControls} weak / untested controls</span>
        <span>${assuranceExceptions} assurance exceptions</span>
        <span>${qraTotal ? `${qraPct}% QRA ready` : "QRA pipeline empty"}</span>
      </div>
    </div>
    <div class="band-status">
      ${statusToken(appetiteCritical ? "Critical appetite breach" : appetiteBreaches.length ? "Appetite breach" : critical ? "Critical attention" : highCritical.length ? "Active escalation" : "Within tolerance", appetiteCritical || critical ? "red" : appetiteBreaches.length || highCritical.length ? "amber" : "green")}
      ${statusToken(openPeriods ? `${openPeriods} open period` : `${closedPeriods} closed periods`, openPeriods ? "blue" : "neutral")}
      ${statusToken(latestRun ? `Last report ${fmtDateTime(latestRun.generated_at)}` : "No report run logged", latestRun ? "green" : "neutral")}
    </div>`;

  const cards = [
    { label: "Residual exposure", value: moneyK(exposure), note: "active risks" },
    { label: "High + critical", value: String(highCritical.length), note: `${critical} critical`, jump: "register" },
    { label: "Appetite", value: String(appetiteBreaches.length), note: `${overdueEscalations} overdue escalations`, jump: "reporting" },
    { label: "Controls", value: String(activeControls.length), note: `${weakControls} weak / untested`, jump: "controls" },
    { label: "QRA readiness", value: qraTotal ? `${qraPct}%` : "0%", note: `${qraReady}/${qraTotal || 0} ready`, jump: "qra" },
    { label: "Review discipline", value: String(overdue), note: `${dueSoon} due soon`, jump: "reviews" },
  ];
  $("controlKpis").innerHTML = cards
    .map((card) => `<div class="kpi${card.jump ? " clk" : ""}"${card.jump ? ` data-control-jump="${card.jump}"` : ""}><div class="l">${esc(card.label)}${card.jump ? ` <span style="float:right;color:var(--teal)">Open</span>` : ""}</div><div class="v">${esc(card.value)}</div><div class="kpi-note">${esc(card.note)}</div></div>`)
    .join("");
  $("controlKpis").querySelectorAll("[data-control-jump]").forEach((card) =>
    card.addEventListener("click", () => {
      const target = (card as HTMLElement).dataset.controlJump || "register";
      navTo(target);
      if (target === "register") {
        $<HTMLInputElement>("fhigh").checked = true;
        renderTable();
      }
    }),
  );

  const qraMissing = qraRows.filter((row) => row.readiness_status !== "Ready").length;
  const lanes = [
    { label: "Governance rhythm", state: overdue ? "Attention" : "On track", tone: overdue ? "red" : "green", body: `${overdue} overdue reviews, ${dueSoon} due soon`, target: "reviews" },
    { label: "Control assurance", state: assuranceExceptions ? "Exceptions" : "Assured", tone: assuranceExceptions ? "red" : "green", body: `${assuranceExceptions} failed or overdue tests, ${activeControls.length} active controls`, target: "controls" },
    { label: "Appetite and escalation", state: appetiteBreaches.length ? "Breach" : "Within appetite", tone: appetiteCritical ? "red" : appetiteBreaches.length ? "amber" : "green", body: `${appetiteBreaches.length} tolerance breaches, ${overdueEscalations} overdue decisions`, target: "reporting" },
    { label: "QRA pipeline", state: qraMissing ? "Data needed" : "Ready", tone: qraMissing ? "amber" : "green", body: `${qraReady} ready, ${qraMissing} incomplete or needing review`, target: "reporting" },
    { label: "Reporting pack", state: openPeriods ? "Period open" : closedPeriods ? "Snapshot available" : "Not started", tone: openPeriods || closedPeriods ? "blue" : "neutral", body: `${reportingPeriods.length} periods, ${reportRuns.length} report runs logged`, target: "reporting" },
  ];
  $("assurancePanel").innerHTML = `<div class="panel-head"><h3>Assurance lanes</h3><button class="lnk" data-control-nav="reporting">Manage outputs</button></div>${lanes
    .map((lane) => `<div class="lane" data-control-nav="${lane.target}"><div><b>${esc(lane.label)}</b><span>${esc(lane.body)}</span></div>${statusToken(lane.state, lane.tone)}</div>`)
    .join("")}`;

  const sponsorRows = highCritical
    .slice()
    .sort((a, b) => post(b) - post(a) || b.exp - a.exp)
    .slice(0, 3);
  $("sponsorBrief").innerHTML = `<div class="panel-head"><h3>Sponsor brief</h3><button class="lnk" data-control-nav="dashboard">Open dashboard</button></div>
    <div class="brief-copy">${sponsorRows.length ? `${sponsorRows.length} priority risks require sponsor visibility this cycle.` : "No high or critical residual risks are currently active."}</div>
    <div class="brief-list">${sponsorRows
      .map((risk) => `<div class="brief-item" data-risk-open="${escAttr(risk.id)}"><span>${esc(risk.id)}</span><b>${esc(risk.title)}</b><em>${moneyK(risk.exp)} · ${levelName(post(risk))}</em></div>`)
      .join("") || '<div class="muted" style="font-size:13px">Current residual profile is inside the configured tolerance bands.</div>'}</div>`;

  const watchlist = active
    .slice()
    .sort((a, b) => post(b) - post(a) || b.exp - a.exp)
    .slice(0, 6);
  $("watchlistPanel").innerHTML = `<div class="panel-head"><h3>Programme watchlist</h3><button class="lnk" data-control-nav="register">Open register</button></div>
    <div class="watchlist">${watchlist
      .map((risk) => {
        const overdueActions = risk.actions.filter((action) => action.status !== "Done" && action.date && new Date(action.date) < TODAY).length;
        return `<div class="watch-row" data-risk-open="${escAttr(risk.id)}"><span>${esc(risk.id)}</span><div><b>${esc(risk.title)}</b><small>${esc(risk.owner)} · ${esc(risk.cat)}</small></div><div>${chip(post(risk))}${trendGlyph(risk)}</div><em>${overdueActions ? `${overdueActions} overdue action${overdueActions === 1 ? "" : "s"}` : fmtDate(risk.due)}</em></div>`;
      })
      .join("")}</div>`;

  const owners = ownerLoad(active);
  $("ownerLoadPanel").innerHTML = `<div class="panel-head"><h3>Owner load</h3><button class="lnk" data-control-nav="reviews">Review dates</button></div>
    <div class="owner-load">${owners
      .map((owner) => `<div class="owner-row"><span>${esc(owner.owner)}</span><b>${owner.count}</b><small>${owner.red} high/critical · ${moneyK(owner.exposure)}</small></div>`)
      .join("") || '<div class="muted" style="font-size:13px">No active owner load.</div>'}</div>`;

  document.querySelectorAll("[data-control-nav]").forEach((button) => {
    button.addEventListener("click", () => navTo((button as HTMLElement).dataset.controlNav || "control"));
  });
  document.querySelectorAll("[data-risk-open]").forEach((row) => {
    row.addEventListener("click", () => openById((row as HTMLElement).dataset.riskOpen || ""));
  });
}

function renderReporting() {
  if (!document.getElementById("periodsTb")) return;
  setDefaultReportingDates();
  renderReportSuite();
  renderReportSectionPicker();
  renderReportTemplates();
  renderReportLayouts();
  renderReportSchedules();
  renderNotificationOutbox();
  renderReportPackGenerator();
  renderPeriods();
  renderQraReadiness();
  renderReportLinks();
  renderReportRuns();
  applyRoleLocks();
}

function renderReportSectionPicker() {
  const selected = new Set(selectedReportSectionsFromForm());
  $("rt-sections").innerHTML = REPORT_SECTION_DEFS.map(
    (section) =>
      `<label class="section-chip"><input type="checkbox" data-report-section="${escAttr(section.key)}" ${selected.has(section.key) ? "checked" : ""}/> ${esc(section.label)}</label>`,
  ).join("");
}

function renderReportTemplates() {
  $("reportTemplateCount").textContent = `${reportTemplates.filter((template) => template.active).length} active templates`;
  $("reportTemplates").innerHTML = reportTemplates.length
    ? reportTemplates
        .map((template) => {
          const sections = parseTemplateSections(template).slice(0, 5);
          return `<div class="report-template-card${template.active ? "" : " inactive"}">
            <div class="report-template-head">
              <div><span>${esc(audienceLabel(template.audience))}</span><b>${esc(template.name)}</b></div>
              ${statusToken(template.active ? "Active" : "Inactive", template.active ? "green" : "neutral")}
            </div>
            <p>${esc(template.description || "No description")}</p>
            <div class="section-list">${sections.map((section) => `<span>${esc(sectionLabel(section))}</span>`).join("")}</div>
            <div class="report-template-meta">${esc(cadenceLabel(template.cadence))} · ${esc(template.output_format.toUpperCase())} · updated ${fmtDateTime(template.updated_at)}</div>
            <div class="report-template-actions">
              <button class="btnp" data-report-template-action="use" data-report-template-id="${escAttr(template.report_template_id)}" ${template.active ? "" : "disabled"}>Log pack</button>
              <button class="btn" data-report-template-action="edit" data-report-template-id="${escAttr(template.report_template_id)}">Edit</button>
              <button class="btn" data-report-template-action="deactivate" data-report-template-id="${escAttr(template.report_template_id)}" ${template.active ? "" : "disabled"}>Deactivate</button>
            </div>
          </div>`;
        })
        .join("")
    : '<div class="muted">No report templates yet.</div>';
}

function renderReportPackGenerator() {
  if (!document.getElementById("reportPackGenerator")) return;
  const activeTemplates = reportTemplates.filter((template) => template.active);
  $("reportPackCount").textContent = `${reportPacks.length} generated packs`;

  const templateSelect = $<HTMLSelectElement>("pack-template");
  const currentTemplate = templateSelect.value || activeTemplates[0]?.report_template_id || "";
  templateSelect.innerHTML = activeTemplates.length
    ? activeTemplates.map((template) => `<option value="${escAttr(template.report_template_id)}">${esc(template.name)} (${esc(audienceLabel(template.audience))})</option>`).join("")
    : '<option value="">No active templates</option>';
  if (activeTemplates.some((template) => template.report_template_id === currentTemplate)) templateSelect.value = currentTemplate;

  const periodSelect = $<HTMLSelectElement>("pack-period");
  const currentPeriod = periodSelect.value;
  periodSelect.innerHTML = '<option value="">Live / no period</option>' + reportingPeriods.map((period) => `<option value="${escAttr(period.reporting_period_id)}">${esc(period.name)} (${esc(period.status)})</option>`).join("");
  if (reportingPeriods.some((period) => period.reporting_period_id === currentPeriod)) periodSelect.value = currentPeriod;

  const selectedTemplate = reportTemplates.find((template) => template.report_template_id === templateSelect.value);
  const availableLayouts = selectedTemplate
    ? reportLayoutVariants.filter((layout) => layout.report_template_id === selectedTemplate.report_template_id && layout.status !== "retired")
    : [];
  const layoutSelect = $<HTMLSelectElement>("pack-layout");
  const currentLayout = layoutSelect.value;
  layoutSelect.innerHTML = availableLayouts.length
    ? availableLayouts
        .slice()
        .sort((a, b) => layoutStatusRank(a) - layoutStatusRank(b) || a.name.localeCompare(b.name))
        .map((layout) => `<option value="${escAttr(layout.report_layout_variant_id)}">${esc(layout.name)}${layout.is_default ? " (default)" : ""}</option>`)
        .join("")
    : '<option value="">Template section order</option>';
  if (availableLayouts.some((layout) => layout.report_layout_variant_id === currentLayout)) layoutSelect.value = currentLayout;
  else if (availableLayouts.length) layoutSelect.value = availableLayouts.find((layout) => layout.is_default)?.report_layout_variant_id || availableLayouts[0].report_layout_variant_id;

  if (selectedTemplate && !value("pack-title")) setValue("pack-title", `${selectedTemplate.name} - ${monthLabel(new Date())}`);
  if (selectedTemplate) setValue("pack-format", selectedTemplate.output_format);

  const sections = selectedTemplate ? parseTemplateSections(selectedTemplate) : [];
  const selectedLayout = reportLayoutVariants.find((layout) => layout.report_layout_variant_id === layoutSelect.value);
  const layoutSections = selectedLayout ? reportLayoutSectionOrder(selectedLayout) : [];
  const displaySections: string[] = layoutSections.length ? layoutSections : sections;
  $("reportPackHint").innerHTML = selectedTemplate
    ? `<b>${esc(displaySections.length.toString())} sections:</b> ${displaySections.slice(0, 8).map((section: string) => esc(sectionLabel(section))).join(", ")}${displaySections.length > 8 ? "..." : ""}${selectedLayout ? `<div class="muted" style="margin-top:5px">Layout: ${esc(selectedLayout.name)} · ${esc(layoutThemeLabel(selectedLayout.theme))}</div>` : ""}`
    : "Create or activate a template before generating a pack.";

  $("reportPacks").innerHTML = reportPacks.length
    ? reportPacks
        .slice(0, 6)
        .map((pack) => {
          const tone = pack.ready_for_issue ? "green" : pack.issue_count > 0 ? "amber" : "blue";
          return `<div class="report-pack-card">
            <div>
              <div class="report-pack-title">${esc(pack.pack_title || pack.report_template_name || "Generated pack")}</div>
              <small>${esc(pack.report_template_name || "No template")} · ${esc(pack.report_layout_variant_name || "Default layout")} · ${esc(pack.reporting_period_name || "Live")} · ${fmtDateTime(pack.generated_at)}</small>
            </div>
            <div class="report-pack-meta">
              ${statusToken(pack.pack_status, pack.pack_status === "failed" ? "red" : "blue")}
              ${statusToken(pack.ready_for_issue ? "Ready for issue" : `${pack.issue_count} issues`, tone)}
              ${pack.issued_at ? statusToken(`Issued ${fmtDateTime(pack.issued_at)}`, "green") : ""}
              <span>${pack.section_count} sections</span>
              <span>${pack.dataset_count} datasets</span>
            </div>
            <div class="report-pack-actions">
              <a class="btn" href="/api/reporting/report-packs/${encodeURIComponent(pack.report_run_id)}" target="_blank" rel="noreferrer">Bundle</a>
              <a class="btn" href="/api/reporting/report-packs/${encodeURIComponent(pack.report_run_id)}/briefing" target="_blank" rel="noreferrer">Briefing</a>
              <a class="btn" href="/api/reporting/report-packs/${encodeURIComponent(pack.report_run_id)}/html" target="_blank" rel="noreferrer">Print/PDF</a>
              <a class="btn" href="/api/reporting/report-packs/${encodeURIComponent(pack.report_run_id)}/xlsx" target="_blank" rel="noreferrer">XLSX</a>
              ${pack.pack_status === "generated" ? `<button class="btnp" data-pack-issue-id="${escAttr(pack.report_run_id)}">Issue</button>` : ""}
              <button class="btn" data-pack-template-id="${escAttr(pack.report_template_id)}">Use template</button>
            </div>
          </div>`;
        })
        .join("")
    : '<div class="muted">No generated report packs yet.</div>';

  const latestPackId = reportPacks[0]?.report_run_id || "";
  const latestSections = reportPackSections.filter((section) => section.report_run_id === latestPackId).sort((a, b) => a.display_order - b.display_order);
  $("reportPackSections").innerHTML = latestSections.length
    ? latestSections
        .map((section) => `<div class="report-section-evidence">
          <span>${String(section.display_order).padStart(2, "0")}</span>
          <div><b>${esc(section.section_title)}</b><small>${esc(section.insight || "")}</small></div>
          ${statusToken(section.status === "not_applicable" ? "No data" : section.status, section.status === "warning" ? "amber" : section.status === "blocked" ? "red" : "green")}
          <em>${section.row_count} rows · ${section.issue_count} issues</em>
        </div>`)
        .join("")
    : '<div class="muted">Generate a pack to see section evidence.</div>';
}

async function generateReportPackFromForm() {
  if (!canManageReportingUi()) return;
  const templateId = value("pack-template");
  const template = reportTemplates.find((item) => item.report_template_id === templateId);
  if (!template) {
    toast("Select an active report template");
    return;
  }
  try {
    const result = await generateReportPack({
      title: value("pack-title") || `${template.name} - ${monthLabel(new Date())}`,
      reportTemplateId: template.report_template_id,
      layoutVariantId: value("pack-layout") || undefined,
      reportingPeriodId: value("pack-period") || undefined,
      format: value("pack-format") as ReportTemplate["output_format"],
      filters: { source: "in-app-report-pack-generator", sections: parseTemplateSections(template), qraMode: "ready" },
    });
    await refreshReporting(false);
    toast(`Pack generated: ${result.reportPack.section_count} sections, ${result.reportPack.issue_count} issues`);
  } catch (err) {
    toast(errorMessage(err));
  }
}

function seedReportPackForm(templateId: string) {
  const template = reportTemplates.find((item) => item.report_template_id === templateId);
  if (!template) return;
  setValue("pack-template", template.report_template_id);
  setValue("pack-title", `${template.name} - ${monthLabel(new Date())}`);
  setValue("pack-format", template.output_format);
  const defaultLayout = reportLayoutVariants.find((layout) => layout.report_template_id === template.report_template_id && layout.status === "active" && layout.is_default);
  if (defaultLayout) setValue("pack-layout", defaultLayout.report_layout_variant_id);
  renderReportPackGenerator();
  $("pack-title").focus();
}

function seedReportPackLayout(layoutId: string) {
  const layout = reportLayoutVariants.find((item) => item.report_layout_variant_id === layoutId);
  if (!layout) return;
  setValue("pack-template", layout.report_template_id);
  setValue("pack-layout", layout.report_layout_variant_id);
  if (!value("pack-title")) setValue("pack-title", `${layout.report_template_name || layout.name} - ${monthLabel(new Date())}`);
  renderReportPackGenerator();
  setValue("pack-layout", layout.report_layout_variant_id);
  $("pack-title").focus();
}

async function issueReportPackFromView(id: string) {
  if (!id || !canManageReportingUi()) return;
  const pack = reportPacks.find((item) => item.report_run_id === id);
  if (!pack) return;
  const issueNote = value("pack-issue-note");
  if (!pack.ready_for_issue && issueNote.length < 12) {
    toast("Issue note is required when issuing a pack with readiness issues");
    return;
  }
  if (!pack.ready_for_issue) {
    const ok = await confirmDestructive({
      title: "Issue pack with exceptions?",
      message: `${pack.issue_count} readiness issues are still present. The issue note will be recorded as the override basis.`,
      confirmLabel: "Issue with override",
    });
    if (!ok) return;
  }
  try {
    await issueReportPack(id, { issueNote, overrideIssue: !pack.ready_for_issue });
    setValue("pack-issue-note", "");
    await refreshReporting(false);
    toast("Report pack issued");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function renderQraWorkbench() {
  if (!document.getElementById("qraWorkbenchTb")) return;
  const rows = qraReadinessRows.filter((row) => row.qra_inclusion_status !== "excluded");
  const ready = rows.filter((row) => row.readiness_status === "Ready");
  const needsReview = rows.filter((row) => row.readiness_status === "Needs review");
  const incomplete = rows.filter((row) => row.readiness_status === "Incomplete");
  const included = rows.filter((row) => row.qra_inclusion_status === "included");
  const exceptions = rows.filter((row) => row.readiness_status !== "Ready");
  const expectedCost = ready.reduce((sum, row) => sum + qraExpectedCost(row), 0);
  const expectedSchedule = ready.reduce((sum, row) => sum + qraExpectedSchedule(row), 0);

  $("qraCommandBand").innerHTML = `
    <div>
      <div class="eyebrow">SRS / QRA interface</div>
      <h2>${ready.length} risks ready for quantitative modelling</h2>
      <div class="band-meta">
        <span>${included.length} explicitly included</span>
        <span>${exceptions.length} exceptions</span>
        <span>${moneyK(Math.round(expectedCost))} weighted cost exposure</span>
        <span>${expectedSchedule.toFixed(1)} weighted schedule days</span>
      </div>
    </div>
    <div class="band-status">
      ${statusToken(qraExportRows.length ? `${qraExportRows.length} export rows` : "No ready export rows", qraExportRows.length ? "green" : "amber")}
      ${statusToken(incomplete.length ? `${incomplete.length} incomplete` : "No incomplete rows", incomplete.length ? "red" : "green")}
      ${statusToken(needsReview.length ? `${needsReview.length} need review` : "Reviewed", needsReview.length ? "amber" : "green")}
    </div>`;

  $("qraWorkbenchKpis").innerHTML = [
    `<div class="kpi"><div class="l">Ready for SRS</div><div class="v">${ready.length}</div><div class="kpi-note">${qraExportRows.length} rows in ready export</div></div>`,
    `<div class="kpi"><div class="l">Needs quant review</div><div class="v">${needsReview.length}</div><div class="kpi-note">Complete data awaiting approval</div></div>`,
    `<div class="kpi"><div class="l">Incomplete</div><div class="v">${incomplete.length}</div><div class="kpi-note">Missing QRA fields</div></div>`,
    `<div class="kpi"><div class="l">Weighted exposure</div><div class="v">${moneyK(Math.round(expectedCost))}</div><div class="kpi-note">${expectedSchedule.toFixed(1)} schedule days</div></div>`,
  ].join("");

  const filter = value("qra-filter") || "exceptions";
  const query = value("qra-search").toLowerCase();
  const filteredRows = rows
    .filter((row) => rowMatchesQraFilter(row, filter))
    .filter((row) => {
      if (!query) return true;
      return [
        row.risk_id,
        row.title,
        row.owner,
        row.category,
        row.project_code,
        row.package_code,
        row.wbs_code,
        row.cbs_code,
        row.schedule_activity_id,
        row.correlation_group,
      ]
        .join(" ")
        .toLowerCase()
        .includes(query);
    })
    .sort((a, b) => qraStatusRank(a) - qraStatusRank(b) || rowNumber(b, "score_post") - rowNumber(a, "score_post") || rowString(a, "risk_id").localeCompare(rowString(b, "risk_id")));

  $("qraExceptionCount").textContent = `${filteredRows.length} shown`;
  $("qraWorkbenchTb").innerHTML = filteredRows.length
    ? filteredRows
        .map((row) => {
          const status = rowString(row, "readiness_status");
          const workflow = rowString(row, "quant_workflow_status") || "draft";
          const probability = rowNumber(row, "probability_pct");
          const mapping = rowString(row, "wbs_code") && rowString(row, "cbs_code") && rowString(row, "schedule_activity_id") ? "Mapped" : "Mapping gap";
          return `<tr data-risk-open="${escAttr(row.risk_id)}">
            <td>${esc(row.risk_id)}</td>
            <td><b>${esc(row.title)}</b><div class="muted" style="font-size:11px">${esc(row.owner)} · ${esc(row.category)} · ${esc(rowString(row, "correlation_group") || "No correlation group")}</div></td>
            <td>${statusToken(mapping, mapping === "Mapped" ? "green" : "amber")}<div class="muted" style="font-size:11px;margin-top:5px">${esc(rowString(row, "package_code") || rowString(row, "project_code") || "No package")}</div></td>
            <td>${probability ? `${probability}%` : '<span class="muted">Missing</span>'}</td>
            <td>${qraRangeLabel(row, "cost")}</td>
            <td>${qraRangeLabel(row, "schedule")}</td>
            <td>${statusToken(status, qraTone(status))}<div style="margin-top:5px">${statusToken(workflowStatusLabel(workflow), workflowTone(workflow))}</div></td>
            <td><button class="btn" data-quant-risk="${escAttr(row.risk_id)}">Quantify</button></td>
          </tr>`;
        })
        .join("")
    : '<tr><td colspan="8" class="muted">No QRA rows match this view.</td></tr>';

  $("qraWorkbenchTb").querySelectorAll("[data-risk-open]").forEach((row) => {
    row.addEventListener("click", () => openById((row as HTMLElement).dataset.riskOpen || ""));
  });
  $("qraWorkbenchTb").querySelectorAll("[data-quant-risk]").forEach((button) => {
    button.addEventListener("click", (event) => {
      event.stopPropagation();
      void openQuantificationForRisk((button as HTMLElement).dataset.quantRisk || "");
    });
  });

  $("qraExportPack").innerHTML = `
    <div class="export-step">
      <span>01</span>
      <div><b>Readiness exception management</b><small>${exceptions.length} rows need quantification, mapping or data-quality review before model handoff.</small></div>
      <a class="btn" href="/api/reporting/qra-readiness?format=csv" target="_blank" rel="noreferrer">Exceptions CSV</a>
    </div>
    <div class="export-step">
      <span>02</span>
      <div><b>SRS-ready export</b><small>${qraExportRows.length} rows have probability, impact range, WBS/CBS/activity and approved data quality.</small></div>
      <a class="btnp" href="/api/reporting/qra-export?format=csv" target="_blank" rel="noreferrer">Download</a>
    </div>
    <div class="export-step">
      <span>03</span>
      <div><b>Candidate export</b><small>Includes ready rows plus candidate exceptions for QRA workshop preparation and challenge sessions.</small></div>
      <a class="btn" href="/api/reporting/qra-export?mode=candidate&format=csv" target="_blank" rel="noreferrer">Candidate CSV</a>
    </div>
    <div class="export-step">
      <span>04</span>
      <div><b>Power BI exposure-state feed</b><small>Normalised inherent, current residual, target forecast and post-mitigation actual rows for lifecycle reporting.</small></div>
      <a class="btn" href="/api/reporting/qra-exposure-states?format=csv" target="_blank" rel="noreferrer">State CSV</a>
    </div>
    <div class="export-step">
      <span>05</span>
      <div><b>Quantification governance events</b><small>Save, submit, approve, challenge and reject events for audit trail and review-board evidence.</small></div>
      <a class="btn" href="/api/reporting/quantification-governance-events?format=csv" target="_blank" rel="noreferrer">Events CSV</a>
    </div>
    <div class="qra-export-foot">
      <b>Integration stance</b>
      <span>This register remains the risk system of record. SRS consumes the export for Monte Carlo cost/schedule analysis, then returns P-values, tornado drivers and S-curve outputs to the reporting layer.</span>
    </div>`;
}

async function refreshSrsIntegration(showToast = true) {
  try {
    [qraModelRuns, srsConnections, srsSyncEvents] = await Promise.all([
      loadQraModelRuns().then((result) => result.items),
      loadSrsConnections().then((result) => result.items),
      loadSrsSyncEvents().then((result) => result.items),
    ]);
    if (!qraModelRuns.some((run) => run.id === activeQraModelRunId)) activeQraModelRunId = qraModelRuns[0]?.id || "";
    if (!srsConnections.some((connection) => connection.id === activeSrsConnectionId)) activeSrsConnectionId = qraModelRuns.find((run) => run.id === activeQraModelRunId)?.srsConnectionId || srsConnections[0]?.id || "";
    qraModelRunDetail = activeQraModelRunId ? await loadQraModelRun(activeQraModelRunId) : null;
    renderSrsIntegration();
    renderReportSuite();
    if (showToast) toast("SRS QRA results refreshed");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function selectSrsRun(id: string) {
  if (!id) return;
  try {
    activeQraModelRunId = id;
    qraModelRunDetail = await loadQraModelRun(id);
    activeSrsConnectionId = qraModelRunDetail.run.srsConnectionId || activeSrsConnectionId || srsConnections[0]?.id || "";
    renderSrsIntegration();
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function createSrsRunFromForm() {
  if (!canManageSrsUi()) return;
  const payload: QraModelRunInput = {
    name: value("srs-run-name"),
    runReference: value("srs-run-ref"),
    modelType: value("srs-model-type") as QraModelRunInput["modelType"],
    sourceSystem: "srs",
    exportMode: value("srs-export-mode") as QraModelRunInput["exportMode"],
    reportingPeriodId: value("srs-period"),
    notes: value("srs-run-notes"),
  };
  try {
    const detail = await createQraModelRun(payload);
    qraModelRunDetail = detail;
    activeQraModelRunId = detail.run.id;
    qraModelRuns = await loadQraModelRuns().then((result) => result.items);
    clearSrsRunForm();
    renderSrsIntegration();
    renderReportSuite();
    toast(`Model run created: ${detail.run.runRiskCount} risks`);
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function importSrsResultsFromForm() {
  if (!canManageSrsUi() || !qraModelRunDetail) return;
  const run = qraModelRunDetail.run;
  const p50Cost = numberField("srs-p50-cost");
  const p80Cost = numberField("srs-p80-cost");
  const p90Cost = numberField("srs-p90-cost");
  const p50Schedule = numberField("srs-p50-schedule");
  const p80Schedule = numberField("srs-p80-schedule");
  const p90Schedule = numberField("srs-p90-schedule");
  const payload: QraResultImportInput = {
    run: {
      status: "completed",
      runStartedAt: run.runStartedAt || new Date().toISOString(),
      completedAt: new Date().toISOString(),
      confidenceLevel: "P80 board confidence",
      p50Cost,
      p80Cost,
      p90Cost,
      p50ScheduleDays: p50Schedule,
      p80ScheduleDays: p80Schedule,
      p90ScheduleDays: p90Schedule,
      resultSummary: value("srs-result-summary") || run.resultSummary,
      notes: run.notes,
    },
    riskResults: pilotRiskResultsFromRun(qraModelRunDetail, p50Cost, p80Cost, p90Cost, p50Schedule, p80Schedule, p90Schedule),
    tornadoDrivers: pilotTornadoDriversFromRun(qraModelRunDetail),
    sCurvePoints: pilotSCurvePointsFromRun(p50Cost, p80Cost, p90Cost, p50Schedule, p80Schedule, p90Schedule),
    artifacts: [
      {
        title: `${run.runReference} result import`,
        artifactType: "srs_output",
        uri: "",
        notes: "Result values imported through the SRS results workspace.",
      },
    ],
  };
  try {
    qraModelRunDetail = await importQraModelRunResults(run.id, payload);
    [qraModelRuns, srsSyncEvents] = await Promise.all([
      loadQraModelRuns().then((result) => result.items),
      loadSrsSyncEvents().then((result) => result.items),
    ]);
    renderSrsIntegration();
    renderReportSuite();
    toast("SRS result values imported");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function saveSrsConnectionFromForm() {
  if (!canManageSrsUi()) return;
  const payload: SrsConnectionInput = {
    name: value("srs-conn-name"),
    environment: value("srs-conn-env") as SrsConnectionInput["environment"],
    baseUrl: value("srs-conn-base"),
    apiVersion: value("srs-conn-version"),
    authMode: value("srs-conn-auth") as SrsConnectionInput["authMode"],
    status: value("srs-conn-status") as SrsConnectionInput["status"],
    healthEndpoint: value("srs-conn-health"),
    pushEndpoint: value("srs-conn-push"),
    pollEndpointTemplate: value("srs-conn-poll"),
    notes: value("srs-conn-notes"),
  };
  try {
    const result = activeSrsConnectionId ? await updateSrsConnection(activeSrsConnectionId, payload) : await createSrsConnection(payload);
    activeSrsConnectionId = result.connection.id;
    srsConnections = await loadSrsConnections().then((response) => response.items);
    renderSrsIntegration();
    toast("SRS connection saved");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function healthCheckSrsConnection() {
  if (!canManageSrsUi() || !activeSrsConnectionId) return;
  try {
    const result = await runSrsHealthCheck(activeSrsConnectionId);
    srsConnections = await loadSrsConnections().then((response) => response.items);
    srsSyncEvents = await loadSrsSyncEvents().then((response) => response.items);
    renderSrsIntegration();
    toast(`SRS health check ${result.event.status}`);
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function pushSelectedRunToSrs() {
  if (!canManageSrsUi() || !activeQraModelRunId || !activeSrsConnectionId) return;
  try {
    const result = await pushQraModelRunToSrs(activeQraModelRunId, activeSrsConnectionId);
    qraModelRunDetail = result.detail;
    [qraModelRuns, srsConnections, srsSyncEvents] = await Promise.all([
      loadQraModelRuns().then((response) => response.items),
      loadSrsConnections().then((response) => response.items),
      loadSrsSyncEvents().then((response) => response.items),
    ]);
    renderSrsIntegration();
    toast(`SRS push ${result.event.status}`);
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function pollSelectedRunFromSrs() {
  if (!canManageSrsUi() || !activeQraModelRunId || !activeSrsConnectionId) return;
  try {
    const result = await pollQraModelRunFromSrs(activeQraModelRunId, activeSrsConnectionId);
    qraModelRunDetail = result.detail;
    [qraModelRuns, srsConnections, srsSyncEvents] = await Promise.all([
      loadQraModelRuns().then((response) => response.items),
      loadSrsConnections().then((response) => response.items),
      loadSrsSyncEvents().then((response) => response.items),
    ]);
    renderSrsIntegration();
    toast(`SRS poll ${result.event.status}`);
  } catch (err) {
    toast(errorMessage(err));
  }
}

function renderSrsIntegration() {
  if (!document.getElementById("srsCommandBand")) return;
  fillSrsPeriodSelect();
  const latest = qraModelRunDetail?.run || qraModelRuns[0] || null;
  const completed = qraModelRuns.filter((run) => run.status === "completed");
  const exported = qraModelRuns.filter((run) => run.status === "exported" || run.status === "running");
  const totalRiskRows = qraModelRuns.reduce((sum, run) => sum + (run.runRiskCount || 0), 0);
  const topCost = latest?.topCostDriver || qraModelRunDetail?.tornadoDrivers.find((driver) => driver.metric === "cost")?.driverName || "";
  const topSchedule = latest?.topScheduleDriver || qraModelRunDetail?.tornadoDrivers.find((driver) => driver.metric === "schedule")?.driverName || "";

  $("srsCommandBand").innerHTML = `
    <div>
      <div class="eyebrow">SRS result interface</div>
      <h2>${latest ? esc(latest.name) : "No model runs yet"}</h2>
      <div class="band-meta">
        <span>${qraModelRuns.length} model runs</span>
        <span>${completed.length} completed</span>
        <span>${totalRiskRows} frozen risk rows</span>
        <span>${latest?.p80Cost == null ? "P80 cost pending" : `${moneyK(Math.round(latest.p80Cost))} P80 cost`}</span>
      </div>
    </div>
    <div class="band-status">
      ${latest ? statusToken(modelRunStatusLabel(latest.status), modelRunStatusTone(latest.status)) : statusToken("No run", "neutral")}
      ${statusToken(topCost ? `Cost: ${topCost}` : "Cost driver pending", topCost ? "blue" : "neutral")}
      ${statusToken(topSchedule ? `Schedule: ${topSchedule}` : "Schedule driver pending", topSchedule ? "blue" : "neutral")}
    </div>`;

  $("srsKpis").innerHTML = [
    `<div class="kpi"><div class="l">P80 cost</div><div class="v">${latest?.p80Cost == null ? "-" : moneyK(Math.round(latest.p80Cost))}</div><div class="kpi-note">${latest?.p50Cost == null ? "P50 pending" : `P50 ${moneyK(Math.round(latest.p50Cost))}`} · ${latest?.p90Cost == null ? "P90 pending" : `P90 ${moneyK(Math.round(latest.p90Cost))}`}</div></div>`,
    `<div class="kpi"><div class="l">P80 schedule</div><div class="v">${latest?.p80ScheduleDays == null ? "-" : `${latest.p80ScheduleDays.toFixed(0)}d`}</div><div class="kpi-note">${latest?.p50ScheduleDays == null ? "P50 pending" : `P50 ${latest.p50ScheduleDays.toFixed(0)}d`} · ${latest?.p90ScheduleDays == null ? "P90 pending" : `P90 ${latest.p90ScheduleDays.toFixed(0)}d`}</div></div>`,
    `<div class="kpi"><div class="l">Model runs</div><div class="v">${qraModelRuns.length}</div><div class="kpi-note">${exported.length} exported/running</div></div>`,
    `<div class="kpi"><div class="l">Drivers</div><div class="v">${qraModelRunDetail?.tornadoDrivers.length || latest?.tornadoDriverCount || 0}</div><div class="kpi-note">${qraModelRunDetail?.sCurvePoints.length || latest?.sCurvePointCount || 0} S-curve points</div></div>`,
  ].join("");

  renderSrsRunList();
  renderSrsRunDetail();
  renderSrsTornado();
  renderSrsCurvesAndContribution();
  renderSrsOperations();
  fillSrsImportFields();
  applyRoleLocks();
}

function renderSrsRunList() {
  $("srsRunCount").textContent = `${qraModelRuns.length} runs`;
  $("srsRunList").innerHTML = qraModelRuns.length
    ? qraModelRuns
        .map(
          (run) => `<button class="srs-run-card${run.id === activeQraModelRunId ? " active" : ""}" data-srs-run-id="${escAttr(run.id)}">
            <span>${esc(run.runReference)}</span>
            <b>${esc(run.name)}</b>
            <small>${esc(modelRunTypeLabel(run.modelType))} · ${esc(run.exportMode)} · ${run.completedAt ? fmtDateTime(run.completedAt) : fmtDateTime(run.createdAt)}</small>
            <em>${statusToken(modelRunStatusLabel(run.status), modelRunStatusTone(run.status))}${run.runRiskCount ? statusToken(`${run.runRiskCount} risks`, "neutral") : ""}</em>
          </button>`,
        )
        .join("")
    : '<div class="muted" style="font-size:13px">No SRS model runs recorded.</div>';
}

function renderSrsRunDetail() {
  const detail = qraModelRunDetail;
  if (!detail) {
    $("srsDetailMeta").textContent = "";
    $("srsRunDetail").innerHTML = '<div class="muted" style="font-size:13px">Create a model run from the QRA export to begin result tracking.</div>';
    return;
  }
  const run = detail.run;
  $("srsDetailMeta").textContent = `${run.runReference} · ${run.runRiskCount} risks`;
  $("srsRunDetail").innerHTML = `
    <div class="srs-result-grid">
      <div><span>P50 / P80 / P90 cost</span><b>${srsPValueSet(run.p50Cost, run.p80Cost, run.p90Cost, "cost")}</b></div>
      <div><span>P50 / P80 / P90 schedule</span><b>${srsPValueSet(run.p50ScheduleDays, run.p80ScheduleDays, run.p90ScheduleDays, "schedule")}</b></div>
      <div><span>Status</span><b>${statusToken(modelRunStatusLabel(run.status), modelRunStatusTone(run.status))}</b></div>
      <div><span>Evidence</span><b>${detail.artifacts.length} artifacts</b></div>
    </div>
    <div class="srs-summary">${esc(run.resultSummary || "No result summary recorded yet.")}</div>
    <div class="srs-artifacts">${detail.artifacts
      .slice(0, 4)
      .map((artifact) => (artifact.uri ? `<a href="${escAttr(artifact.uri)}" target="_blank" rel="noreferrer">${esc(artifact.title)}</a>` : `<span>${esc(artifact.title)}</span>`))
      .join("")}</div>`;
}

function renderSrsTornado() {
  const drivers = qraModelRunDetail?.tornadoDrivers || [];
  if (!drivers.length) {
    $("srsTornado").innerHTML = '<div class="muted" style="font-size:13px">No tornado drivers imported for this run.</div>';
    return;
  }
  const maxSwing = Math.max(...drivers.map((driver) => Math.abs(driver.swingValue || 0)), 1);
  $("srsTornado").innerHTML = drivers
    .map(
      (driver) => `<div class="tornado-row">
        <div><b>${esc(driver.driverName)}</b><small>${esc(driver.metric)} · ${esc(driver.driverType)}${driver.riskCode ? ` · ${esc(driver.riskCode)}` : ""}</small></div>
        <div class="tornado-bar"><span style="width:${Math.max(4, Math.round((Math.abs(driver.swingValue || 0) / maxSwing) * 100))}%"></span></div>
        <em>${formatDriverValue(driver.swingValue, driver.metric)}</em>
      </div>`,
    )
    .join("");
}

function renderSrsCurvesAndContribution() {
  const detail = qraModelRunDetail;
  if (!detail) {
    $("srsCurves").innerHTML = "";
    $("srsRiskContrib").innerHTML = "";
    return;
  }
  const costPoints = detail.sCurvePoints.filter((point) => point.curveType === "cost");
  const schedulePoints = detail.sCurvePoints.filter((point) => point.curveType === "schedule");
  $("srsCurves").innerHTML = `
    <div class="srs-curve-grid">
      ${srsCurveHtml("Cost", costPoints)}
      ${srsCurveHtml("Schedule", schedulePoints)}
    </div>`;
  const risks = detail.risks
    .slice()
    .sort((a, b) => (b.p80CostContribution || 0) - (a.p80CostContribution || 0) || (a.rankCost || 999) - (b.rankCost || 999))
    .slice(0, 8);
  $("srsRiskContrib").innerHTML = `
    <table class="srs-risk-table"><thead><tr><th>ID</th><th>Risk</th><th>P80 cost</th><th>P80 schedule</th><th>Rank</th></tr></thead><tbody>
      ${risks
        .map(
          (risk) => `<tr data-risk-open="${escAttr(risk.riskCode)}"><td>${esc(risk.riskCode)}</td><td>${esc(risk.riskTitle)}<div class="muted" style="font-size:11px">${esc(risk.packageCode || risk.wbsCode || "")}</div></td><td>${risk.p80CostContribution == null ? "-" : moneyK(Math.round(risk.p80CostContribution))}</td><td>${risk.p80ScheduleContributionDays == null ? "-" : `${risk.p80ScheduleContributionDays.toFixed(0)}d`}</td><td>${risk.rankCost || "-"}</td></tr>`,
        )
        .join("") || '<tr><td colspan="5" class="muted">No risk contribution rows.</td></tr>'}
    </tbody></table>`;
  $("srsRiskContrib").querySelectorAll("[data-risk-open]").forEach((row) => {
    row.addEventListener("click", () => openById((row as HTMLElement).dataset.riskOpen || ""));
  });
}

function renderSrsOperations() {
  const connection = srsConnections.find((item) => item.id === activeSrsConnectionId) || srsConnections[0] || null;
  if (connection && activeSrsConnectionId !== connection.id) activeSrsConnectionId = connection.id;
  const run = qraModelRunDetail?.run || null;
  const runEvents = srsSyncEvents.filter((event) => !run || event.modelRunId === run.id || event.connectionId === activeSrsConnectionId).slice(0, 10);
  const failed = srsSyncEvents.filter((event) => event.status === "failed").length;
  const lastEvent = srsSyncEvents[0] || null;

  $("srsConnectionPanel").innerHTML = connection
    ? `<div class="srs-connection-status">
        <div>
          <span>Connection</span>
          <b>${esc(connection.name)}</b>
          <small>${esc(connection.environment)} · ${esc(connection.apiVersion)} · ${connection.baseUrl ? esc(connection.baseUrl) : "contract / mock-ready mode"}</small>
        </div>
        <div>${statusToken(srsConnectionStatusLabel(connection.status), srsConnectionTone(connection.status))}</div>
      </div>
      <div class="srs-sync-metrics">
        <div><span>Health</span><b>${connection.lastHealthStatusCode == null ? "-" : connection.lastHealthStatusCode}</b><small>${connection.lastHealthAt ? fmtDateTime(connection.lastHealthAt) : "Not checked"}</small></div>
        <div><span>Sync</span><b>${lastEvent ? srsSyncActionLabel(lastEvent.action) : "-"}</b><small>${connection.lastSyncAt ? fmtDateTime(connection.lastSyncAt) : "No sync yet"}</small></div>
        <div><span>External run</span><b>${esc(run?.externalRunId || "-")}</b><small>${esc(run?.externalStatus || "No external status")}</small></div>
        <div><span>Exceptions</span><b>${failed}</b><small>${srsSyncEvents.length} events</small></div>
      </div>
      <div class="srs-summary">${esc(connection.lastHealthMessage || connection.notes || "No connection message recorded.")}</div>`
    : '<div class="muted" style="font-size:13px">No SRS connection configured yet.</div>';

  fillSrsConnectionForm(connection);

  $("srsSyncEvents").innerHTML = runEvents.length
    ? `<div class="srs-event-list">${runEvents
        .map(
          (event) => `<div class="srs-event">
            <div>
              <b>${esc(srsSyncActionLabel(event.action))}</b>
              <small>${esc(event.runReference || event.connectionName || "Connection")} · ${fmtDateTime(event.createdAt)} · ${esc(event.endpoint || "")}</small>
              <p>${esc(event.errorMessage || event.responseSummary || event.requestSummary)}</p>
            </div>
            <div>${statusToken(srsSyncStatusLabel(event.status), srsSyncTone(event.status))}</div>
          </div>`,
        )
        .join("")}</div>`
    : '<div class="muted" style="font-size:13px">No SRS sync events yet.</div>';
}

function fillSrsConnectionForm(connection: SrsConnection | null) {
  if (!document.getElementById("srs-conn-name")) return;
  setValue("srs-conn-name", connection?.name || "SOMA Risk Studio dev integration");
  setValue("srs-conn-env", connection?.environment || "development");
  setValue("srs-conn-base", connection?.baseUrl || "");
  setValue("srs-conn-version", connection?.apiVersion || "srs-qra-v1");
  setValue("srs-conn-auth", connection?.authMode || "manual");
  setValue("srs-conn-status", connection?.status || "mock_ready");
  setValue("srs-conn-health", connection?.healthEndpoint || "/health");
  setValue("srs-conn-push", connection?.pushEndpoint || "/api/qra/model-runs");
  setValue("srs-conn-poll", connection?.pollEndpointTemplate || "/api/qra/model-runs/{externalRunId}/results");
  setValue("srs-conn-notes", connection?.notes || "Credentials are managed outside D1; configure live SRS endpoint when the SRS API is exposed.");
}

function srsCurveHtml(title: string, points: Array<{ percentile: number; value: number; unit: string }>) {
  if (!points.length) return `<div class="srs-curve"><b>${esc(title)}</b><small class="muted">No points</small></div>`;
  const max = Math.max(...points.map((point) => point.value), 1);
  return `<div class="srs-curve"><b>${esc(title)}</b>${points
    .map((point) => `<div class="curve-point"><span>P${point.percentile}</span><div><i style="width:${Math.max(4, Math.round((point.value / max) * 100))}%"></i></div><em>${point.unit === "gbp_k" ? moneyK(Math.round(point.value)) : `${point.value.toFixed(0)}d`}</em></div>`)
    .join("")}</div>`;
}

function fillSrsPeriodSelect() {
  const sel = document.getElementById("srs-period") as HTMLSelectElement | null;
  if (!sel) return;
  const current = sel.value;
  sel.innerHTML = '<option value="">Live / no period</option>' + reportingPeriods.map((period) => `<option value="${escAttr(period.reporting_period_id)}">${esc(period.name)} (${esc(period.status)})</option>`).join("");
  sel.value = reportingPeriods.some((period) => period.reporting_period_id === current) ? current : "";
  if (!value("srs-run-name")) setValue("srs-run-name", `SRS integrated QRA ${monthDate(TODAY.getDate()).replace(/-/g, "")}`);
  if (!value("srs-run-ref")) setValue("srs-run-ref", `SRS-${session?.tenant.slug.toUpperCase() || "TENANT"}-${monthDate(TODAY.getDate()).replace(/-/g, "")}`);
}

function fillSrsImportFields() {
  const run = qraModelRunDetail?.run;
  if (!run) return;
  setValue("srs-p50-cost", numberText(run.p50Cost));
  setValue("srs-p80-cost", numberText(run.p80Cost));
  setValue("srs-p90-cost", numberText(run.p90Cost));
  setValue("srs-p50-schedule", numberText(run.p50ScheduleDays));
  setValue("srs-p80-schedule", numberText(run.p80ScheduleDays));
  setValue("srs-p90-schedule", numberText(run.p90ScheduleDays));
  setValue("srs-result-summary", run.resultSummary || "");
}

function clearSrsRunForm() {
  setValue("srs-run-name", "");
  setValue("srs-run-ref", "");
  setValue("srs-run-notes", "");
  setValue("srs-export-mode", "ready");
  setValue("srs-model-type", "integrated");
}

function pilotRiskResultsFromRun(detail: QraModelRunDetail, p50Cost: number | null, p80Cost: number | null, p90Cost: number | null, p50Schedule: number | null, p80Schedule: number | null, p90Schedule: number | null): QraResultImportInput["riskResults"] {
  const risks = detail.risks.slice().sort((a, b) => (b.expectedCost || 0) - (a.expectedCost || 0));
  const totalCost = risks.reduce((sum, risk) => sum + Math.max(0, risk.expectedCost || 0), 0) || 1;
  const totalSchedule = risks.reduce((sum, risk) => sum + Math.max(0, risk.expectedScheduleDays || 0), 0) || 1;
  return risks.map((risk, index) => {
    const costWeight = Math.max(0, risk.expectedCost || 0) / totalCost;
    const scheduleWeight = Math.max(0, risk.expectedScheduleDays || 0) / totalSchedule;
    return {
      riskCode: risk.riskCode,
      includeInModel: true,
      p50CostContribution: p50Cost == null ? null : roundNumber(p50Cost * costWeight),
      p80CostContribution: p80Cost == null ? null : roundNumber(p80Cost * costWeight),
      p90CostContribution: p90Cost == null ? null : roundNumber(p90Cost * costWeight),
      p50ScheduleContributionDays: p50Schedule == null ? null : roundNumber(p50Schedule * scheduleWeight),
      p80ScheduleContributionDays: p80Schedule == null ? null : roundNumber(p80Schedule * scheduleWeight),
      p90ScheduleContributionDays: p90Schedule == null ? null : roundNumber(p90Schedule * scheduleWeight),
      rankCost: index + 1,
      rankSchedule: risks.slice().sort((a, b) => (b.expectedScheduleDays || 0) - (a.expectedScheduleDays || 0)).findIndex((item) => item.riskCode === risk.riskCode) + 1,
      sensitivityScore: roundNumber(Math.max(costWeight, scheduleWeight)),
      resultNotes: "Pilot import allocation based on frozen expected exposure weighting.",
    };
  });
}

function pilotTornadoDriversFromRun(detail: QraModelRunDetail): QraResultImportInput["tornadoDrivers"] {
  const costTop = detail.risks.slice().sort((a, b) => (b.costHigh || 0) - (a.costHigh || 0)).slice(0, 4);
  const scheduleTop = detail.risks.slice().sort((a, b) => (b.scheduleHighDays || 0) - (a.scheduleHighDays || 0)).slice(0, 4);
  return [
    ...costTop.map((risk, index) => ({
      riskCode: risk.riskCode,
      driverName: risk.riskTitle,
      driverType: "risk" as const,
      metric: "cost" as const,
      lowValue: risk.costLow,
      highValue: risk.costHigh,
      swingValue: risk.costHigh == null || risk.costLow == null ? 0 : risk.costHigh - risk.costLow,
      rank: index + 1,
      notes: "Pilot cost tornado generated from frozen range width.",
    })),
    ...scheduleTop.map((risk, index) => ({
      riskCode: risk.riskCode,
      driverName: risk.riskTitle,
      driverType: "risk" as const,
      metric: "schedule" as const,
      lowValue: risk.scheduleLowDays,
      highValue: risk.scheduleHighDays,
      swingValue: risk.scheduleHighDays == null || risk.scheduleLowDays == null ? 0 : risk.scheduleHighDays - risk.scheduleLowDays,
      rank: index + 1,
      notes: "Pilot schedule tornado generated from frozen range width.",
    })),
  ];
}

function pilotSCurvePointsFromRun(p50Cost: number | null, p80Cost: number | null, p90Cost: number | null, p50Schedule: number | null, p80Schedule: number | null, p90Schedule: number | null): QraResultImportInput["sCurvePoints"] {
  const cost50 = p50Cost || 0;
  const cost80 = p80Cost || cost50 * 1.35;
  const cost90 = p90Cost || cost80 * 1.25;
  const schedule50 = p50Schedule || 0;
  const schedule80 = p80Schedule || schedule50 * 1.35;
  const schedule90 = p90Schedule || schedule80 * 1.25;
  return [
    { curveType: "cost", percentile: 10, value: roundNumber(cost50 * 0.62), unit: "gbp_k" },
    { curveType: "cost", percentile: 25, value: roundNumber(cost50 * 0.82), unit: "gbp_k" },
    { curveType: "cost", percentile: 50, value: roundNumber(cost50), unit: "gbp_k" },
    { curveType: "cost", percentile: 80, value: roundNumber(cost80), unit: "gbp_k" },
    { curveType: "cost", percentile: 90, value: roundNumber(cost90), unit: "gbp_k" },
    { curveType: "schedule", percentile: 10, value: roundNumber(schedule50 * 0.62), unit: "days" },
    { curveType: "schedule", percentile: 25, value: roundNumber(schedule50 * 0.82), unit: "days" },
    { curveType: "schedule", percentile: 50, value: roundNumber(schedule50), unit: "days" },
    { curveType: "schedule", percentile: 80, value: roundNumber(schedule80), unit: "days" },
    { curveType: "schedule", percentile: 90, value: roundNumber(schedule90), unit: "days" },
  ];
}

function srsPValueSet(p50: number | null, p80: number | null, p90: number | null, type: "cost" | "schedule") {
  const formatter = (value: number | null) => (value == null ? "-" : type === "cost" ? moneyK(Math.round(value)) : `${value.toFixed(0)}d`);
  return `${formatter(p50)} / ${formatter(p80)} / ${formatter(p90)}`;
}

function formatDriverValue(value: number, metric: string) {
  return metric === "cost" ? moneyK(Math.round(value)) : `${Number(value || 0).toFixed(0)}d`;
}

function modelRunStatusLabel(status: string) {
  if (status === "exported") return "Exported";
  if (status === "running") return "Running";
  if (status === "completed") return "Completed";
  if (status === "failed") return "Failed";
  if (status === "superseded") return "Superseded";
  return "Draft";
}

function modelRunStatusTone(status: string) {
  if (status === "completed") return "green";
  if (status === "running" || status === "exported") return "blue";
  if (status === "failed") return "red";
  if (status === "superseded") return "neutral";
  return "amber";
}

function modelRunTypeLabel(type: string) {
  if (type === "qcra") return "QCRA";
  if (type === "qsra") return "QSRA";
  if (type === "qra") return "QRA";
  return "Integrated";
}

function srsConnectionStatusLabel(status: string) {
  if (status === "mock_ready") return "Mock ready";
  if (status === "ready") return "Ready";
  if (status === "disabled") return "Disabled";
  if (status === "error") return "Error";
  return "Draft";
}

function srsConnectionTone(status: string) {
  if (status === "ready" || status === "mock_ready") return "green";
  if (status === "error") return "red";
  if (status === "disabled") return "neutral";
  return "amber";
}

function srsSyncActionLabel(action: string) {
  if (action === "health_check") return "Health check";
  if (action === "push_export") return "Push export";
  if (action === "poll_results") return "Poll results";
  if (action === "import_results") return "Import results";
  return action;
}

function srsSyncStatusLabel(status: string) {
  if (status === "success") return "Success";
  if (status === "failed") return "Failed";
  if (status === "skipped") return "Skipped";
  return "Queued";
}

function srsSyncTone(status: string) {
  if (status === "success") return "green";
  if (status === "failed") return "red";
  if (status === "skipped") return "neutral";
  return "amber";
}

function canManageSrsUi() {
  return hasPermissionUi("srs.manage");
}

function roundNumber(value: number) {
  return Math.round(value * 100) / 100;
}

function renderReportSuite() {
  const qraTotal = qraReadinessRows.length;
  const qraReady = qraReadinessRows.filter((row) => row.readiness_status === "Ready").length;
  const appetiteBreaches = riskAppetiteRows.filter((row) => row.escalation_required || row.appetite_status === "breach" || row.appetite_status === "critical_breach").length;
  const overdueEscalations = riskAppetiteRows.filter((row) => row.decision_due_status === "Overdue").length;
  const redIndicators = riskIndicators.filter((row) => row.status === "red").length;
  const qraIndicatorAlerts = riskIndicators.filter((row) => row.qra_impact && row.qra_impact !== "none").length;
  const latestClosed = reportingPeriods.find((period) => period.status === "closed");
  const latestRun = reportRuns.slice().sort((a, b) => new Date(b.generated_at).getTime() - new Date(a.generated_at).getTime())[0];
  const currentRisks = risks.filter((risk) => risk.status !== "Closed").length;
  $("reportSuite").innerHTML = [
    {
      title: "Board risk pack",
      metric: `${currentRisks} active`,
      body: latestRun ? `Last logged ${fmtDateTime(latestRun.generated_at)}` : "No evidence run logged",
      action: '<button class="btnp" data-report-action="print">PDF pack</button>',
    },
    {
      title: "Power BI dataset",
      metric: "36 feeds",
      body: "Risk, appetite, escalation, workshop, KRI, programme intelligence, evidence, import-quality, QRA, SRS, report-pack, taxonomy, controls, bow-tie, assurance and obligation dimensions",
      action: '<a class="btn" href="/api/reporting/schema" target="_blank" rel="noreferrer">Schema</a><a class="btn" href="/api/reporting/report-packs?format=csv" target="_blank" rel="noreferrer">Packs</a>',
    },
    {
      title: "KRIs and triggers",
      metric: `${redIndicators} red`,
      body: `${qraIndicatorAlerts} indicators require QRA probability, impact or candidate review`,
      action: '<a class="btnp" href="/api/reporting/risk-indicators?format=csv" target="_blank" rel="noreferrer">Indicators CSV</a><a class="btn" href="/api/reporting/risk-indicator-events?format=csv" target="_blank" rel="noreferrer">Events CSV</a>',
    },
    {
      title: "Workshop decisions",
      metric: `${riskWorkshopDecisions.filter((row) => row.status === "open" || row.status === "in_progress").length} open`,
      body: `${riskWorkshopDecisions.filter((row) => row.qra_impact && row.qra_impact !== "none").length} decisions affect QRA inclusion, mapping or assumptions`,
      action: '<a class="btnp" href="/api/reporting/risk-workshop-decisions?format=csv" target="_blank" rel="noreferrer">Decisions CSV</a><a class="btn" href="/api/reporting/risk-workshops?format=csv" target="_blank" rel="noreferrer">Workshops CSV</a>',
    },
    {
      title: "Appetite breaches",
      metric: `${appetiteBreaches} breach${appetiteBreaches === 1 ? "" : "es"}`,
      body: overdueEscalations ? `${overdueEscalations} overdue escalation decision${overdueEscalations === 1 ? "" : "s"}` : "Tolerance status and escalation forums available for board packs",
      action: '<a class="btnp" href="/api/reporting/risk-appetite-assessments?format=csv" target="_blank" rel="noreferrer">Appetite CSV</a><a class="btn" href="/api/reporting/risk-escalation-events?format=csv" target="_blank" rel="noreferrer">Events CSV</a>',
    },
    {
      title: "SRS / QRA export",
      metric: qraTotal ? `${qraReady}/${qraTotal} ready` : "0/0 ready",
      body: "Ready export plus candidate exception pack",
      action: '<a class="btnp" href="/api/reporting/qra-export?format=csv" target="_blank" rel="noreferrer">Ready CSV</a><button class="btn" data-report-action="qra">Workbench</button>',
    },
    {
      title: "Period evidence",
      metric: latestClosed ? esc(latestClosed.name) : `${reportingPeriods.length} periods`,
      body: latestClosed ? `Closed ${fmtDateTime(latestClosed.closed_at || latestClosed.created_at)}` : "Create and close a snapshot before issue",
      action: '<button class="btn" data-report-action="periods">Periods</button>',
    },
  ]
    .map((card) => `<div class="report-card"><div class="report-card-main"><span>${card.title}</span><b>${card.metric}</b><small>${card.body}</small></div><div class="report-card-actions">${card.action}</div></div>`)
    .join("");
  $("reportSuite").querySelectorAll("[data-report-action]").forEach((button) => {
    button.addEventListener("click", () => {
      const action = (button as HTMLElement).dataset.reportAction;
      if (action === "print") doReport();
      if (action === "periods") $("rp-name").focus();
      if (action === "qra") navTo("qra");
    });
  });
}

function renderPeriods() {
  const canManage = canManageReportingUi();
  const tb = $("periodsTb");
  if (!reportingPeriods.length) {
    tb.innerHTML = '<tr><td colspan="4" class="muted">No reporting periods yet.</td></tr>';
  } else {
    tb.innerHTML = reportingPeriods
      .map((period) => {
        const locked = period.status === "closed";
        const actions = locked
          ? `<a class="lnk" href="/api/reporting/risks/snapshots?periodId=${encodeURIComponent(period.reporting_period_id)}&format=csv" target="_blank" rel="noreferrer">CSV</a>`
          : `<button class="lnk" data-period-snapshot="${escAttr(period.reporting_period_id)}" ${canManage ? "" : "disabled"}>Snapshot</button><button class="lnk" data-period-close="${escAttr(period.reporting_period_id)}" ${canManage ? "" : "disabled"}>Close</button>`;
        return `<tr><td>${esc(period.name)}<div class="muted" style="font-size:11px">${esc(period.created_by_name || "")}</div></td><td class="muted">${fmtDate(period.period_start)} - ${fmtDate(period.period_end)}</td><td>${statusPill(period.status)}</td><td>${actions}</td></tr>`;
      })
      .join("");
  }

  tb.querySelectorAll("[data-period-snapshot]").forEach((button) => {
    button.addEventListener("click", () => void snapshotPeriod((button as HTMLElement).dataset.periodSnapshot || ""));
  });
  tb.querySelectorAll("[data-period-close]").forEach((button) => {
    button.addEventListener("click", () => void closePeriodFromView((button as HTMLElement).dataset.periodClose || ""));
  });

  const sel = $<HTMLSelectElement>("rr-period");
  const current = sel.value;
  sel.innerHTML = reportingPeriods.length
    ? reportingPeriods.map((period) => `<option value="${escAttr(period.reporting_period_id)}">${esc(period.name)} (${esc(period.status)})</option>`).join("")
    : '<option value="">No period</option>';
  if (reportingPeriods.some((period) => period.reporting_period_id === current)) sel.value = current;
}

function renderQraReadiness() {
  const ready = qraReadinessRows.filter((row) => row.readiness_status === "Ready").length;
  const review = qraReadinessRows.filter((row) => row.readiness_status === "Needs review").length;
  const incomplete = qraReadinessRows.filter((row) => row.readiness_status === "Incomplete").length;
  $("qra-kpis").innerHTML = [
    `<div class="kpi"><div class="l">Ready</div><div class="v">${ready}</div></div>`,
    `<div class="kpi"><div class="l">Needs review</div><div class="v">${review}</div></div>`,
    `<div class="kpi"><div class="l">Incomplete</div><div class="v">${incomplete}</div></div>`,
  ].join("");

  const rows = qraReadinessRows
    .filter((row) => row.readiness_status !== "Ready")
    .slice(0, 8);
  $("qraTb").innerHTML = rows.length
    ? rows
        .map(
          (row) =>
            `<tr><td>${esc(row.risk_id)}</td><td>${esc(row.title)}</td><td><span class="pill o-open">${esc(row.readiness_status)}</span></td><td class="muted qra-missing">${formatMissingFields(row.missing_fields || row.readiness_note || "")}</td></tr>`,
        )
        .join("")
    : '<tr><td colspan="4" class="muted">No QRA readiness exceptions.</td></tr>';
}

function formatMissingFields(value: unknown) {
  const text = String(value || "");
  if (!text) return "";
  if (!text.includes(",")) return esc(text.replace(/_/g, " "));
  return text
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean)
    .map((item) => `<span>${esc(item.replace(/_/g, " "))}</span>`)
    .join("");
}

function renderReportLinks() {
  const links = [
    ["Projects", "/api/reporting/projects?format=csv"],
    ["Packages", "/api/reporting/packages?format=csv"],
    ["Current risks", "/api/reporting/risks/current?format=csv"],
    ["Programme items", "/api/reporting/programme-items?format=csv"],
    ["Import batches", "/api/reporting/import-batches?format=csv"],
    ["Import rows", "/api/reporting/import-rows?format=csv"],
    ["Import row resolutions", "/api/reporting/import-row-resolutions?format=csv"],
    ["Import validation issues", "/api/reporting/import-validation-issues?format=csv"],
    ["Import validation rules", "/api/reporting/import-validation-rules?format=csv"],
    ["Evidence records", "/api/reporting/evidence-records?format=csv"],
    ["Evidence links", "/api/reporting/evidence-links?format=csv"],
    ["Evidence attachments", "/api/reporting/evidence-attachments?format=csv"],
    ["Evidence packages", "/api/reporting/evidence-packages?format=csv"],
    ["Evidence package items", "/api/reporting/evidence-package-items?format=csv"],
    ["Risk snapshots", "/api/reporting/risks/snapshots?format=csv"],
    ["Actions", "/api/reporting/actions?format=csv"],
    ["Reviews", "/api/reporting/reviews?format=csv"],
    ["Risk appetite", "/api/reporting/risk-appetite-assessments?format=csv"],
    ["Risk escalations", "/api/reporting/risk-escalation-events?format=csv"],
    ["Risk workshops", "/api/reporting/risk-workshops?format=csv"],
    ["Workshop attendees", "/api/reporting/risk-workshop-attendees?format=csv"],
    ["Workshop decisions", "/api/reporting/risk-workshop-decisions?format=csv"],
    ["Risk indicators", "/api/reporting/risk-indicators?format=csv"],
    ["Indicator events", "/api/reporting/risk-indicator-events?format=csv"],
    ["QRA readiness", "/api/reporting/qra-readiness?format=csv"],
    ["QRA ready export", "/api/reporting/qra-export?format=csv"],
    ["QRA candidate export", "/api/reporting/qra-export?mode=candidate&format=csv"],
    ["QRA exposure states", "/api/reporting/qra-exposure-states?format=csv"],
    ["QRA state evidence", "/api/reporting/qra-exposure-state-evidence?format=csv"],
    ["QRA model runs", "/api/reporting/qra-model-runs?format=csv"],
    ["QRA model risks", "/api/reporting/qra-model-run-risks?format=csv"],
    ["QRA tornado drivers", "/api/reporting/qra-tornado-drivers?format=csv"],
    ["QRA S-curve points", "/api/reporting/qra-s-curve-points?format=csv"],
    ["QRA artifacts", "/api/reporting/qra-model-run-artifacts?format=csv"],
    ["SRS connections", "/api/reporting/srs-connections?format=csv"],
    ["SRS sync events", "/api/reporting/srs-sync-events?format=csv"],
    ["Controls", "/api/reporting/controls?format=csv"],
    ["Risk controls", "/api/reporting/risk-controls?format=csv"],
    ["Bow-tie controls", "/api/reporting/bowtie-controls?format=csv"],
    ["Control assurance tests", "/api/reporting/control-assurance-tests?format=csv"],
    ["Control obligations", "/api/reporting/control-obligations?format=csv"],
    ["Report templates", "/api/reporting/templates?format=csv"],
    ["Report layouts", "/api/reporting/layout-variants?format=csv"],
    ["Report schedules", "/api/reporting/schedules?format=csv"],
    ["Schedule runs", "/api/reporting/schedule-runs?format=csv"],
    ["Notification outbox", "/api/reporting/notification-events?format=csv"],
    ["Generated report packs", "/api/reporting/report-packs?format=csv"],
    ["Report pack sections", "/api/reporting/report-pack-sections?format=csv"],
    ["Power BI semantic model", "/api/reporting/power-bi/semantic-model"],
    ["Quant governance events", "/api/reporting/quantification-governance-events?format=csv"],
    ["Quant approval attestations", "/api/reporting/quantification-approval-attestations?format=csv"],
    ["Report runs", "/api/reporting/report-runs?format=csv"],
  ];
  $("reportLinks").innerHTML = links.map(([label, href]) => `<a class="btn" href="${href}" target="_blank" rel="noreferrer">${label}</a>`).join("");
}

function renderReportRuns() {
  const tb = $("reportRunsTb");
  tb.innerHTML = reportRuns.length
    ? reportRuns
        .slice(0, 10)
        .map((run) => `<tr><td>${esc(run.report_type)}<div class="muted" style="font-size:11px">${esc(run.report_template_name || run.generated_by_name || "")}</div></td><td class="muted">${esc(run.reporting_period_name || "Live")}</td><td><span class="pill o-managed">${esc(run.format)}</span></td><td class="muted">${fmtDateTime(run.generated_at)}</td></tr>`)
        .join("")
    : '<tr><td colspan="4" class="muted">No report runs logged yet.</td></tr>';
}

async function createPeriodFromForm() {
  if (!canManageReportingUi()) return;
  try {
    await createReportingPeriod({
      name: value("rp-name"),
      periodStart: value("rp-start"),
      periodEnd: value("rp-end"),
      notes: value("rp-notes"),
    });
    setValue("rp-name", "");
    setValue("rp-notes", "");
    await refreshReporting(false);
    toast("Reporting period created");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function snapshotPeriod(id: string) {
  if (!id || !canManageReportingUi()) return;
  try {
    const result = await snapshotReportingPeriod(id);
    await refreshReporting(false);
    toast(`Snapshot captured: ${result.snapshotRowCount} risks`);
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function closePeriodFromView(id: string) {
  if (!id || !canManageReportingUi()) return;
  const ok = await confirmDestructive({
    title: "Close reporting period?",
    message: "Closing locks the period snapshot for governance reporting. It cannot be resnapshotted afterwards.",
    confirmLabel: "Close period",
  });
  if (!ok) return;
  try {
    const result = await closeReportingPeriod(id);
    await refreshReporting(false);
    toast(`Period closed: ${result.snapshotRowCount} risks locked`);
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function logReportRunFromForm() {
  if (!canManageReportingUi()) return;
  const reportingPeriodId = value("rr-period");
  try {
    await createReportRun({
      reportType: value("rr-type") || "Monthly project risk report",
      reportingPeriodId: reportingPeriodId || undefined,
      format: value("rr-format"),
      filters: { source: "in-app-reporting-view" },
    });
    await refreshReporting(false);
    toast("Report run logged");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function saveReportTemplateFromForm() {
  if (!canManageReportingUi()) return;
  const payload = reportTemplatePayloadFromForm();
  if (!payload.sections.length) {
    toast("Select at least one report section");
    return;
  }
  const id = value("rt-id");
  try {
    if (id) await updateReportTemplate(id, payload);
    else await createReportTemplate(payload);
    clearReportTemplateForm();
    await refreshReporting(false);
    toast(id ? "Report template updated" : "Report template created");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function reportTemplatePayloadFromForm(): ReportTemplateInput {
  return {
    name: value("rt-name"),
    description: value("rt-description"),
    audience: value("rt-audience") as ReportTemplateInput["audience"],
    cadence: value("rt-cadence") as ReportTemplateInput["cadence"],
    outputFormat: value("rt-format") as ReportTemplateInput["outputFormat"],
    sections: selectedReportSectionsFromForm(),
    filters: { source: "in-app-report-template-builder", qraApprovalRequired: selectedReportSectionsFromForm().includes("qra_export") },
    active: $<HTMLInputElement>("rt-active").checked,
  };
}

function selectedReportSectionsFromForm() {
  const selected = Array.from(document.querySelectorAll<HTMLInputElement>("[data-report-section]"))
    .filter((input) => input.checked)
    .map((input) => input.dataset.reportSection || "")
    .filter(Boolean);
  return selected.length ? selected : ["executive_summary", "risk_appetite", "top_risks", "actions", "reviews"];
}

function fillReportTemplateForm(id: string) {
  const template = reportTemplates.find((item) => item.report_template_id === id);
  if (!template) return;
  setValue("rt-id", template.report_template_id);
  setValue("rt-name", template.name);
  setValue("rt-audience", template.audience);
  setValue("rt-cadence", template.cadence);
  setValue("rt-format", template.output_format);
  setValue("rt-description", template.description || "");
  $<HTMLInputElement>("rt-active").checked = template.active;
  const sections = new Set(parseTemplateSections(template));
  document.querySelectorAll<HTMLInputElement>("[data-report-section]").forEach((input) => {
    input.checked = sections.has(input.dataset.reportSection || "");
  });
  $("rt-name").focus();
}

function clearReportTemplateForm() {
  setValue("rt-id", "");
  setValue("rt-name", "");
  setValue("rt-audience", "board");
  setValue("rt-cadence", "monthly");
  setValue("rt-format", "pdf");
  setValue("rt-description", "");
  $<HTMLInputElement>("rt-active").checked = true;
  document.querySelectorAll<HTMLInputElement>("[data-report-section]").forEach((input) => {
    input.checked = ["executive_summary", "risk_appetite", "top_risks", "actions", "reviews"].includes(input.dataset.reportSection || "");
  });
}

function renderReportLayouts() {
  if (!document.getElementById("reportLayoutDesigner")) return;
  $("reportLayoutCount").textContent = `${reportLayoutVariants.filter((layout) => layout.status === "active").length} active layouts`;

  const templateSelect = $<HTMLSelectElement>("rl-template");
  const currentTemplate = templateSelect.value || reportTemplates.find((template) => template.active)?.report_template_id || reportTemplates[0]?.report_template_id || "";
  templateSelect.innerHTML = reportTemplates.length
    ? reportTemplates.map((template) => `<option value="${escAttr(template.report_template_id)}">${esc(template.name)} (${esc(audienceLabel(template.audience))})</option>`).join("")
    : '<option value="">No templates</option>';
  if (reportTemplates.some((template) => template.report_template_id === currentTemplate)) templateSelect.value = currentTemplate;

  $("reportLayouts").innerHTML = reportLayoutVariants.length
    ? reportLayoutVariants
        .slice()
        .sort((a, b) => layoutStatusRank(a) - layoutStatusRank(b) || a.report_template_name.localeCompare(b.report_template_name) || a.name.localeCompare(b.name))
        .map((layout) => {
          const sections = reportLayoutSectionOrder(layout).slice(0, 6);
          return `<div class="report-template-card${layout.status === "retired" ? " inactive" : ""}">
            <div class="report-template-head">
              <div><span>${esc(layoutThemeLabel(layout.theme))}</span><b>${esc(layout.name)}</b></div>
              ${statusToken(layout.status === "active" ? (layout.is_default ? "Default" : "Active") : layout.status, layout.status === "active" ? "green" : layout.status === "draft" ? "amber" : "neutral")}
            </div>
            <p>${esc(layout.description || "No description")}</p>
            <div class="section-list">${sections.map((section) => `<span>${esc(sectionLabel(section))}</span>`).join("")}</div>
            <div class="report-template-meta">${esc(layout.report_template_name || "No template")} · ${esc(layout.page_size.replace(/_/g, " "))} · updated ${fmtDateTime(layout.updated_at)}</div>
            <div class="report-template-actions">
              <button class="btnp" data-report-layout-action="use" data-report-layout-id="${escAttr(layout.report_layout_variant_id)}" ${layout.status === "retired" ? "disabled" : ""}>Use layout</button>
              <button class="btn" data-report-layout-action="edit" data-report-layout-id="${escAttr(layout.report_layout_variant_id)}">Edit</button>
              <button class="btn" data-report-layout-action="retire" data-report-layout-id="${escAttr(layout.report_layout_variant_id)}" ${layout.status === "retired" ? "disabled" : ""}>Retire</button>
            </div>
          </div>`;
        })
        .join("")
    : '<div class="muted">No report layouts yet.</div>';
}

function reportLayoutPayloadFromForm(): ReportLayoutVariantInput {
  return {
    reportTemplateId: value("rl-template"),
    name: value("rl-name"),
    description: value("rl-description"),
    theme: value("rl-theme") as ReportLayoutVariantInput["theme"],
    pageSize: value("rl-page-size") as ReportLayoutVariantInput["pageSize"],
    status: value("rl-status") as ReportLayoutVariantInput["status"],
    isDefault: $<HTMLInputElement>("rl-default").checked,
    layout: jsonObjectFromField("rl-layout", layoutSeedForTemplate(reportTemplates.find((template) => template.report_template_id === value("rl-template")))),
    qualityRules: jsonObjectFromField("rl-quality", defaultQualityRules()),
  };
}

async function saveReportLayoutFromForm() {
  if (!canManageReportingUi()) return;
  const id = value("rl-id");
  try {
    const payload = reportLayoutPayloadFromForm();
    if (!payload.reportTemplateId || !payload.name) {
      toast("Template and layout name are required");
      return;
    }
    if (id) await updateReportLayoutVariant(id, payload);
    else await createReportLayoutVariant(payload);
    clearReportLayoutForm();
    await refreshReporting(false);
    toast(id ? "Report layout updated" : "Report layout created");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function fillReportLayoutForm(id: string) {
  const layout = reportLayoutVariants.find((item) => item.report_layout_variant_id === id);
  if (!layout) return;
  setValue("rl-id", layout.report_layout_variant_id);
  setValue("rl-template", layout.report_template_id);
  setValue("rl-name", layout.name);
  setValue("rl-description", layout.description || "");
  setValue("rl-theme", layout.theme);
  setValue("rl-page-size", layout.page_size);
  setValue("rl-status", layout.status);
  $<HTMLInputElement>("rl-default").checked = layout.is_default;
  setValue("rl-layout", prettyJson(layout.layout_json, layoutSeedForTemplate(reportTemplates.find((template) => template.report_template_id === layout.report_template_id))));
  setValue("rl-quality", prettyJson(layout.quality_rules_json, defaultQualityRules()));
  $("rl-name").focus();
}

function clearReportLayoutForm() {
  setValue("rl-id", "");
  setValue("rl-name", "");
  setValue("rl-description", "");
  setValue("rl-theme", "soma_board");
  setValue("rl-page-size", "a4_landscape");
  setValue("rl-status", "draft");
  $<HTMLInputElement>("rl-default").checked = false;
  seedReportLayoutFromTemplate();
}

function seedReportLayoutFromTemplate() {
  const template = reportTemplates.find((item) => item.report_template_id === value("rl-template"));
  setValue("rl-layout", JSON.stringify(layoutSeedForTemplate(template), null, 2));
  setValue("rl-quality", JSON.stringify(defaultQualityRules(), null, 2));
  if (template && !value("rl-name")) setValue("rl-name", `${template.name} - custom layout`);
}

async function retireLayoutFromView(id: string) {
  if (!canManageReportingUi()) return;
  try {
    await retireReportLayoutVariant(id);
    await refreshReporting(false);
    toast("Report layout retired");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function layoutSeedForTemplate(template?: ReportTemplate) {
  const sections = template ? parseTemplateSections(template) : ["executive_summary", "risk_appetite", "top_risks", "actions", "reviews"];
  return {
    cover: { showProgramme: true, showIssueStatus: true },
    sectionOrder: sections,
    blocks: sections.map((section, index) => ({
      id: `block-${index + 1}`,
      type: index === 0 ? "narrative" : "table",
      sectionKey: section,
      title: sectionLabel(section),
      width: "full",
      emphasis: index === 0 || section === "decisions_required" || section === "risk_appetite" || section === "qra_readiness" ? "high" : "normal",
    })),
    appendix: { includeDatasets: true },
  };
}

function renderReportDistributionLists() {
  if (!document.getElementById("reportDistributionLists")) return;
  $("reportDistributionCount").textContent = `${reportDistributionLists.filter((list) => list.status === "active").length} active lists`;
  $("reportDistributionLists").innerHTML = reportDistributionLists.length
    ? reportDistributionLists
        .slice()
        .sort((a, b) => distributionStatusRank(a) - distributionStatusRank(b) || a.audience.localeCompare(b.audience) || a.name.localeCompare(b.name))
        .map((list) => {
          const recipients = reportDistributionRecipients.filter((recipient) => recipient.report_distribution_list_id === list.report_distribution_list_id && recipient.status === "active");
          return `<div class="report-template-card${list.status === "retired" ? " inactive" : ""}">
            <div class="report-template-head">
              <div><span>${esc(audienceLabel(list.audience))}</span><b>${esc(list.name)}</b></div>
              ${statusToken(list.status, list.status === "active" ? "green" : list.status === "draft" ? "amber" : "neutral")}
            </div>
            <p>${esc(list.description || "No description")}</p>
            <div class="report-template-meta">${recipients.length} active recipients · updated ${fmtDateTime(list.updated_at)}</div>
            <div class="section-list">${recipients.slice(0, 4).map((recipient) => `<span>${esc(recipient.name || recipient.email)}</span>`).join("")}${recipients.length > 4 ? `<span>+${recipients.length - 4}</span>` : ""}</div>
            <div class="report-template-actions">
              <button class="btn" data-report-distribution-action="edit" data-report-distribution-id="${escAttr(list.report_distribution_list_id)}">Edit</button>
              <button class="btn" data-report-distribution-action="retire" data-report-distribution-id="${escAttr(list.report_distribution_list_id)}" ${list.status === "retired" ? "disabled" : ""}>Retire</button>
            </div>
          </div>`;
        })
        .join("")
    : '<div class="muted">No governed distribution lists yet.</div>';
}

function renderReportSchedules() {
  if (!document.getElementById("reportScheduler")) return;
  $("reportScheduleCount").textContent = `${reportSchedules.filter((schedule) => schedule.status === "active").length} active schedules`;
  renderReportDistributionLists();
  renderScheduleTemplateOptions();

  $("reportSchedules").innerHTML = reportSchedules.length
    ? reportSchedules
        .slice()
        .sort((a, b) => scheduleStatusRank(a) - scheduleStatusRank(b) || String(a.next_due_date || "").localeCompare(String(b.next_due_date || "")) || a.name.localeCompare(b.name))
        .map((schedule) => `<div class="report-template-card${schedule.status === "retired" ? " inactive" : ""}">
          <div class="report-template-head">
            <div><span>${esc(schedule.cadence.replace(/_/g, " "))}</span><b>${esc(schedule.name)}</b></div>
            ${statusToken(schedule.status, schedule.status === "active" ? "green" : schedule.status === "paused" ? "amber" : "neutral")}
          </div>
          <p>${esc(schedule.description || "No description")}</p>
          <div class="report-template-meta">${esc(schedule.report_template_name)} · ${esc(schedule.report_layout_variant_name || "Default layout")} · next ${schedule.next_due_date ? fmtDate(schedule.next_due_date) : "not set"}</div>
          <div class="report-pack-meta">
            <span>${esc(schedule.delivery_format.toUpperCase())}</span>
            <span>${esc(schedule.reporting_period_mode.replace(/_/g, " "))}</span>
            <span>${esc(schedule.report_distribution_list_name || schedule.recipient_group || "No distribution list")}${schedule.report_distribution_recipient_count ? ` · ${schedule.report_distribution_recipient_count}` : ""}</span>
            ${schedule.auto_issue ? statusToken("Auto-issue", "blue") : ""}
          </div>
          <div class="report-template-actions">
            <button class="btnp" data-report-schedule-action="run" data-report-schedule-id="${escAttr(schedule.report_schedule_id)}" ${schedule.status !== "active" ? "disabled" : ""}>Run now</button>
            <button class="btn" data-report-schedule-action="edit" data-report-schedule-id="${escAttr(schedule.report_schedule_id)}">Edit</button>
            <button class="btn" data-report-schedule-action="retire" data-report-schedule-id="${escAttr(schedule.report_schedule_id)}" ${schedule.status === "retired" ? "disabled" : ""}>Retire</button>
          </div>
        </div>`)
        .join("")
    : '<div class="muted">No report schedules yet.</div>';

  $("reportScheduleRuns").innerHTML = reportScheduleRuns.length
    ? reportScheduleRuns
        .slice(0, 6)
        .map((run) => `<div class="report-section-evidence">
          <span>${esc(run.run_status.slice(0, 2).toUpperCase())}</span>
          <div><b>${esc(run.report_schedule_name || "Schedule run")}</b><small>${esc(run.pack_title || run.report_run_id || "")}</small></div>
          ${statusToken(run.run_status, run.run_status === "issued" ? "green" : run.run_status === "failed" ? "red" : "blue")}
          <em>${fmtDateTime(run.completed_at || run.created_at)}</em>
        </div>`)
        .join("")
    : '<div class="muted">Run a schedule to see production evidence.</div>';

  $("reportDeliveryJobs").innerHTML = reportDeliveryJobs.length
    ? `<div class="panel-head compact-head"><h3>Delivery evidence</h3><a class="lnk" href="/api/reporting/delivery-events?format=csv" target="_blank" rel="noreferrer">Events CSV</a></div>` +
      reportDeliveryJobs
        .slice(0, 6)
        .map((job) => {
          const links = parseJsonObject(job.artifact_links_json);
          return `<div class="report-section-evidence delivery-evidence">
            <span>${esc(job.channel.slice(0, 2).toUpperCase())}</span>
            <div><b>${esc(job.subject)}</b><small>${esc(job.report_distribution_list_name || job.recipient_group || job.pack_title || "")} · ${job.recipient_count || 0} recipients${job.sent_summary ? ` · ${job.sent_summary}` : ""}</small></div>
            ${statusToken(job.status, job.status === "prepared" || job.status === "sent" ? "green" : job.status === "failed" ? "red" : "blue")}
            <em>${fmtDateTime(job.prepared_at || job.queued_at)}</em>
            <div class="report-delivery-links">
              <a class="lnk" href="${escAttr(String(links.briefing || "#"))}" target="_blank" rel="noreferrer">Briefing</a>
              <a class="lnk" href="${escAttr(String(links.html || "#"))}" target="_blank" rel="noreferrer">HTML</a>
              <a class="lnk" href="${escAttr(String(links.xlsx || "#"))}" target="_blank" rel="noreferrer">XLSX</a>
              <button class="lnk" data-delivery-send-id="${escAttr(job.report_delivery_job_id)}" ${job.status === "sent" || !job.report_distribution_list_id ? "disabled" : ""}>Dry-run send</button>
            </div>
          </div>`;
        })
        .join("")
    : '<div class="muted">No delivery packages prepared yet.</div>';
}

function renderNotificationOutbox() {
  if (!document.getElementById("notificationOutbox")) return;
  if (!value("notification-due-date")) setValue("notification-due-date", todayIso());
  const openEvents = notificationEvents.filter((event) => !["acknowledged", "dismissed", "skipped"].includes(event.status));
  const criticalEvents = openEvents.filter((event) => event.severity === "critical");
  const queuedEvents = openEvents.filter((event) => event.status === "queued");
  $("notificationOutboxCount").textContent = `${openEvents.length} open · ${criticalEvents.length} critical · ${queuedEvents.length} queued`;
  $("notificationRuleSummary").innerHTML = notificationRules.length
    ? notificationRules
        .slice()
        .sort((a, b) => a.source_type.localeCompare(b.source_type))
        .map((rule) => `<span class="notification-rule-chip">${esc(notificationSourceLabel(rule.source_type))}${statusToken(rule.severity, notificationSeverityTone(rule.severity))}<small>${esc(rule.channel.replace(/_/g, " "))}${rule.active ? "" : " · inactive"}</small></span>`)
        .join("")
    : '<span class="muted">No notification rules configured.</span>';

  $("notificationEventList").innerHTML = notificationEvents.length
    ? notificationEvents
        .slice()
        .sort((a, b) => notificationSortRank(a) - notificationSortRank(b) || String(a.due_date || "").localeCompare(String(b.due_date || "")) || String(b.created_at || "").localeCompare(String(a.created_at || "")))
        .slice(0, 12)
        .map((event) => `<div class="notification-event">
          <div class="notification-event-main">
            <span class="notification-source">${esc(notificationSourceLabel(event.source_type))}</span>
            <b>${esc(event.title)}</b>
            <small>${esc(event.message)}</small>
            <em>${esc(event.owner_name || "Unassigned")}${event.owner_email ? ` · ${esc(event.owner_email)}` : ""}</em>
          </div>
          <div class="notification-event-meta">
            ${statusToken(event.severity, notificationSeverityTone(event.severity))}
            ${statusToken(event.status, event.status === "queued" ? "blue" : event.status === "failed" ? "red" : event.status === "acknowledged" ? "green" : "neutral")}
            <span>${event.due_date ? fmtDate(event.due_date) : "No due date"}</span>
            <span>${esc(event.entity_id || event.source_code || "")}</span>
            ${notificationEventActionHtml(event)}
          </div>
        </div>`)
        .join("")
    : '<div class="muted">No notification events generated yet. Dispatch due items to populate the governed outbox.</div>';
}

async function dispatchDueNotificationsFromView() {
  if (!canManageReportingUi()) return;
  try {
    const result = await dispatchDueNotifications({
      dueDate: value("notification-due-date") || todayIso(),
      dryRun: $<HTMLInputElement>("notification-dry-run").checked,
      limit: Math.max(1, Math.min(250, Number(value("notification-limit") || 100))),
    });
    const refreshed = await loadNotifications();
    notificationRules = refreshed.rules;
    notificationEvents = refreshed.events;
    renderNotificationOutbox();
    renderReportLinks();
    toast(result.dryRun ? `${result.candidateCount} notifications would be queued` : `${result.queuedCount} notifications queued · ${result.existingCount} existing`);
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function updateNotificationEventFromView(id: string, action: string) {
  if (!id || !canManageReportingUi()) return;
  try {
    if (action === "acknowledge") await acknowledgeNotificationEvent(id, "Acknowledged from Reporting suite notification outbox.");
    else if (action === "dismiss") await dismissNotificationEvent(id, "Dismissed from Reporting suite notification outbox.");
    else return;
    const refreshed = await loadNotifications();
    notificationRules = refreshed.rules;
    notificationEvents = refreshed.events;
    renderNotificationOutbox();
    toast(action === "acknowledge" ? "Notification acknowledged" : "Notification dismissed");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function notificationEventActionHtml(event: NotificationEvent) {
  if (["acknowledged", "dismissed", "skipped"].includes(event.status)) {
    return event.acknowledged_by_name ? `<small class="notification-closed-by">${esc(event.acknowledged_by_name)}</small>` : "";
  }
  return `<div class="notification-event-actions">
    <button class="lnk" data-notification-action="acknowledge" data-notification-id="${escAttr(event.id)}">Acknowledge</button>
    <button class="lnk" data-notification-action="dismiss" data-notification-id="${escAttr(event.id)}">Dismiss</button>
  </div>`;
}

function notificationSourceLabel(sourceType: string) {
  const labels: Record<string, string> = {
    risk_review_due: "Risk review",
    action_due: "Action",
    indicator_response_due: "KRI response",
    assurance_test_due: "Assurance",
    appetite_decision_due: "Appetite",
    report_schedule_due: "Report schedule",
  };
  return labels[sourceType] || sourceType.replace(/_/g, " ");
}

function notificationSeverityTone(severity: string) {
  if (severity === "critical") return "red";
  if (severity === "high") return "amber";
  if (severity === "medium") return "blue";
  return "neutral";
}

function notificationSortRank(event: NotificationEvent) {
  const severityRank = event.severity === "critical" ? 0 : event.severity === "high" ? 1 : event.severity === "medium" ? 2 : 3;
  const statusRank = event.status === "queued" ? 0 : event.status === "failed" ? 1 : event.status === "sent" ? 2 : event.status === "acknowledged" ? 4 : 3;
  return severityRank * 10 + statusRank;
}

function renderScheduleTemplateOptions() {
  const templateSelect = $<HTMLSelectElement>("rs-template");
  const currentTemplate = templateSelect.value || reportTemplates.find((template) => template.active)?.report_template_id || reportTemplates[0]?.report_template_id || "";
  templateSelect.innerHTML = reportTemplates.length
    ? reportTemplates.map((template) => `<option value="${escAttr(template.report_template_id)}">${esc(template.name)}</option>`).join("")
    : '<option value="">No templates</option>';
  if (reportTemplates.some((template) => template.report_template_id === currentTemplate)) templateSelect.value = currentTemplate;

  const layoutSelect = $<HTMLSelectElement>("rs-layout");
  const currentLayout = layoutSelect.value;
  const layouts = reportLayoutVariants.filter((layout) => layout.report_template_id === templateSelect.value && layout.status !== "retired");
  layoutSelect.innerHTML = '<option value="">Default layout</option>' + layouts.map((layout) => `<option value="${escAttr(layout.report_layout_variant_id)}">${esc(layout.name)}${layout.is_default ? " (default)" : ""}</option>`).join("");
  if (layouts.some((layout) => layout.report_layout_variant_id === currentLayout)) layoutSelect.value = currentLayout;
  else layoutSelect.value = layouts.find((layout) => layout.is_default)?.report_layout_variant_id || "";

  const distributionSelect = $<HTMLSelectElement>("rs-distribution-list");
  const currentDistribution = distributionSelect.value;
  const activeLists = reportDistributionLists.filter((list) => list.status !== "retired");
  distributionSelect.innerHTML =
    '<option value="">No governed list</option>' +
    activeLists
      .slice()
      .sort((a, b) => distributionStatusRank(a) - distributionStatusRank(b) || a.name.localeCompare(b.name))
      .map((list) => `<option value="${escAttr(list.report_distribution_list_id)}">${esc(list.name)} (${list.active_recipient_count || 0})</option>`)
      .join("");
  if (activeLists.some((list) => list.report_distribution_list_id === currentDistribution)) distributionSelect.value = currentDistribution;
}

function reportSchedulePayloadFromForm(): ReportScheduleInput {
  return {
    name: value("rs-name"),
    description: value("rs-description"),
    reportTemplateId: value("rs-template"),
    reportLayoutVariantId: value("rs-layout") || undefined,
    reportDistributionListId: value("rs-distribution-list") || undefined,
    cadence: value("rs-cadence") as ReportScheduleInput["cadence"],
    deliveryFormat: value("rs-format") as ReportScheduleInput["deliveryFormat"],
    recipientGroup: value("rs-recipients"),
    reportingPeriodMode: value("rs-period-mode") as ReportScheduleInput["reportingPeriodMode"],
    filters: { source: "in-app-report-scheduler", qraMode: "ready" },
    autoIssue: $<HTMLInputElement>("rs-auto-issue").checked,
    status: value("rs-status") as ReportScheduleInput["status"],
    nextDueDate: value("rs-next-due"),
  };
}

async function saveReportScheduleFromForm() {
  if (!canManageReportingUi()) return;
  const id = value("rs-id");
  try {
    const payload = reportSchedulePayloadFromForm();
    if (!payload.name || !payload.reportTemplateId) {
      toast("Schedule name and template are required");
      return;
    }
    if (id) await updateReportSchedule(id, payload);
    else await createReportSchedule(payload);
    clearReportScheduleForm();
    await refreshReporting(false);
    toast(id ? "Report schedule updated" : "Report schedule created");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function fillReportScheduleForm(id: string) {
  const schedule = reportSchedules.find((item) => item.report_schedule_id === id);
  if (!schedule) return;
  setValue("rs-id", schedule.report_schedule_id);
  setValue("rs-name", schedule.name);
  setValue("rs-status", schedule.status);
  setValue("rs-template", schedule.report_template_id);
  renderScheduleTemplateOptions();
  setValue("rs-layout", schedule.report_layout_variant_id || "");
  setValue("rs-cadence", schedule.cadence);
  setValue("rs-format", schedule.delivery_format);
  setValue("rs-period-mode", schedule.reporting_period_mode);
  setValue("rs-next-due", schedule.next_due_date || "");
  setValue("rs-recipients", schedule.recipient_group || "");
  setValue("rs-distribution-list", schedule.report_distribution_list_id || "");
  setValue("rs-description", schedule.description || "");
  $<HTMLInputElement>("rs-auto-issue").checked = schedule.auto_issue;
  $("rs-name").focus();
}

function clearReportScheduleForm() {
  setValue("rs-id", "");
  setValue("rs-name", "");
  setValue("rs-status", "active");
  setValue("rs-cadence", "monthly");
  setValue("rs-format", "pdf");
  setValue("rs-period-mode", "latest_closed");
  setValue("rs-next-due", monthDate(new Date(TODAY.getFullYear(), TODAY.getMonth() + 1, 0).getDate()));
  setValue("rs-recipients", "");
  setValue("rs-distribution-list", "");
  setValue("rs-description", "");
  $<HTMLInputElement>("rs-auto-issue").checked = false;
  renderScheduleTemplateOptions();
}

function reportDistributionListPayloadFromForm(): ReportDistributionListInput {
  return {
    name: value("rdl-name"),
    description: value("rdl-description"),
    audience: value("rdl-audience") as ReportDistributionListInput["audience"],
    status: value("rdl-status") as ReportDistributionListInput["status"],
    recipients: parseDistributionRecipients(value("rdl-recipients")),
  };
}

function parseDistributionRecipients(text: string): ReportDistributionListInput["recipients"] {
  return text
    .split(/\n+/)
    .map((line, index) => {
      const parts = line
        .split(/[;,]/)
        .map((part) => part.trim())
        .filter(Boolean);
      if (!parts.length) return null;
      const first = parts[0] || "";
      const second = parts[1] || "";
      const email = (second.includes("@") ? second : first.includes("@") ? first : "").toLowerCase();
      const name = first.includes("@") ? second || first : first || email;
      if (!email) return null;
      const status = (parts[3] || "active").toLowerCase();
      return {
        name,
        email,
        role: parts[2] || "",
        status: (["active", "paused", "retired"].includes(status) ? status : "active") as ReportDistributionRecipient["status"],
        sortOrder: index + 1,
      };
    })
    .filter((recipient): recipient is ReportDistributionListInput["recipients"][number] => Boolean(recipient));
}

function distributionRecipientsToText(distributionListId: string) {
  return reportDistributionRecipients
    .filter((recipient) => recipient.report_distribution_list_id === distributionListId)
    .slice()
    .sort((a, b) => a.sort_order - b.sort_order || a.name.localeCompare(b.name))
    .map((recipient) => [recipient.name, recipient.email, recipient.role, recipient.status].filter((part) => part !== "").join(", "))
    .join("\n");
}

async function saveReportDistributionListFromForm() {
  if (!canManageReportingUi()) return;
  const id = value("rdl-id");
  try {
    const payload = reportDistributionListPayloadFromForm();
    if (!payload.name || !payload.recipients.length) {
      toast("Distribution list name and at least one recipient are required");
      return;
    }
    if (id) await updateReportDistributionList(id, payload);
    else await createReportDistributionList(payload);
    clearReportDistributionListForm();
    await refreshReporting(false);
    toast(id ? "Distribution list updated" : "Distribution list created");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function fillReportDistributionListForm(id: string) {
  const list = reportDistributionLists.find((item) => item.report_distribution_list_id === id);
  if (!list) return;
  setValue("rdl-id", list.report_distribution_list_id);
  setValue("rdl-name", list.name);
  setValue("rdl-status", list.status);
  setValue("rdl-audience", list.audience);
  setValue("rdl-description", list.description || "");
  setValue("rdl-recipients", distributionRecipientsToText(list.report_distribution_list_id));
  $("rdl-name").focus();
}

function clearReportDistributionListForm() {
  setValue("rdl-id", "");
  setValue("rdl-name", "");
  setValue("rdl-status", "active");
  setValue("rdl-audience", "board");
  setValue("rdl-description", "");
  setValue("rdl-recipients", "");
}

async function retireDistributionListFromView(id: string) {
  if (!id || !canManageReportingUi()) return;
  try {
    await retireReportDistributionList(id);
    if (value("rdl-id") === id) clearReportDistributionListForm();
    await refreshReporting(false);
    toast("Distribution list retired");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function dryRunReportDeliveryFromView(id: string) {
  if (!id || !canManageReportingUi()) return;
  try {
    const input: ReportDeliverySendInput = {
      dryRun: true,
      sendEmail: false,
      note: "Pilot dry-run from Reporting suite; recipient list and artifacts validated without sending email.",
    };
    await sendReportDeliveryJob(id, input);
    await refreshReporting(false);
    toast("Delivery dry-run recorded");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function runReportScheduleFromView(id = value("rs-id")) {
  if (!id || !canManageReportingUi()) return;
  try {
    const result = await runReportSchedule(id, {
      issueNote: value("pack-issue-note"),
      overrideIssue: Boolean(value("pack-issue-note")),
    });
    await refreshReporting(false);
    toast(`Schedule run ${result.scheduleRun.run_status}: ${result.reportPack.pack_title}`);
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function dispatchDueSchedulesFromView() {
  if (!canManageReportingUi()) return;
  try {
    const result = await dispatchDueReportSchedules({
      dueDate: todayIso(),
      limit: 10,
      dryRun: false,
      issueNote: value("pack-issue-note") || "Prepared from Reporting suite due-dispatch control.",
      overrideIssue: Boolean(value("pack-issue-note")),
    });
    await refreshReporting(false);
    toast(`Dispatch prepared ${result.processedCount} of ${result.dueCount} due schedules`);
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function retireScheduleFromView(id: string) {
  if (!id || !canManageReportingUi()) return;
  try {
    await retireReportSchedule(id);
    await refreshReporting(false);
    toast("Report schedule retired");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function defaultQualityRules() {
  return {
    requireNoCriticalIssues: true,
    requireClosedPeriodForBoard: false,
    requireQraApprovedRows: true,
    allowIssueOverride: true,
  };
}

async function logReportPackFromTemplate(id: string) {
  if (!canManageReportingUi()) return;
  const template = reportTemplates.find((item) => item.report_template_id === id);
  if (!template) return;
  try {
    await createReportRun({
      reportType: template.name,
      reportTemplateId: template.report_template_id,
      reportingPeriodId: value("rr-period") || undefined,
      format: template.output_format,
      filters: { source: "report-template-card", sections: parseTemplateSections(template), audience: template.audience },
    });
    await refreshReporting(false);
    toast(`Report pack logged: ${template.name}`);
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function deactivateTemplateFromView(id: string) {
  if (!canManageReportingUi()) return;
  try {
    await deactivateReportTemplate(id);
    await refreshReporting(false);
    toast("Report template deactivated");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function parseTemplateSections(template: ReportTemplate) {
  try {
    const parsed = JSON.parse(template.sections_json || "[]");
    return Array.isArray(parsed) ? parsed.map((item) => String(item)).filter(Boolean) : [];
  } catch {
    return [];
  }
}

function reportLayoutSectionOrder(layout: ReportLayoutVariant): string[] {
  const parsed = jsonFromText<Record<string, unknown>>(layout.layout_json, {});
  const order = Array.isArray(parsed.sectionOrder) ? parsed.sectionOrder.map((item: unknown) => String(item)).filter(Boolean) : [];
  if (order.length) return order;
  if (Array.isArray(parsed.blocks)) {
    return parsed.blocks
      .map((block: unknown) => (block && typeof block === "object" ? String((block as Record<string, unknown>).sectionKey || "") : ""))
      .filter(Boolean);
  }
  return [];
}

function jsonObjectFromField(id: string, fallback: Record<string, unknown>) {
  const text = value(id);
  if (!text) return fallback;
  const parsed = jsonFromText(text, null);
  if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) return parsed as Record<string, unknown>;
  throw new Error(`${id.replace(/-/g, " ")} must contain a JSON object`);
}

function prettyJson(text: string, fallback: Record<string, unknown>) {
  return JSON.stringify(jsonFromText(text, fallback), null, 2);
}

function jsonFromText<T>(text: string, fallback: T): T {
  try {
    return JSON.parse(text) as T;
  } catch {
    return fallback;
  }
}

function parseJsonObject(text: string) {
  const parsed = jsonFromText<Record<string, unknown> | null>(text, null);
  return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
}

function parseJsonArray<T>(text: string) {
  const parsed = jsonFromText<T[] | null>(text, null);
  return Array.isArray(parsed) ? parsed : [];
}

function layoutStatusRank(layout: ReportLayoutVariant) {
  if (layout.status === "active") return layout.is_default ? 0 : 1;
  if (layout.status === "draft") return 2;
  return 3;
}

function scheduleStatusRank(schedule: ReportSchedule) {
  if (schedule.status === "active") return 0;
  if (schedule.status === "paused") return 1;
  return 2;
}

function distributionStatusRank(list: ReportDistributionList) {
  if (list.status === "active") return 0;
  if (list.status === "draft") return 1;
  return 2;
}

function layoutThemeLabel(value: string) {
  if (value === "soma_board") return "SOMA board";
  if (value === "client_formal") return "Client formal";
  if (value === "qra_workshop") return "QRA workshop";
  if (value === "power_bi") return "Power BI";
  return audienceLabel(value);
}

function sectionLabel(key: string) {
  return REPORT_SECTION_DEFS.find((section) => section.key === key)?.label || key.replace(/_/g, " ");
}

function audienceLabel(value: string) {
  if (value === "qra_workshop") return "QRA workshop";
  if (value === "project_team") return "Project team";
  return value.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
}

function cadenceLabel(value: string) {
  if (value === "ad_hoc") return "Ad hoc";
  return audienceLabel(value);
}

function setDefaultReportingDates() {
  const start = $<HTMLInputElement>("rp-start");
  const end = $<HTMLInputElement>("rp-end");
  if (!start.value) start.value = monthDate(1);
  if (!end.value) end.value = monthDate(new Date(TODAY.getFullYear(), TODAY.getMonth() + 1, 0).getDate());
}

function canManageReportingUi() {
  return hasPermissionUi("reporting.manage");
}

function canManageControlsUi() {
  return hasPermissionUi("controls.manage");
}

function controlSortRank(control: Pick<Control, "criticality" | "effectiveness"> | Pick<RiskControl, "criticality" | "effectiveness">) {
  return criticalityRank(control.criticality) * 10 + effectivenessRank(control.effectiveness);
}

function criticalityRank(value: string) {
  if (value === "critical") return 0;
  if (value === "key") return 1;
  return 2;
}

function effectivenessRank(value: string) {
  if (value === "ineffective") return 0;
  if (value === "untested") return 1;
  if (value === "partially_effective") return 2;
  return 3;
}

function assuranceSortRank(test: AssuranceTest) {
  if (test.result === "fail") return 0;
  if (test.result === "not_run" && isPast(test.dueDate)) return 1;
  if (test.result === "partial") return 2;
  if (test.result === "not_run") return 3;
  return 4;
}

function obligationSortRank(obligation: ControlObligation) {
  if (obligation.status === "overdue" || (obligation.status === "open" && isPast(obligation.dueDate))) return 0;
  if (obligation.status === "open") return 1;
  if (obligation.status === "compliant") return 2;
  return 3;
}

function isPast(dateText: string) {
  if (!dateText) return false;
  const date = new Date(`${dateText}T00:00:00`);
  return Number.isFinite(date.getTime()) && date < TODAY;
}

function controlTypeLabel(value: string) {
  return CONTROL_TYPE_DEFS.find((item) => item.key === value)?.label || audienceLabel(value);
}

function effectivenessLabel(value: string) {
  return CONTROL_EFFECTIVENESS_DEFS.find((item) => item.key === value)?.label || audienceLabel(value);
}

function criticalityLabel(value: string) {
  return value === "key" ? "Key" : audienceLabel(value);
}

function bowtieSideLabel(value: string) {
  if (value === "cause") return "Causes / threats";
  if (value === "event") return "Event controls";
  if (value === "effect") return "Effects / consequences";
  return audienceLabel(value);
}

function assuranceStatusLabel(value: string) {
  if (value === "needs_test") return "Needs test";
  if (value === "not_tested") return "Not tested";
  return audienceLabel(value);
}

function assuranceResultLabel(value: string) {
  if (value === "not_run") return "Not run";
  return audienceLabel(value);
}

function obligationTypeLabel(value: string) {
  return audienceLabel(value);
}

function obligationStatusLabel(value: string) {
  return audienceLabel(value);
}

function effectivenessTone(value: string) {
  if (value === "effective") return "green";
  if (value === "partially_effective") return "amber";
  if (value === "ineffective") return "red";
  return "neutral";
}

function assuranceResultTone(value: string, dueDate = "") {
  if (value === "pass") return "green";
  if (value === "partial") return "amber";
  if (value === "fail") return "red";
  if (isPast(dueDate)) return "red";
  return "neutral";
}

function obligationTone(status: string, dueDate = "") {
  if (status === "compliant") return "green";
  if (status === "waived") return "neutral";
  if (status === "overdue" || isPast(dueDate)) return "red";
  return "amber";
}

function navTo(v: string) {
  document.querySelectorAll(".nav").forEach((x) => {
    const isActive = (x as HTMLElement).dataset.v === v;
    x.classList.toggle("active", isActive);
    if (isActive) x.setAttribute("aria-current", "page");
    else x.removeAttribute("aria-current");
  });
  document.querySelectorAll(".view").forEach((x) => x.classList.toggle("active", x.id === `v-${v}`));
}

function fillScale(sel: HTMLSelectElement, arr: string[]) {
  sel.innerHTML = "";
  for (let i = 1; i <= 5; i += 1) {
    const o = document.createElement("option");
    o.value = String(i);
    o.textContent = `${i} — ${arr[i]}`;
    if (i === 3) o.selected = true;
    sel.appendChild(o);
  }
}

function fillFcat() {
  const sel = $<HTMLSelectElement>("fcat");
  const v = sel.value;
  sel.innerHTML = '<option value="">All categories</option>';
  CATS.forEach((c) => {
    const o = document.createElement("option");
    o.value = c;
    o.textContent = c;
    sel.appendChild(o);
  });
  sel.value = ["", ...CATS].includes(v) ? v : "";
}

function fillCatSelect(sel: HTMLSelectElement) {
  const v = sel.value;
  sel.innerHTML = "";
  CATS.forEach((c) => {
    const o = document.createElement("option");
    o.textContent = c;
    sel.appendChild(o);
  });
  if (CATS.includes(v)) sel.value = v;
}

function filtered() {
  const q = value("search").toLowerCase();
  const fc = value("fcat");
  const fs = value("fstatus");
  const hi = $<HTMLInputElement>("fhigh").checked;
  const list = risks.filter((d) => {
    if (fc && d.cat !== fc) return false;
    if (fs && d.status !== fs) return false;
    if (hi && !isRed(post(d))) return false;
    if (q && `${d.id} ${d.title} ${d.owner} ${d.cat}`.toLowerCase().indexOf(q) < 0) return false;
    return true;
  });
  list.sort((a, b) => {
    const x = sortVal(a, sortK);
    const y = sortVal(b, sortK);
    return (x < y ? -1 : x > y ? 1 : 0) * sortDir;
  });
  return list;
}

function renderTable() {
  const list = filtered();
  const tb = $("rtb");
  tb.innerHTML = "";
  $("empty").style.display = list.length ? "none" : "block";
  list.forEach((d) => {
    const tr = document.createElement("tr");
    tr.innerHTML = `<td>${esc(d.id)}</td><td>${esc(d.title)}</td><td>${esc(d.cat)}</td><td>${esc(d.owner)}</td><td>${chip(pre(d))}</td><td>${chip(post(d))}${trendGlyph(d)} <span class="muted" style="font-size:11px">${levelName(post(d))}</span></td><td>${registerAppetiteCell(d)}</td><td>${registerForecastCell(d)}</td><td>${statusPill(d.status)}</td><td class="muted">${fmtDate(d.due)}</td>`;
    tr.addEventListener("click", () => openDetail(d));
    tb.appendChild(tr);
  });
  const exp = list.reduce((s, d) => s + d.exp, 0);
  const cnt = { low: 0, medium: 0, high: 0, critical: 0 };
  list.forEach((d) => {
    cnt[levelFor(post(d))] += 1;
  });
  $("summ").innerHTML = `Showing ${list.length} of ${risks.length} risks · residual exposure £${(exp / 1000).toFixed(2)}m · ${cnt.critical} critical, ${cnt.high} high, ${cnt.medium} medium, ${cnt.low} low`;
  updateArrows();
}

function openDetail(d: RiskRecord) {
  curD = d;
  editIdx = -1;
  riskTimelineEvents = [];
  $("m-id").textContent = d.id;
  $("m-title").textContent = d.title;
  $("m-meta").innerHTML = [
    `<span class="pill" style="background:#E6F1FB;color:#0C447C">${esc(d.cat)}</span>`,
    `<span class="pill o-open">Owner: ${esc(d.owner)}</span>`,
    statusPill(d.status),
    `<span class="pill" style="background:#eef1f4;color:#52606d">Review ${fmtDate(d.due)}</span>`,
  ].join("");
  $("m-cause").textContent = d.cause;
  $("m-event").textContent = d.event;
  $("m-effect").textContent = d.effect;
  $("m-strategy").textContent = d.strategy || "—";
  $("m-pre").innerHTML = `${chip(pre(d))} ${lvlPill(pre(d))}<div class="muted" style="margin-top:5px">${esc(LIKE[d.lpre])} × ${esc(IMP[d.ipre])}</div>`;
  $("m-post").innerHTML = `${chip(post(d))}${trendGlyph(d)} ${lvlPill(post(d))}<div class="muted" style="margin-top:5px">${esc(LIKE[d.lpost])} × ${esc(IMP[d.ipost])}</div>`;
  $("m-exp").textContent = `£${d.exp}k`;
  renderOpenRiskDetailSupplements();
  renderActions(d);
  $("m-addform").style.display = "none";
  clearActForm();
  $<HTMLTextAreaElement>("m-emailbox").style.display = "none";
  $<HTMLTextAreaElement>("m-emailbox").value = "";
  showModal("modal");
}

function openById(id: string) {
  const d = risks.find((x) => x.id === id);
  if (d) openDetail(d);
}

async function openQuantificationForRisk(id: string) {
  const risk = risks.find((item) => item.id === id);
  if (!risk) {
    toast(`Risk not found: ${id}`);
    return;
  }
  curD = risk;
  await openQuantification();
}

function renderActions(d: RiskRecord) {
  if (!d.actions.length) {
    $("m-actions").innerHTML = '<div class="action-empty">No mitigation actions yet — add one below.</div>';
    return;
  }
  $("m-actions").innerHTML = d.actions
    .map((a, idx) => {
      const done = a.status === "Done";
      const due = a.date ? `<span title="Action date">${fmtDate(a.date)}</span>` : '<span style="opacity:.65">No date</span>';
      const forecast = (a.forecastCostReduction || 0) || (a.forecastScheduleReductionDays || 0) ? `${moneyK(a.forecastCostReduction || 0)} / ${(a.forecastScheduleReductionDays || 0).toFixed(1)}d forecast` : "No forecast benefit";
      const actual = (a.actualCostReduction || 0) || (a.actualScheduleReductionDays || 0) ? `${moneyK(a.actualCostReduction || 0)} / ${(a.actualScheduleReductionDays || 0).toFixed(1)}d actual` : "No actual benefit";
      return `<div class="act">
        <span class="dot" style="background:${done ? "#0F6E56" : "#cbd5dd"}"></span>
        <div class="act-main">
          <div class="act-task">${esc(a.task)}</div>
          <div class="act-meta"><span>${esc(a.owner)}</span><span>${due}</span>${statusPill2(a.status)}${statusToken(actionPriorityLabel(a.priority), actionPriorityTone(a.priority))}${statusToken(`${a.percentComplete || 0}%`, done ? "green" : "neutral")}</div>
          <div class="action-benefit-row">
            <span>${esc(actionResponseLabel(a.responseType))}</span>
            <span>${esc(forecast)}</span>
            <span>${esc(actual)}</span>
            <span>${esc(actionEffectivenessLabel(a.effectiveness))}</span>
          </div>
          ${a.evidenceRef || a.linkedControlId || a.progressNote ? `<div class="action-evidence-row">${a.linkedControlId ? `<span>Control ${esc(a.linkedControlId)}</span>` : ""}${a.evidenceRef ? `<span>${esc(a.evidenceRef)}</span>` : ""}${a.progressNote ? `<small>${esc(a.progressNote)}</small>` : ""}</div>` : ""}
        </div>
        <div class="act-actions"><button class="lnk" data-edit="${idx}">Edit</button><button class="lnk danger-link" data-del="${idx}" aria-label="Delete action">Delete</button></div>
      </div>`;
    })
    .join("");
  $("m-actions").querySelectorAll("[data-edit]").forEach((b) => b.addEventListener("click", () => editAction(Number((b as HTMLElement).dataset.edit))));
  $("m-actions").querySelectorAll("[data-del]").forEach((b) => b.addEventListener("click", () => void deleteActionFromDetail(Number((b as HTMLElement).dataset.del))));
  applyRoleLocks();
}

function clearActForm() {
  setValue("m-atask", "");
  setValue("m-aowner", "");
  setValue("m-adue", "");
  setValue("m-abase", "");
  setValue("m-astatus", "Open");
  setValue("m-response-type", "mitigate");
  setValue("m-apriority", "medium");
  setValue("m-apct", "0");
  setValue("m-aeffect", "not_assessed");
  setValue("m-afcost", "0");
  setValue("m-aacost", "0");
  setValue("m-afdays", "0");
  setValue("m-aadays", "0");
  setValue("m-acontrol", "");
  setValue("m-aevidence", "");
  setValue("m-anote", "");
  setValue("m-acompleted", "");
  setDisabled("m-aprogress", true);
}

function editAction(i: number) {
  if (!curD) return;
  editIdx = i;
  const a = curD.actions[i];
  setValue("m-atask", a.task || "");
  setValue("m-aowner", a.owner || "");
  setValue("m-astatus", a.status || "Open");
  setValue("m-adue", a.date || "");
  setValue("m-abase", a.baselineDate || a.date || "");
  setValue("m-response-type", a.responseType || "mitigate");
  setValue("m-apriority", a.priority || "medium");
  setValue("m-apct", String(a.percentComplete || 0));
  setValue("m-aeffect", a.effectiveness || "not_assessed");
  setValue("m-afcost", String(a.forecastCostReduction || 0));
  setValue("m-aacost", String(a.actualCostReduction || 0));
  setValue("m-afdays", String(a.forecastScheduleReductionDays || 0));
  setValue("m-aadays", String(a.actualScheduleReductionDays || 0));
  setValue("m-acontrol", a.linkedControlId || "");
  setValue("m-aevidence", a.evidenceRef || "");
  setValue("m-anote", a.progressNote || "");
  setValue("m-acompleted", a.completedAt ? dateValue(a.completedAt) : "");
  $("m-asave").textContent = "Save changes";
  setDisabled("m-aprogress", false);
  $("m-addform").style.display = "block";
  $("m-atask").focus();
}

async function saveActionFromForm() {
  if (!curD) return;
  const t = value("m-atask");
  if (!t) {
    $("m-atask").focus();
    return;
  }
  const rec: ActionInput = {
    task: t,
    owner: value("m-aowner") || "Unassigned",
    status: value("m-astatus") as ActionInput["status"],
    date: value("m-adue"),
    responseType: value("m-response-type") as ActionInput["responseType"],
    priority: value("m-apriority") as ActionInput["priority"],
    baselineDate: value("m-abase"),
    percentComplete: Number(value("m-apct") || 0),
    forecastCostReduction: Number(value("m-afcost") || 0),
    forecastScheduleReductionDays: Number(value("m-afdays") || 0),
    actualCostReduction: Number(value("m-aacost") || 0),
    actualScheduleReductionDays: Number(value("m-aadays") || 0),
    effectiveness: value("m-aeffect") as ActionInput["effectiveness"],
    linkedControlId: value("m-acontrol"),
    evidenceRef: value("m-aevidence"),
    progressNote: value("m-anote"),
    completedAt: value("m-acompleted"),
    lastProgressAt: "",
  };
  try {
    const result =
      editIdx >= 0 && curD.actions[editIdx]?.id
        ? await updateAction(curD.id, curD.actions[editIdx].id, rec)
        : await createAction(curD.id, rec);
    replaceRisk(result.risk);
    curD = result.risk;
    editIdx = -1;
    $("m-qra").innerHTML = qraDetailHtml(result.risk);
    renderActions(result.risk);
    clearActForm();
    $("m-addform").style.display = "none";
    renderControlCentre();
    renderTable();
    renderDash();
    renderReviews();
    void refreshRiskTimelineForDetail(result.risk.id);
    toast("Action saved");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function recordActionProgressFromForm() {
  if (!curD || editIdx < 0 || !curD.actions[editIdx]?.id) return;
  const action = curD.actions[editIdx];
  const input: ActionProgressInput = {
    eventType: value("m-astatus") === "Done" ? "closure" : "progress_update",
    status: value("m-astatus") as ActionProgressInput["status"],
    percentComplete: Number(value("m-apct") || 0),
    forecastCostReduction: Number(value("m-afcost") || 0),
    forecastScheduleReductionDays: Number(value("m-afdays") || 0),
    actualCostReduction: Number(value("m-aacost") || 0),
    actualScheduleReductionDays: Number(value("m-aadays") || 0),
    effectiveness: value("m-aeffect") as ActionProgressInput["effectiveness"],
    evidenceRef: value("m-aevidence"),
    note: value("m-anote") || `Progress updated for ${action.task}`,
    completedAt: value("m-acompleted"),
  };
  try {
    const result = await recordActionProgress(curD.id, action.id, input);
    replaceRisk(result.risk);
    curD = result.risk;
    $("m-qra").innerHTML = qraDetailHtml(result.risk);
    renderActions(result.risk);
    renderControlCentre();
    renderTable();
    renderDash();
    renderReviews();
    void refreshRiskTimelineForDetail(result.risk.id);
    toast("Progress recorded");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function actionResponseLabel(value: string) {
  if (value === "avoid") return "Avoid";
  if (value === "transfer") return "Transfer";
  if (value === "accept") return "Accept";
  if (value === "exploit") return "Exploit";
  if (value === "enhance") return "Enhance";
  return "Mitigate";
}

function actionPriorityLabel(value: string) {
  if (value === "critical") return "Critical";
  if (value === "high") return "High";
  if (value === "low") return "Low";
  return "Medium";
}

function actionPriorityTone(value: string) {
  if (value === "critical") return "red";
  if (value === "high") return "amber";
  if (value === "low") return "green";
  return "neutral";
}

function actionEffectivenessLabel(value: string) {
  if (value === "effective") return "Effective";
  if (value === "partially_effective") return "Partially effective";
  if (value === "ineffective") return "Ineffective";
  return "Not assessed";
}

async function deleteActionFromDetail(idx: number) {
  if (!curD) return;
  const action = curD.actions[idx];
  if (!action) return;
  const ok = await confirmDestructive({
    title: "Delete mitigation action?",
    message: `This will permanently remove "${action.task}" from ${curD.id}. This cannot be undone.`,
    confirmLabel: "Delete action",
  });
  if (!ok) return;
  try {
    const result = await deleteAction(curD.id, action.id);
    replaceRisk(result.risk);
    curD = result.risk;
    $("m-qra").innerHTML = qraDetailHtml(result.risk);
    renderActions(result.risk);
    renderControlCentre();
    renderTable();
    renderDash();
    renderReviews();
    void refreshRiskTimelineForDetail(result.risk.id);
    toast("Action deleted");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function rmPreview() {
  const lp = Number(value("rm-lpre"));
  const ip = Number(value("rm-ipre"));
  const lq = Number(value("rm-lpost"));
  const iq = Number(value("rm-ipost"));
  $("rm-preview").innerHTML = `Pre ${chip(lp * ip)} ${lvlPill(lp * ip)} &nbsp;·&nbsp; Residual ${chip(lq * iq)} ${lvlPill(lq * iq)}`;
}

function openRiskForm(d: RiskRecord | null) {
  if (d) {
    riskEditId = d.id;
    $("rm-title").textContent = "Edit risk";
    setValue("rm-rtitle", d.title);
    setValue("rm-cat", d.cat);
    setValue("rm-owner", d.owner);
    setValue("rm-status", d.status);
    setValue("rm-cause", d.cause === "—" ? "" : d.cause);
    setValue("rm-event", d.event === "—" ? "" : d.event);
    setValue("rm-effect", d.effect === "—" ? "" : d.effect);
    setValue("rm-strategy", d.strategy || "");
    setValue("rm-lpre", String(d.lpre));
    setValue("rm-ipre", String(d.ipre));
    setValue("rm-lpost", String(d.lpost));
    setValue("rm-ipost", String(d.ipost));
    setValue("rm-exp", String(d.exp));
    setValue("rm-due", d.due || "");
  } else {
    riskEditId = null;
    $("rm-title").textContent = "New risk";
    setValue("rm-rtitle", "");
    $<HTMLSelectElement>("rm-cat").selectedIndex = 0;
    setValue("rm-owner", "");
    setValue("rm-status", "Open");
    setValue("rm-cause", "");
    setValue("rm-event", "");
    setValue("rm-effect", "");
    setValue("rm-strategy", "");
    setValue("rm-lpre", "3");
    setValue("rm-ipre", "3");
    setValue("rm-lpost", "3");
    setValue("rm-ipost", "3");
    setValue("rm-exp", "");
    setValue("rm-due", "");
  }
  rmPreview();
  showModal("riskmodal");
}

function closeRisk() {
  hideModal("riskmodal");
}

async function saveRiskForm() {
  const t = value("rm-rtitle");
  if (!t) {
    $("rm-rtitle").focus();
    return;
  }
  const vals: RiskInput = {
    title: t,
    cat: value("rm-cat"),
    owner: value("rm-owner") || "Unassigned",
    status: value("rm-status") as RiskInput["status"],
    cause: value("rm-cause") || "—",
    event: value("rm-event") || "—",
    effect: value("rm-effect") || "—",
    strategy: value("rm-strategy"),
    lpre: Number(value("rm-lpre")),
    ipre: Number(value("rm-ipre")),
    lpost: Number(value("rm-lpost")),
    ipost: Number(value("rm-ipost")),
    prev: riskEditId ? risks.find((risk) => risk.id === riskEditId)?.prev || Number(value("rm-lpost")) * Number(value("rm-ipost")) : Number(value("rm-lpost")) * Number(value("rm-ipost")),
    exp: Number.parseInt(value("rm-exp"), 10) || 0,
    due: value("rm-due"),
  };
  try {
    const result = riskEditId ? await updateRisk(riskEditId, vals) : await createRisk(vals);
    replaceRisk(result.risk);
    closeRisk();
    renderControlCentre();
    renderTable();
    renderDash();
    renderReviews();
    if (riskEditId) openById(riskEditId);
    riskEditId = null;
    toast("Risk saved");
  } catch (err) {
    toast(errorMessage(err));
  }
}

async function deleteCurrentRisk() {
  if (!curD) return;
  const id = curD.id;
  const ok = await confirmDestructive({
    title: "Delete risk?",
    message: `This will permanently delete ${curD.id} — ${curD.title}, including its mitigation actions. This cannot be undone.`,
    confirmLabel: "Delete risk",
  });
  if (!ok) return;
  try {
    await deleteRisk(id);
    risks = risks.filter((risk) => risk.id !== id);
    closeDetail();
    renderControlCentre();
    renderTable();
    renderDash();
    renderReviews();
    toast("Risk deleted");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function renderDash() {
  const active = risks.filter((d) => d.status !== "Closed");
  const reds = active.filter((d) => isRed(post(d))).length;
  const exp = active.reduce((s, d) => s + d.exp, 0);
  const overdue = risks.filter((d) => reviewState(d.due) === "overdue").length;
  const cards = [
    { l: "Active risks", v: active.length, act: "reg" },
    { l: "High + critical", v: `<span style="color:#A32D2D">${reds}</span>`, act: "hc", link: "View →" },
    { l: "Exposure", v: `£${(exp / 1000).toFixed(2)}m` },
    { l: "Reviews overdue", v: `<span style="color:#854F0B">${overdue}</span>`, act: "rev", link: "View →" },
  ];
  $("kpis").innerHTML = cards
    .map((k) => `<div class="kpi${k.act ? " clk" : ""}"${k.act ? ` data-act="${k.act}"` : ""}><div class="l">${k.l}${k.link ? ` <span style="float:right;color:var(--teal)">${k.link}</span>` : ""}</div><div class="v">${k.v}</div></div>`)
    .join("");
  $("kpis").querySelectorAll("[data-act]").forEach((c) =>
    c.addEventListener("click", () => {
      const a = (c as HTMLElement).dataset.act;
      if (a === "hc") {
        navTo("register");
        $<HTMLInputElement>("fhigh").checked = true;
        renderTable();
      } else if (a === "rev") {
        navTo("reviews");
      } else {
        navTo("register");
        $<HTMLInputElement>("fhigh").checked = false;
        renderTable();
      }
    }),
  );
  const imp = active.filter((d) => post(d) < d.prev).length;
  const wor = active.filter((d) => post(d) > d.prev).length;
  $("movement").innerHTML = `Since last review: <span class="down">&#9660; ${imp} improved</span> · <span class="up">&#9650; ${wor} worsened</span> · ${active.length - imp - wor} unchanged`;
  $("hm").innerHTML = heatMapHTML(active, 0);
  $("bars").innerHTML = barsHTML(active);
  const top = active.slice().sort((a, b) => b.exp - a.exp).slice(0, 5);
  $("top").innerHTML = top.map((d, i) => `<div class="row clkrow" data-id="${escAttr(d.id)}"><span class="rank">${i + 1}</span><span style="flex:1">${esc(d.title)}</span>${lvlPill(post(d))}<span class="muted">${esc(d.id)}</span><b>£${d.exp}k</b></div>`).join("");
  $("top").querySelectorAll(".clkrow").forEach((r) => r.addEventListener("click", () => openById((r as HTMLElement).dataset.id || "")));
}

function renderReviews() {
  const list = risks.slice().sort((a, b) => new Date(a.due).getTime() - new Date(b.due).getTime());
  $("revtb").innerHTML = list
    .map((d) => {
      const st = reviewState(d.due);
      const pill =
        st === "overdue"
          ? '<span class="pill" style="background:#FCEBEB;color:#A32D2D">Overdue</span>'
          : st === "soon"
            ? '<span class="pill" style="background:#FAEEDA;color:#854F0B">Due soon</span>'
            : '<span class="pill o-open">Scheduled</span>';
      return `<tr data-id="${escAttr(d.id)}"><td>${esc(d.id)}</td><td>${esc(d.title)}</td><td class="muted">${esc(d.owner)}</td><td>${fmtDate(d.due)}</td><td>${pill}</td><td><button class="btn revbtn" data-id="${escAttr(d.id)}">Open</button></td></tr>`;
    })
    .join("");
  document.querySelectorAll(".revbtn").forEach((b) =>
    b.addEventListener("click", (e) => {
      e.stopPropagation();
      openById((b as HTMLElement).dataset.id || "");
    }),
  );
}

function renderLegend() {
  const rows = [
    ["low", `1–${BANDS.low}`],
    ["medium", `${BANDS.low + 1}–${BANDS.medium}`],
    ["high", `${BANDS.medium + 1}–${BANDS.high}`],
    ["critical", `${BANDS.high + 1}–25`],
  ] as const;
  let h = rows.map((x) => `<span><span class="chip" style="background:${fillFor[x[0]]};color:${inkFor[x[0]]}">${x[1]}</span> ${LV[x[0]]}</span>`).join("");
  h += '<span style="margin-left:6px"><span class="trend down">&#9660;</span> improved &nbsp;<span class="trend up">&#9650;</span> worsened</span>';
  $("legend").innerHTML = h;
}

function collectCats() {
  const out: string[] = [];
  for (let i = 0; i < CATS.length; i += 1) {
    const el = document.getElementById(`cat${i}`) as HTMLInputElement | null;
    if (el?.value.trim()) out.push(el.value.trim());
  }
  return out;
}

function renderCats() {
  let h = "";
  CATS.forEach((c, i) => {
    h += `<div class="scl-row"><input class="scl-in" id="cat${i}" value="${escAttr(c)}" style="width:280px"/><button class="lnk" data-delcat="${i}" style="color:#A32D2D">Remove</button></div>`;
  });
  h += '<div class="scl-row"><input class="scl-in" id="catnew" placeholder="Add a category…" style="width:280px"/><button class="btn" id="cat-add">Add</button></div>';
  h += '<div style="margin-top:10px"><button class="btnp" id="cat-save">Save categories</button></div>';
  $("cats").innerHTML = h;
  $("cat-add").addEventListener("click", () => {
    const cur = collectCats();
    const v = value("catnew");
    if (v) cur.push(v);
    CATS = cur;
    renderCats();
  });
  $("cats").querySelectorAll("[data-delcat]").forEach((b) =>
    b.addEventListener("click", () => void removeCategoryFromAdmin(Number((b as HTMLElement).dataset.delcat))),
  );
  $("cat-save").addEventListener("click", () => void saveCategories());
  applyRoleLocks();
}

async function removeCategoryFromAdmin(index: number) {
  const cur = collectCats();
  const category = cur[index];
  if (!category) return;
  const inUse = risks.filter((risk) => risk.cat === category).length;
  if (inUse) {
    toast(`Category is in use: ${category}`);
    return;
  }
  const ok = await confirmDestructive({
    title: "Remove category?",
    message: `Remove "${category}" from this tenant's category list? The change is applied when you save categories.`,
    confirmLabel: "Remove category",
  });
  if (!ok) return;
  cur.splice(index, 1);
  CATS = cur;
  renderCats();
}

async function saveCategories() {
  const previous = settings.categories.slice();
  const out = collectCats();
  if (!out.length) return;

  if (out.length !== previous.length) {
    const removedInUse = previous.filter((category) => !out.includes(category) && risks.some((risk) => risk.cat === category));
    if (removedInUse.length) {
      CATS = previous;
      renderCats();
      toast(`Category is in use: ${removedInUse[0]}`);
      return;
    }
  }

  const categoryRenames =
    out.length === previous.length
      ? previous.map((from, index) => ({ from, to: out[index] })).filter((rename) => rename.from && rename.to && rename.from !== rename.to)
      : [];

  CATS = out;
  await persistSettings(categoryRenames);
  if (categoryRenames.length) {
    risks = (await loadRisks()).risks;
  }
  applyCats();
}

function applyCats() {
  fillFcat();
  fillCatSelect($<HTMLSelectElement>("rm-cat"));
  renderControlCentre();
  renderTable();
  renderCats();
}

function renderScales() {
  let h = '<div style="display:flex;gap:34px;flex-wrap:wrap">';
  h += '<div><div class="scl-h">Likelihood</div>';
  for (let i = 5; i >= 1; i -= 1) h += `<div class="scl-row"><span class="scl-n">${i}</span><input class="scl-in" id="lk${i}" value="${escAttr(LIKE[i])}"/></div>`;
  h += '</div><div><div class="scl-h">Impact</div>';
  for (let j = 5; j >= 1; j -= 1) h += `<div class="scl-row"><span class="scl-n">${j}</span><input class="scl-in" id="im${j}" value="${escAttr(IMP[j])}"/></div>`;
  h += '</div><div><div class="scl-h">Rating thresholds (score 1–25)</div>';
  h += `<div class="scl-row" style="width:210px">${lvlPillName("low")}<span class="muted" style="margin-left:auto">up to</span> <input class="scl-num" id="bLow" type="number" min="1" max="23" value="${BANDS.low}"/></div>`;
  h += `<div class="scl-row" style="width:210px">${lvlPillName("medium")}<span class="muted" style="margin-left:auto">up to</span> <input class="scl-num" id="bMed" type="number" min="2" max="24" value="${BANDS.medium}"/></div>`;
  h += `<div class="scl-row" style="width:210px">${lvlPillName("high")}<span class="muted" style="margin-left:auto">up to</span> <input class="scl-num" id="bHigh" type="number" min="3" max="24" value="${BANDS.high}"/></div>`;
  h += `<div class="scl-row" style="width:210px">${lvlPillName("critical")}<span class="muted" style="margin-left:auto">above High</span></div>`;
  h += '<div id="scl-err" class="muted" style="color:#A32D2D;display:none;margin-top:4px;font-size:12px">Thresholds must increase: Low &lt; Medium &lt; High &lt; 25.</div>';
  h += '<div style="margin-top:12px;display:flex;gap:8px"><button class="btnp" id="scl-save">Save scales</button><button class="btn" id="scl-reset">Reset to default</button></div>';
  h += "</div></div>";
  $("scales").innerHTML = h;
  $("scl-save").addEventListener("click", () => void saveScales());
  $("scl-reset").addEventListener("click", () => {
    LIKE = DEF_LIKE.slice();
    IMP = DEF_IMP.slice();
    BANDS = { low: 4, medium: 9, high: 15 };
    void persistSettings().then(applyScales);
  });
  applyRoleLocks();
}

async function saveScales() {
  const lo = Number.parseInt(value("bLow"), 10);
  const me = Number.parseInt(value("bMed"), 10);
  const hi = Number.parseInt(value("bHigh"), 10);
  if (!(lo >= 1 && lo < me && me < hi && hi < 25)) {
    $("scl-err").style.display = "block";
    return;
  }
  for (let i = 1; i <= 5; i += 1) {
    const lv = value(`lk${i}`);
    const iv = value(`im${i}`);
    if (lv) LIKE[i] = lv;
    if (iv) IMP[i] = iv;
  }
  BANDS = { low: lo, medium: me, high: hi };
  await persistSettings();
  applyScales();
}

function applyScales() {
  fillScale($<HTMLSelectElement>("rm-lpre"), LIKE);
  fillScale($<HTMLSelectElement>("rm-ipre"), IMP);
  fillScale($<HTMLSelectElement>("rm-lpost"), LIKE);
  fillScale($<HTMLSelectElement>("rm-ipost"), IMP);
  renderControlCentre();
  renderTable();
  renderDash();
  renderLegend();
  renderScales();
}

async function persistSettings(categoryRenames: Array<{ from: string; to: string }> = []) {
  try {
    const result = await saveTenantSettings({
      ...settings,
      categories: CATS,
      likelihood: LIKE,
      impact: IMP,
      bands: BANDS,
    }, categoryRenames);
    settings = result.settings;
    toast("Configuration saved");
  } catch (err) {
    toast(errorMessage(err));
  }
}

function heatMapHTML(active: RiskRecord[], cell: number) {
  const cnt: Record<string, number> = {};
  active.forEach((d) => {
    const k = `${d.lpost}-${d.ipost}`;
    cnt[k] = (cnt[k] || 0) + 1;
  });
  let hm = "";
  for (let L = 5; L >= 1; L -= 1) {
    hm += `<div class="hmrow"><div class="hmlab" title="${escAttr(LIKE[L])}">${L}</div>`;
    for (let I = 1; I <= 5; I += 1) {
      const s = L * I;
      const b = levelFor(s);
      const c = cnt[`${L}-${I}`] || 0;
      const tt = `${LIKE[L]} × ${IMP[I]} = ${s} (${levelName(s)})`;
      hm += `<div class="hmcell" title="${escAttr(tt)}" style="background:${fillFor[b]};color:${inkFor[b]}${cell ? `;height:${cell}px` : ""}">${c > 0 ? `<b>${c}</b>` : `<span style="opacity:.45">${s}</span>`}</div>`;
    }
    hm += "</div>";
  }
  hm += `<div class="axis"><div title="${escAttr(IMP[1])}">1</div><div title="${escAttr(IMP[2])}">2</div><div title="${escAttr(IMP[3])}">3</div><div title="${escAttr(IMP[4])}">4</div><div title="${escAttr(IMP[5])}">5</div></div>`;
  hm += '<div style="display:flex;justify-content:space-between;margin-top:6px;font-size:11px" class="muted"><span>&#8593; Likelihood</span><span>Impact &#8594;</span></div>';
  return hm;
}

function barsHTML(active: RiskRecord[]) {
  const agg: Record<string, number> = {};
  active.forEach((d) => {
    agg[d.cat] = (agg[d.cat] || 0) + d.exp;
  });
  const rows = Object.keys(agg)
    .map((k) => [k, agg[k]] as const)
    .filter((r) => r[1] > 0)
    .sort((a, b) => b[1] - a[1]);
  const max = rows.length ? rows[0][1] : 1;
  return rows.map((r) => `<div class="barrow"><div class="t"><span class="muted">${esc(r[0])}</span><b>£${r[1]}k</b></div><div class="bartrack"><div class="barfill" style="width:${Math.round((r[1] / max) * 100)}%"></div></div></div>`).join("");
}

function qraDetailHtml(risk: RiskRecord) {
  const readiness = riskReadiness(risk);
  const status = String(readiness.readiness_status || "Needs review");
  const missing = String(readiness.missing_fields || readiness.readiness_note || "No exceptions recorded");
  const costReady = readiness.cost_range_complete === true;
  const scheduleReady = readiness.schedule_range_complete === true;
  const probability = typeof readiness.probability_pct === "number" ? `${readiness.probability_pct}%` : "Missing";
  const mappingReady = Boolean(readiness.wbs_code && readiness.cbs_code && readiness.schedule_activity_id);
  const workflow = rowString(readiness, "quant_workflow_status") || "draft";
  const approvedVersion = rowString(readiness, "approved_quant_version_no");
  const approvedBy = rowString(readiness, "approved_by_name");
  return `
    <div class="qra-grid">
      <div class="qra-card"><span>QRA status</span>${statusToken(status, qraTone(status))}<small>${esc(missing)}</small></div>
      <div class="qra-card"><span>Probability</span>${statusToken(probability, typeof readiness.probability_pct === "number" ? "blue" : "amber")}<small>${esc(readiness.distribution_type || "No distribution selected")}</small></div>
      <div class="qra-card"><span>Cost / schedule</span>${statusToken(costReady || scheduleReady ? `${costReady ? "Cost" : ""}${costReady && scheduleReady ? " + " : ""}${scheduleReady ? "Schedule" : ""}` : "Range missing", costReady || scheduleReady ? "green" : "amber")}<small>QRA impact ranges</small></div>
      <div class="qra-card"><span>Mapping</span>${statusToken(mappingReady ? "Mapped" : "Needs WBS/CBS/activity", mappingReady ? "green" : "amber")}<small>${esc(readiness.project_code || risk.cat)}</small></div>
      <div class="qra-card"><span>Quant governance</span>${statusToken(workflowStatusLabel(workflow), workflowTone(workflow))}<small>${approvedVersion ? `Approved v${esc(approvedVersion)}${approvedBy ? ` by ${esc(approvedBy)}` : ""}` : "Approval required before QRA handoff"}</small></div>
    </div>`;
}

function riskBowtieDetailHtml(risk: RiskRecord) {
  const links = riskControls
    .filter((row) => row.riskId === risk.id)
    .sort((a, b) => controlSortRank(a) - controlSortRank(b) || bowtieSideRank(a.bowtieSide) - bowtieSideRank(b.bowtieSide) || a.controlCode.localeCompare(b.controlCode));
  if (!links.length) {
    return `<div class="risk-exposure-empty"><b>No controls mapped</b><span>Map preventive, event and recovery controls in the Controls workspace to show bow-tie coverage and assurance status here.</span></div>`;
  }
  const critical = links.filter((row) => row.criticality === "critical").length;
  const weak = links.filter((row) => row.effectiveness === "ineffective" || row.effectiveness === "untested").length;
  const assuranceExceptions = links.filter((row) => riskControlAssuranceTone(row) === "red").length;
  const openObligations = links.reduce((count, row) => count + controlObligations.filter((obligation) => obligation.controlId === row.controlId && obligation.status !== "compliant" && obligation.status !== "waived").length, 0);
  const groups: Record<BowtieSide, RiskControl[]> = {
    cause: links.filter((row) => row.bowtieSide === "cause"),
    event: links.filter((row) => row.bowtieSide === "event"),
    effect: links.filter((row) => row.bowtieSide === "effect"),
  };
  return `
    <div class="risk-bowtie-summary">
      <div><span>Mapped controls</span><b>${links.length}</b><small>${critical} critical / key controls</small></div>
      <div><span>Weak design</span><b>${weak}</b><small>Ineffective or untested controls</small></div>
      <div><span>Assurance exceptions</span><b>${assuranceExceptions}</b><small>Failed, overdue or not tested</small></div>
      <div><span>Open obligations</span><b>${openObligations}</b><small>Statutory, client or contract controls</small></div>
    </div>
    ${riskBowtieDiagramHtml(risk, groups)}
    <div class="risk-bowtie-board">
      ${(["cause", "event", "effect"] as BowtieSide[]).map((side) => riskBowtieColumnHtml(side, groups[side])).join("")}
    </div>`;
}

function riskBowtieDiagramHtml(risk: RiskRecord, groups: Record<BowtieSide, RiskControl[]>) {
  const nodeHtml = (side: BowtieSide) => {
    const rows = groups[side];
    const tone = controlCoverageSideTone(rows);
    const weak = rows.filter((row) => row.effectiveness === "ineffective" || row.effectiveness === "untested").length;
    const exceptions = rows.filter((row) => riskControlAssuranceTone(row) === "red").length;
    const note = rows.length ? `${weak} weak · ${exceptions} exceptions` : "No mapped controls";
    return `<div class="risk-bowtie-node ${escAttr(side)} tone-${escAttr(tone)}">
      <span>${esc(bowtieSideLabel(side))}</span>
      <b>${rows.length}</b>
      <small>${esc(note)}</small>
    </div>`;
  };
  return `<div class="risk-bowtie-diagram" aria-label="Bow-tie coverage diagram for ${escAttr(risk.id)}">
    ${nodeHtml("cause")}
    <div class="risk-bowtie-connector"></div>
    <div class="risk-bowtie-event-node">
      <span>${esc(risk.id)}</span>
      <b>${esc(risk.event || "Risk event")}</b>
      <small>${esc(levelName(post(risk)))} residual · ${moneyK(risk.exp)}</small>
    </div>
    <div class="risk-bowtie-connector"></div>
    ${nodeHtml("effect")}
    <div class="risk-bowtie-event-controls">${nodeHtml("event")}</div>
  </div>`;
}

function riskBowtieColumnHtml(side: BowtieSide, rows: RiskControl[]) {
  return `<div class="risk-bowtie-column ${escAttr(side)}">
    <div class="risk-bowtie-column-head"><span>${esc(bowtieSideLabel(side))}</span><b>${rows.length}</b></div>
    ${
      rows.length
        ? rows.map((row) => riskBowtieControlHtml(row)).join("")
        : '<div class="risk-bowtie-empty">No mapped controls on this side.</div>'
    }
  </div>`;
}

function riskBowtieControlHtml(row: RiskControl) {
  const tests = assuranceTests.filter((test) => test.riskControlId === row.id).sort((a, b) => assuranceSortRank(a) - assuranceSortRank(b) || (a.dueDate || "9999-12-31").localeCompare(b.dueDate || "9999-12-31"));
  const obligations = controlObligations.filter((obligation) => obligation.controlId === row.controlId && obligation.status !== "compliant" && obligation.status !== "waived").sort((a, b) => obligationSortRank(a) - obligationSortRank(b));
  const keyTest = tests[0];
  return `<div class="risk-bowtie-control tone-left-${escAttr(riskControlAssuranceTone(row))}">
    <div class="risk-bowtie-control-head">
      <div><span>${esc(row.controlCode)} · ${esc(controlTypeLabel(row.linkType))}</span><b>${esc(row.controlName)}</b></div>
      ${statusToken(assuranceStatusLabel(row.assuranceStatus), riskControlAssuranceTone(row))}
    </div>
    <p>${esc(row.coverageNotes || "No coverage note recorded.")}</p>
    <div class="control-card-meta">
      <span>${esc(criticalityLabel(row.criticality))}</span>
      <span>${esc(effectivenessLabel(row.effectiveness))}</span>
      <span>${esc(row.controlOwner || "No owner")}</span>
      <span>${esc(row.nextTestDue ? `Next ${fmtDate(row.nextTestDue)}` : "No test date")}</span>
    </div>
    ${
      keyTest
        ? `<div class="risk-bowtie-test">${statusToken(assuranceResultLabel(keyTest.result), assuranceResultTone(keyTest.result, keyTest.dueDate))}<span>${esc(keyTest.testName)}</span><small>${esc(keyTest.evidenceRef || keyTest.notes || "No evidence reference")}</small></div>`
        : '<div class="risk-bowtie-test muted">No assurance test recorded for this control link.</div>'
    }
    ${
      obligations.length
        ? `<div class="risk-bowtie-obligations">${obligations.slice(0, 2).map((obligation) => `<span>${esc(obligation.reference || obligationTypeLabel(obligation.obligationType))} · ${esc(obligationStatusLabel(obligation.status))}</span>`).join("")}</div>`
        : ""
    }
  </div>`;
}

function bowtieSideRank(value: string) {
  if (value === "cause") return 0;
  if (value === "event") return 1;
  return 2;
}

function riskControlAssuranceTone(row: RiskControl) {
  if (row.assuranceStatus === "failed" || row.assuranceStatus === "overdue" || isPast(row.nextTestDue)) return "red";
  if (row.assuranceStatus === "needs_test" || row.assuranceStatus === "not_tested") return "amber";
  if (row.assuranceStatus === "assured") return "green";
  return "neutral";
}

function renderOpenRiskDetailSupplements() {
  if (!curD || !document.getElementById("m-exposure-profile")) return;
  $("m-bowtie").innerHTML = riskBowtieDetailHtml(curD);
  $("m-qra").innerHTML = qraDetailHtml(curD);
  $("m-appetite").innerHTML = riskAppetiteHtml(curD);
  $("m-workshops").innerHTML = riskWorkshopDecisionHtml(curD);
  $("m-indicators").innerHTML = riskIndicatorHtml(curD);
  renderIndicatorAdmin();
  $("m-exposure-profile").innerHTML = riskExposureProfileHtml(curD);
  $("m-object-governance").innerHTML = riskObjectGovernanceHtml(curD);
  renderRiskTimeline(curD.id);
  void refreshRiskTimelineForDetail(curD.id);
}

async function refreshRiskTimelineForDetail(riskId = curD?.id || "") {
  if (!riskId || !document.getElementById("m-timeline")) return;
  const target = $("m-timeline");
  target.innerHTML = `<div class="risk-exposure-empty"><b>Loading risk history</b><span>Collecting action progress, QRA workflow, indicators, escalations, workshops and audit events.</span></div>`;
  try {
    const result = await loadRiskTimeline(riskId);
    if (!curD || curD.id !== result.riskId) return;
    riskTimelineEvents = result.events;
    renderRiskTimeline(result.riskId);
  } catch (err) {
    target.innerHTML = `<div class="risk-exposure-empty"><b>Timeline unavailable</b><span>${esc(errorMessage(err))}</span></div>`;
  }
}

function renderRiskTimeline(riskId = curD?.id || "") {
  const target = document.getElementById("m-timeline");
  if (!target || !riskId) return;
  const rows = riskTimelineEvents
    .filter((event) => event.riskId === riskId)
    .sort((a, b) => Date.parse(b.eventAt || "") - Date.parse(a.eventAt || ""))
    .slice(0, 16);
  if (!rows.length) {
    target.innerHTML = `<div class="risk-exposure-empty"><b>No timeline events loaded</b><span>Open actions, QRA reviews, indicators, escalations, workshops or audited edits will appear here.</span></div>`;
    return;
  }
  const sourceCounts = rows.reduce<Record<string, number>>((acc, row) => {
    acc[row.source] = (acc[row.source] || 0) + 1;
    return acc;
  }, {});
  target.innerHTML = `
    <div class="risk-timeline-summary">
      <div><span>Events shown</span><b>${rows.length}</b><small>Latest first</small></div>
      <div><span>Sources</span><b>${Object.keys(sourceCounts).length}</b><small>${esc(Object.keys(sourceCounts).join(", "))}</small></div>
      <div><span>Latest activity</span><b>${esc(fmtDateTime(rows[0].eventAt) || "-")}</b><small>${esc(rows[0].source)}</small></div>
    </div>
    <div class="risk-timeline-list">
      ${rows.map((event) => riskTimelineEventHtml(event)).join("")}
    </div>`;
}

function riskTimelineEventHtml(event: RiskTimelineEvent) {
  const meta = [event.actor, fmtDateTime(event.eventAt)].filter(Boolean).join(" · ");
  return `
    <div class="risk-timeline-event tone-left-${escAttr(event.tone)}">
      <div class="risk-timeline-marker">${esc(timelineSourceInitial(event.source))}</div>
      <div class="risk-timeline-content">
        <div class="risk-timeline-top">
          <div><span>${esc(event.source)}</span><b>${esc(event.title || event.eventType)}</b></div>
          ${event.status ? statusToken(event.status, event.tone) : ""}
        </div>
        <p>${esc(event.summary || "No narrative recorded.")}</p>
        <div class="risk-timeline-meta">
          ${meta ? `<span>${esc(meta)}</span>` : ""}
          ${event.evidenceRef ? `<span>${esc(event.evidenceRef)}</span>` : ""}
          ${event.qraImpact ? `<span>${esc(event.qraImpact)}</span>` : ""}
        </div>
      </div>
    </div>`;
}

function timelineSourceInitial(source: string) {
  if (/qra/i.test(source)) return "Q";
  if (/indicator/i.test(source)) return "K";
  if (/action/i.test(source)) return "A";
  if (/escalation/i.test(source)) return "E";
  if (/workshop/i.test(source)) return "W";
  return "L";
}

function registerAppetiteCell(risk: RiskRecord) {
  const row = riskAppetiteForRisk(risk.id);
  if (!row) return `<div class="forecast-cell">${statusToken("Not assessed", "neutral")}<small>Framework pending</small></div>`;
  return `<div class="forecast-cell">${statusToken(row.appetite_label || appetiteStatusLabel(row.appetite_status), appetiteTone(row.appetite_status))}<small>${row.escalation_required ? esc(row.escalation_forum || "Escalate") : esc(row.decision_due_status || "Within tolerance")}</small></div>`;
}

function registerForecastCell(risk: RiskRecord) {
  const current = riskExposureState(risk.id, "current");
  const target = riskExposureState(risk.id, "target");
  const currentCost = rowNullableNumber(current, "expected_cost");
  const targetCost = rowNullableNumber(target, "expected_cost");
  const currentSchedule = rowNullableNumber(current, "expected_schedule_days");
  const targetSchedule = rowNullableNumber(target, "expected_schedule_days");
  const costDelta = nullableDelta(currentCost, targetCost);
  const scheduleDelta = nullableDelta(currentSchedule, targetSchedule);
  const ready = target && rowString(target, "data_quality_status") === "ready";
  const label = costDelta != null ? `${costDelta >= 0 ? "-" : "+"}${moneyK(Math.abs(Math.round(costDelta)))}` : targetCost != null ? moneyK(Math.round(targetCost)) : "Not set";
  const schedule = scheduleDelta != null ? `${scheduleDelta >= 0 ? "-" : "+"}${Math.abs(scheduleDelta).toFixed(1)}d` : targetSchedule != null ? `${targetSchedule.toFixed(1)}d` : "";
  return `<div class="forecast-cell">${statusToken(label, ready ? "green" : target ? "amber" : "neutral")}<small>${schedule || "Target exposure required"}</small></div>`;
}

function riskAppetiteHtml(risk: RiskRecord) {
  const row = riskAppetiteForRisk(risk.id);
  if (!row) {
    return `<div class="risk-exposure-empty"><b>No appetite assessment available</b><span>Refresh reporting after the appetite framework migration to calculate tolerance position.</span></div>`;
  }
  const reasons = parseListText(row.breach_reasons);
  const events = riskEscalationEvents.filter((event) => event.risk_id === risk.id).slice(0, 4);
  const expectedCost = row.current_expected_cost_k == null ? "Not quantified" : moneyK(Math.round(row.current_expected_cost_k));
  const expectedSchedule = row.current_expected_schedule_days == null ? "Not quantified" : `${Number(row.current_expected_schedule_days).toFixed(1)}d`;
  return `
    <div class="risk-appetite-summary ${appetiteClass(row.appetite_status)}">
      <div class="risk-appetite-main">
        <span>Appetite status</span>
        <b>${esc(row.appetite_label || appetiteStatusLabel(row.appetite_status))}</b>
        <small>${esc(row.threshold_label || "Active appetite framework")} · ${row.escalation_required ? "Escalation required" : "No escalation required"}</small>
      </div>
      <div class="risk-appetite-metrics">
        <div><span>Residual</span><b>${row.residual_score}</b><small>${esc(levelName(row.residual_score))}</small></div>
        <div><span>Exposure</span><b>${moneyK(row.residual_exposure_k)}</b><small>Qualitative register</small></div>
        <div><span>Expected cost</span><b>${esc(expectedCost)}</b><small>Current QRA state</small></div>
        <div><span>Expected schedule</span><b>${esc(expectedSchedule)}</b><small>Current QRA state</small></div>
      </div>
    </div>
    <div class="risk-appetite-grid">
      <div class="risk-appetite-card"><span>Escalation forum</span><b>${esc(row.escalation_forum || "-")}</b><small>${esc(row.escalation_level || "No escalation level")}</small></div>
      <div class="risk-appetite-card"><span>Decision due</span><b>${esc(row.decision_due_date ? fmtDate(row.decision_due_date) : "No date")}</b><small>${esc(row.decision_due_status || "")}</small></div>
      <div class="risk-appetite-card"><span>QRA gate</span><b>${row.qra_required ? "Required" : "Not required"}</b><small>${row.qra_required ? "Include in QRA review / challenge" : "Monitor through reviews"}</small></div>
      <div class="risk-appetite-card"><span>Latest event</span><b>${esc(row.latest_escalation_event_type ? appetiteEventLabel(row.latest_escalation_event_type) : "None")}</b><small>${esc(row.latest_escalation_decision || "No decision recorded")}</small></div>
    </div>
    <div class="risk-appetite-section-title">Breach reasons</div>
    <div class="risk-appetite-reasons">
      ${reasons.length ? reasons.map((reason) => `<span>${esc(reason)}</span>`).join("") : "<span>Within tolerance on current available data.</span>"}
    </div>
    <div class="risk-appetite-section-title">Escalation history</div>
    <div class="risk-appetite-events">
      ${events.length ? events.map((event) => `<div><b>${esc(appetiteEventLabel(event.event_type))}</b><span>${esc(event.decision || event.note || "-")}</span><small>${fmtDateTime(event.created_at)}</small></div>`).join("") : '<div class="muted">No escalation event history.</div>'}
    </div>`;
}

function riskWorkshopDecisionHtml(risk: RiskRecord) {
  const rows = riskWorkshopDecisions
    .filter((row) => row.risk_id === risk.id || row.entity_code === risk.id)
    .sort((a, b) => workshopDecisionRank(a) - workshopDecisionRank(b) || dateValue(a.due_date).localeCompare(dateValue(b.due_date)))
    .slice(0, 5);
  if (!rows.length) {
    return `<div class="risk-exposure-empty"><b>No workshop decisions linked</b><span>QRA challenge, mitigation review and board decision outputs will appear here when linked to this risk.</span></div>`;
  }
  return `
    <div class="risk-workshop-list">
      ${rows.map((row) => `
        <div class="risk-workshop-item ${row.status === "open" || row.status === "in_progress" ? "open" : "closed"}">
          <div>
            <b>${esc(row.decision_label || row.decision_type)}</b>
            <span>${esc(row.decision)}</span>
            <small>${esc(row.workshop_code)} · ${esc(row.workshop_title)}</small>
          </div>
          <div>
            ${statusToken(row.qra_impact_label || row.qra_impact, row.qra_impact && row.qra_impact !== "none" ? "blue" : "neutral")}
            <small>${esc(row.owner || "Unassigned")} · ${esc(row.due_date ? fmtDate(row.due_date) : "No due date")} · ${esc(row.due_status || "")}</small>
          </div>
        </div>
      `).join("")}
    </div>`;
}

function workshopDecisionRank(row: RiskWorkshopDecision) {
  if (row.status === "open") return 0;
  if (row.status === "in_progress") return 1;
  if (row.qra_impact && row.qra_impact !== "none") return 2;
  return 3;
}

function riskIndicatorHtml(risk: RiskRecord) {
  const rows = riskIndicators
    .filter((row) => row.risk_id === risk.id)
    .sort((a, b) => riskIndicatorRank(a) - riskIndicatorRank(b) || dateValue(a.review_due).localeCompare(dateValue(b.review_due)))
    .slice(0, 6);
  if (!rows.length) {
    return `<div class="risk-exposure-empty"><b>No indicators linked</b><span>KRIs, trigger thresholds, source-system alerts and QRA-impact signals will appear here when configured for this risk.</span></div>`;
  }
  const red = rows.filter((row) => row.status === "red").length;
  const qraAlerts = rows.filter((row) => row.qra_impact && row.qra_impact !== "none").length;
  const manage = canManageIndicatorsUi();
  const record = canRecordIndicatorEventsUi();
  return `
    <div class="risk-indicator-summary">
      <div><span>Indicators</span><b>${rows.length}</b><small>${red} red threshold${red === 1 ? "" : "s"}</small></div>
      <div><span>QRA impact</span><b>${qraAlerts}</b><small>Probability, impact or candidate review</small></div>
      <div><span>Latest event</span><b>${esc(rows[0].latest_event_type ? indicatorLabel(rows[0].latest_event_type) : "No event")}</b><small>${esc(rows[0].latest_event_decision || rows[0].note || "No decision recorded")}</small></div>
    </div>
    <div class="risk-indicator-list">
      ${rows.map((row) => `
        <div class="risk-indicator-item ${escAttr(row.status || "normal")}">
          <div>
            <span>${esc(row.indicator_code)} · ${esc(row.metric_type_label || indicatorLabel(row.metric_type))}</span>
            <b>${esc(row.name)}</b>
            <small>${esc(row.description || row.note || "No description")}</small>
          </div>
          <div class="risk-indicator-reading">
            ${statusToken(row.status_label || indicatorLabel(row.status), riskIndicatorTone(row.status))}
            <b>${formatIndicatorValue(row.current_value, row.unit)}</b>
            <small>${esc(row.trend_label || indicatorLabel(row.trend))} · target ${formatIndicatorValue(row.target_value, row.unit)}</small>
          </div>
          <div>
            ${statusToken(row.qra_impact_label || indicatorLabel(row.qra_impact), row.qra_impact && row.qra_impact !== "none" ? "blue" : "neutral")}
            <small>${esc(row.owner || "Unassigned")} · ${esc(row.review_due ? fmtDate(row.review_due) : "No review due")} · ${esc(row.review_due_status || "")}</small>
            ${manage || record ? `<div class="risk-indicator-actions">${manage ? `<button class="lnk" data-indicator-edit="${escAttr(row.indicator_id)}">Edit</button>` : ""}${record ? `<button class="lnk" data-indicator-event="${escAttr(row.indicator_id)}">Event</button>` : ""}</div>` : ""}
          </div>
        </div>
      `).join("")}
    </div>`;
}

function renderIndicatorAdmin() {
  if (!curD || !document.getElementById("m-indicator-admin")) return;
  const canManage = canManageIndicatorsUi();
  const canRecord = canRecordIndicatorEventsUi();
  const indicators = riskIndicators.filter((row) => row.risk_id === curD?.id).sort((a, b) => riskIndicatorRank(a) - riskIndicatorRank(b) || String(a.indicator_code).localeCompare(String(b.indicator_code)));
  const selected = indicators.find((row) => row.indicator_id === indicatorEditId) || null;
  if (!canManage && !canRecord) {
    $("m-indicator-admin").innerHTML = `<div class="risk-exposure-empty"><b>Indicator management is read-only</b><span>Viewer users can inspect warning signals and reporting outputs but cannot change threshold evidence.</span></div>`;
    return;
  }
  const activeId = selected?.indicator_id || "";
  $("m-indicator-admin").innerHTML = `
    <div class="risk-indicator-admin-grid">
      <div class="risk-indicator-form">
        <div class="panel-head"><h4>${selected ? "Edit indicator" : "Create indicator"}</h4><button class="lnk" id="mi-clear">Clear</button></div>
        <input id="mi-id" type="hidden" value="${escAttr(activeId)}"/>
        <div class="indicator-form-grid">
          <div class="field"><label>Code</label><input id="mi-code" ${canManage ? "" : "disabled"} value="${escAttr(selected?.indicator_code || nextIndicatorCode(curD))}"/></div>
          <div class="field"><label>Type</label><select id="mi-type" ${canManage ? "" : "disabled"}>${indicatorOptions(["kri", "trigger", "performance", "control", "external"], selected?.metric_type || "kri")}</select></div>
          <div class="field wide"><label>Name</label><input id="mi-name" ${canManage ? "" : "disabled"} value="${escAttr(selected?.name || "")}" placeholder="Indicator name"/></div>
          <div class="field"><label>Status</label><select id="mi-status" ${canManage ? "" : "disabled"}>${indicatorOptions(["normal", "watch", "amber", "red", "closed", "retired"], selected?.status || "watch")}</select></div>
          <div class="field"><label>Trend</label><select id="mi-trend" ${canManage ? "" : "disabled"}>${indicatorOptions(["improving", "stable", "worsening", "new"], selected?.trend || "stable")}</select></div>
          <div class="field"><label>Unit</label><input id="mi-unit" ${canManage ? "" : "disabled"} value="${escAttr(selected?.unit || "")}" placeholder="%, days, £k"/></div>
          <div class="field"><label>Current</label><input id="mi-current" type="number" step="0.1" ${canManage ? "" : "disabled"} value="${numberText(selected?.current_value ?? null)}"/></div>
          <div class="field"><label>Previous</label><input id="mi-prev" type="number" step="0.1" ${canManage ? "" : "disabled"} value="${numberText(selected?.previous_value ?? null)}"/></div>
          <div class="field"><label>Target</label><input id="mi-target" type="number" step="0.1" ${canManage ? "" : "disabled"} value="${numberText(selected?.target_value ?? null)}"/></div>
          <div class="field"><label>Adverse direction</label><select id="mi-th-dir" ${canManage ? "" : "disabled"}>${indicatorOptions(["above", "below"], selected?.threshold_direction || "above")}</select></div>
          <div class="field"><label>Green</label><input id="mi-green" type="number" step="0.1" ${canManage ? "" : "disabled"} value="${numberText(selected?.green_threshold ?? null)}"/></div>
          <div class="field"><label>Amber</label><input id="mi-amber" type="number" step="0.1" ${canManage ? "" : "disabled"} value="${numberText(selected?.amber_threshold ?? null)}"/></div>
          <div class="field"><label>Red</label><input id="mi-red" type="number" step="0.1" ${canManage ? "" : "disabled"} value="${numberText(selected?.red_threshold ?? null)}"/></div>
          <div class="field"><label>Owner</label><input id="mi-owner" ${canManage ? "" : "disabled"} value="${escAttr(selected?.owner || curD.owner)}"/></div>
          <div class="field"><label>Source</label><input id="mi-source" ${canManage ? "" : "disabled"} value="${escAttr(selected?.source_system || "")}" placeholder="P6, cost report, tracker"/></div>
          <div class="field"><label>Measured</label><input id="mi-measured" type="date" ${canManage ? "" : "disabled"} value="${escAttr(dateValue(selected?.measured_at))}"/></div>
          <div class="field"><label>Review due</label><input id="mi-review" type="date" ${canManage ? "" : "disabled"} value="${escAttr(dateValue(selected?.review_due))}"/></div>
          <div class="field"><label>QRA impact</label><select id="mi-qra" ${canManage ? "" : "disabled"}>${indicatorOptions(["none", "probability_review", "impact_review", "include_candidate", "srs_escalation"], selected?.qra_impact || "none")}</select></div>
          <div class="field wide"><label>Description</label><textarea id="mi-description" ${canManage ? "" : "disabled"}>${esc(selected?.description || "")}</textarea></div>
          <div class="field wide"><label>Response required</label><textarea id="mi-response" ${canManage ? "" : "disabled"}>${esc(selected?.response_required || "")}</textarea></div>
          <div class="field wide"><label>Note</label><textarea id="mi-note" ${canManage ? "" : "disabled"}>${esc(selected?.note || "")}</textarea></div>
        </div>
        <div class="structure-actions"><span class="form-msg" id="mi-message"></span>${canManage && selected ? '<button class="btn danger" id="mi-retire">Retire</button>' : ""}${canManage ? '<button class="btnp" id="mi-save">Save indicator</button>' : ""}</div>
      </div>
      <div class="risk-indicator-event-form">
        <div class="panel-head"><h4>Record event</h4><span class="muted">${selected ? esc(selected.indicator_code) : "Select an indicator"}</span></div>
        <div class="indicator-form-grid">
          <div class="field"><label>Event type</label><select id="mi-event-type" ${canRecord && selected ? "" : "disabled"}>${indicatorOptions(["measurement", "threshold_breach", "review", "response_required", "waiver", "closed"], "measurement")}</select></div>
          <div class="field"><label>Value</label><input id="mi-event-value" type="number" step="0.1" ${canRecord && selected ? "" : "disabled"} value="${numberText(selected?.current_value ?? null)}"/></div>
          <div class="field"><label>New status</label><select id="mi-event-status" ${canRecord && selected ? "" : "disabled"}>${indicatorOptions(["", "normal", "watch", "amber", "red", "closed"], selected?.status || "")}</select></div>
          <div class="field"><label>Response due</label><input id="mi-event-due" type="date" ${canRecord && selected ? "" : "disabled"} value="${escAttr(dateValue(selected?.review_due))}"/></div>
          <div class="field"><label>QRA impact</label><select id="mi-event-qra" ${canRecord && selected ? "" : "disabled"}>${indicatorOptions(["", "none", "probability_review", "impact_review", "include_candidate", "srs_escalation"], selected?.qra_impact || "")}</select></div>
          <div class="field wide"><label>Response required</label><textarea id="mi-event-response" ${canRecord && selected ? "" : "disabled"}>${esc(selected?.response_required || "")}</textarea></div>
          <div class="field wide"><label>Decision</label><textarea id="mi-event-decision" ${canRecord && selected ? "" : "disabled"} placeholder="Decision, escalation or interpretation"></textarea></div>
          <div class="field wide"><label>Note</label><textarea id="mi-event-note" ${canRecord && selected ? "" : "disabled"} placeholder="Observed evidence, source extract or follow-up note"></textarea></div>
        </div>
        <div class="structure-actions">${canRecord ? '<button class="btnp" id="mi-event-save" ' + (selected ? "" : "disabled") + ">Record event</button>" : ""}</div>
      </div>
    </div>`;
}

async function saveIndicatorFromDetail() {
  if (!curD) return;
  try {
    const payload = indicatorPayloadFromForm(curD);
    const id = value("mi-id");
    const result = id ? await updateRiskIndicator(id, payload) : await createRiskIndicator(payload);
    indicatorEditId = result.item.indicator_id;
    await refreshIndicatorsForDetail();
    toast(id ? "Indicator updated" : "Indicator created");
  } catch (err) {
    setIndicatorMessage(errorMessage(err));
    toast(errorMessage(err));
  }
}

async function retireIndicatorFromDetail() {
  const id = value("mi-id");
  if (!id) return;
  try {
    await retireRiskIndicator(id);
    indicatorEditId = "";
    await refreshIndicatorsForDetail();
    toast("Indicator retired");
  } catch (err) {
    setIndicatorMessage(errorMessage(err));
    toast(errorMessage(err));
  }
}

async function recordIndicatorEventFromDetail() {
  const id = value("mi-id");
  if (!id) {
    setIndicatorMessage("Select an indicator first");
    return;
  }
  try {
    const payload: RiskIndicatorEventInput = {
      eventType: value("mi-event-type") as RiskIndicatorEventInput["eventType"],
      value: numberField("mi-event-value"),
      status: value("mi-event-status") as RiskIndicatorEventInput["status"],
      decision: value("mi-event-decision"),
      note: value("mi-event-note"),
      dueDate: value("mi-event-due"),
      reviewDue: value("mi-event-due"),
      responseRequired: value("mi-event-response"),
      qraImpact: value("mi-event-qra") as RiskIndicatorEventInput["qraImpact"],
    };
    await recordRiskIndicatorEvent(id, payload);
    await refreshIndicatorsForDetail();
    toast("Indicator event recorded");
  } catch (err) {
    setIndicatorMessage(errorMessage(err));
    toast(errorMessage(err));
  }
}

function indicatorPayloadFromForm(risk: RiskRecord): RiskIndicatorInput {
  return {
    riskId: risk.id,
    indicatorCode: value("mi-code"),
    name: value("mi-name"),
    description: value("mi-description"),
    metricType: value("mi-type") as RiskIndicatorInput["metricType"],
    unit: value("mi-unit"),
    thresholdDirection: value("mi-th-dir") as RiskIndicatorInput["thresholdDirection"],
    greenThreshold: numberField("mi-green"),
    amberThreshold: numberField("mi-amber"),
    redThreshold: numberField("mi-red"),
    currentValue: numberField("mi-current"),
    previousValue: numberField("mi-prev"),
    targetValue: numberField("mi-target"),
    status: value("mi-status") as RiskIndicatorInput["status"],
    trend: value("mi-trend") as RiskIndicatorInput["trend"],
    owner: value("mi-owner"),
    sourceSystem: value("mi-source"),
    measuredAt: value("mi-measured"),
    reviewDue: value("mi-review"),
    responseRequired: value("mi-response"),
    qraImpact: value("mi-qra") as RiskIndicatorInput["qraImpact"],
    note: value("mi-note"),
  };
}

async function refreshIndicatorsForDetail() {
  const [indicators, indicatorEvents] = await Promise.all([loadManagedRiskIndicators(), loadRiskIndicatorEvents()]);
  riskIndicators = indicators.items;
  riskIndicatorEvents = indicatorEvents.rows;
  if (curD) {
    $("m-indicators").innerHTML = riskIndicatorHtml(curD);
    renderIndicatorAdmin();
    void refreshRiskTimelineForDetail(curD.id);
  }
  renderReportSuite();
}

function setIndicatorMessage(message: string) {
  const el = document.getElementById("mi-message");
  if (el) el.textContent = message;
}

function nextIndicatorCode(risk: RiskRecord) {
  const count = riskIndicators.filter((row) => row.risk_id === risk.id).length + 1;
  return `KRI-${risk.id.replace(/[^A-Z0-9]/gi, "")}-${String(count).padStart(2, "0")}`;
}

function indicatorOptions(values: string[], current: string) {
  return values.map((value) => `<option value="${escAttr(value)}" ${value === current ? "selected" : ""}>${esc(value ? indicatorLabel(value) : "No change")}</option>`).join("");
}

function canManageIndicatorsUi() {
  return hasPermissionUi("indicators.manage");
}

function canRecordIndicatorEventsUi() {
  return hasPermissionUi("indicators.event.record");
}

function riskIndicatorRank(row: RiskIndicator) {
  if (row.status === "red") return 0;
  if (row.status === "amber") return 1;
  if (row.status === "watch") return 2;
  if (row.qra_impact && row.qra_impact !== "none") return 3;
  return 4;
}

function riskIndicatorTone(status: string) {
  if (status === "red") return "red";
  if (status === "amber" || status === "watch") return "amber";
  if (status === "normal") return "green";
  return "neutral";
}

function indicatorLabel(value: string) {
  if (!value) return "None";
  return value.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
}

function formatIndicatorValue(value: unknown, unit: unknown) {
  if (value == null || value === "") return "-";
  const numeric = Number(value);
  const formatted = Number.isFinite(numeric) ? `${Math.round(numeric * 10) / 10}` : esc(String(value));
  const unitText = String(unit || "");
  return `${formatted}${unitText && unitText.length <= 3 ? unitText : unitText ? ` ${esc(unitText)}` : ""}`;
}

function riskExposureProfileHtml(risk: RiskRecord) {
  const rows = EXPOSURE_STATE_DEFS.map((state) => riskExposureState(risk.id, state.key));
  const hasRows = rows.some(Boolean);
  if (!hasRows) {
    return `
      <div class="risk-exposure-empty">
        <b>No lifecycle exposure states captured</b>
        <span>Add inherent, current, target and actual exposure ranges before relying on this risk for QRA, board reporting or mitigation benefit tracking.</span>
      </div>`;
  }
  const current = riskExposureState(risk.id, "current");
  const target = riskExposureState(risk.id, "target");
  const actual = riskExposureState(risk.id, "post_mitigation");
  const costReduction = nullableDelta(rowNullableNumber(current, "expected_cost"), rowNullableNumber(target, "expected_cost"));
  const scheduleReduction = nullableDelta(rowNullableNumber(current, "expected_schedule_days"), rowNullableNumber(target, "expected_schedule_days"));
  const actualCostVariance = nullableDelta(rowNullableNumber(target, "expected_cost"), rowNullableNumber(actual, "expected_cost"));
  const actualScheduleVariance = nullableDelta(rowNullableNumber(target, "expected_schedule_days"), rowNullableNumber(actual, "expected_schedule_days"));
  return `
    <div class="risk-exposure-summary">
      <div><span>Forecast cost buy-down</span><b>${costReduction == null ? "-" : moneyK(Math.round(costReduction))}</b><small>Current residual less target forecast</small></div>
      <div><span>Forecast schedule buy-down</span><b>${scheduleReduction == null ? "-" : `${scheduleReduction.toFixed(1)}d`}</b><small>Current residual less target forecast</small></div>
      <div><span>Actual vs target</span><b>${actualCostVariance == null ? "-" : moneyK(Math.round(actualCostVariance))}</b><small>${actualScheduleVariance == null ? "Actual captured after mitigation" : `${actualScheduleVariance.toFixed(1)}d schedule variance`}</small></div>
    </div>
    <div class="risk-exposure-states">
      ${EXPOSURE_STATE_DEFS.map((state) => riskExposureStateCardHtml(state, riskExposureState(risk.id, state.key))).join("")}
    </div>`;
}

function riskExposureStateCardHtml(stateDef: (typeof EXPOSURE_STATE_DEFS)[number], row: ReportingRow | undefined) {
  const probability = rowNullableNumber(row, "probability_pct");
  const expectedCost = rowNullableNumber(row, "expected_cost");
  const expectedSchedule = rowNullableNumber(row, "expected_schedule_days");
  const quality = row ? rowString(row, "data_quality_status") || "incomplete" : "incomplete";
  const confidence = row ? rowString(row, "confidence_level") : "";
  const basis = row ? rowString(row, "basis") : "";
  const costRange = exposureRangeText(row, "cost");
  const scheduleRange = exposureRangeText(row, "schedule");
  return `
    <div class="risk-exposure-card ${row ? "" : "empty"}">
      <div class="risk-exposure-card-head">
        <div><span>${esc(stateDef.short)}</span><b>${esc(stateDef.label)}</b></div>
        ${statusToken(row ? qualityLabel(quality) : "Not captured", row ? qualityTone(quality) : "neutral")}
      </div>
      <div class="risk-exposure-numbers">
        <div><span>Probability</span><b>${probability == null ? "-" : `${probability}%`}</b></div>
        <div><span>Weighted cost</span><b>${expectedCost == null ? "-" : moneyK(Math.round(expectedCost))}</b></div>
        <div><span>Weighted schedule</span><b>${expectedSchedule == null ? "-" : `${expectedSchedule.toFixed(1)}d`}</b></div>
      </div>
      <div class="risk-exposure-ranges">
        <span>${esc(costRange || "Cost range not set")}</span>
        <span>${esc(scheduleRange || "Schedule range not set")}</span>
      </div>
      <small>${esc([confidence ? `${confidence} confidence` : "", basis ? truncate(basis, 120) : stateDef.note].filter(Boolean).join(" · "))}</small>
    </div>`;
}

function riskObjectGovernanceHtml(risk: RiskRecord) {
  const customFields = customFieldsForRisk(risk);
  const workflows = workflowInstances.filter((item) => item.entity_type === "risk" && item.entity_id === risk.id);
  const fieldHtml = customFields.length
    ? customFields
        .map(({ definition, value }) => `<div class="risk-custom-field${definition.required && !value ? " missing" : ""}"><span>${esc(definition.label)}</span><b>${esc(value || (definition.required ? "Required" : "-"))}</b><small>${esc(definition.help_text || definition.field_key)}</small></div>`)
        .join("")
    : '<div class="risk-governance-empty">No active risk custom fields configured.</div>';
  const workflowHtml = workflows.length
    ? workflows
        .map((workflow) => {
          const next = workflow.nextTransitions.length ? workflow.nextTransitions.map((item) => item.label).join(", ") : "No available transition";
          return `<div class="risk-workflow-card">
            <div><span>${esc(workflow.workflow_name)}</span><b>${esc(workflow.current_state_label || workflow.current_state)}</b></div>
            <small>${esc(workflow.owner || "No owner")} · ${workflow.due_date ? `Due ${fmtDate(workflow.due_date)}` : "No due date"} · ${esc(next)}</small>
          </div>`;
        })
        .join("")
    : '<div class="risk-governance-empty">No lifecycle workflow instance for this risk.</div>';
  return `
    <div class="risk-governance-grid">
      <div>
        <div class="risk-governance-label">Configurable fields</div>
        <div class="risk-custom-field-grid">${fieldHtml}</div>
      </div>
      <div>
        <div class="risk-governance-label">Lifecycle workflow</div>
        <div class="risk-workflow-list">${workflowHtml}</div>
      </div>
    </div>`;
}

function customFieldsForRisk(risk: RiskRecord) {
  const valuesByDefinition = new Map(customFieldValues.filter((item) => item.entity_type === "risk" && item.entity_id === risk.id).map((item) => [item.custom_field_definition_id, item.value_text]));
  return customFieldDefinitions
    .filter((definition) => definition.entity_type === "risk" && definition.status === "active")
    .sort((a, b) => a.sort_order - b.sort_order || a.label.localeCompare(b.label))
    .map((definition) => ({ definition, value: valuesByDefinition.get(definition.custom_field_definition_id) || "" }));
}

function riskExposureState(riskId: string, stateKey: ExposureStateKey) {
  return qraExposureStateRows.find((row) => rowString(row, "risk_id") === riskId && rowString(row, "state_key") === stateKey);
}

function riskAppetiteForRisk(riskId: string) {
  return riskAppetiteRows.find((row) => row.risk_id === riskId);
}

function upsertRiskAppetiteRow(row: RiskAppetiteAssessment) {
  const index = riskAppetiteRows.findIndex((item) => item.risk_id === row.risk_id);
  if (index >= 0) riskAppetiteRows[index] = row;
  else riskAppetiteRows.push(row);
}

function mergeRiskEscalationEvents(riskId: string, events: RiskEscalationEvent[]) {
  riskEscalationEvents = riskEscalationEvents.filter((event) => event.risk_id !== riskId).concat(events);
}

function appetiteStatusLabel(status: string) {
  if (status === "critical_breach") return "Critical breach";
  if (status === "breach") return "Breach";
  if (status === "accepted_exposure") return "Accepted exposure";
  if (status === "monitor") return "Monitor";
  return "Within appetite";
}

function appetiteClass(status: string) {
  if (status === "critical_breach") return "critical";
  if (status === "breach") return "breach";
  if (status === "accepted_exposure") return "accepted";
  if (status === "monitor") return "monitor";
  return "within";
}

function appetiteTone(status: string) {
  if (status === "critical_breach") return "red";
  if (status === "breach") return "amber";
  if (status === "accepted_exposure") return "blue";
  if (status === "monitor") return "amber";
  return "green";
}

function appetiteEventLabel(eventType: string) {
  if (eventType === "mitigation_required") return "Mitigation required";
  return eventType.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
}

function parseListText(value: unknown) {
  const text = String(value || "");
  if (!text) return [];
  return text.split(";").map((item) => item.trim()).filter(Boolean);
}

function dateValue(value: unknown) {
  const text = String(value || "");
  return /^\d{4}-\d{2}-\d{2}/.test(text) ? text.slice(0, 10) : "";
}

function exposureRangeText(row: ReportingRow | undefined, kind: "cost" | "schedule") {
  if (!row) return "";
  const suffix = kind === "cost" ? "" : "d";
  const prefix = kind === "cost" ? "£" : "";
  const low = rowNullableNumber(row, kind === "cost" ? "cost_low" : "schedule_low_days");
  const mostLikely = rowNullableNumber(row, kind === "cost" ? "cost_most_likely" : "schedule_most_likely_days");
  const high = rowNullableNumber(row, kind === "cost" ? "cost_high" : "schedule_high_days");
  if (low == null || mostLikely == null || high == null) return "";
  return `${kind === "cost" ? "Cost" : "Schedule"} ${prefix}${low}${suffix} / ${prefix}${mostLikely}${suffix} / ${prefix}${high}${suffix}`;
}

function rowNullableNumber(row: ReportingRow | undefined, key: string) {
  if (!row) return null;
  const value = row[key];
  if (value == null || value === "") return null;
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}

function nullableDelta(from: number | null, to: number | null) {
  if (from == null || to == null) return null;
  return from - to;
}

function qualityLabel(value: string) {
  if (value === "ready") return "Ready";
  if (value === "needs_review") return "Needs review";
  return "Incomplete";
}

function qualityTone(value: string) {
  if (value === "ready") return "green";
  if (value === "needs_review") return "amber";
  return "neutral";
}

function truncate(value: string, maxLength: number) {
  return value.length > maxLength ? `${value.slice(0, Math.max(0, maxLength - 1))}…` : value;
}

function riskReadiness(risk: RiskRecord): ReportingRow {
  const row = qraReadinessRows.find((candidate) => String(candidate.risk_id || "") === risk.id);
  if (row) return row;
  const missing: string[] = [];
  if (!risk.strategy) missing.push("mitigation strategy");
  if (!risk.exp) missing.push("cost exposure");
  if (!/programme|schedule|construction|delivery|design|commercial|cost|funding/i.test(risk.cat)) missing.push("QRA mapping");
  return {
    risk_id: risk.id,
    title: risk.title,
    readiness_status: qraCandidate(risk) ? (missing.length ? "Needs review" : "Ready") : "Not selected",
    missing_fields: missing.join(", "),
    readiness_note: missing.length ? missing.join(", ") : "Ready for QRA triage",
  };
}

function qraCandidate(risk: RiskRecord) {
  return post(risk) > BANDS.medium || risk.exp >= 250 || /programme|schedule|commercial|cost|funding|construction|delivery/i.test(risk.cat);
}

function qraTone(status: string) {
  if (/ready/i.test(status)) return "green";
  if (/incomplete|missing/i.test(status)) return "red";
  if (/not selected/i.test(status)) return "neutral";
  return "amber";
}

function rowString(row: ReportingRow, key: string) {
  const value = row[key];
  return value == null ? "" : String(value);
}

function rowNumber(row: ReportingRow, key: string) {
  const value = row[key];
  const num = Number(value);
  return Number.isFinite(num) ? num : 0;
}

function rowBool(row: ReportingRow, key: string) {
  return row[key] === true || row[key] === "true" || row[key] === 1;
}

function rowMatchesQraFilter(row: ReportingRow, filter: string) {
  const status = rowString(row, "readiness_status");
  if (filter === "all") return true;
  if (filter === "ready") return status === "Ready";
  if (filter === "needs_review") return status === "Needs review";
  if (filter === "incomplete") return status === "Incomplete";
  if (filter === "included") return rowString(row, "qra_inclusion_status") === "included";
  return status !== "Ready";
}

function qraStatusRank(row: ReportingRow) {
  const status = rowString(row, "readiness_status");
  if (status === "Incomplete") return 0;
  if (status === "Needs review") return 1;
  if (status === "Ready") return 2;
  return 3;
}

function qraRangeLabel(row: ReportingRow, type: "cost" | "schedule") {
  const complete = rowBool(row, `${type}_range_complete`);
  const targetComplete = rowBool(row, `target_${type}_range_complete`);
  const suffix = type === "cost" ? "£k" : "d";
  const low = rowNumber(row, type === "cost" ? "cost_low" : "schedule_low_days");
  const mostLikely = rowNumber(row, type === "cost" ? "cost_most_likely" : "schedule_most_likely_days");
  const high = rowNumber(row, type === "cost" ? "cost_high" : "schedule_high_days");
  const targetLow = rowNumber(row, type === "cost" ? "target_cost_low" : "target_schedule_low_days");
  const targetMostLikely = rowNumber(row, type === "cost" ? "target_cost_most_likely" : "target_schedule_most_likely_days");
  const targetHigh = rowNumber(row, type === "cost" ? "target_cost_high" : "target_schedule_high_days");
  if (!complete && !targetComplete) return '<span class="muted">Missing</span>';
  return `<span class="qra-range">${complete ? `${low}-${mostLikely}-${high}${suffix}` : "Current missing"}</span><small class="qra-target-range">${targetComplete ? `Forecast ${targetLow}-${targetMostLikely}-${targetHigh}${suffix}` : "Forecast missing"}</small>`;
}

function qraExpectedCost(row: ReportingRow) {
  if (row.current_expected_cost != null) return rowNumber(row, "current_expected_cost");
  return expectedWeighted(rowNumber(row, "cost_low"), rowNumber(row, "cost_most_likely"), rowNumber(row, "cost_high"), rowNumber(row, "probability_pct") / 100, rowBool(row, "cost_range_complete"));
}

function qraExpectedSchedule(row: ReportingRow) {
  if (row.current_expected_schedule_days != null) return rowNumber(row, "current_expected_schedule_days");
  return expectedWeighted(rowNumber(row, "schedule_low_days"), rowNumber(row, "schedule_most_likely_days"), rowNumber(row, "schedule_high_days"), rowNumber(row, "probability_pct") / 100, rowBool(row, "schedule_range_complete"));
}

function expectedWeighted(low: number, mostLikely: number, high: number, probabilityFactor: number, complete: boolean) {
  if (!complete || !Number.isFinite(probabilityFactor) || probabilityFactor <= 0) return 0;
  return ((low + mostLikely + high) / 3) * probabilityFactor;
}

function statusToken(label: string, tone: string) {
  return `<span class="status-token tone-${escAttr(tone)}">${esc(label)}</span>`;
}

function moneyK(value: number) {
  if (value >= 1000) return `£${(value / 1000).toFixed(2)}m`;
  return `£${value}k`;
}

function numberText(value: number | null) {
  return value == null ? "" : String(value);
}

function numberField(id: string) {
  const raw = value(id);
  if (!raw) return null;
  const num = Number(raw);
  return Number.isFinite(num) ? num : null;
}

function orderedRange(low: number | null, mostLikely: number | null, high: number | null) {
  if (low == null || mostLikely == null || high == null) return true;
  return low <= mostLikely && mostLikely <= high;
}

function rangeComplete(low: number | null, mostLikely: number | null, high: number | null) {
  return low != null && mostLikely != null && high != null && low <= mostLikely && mostLikely <= high;
}

function triangularMean(low: number | null, mostLikely: number | null, high: number | null) {
  if (!rangeComplete(low, mostLikely, high)) return null;
  return (Number(low) + Number(mostLikely) + Number(high)) / 3;
}

function ownerLoad(active: RiskRecord[]) {
  const grouped = new Map<string, { owner: string; count: number; red: number; exposure: number }>();
  active.forEach((risk) => {
    const row = grouped.get(risk.owner) || { owner: risk.owner, count: 0, red: 0, exposure: 0 };
    row.count += 1;
    row.red += isRed(post(risk)) ? 1 : 0;
    row.exposure += risk.exp;
    grouped.set(risk.owner, row);
  });
  return Array.from(grouped.values())
    .sort((a, b) => b.red - a.red || b.exposure - a.exposure || b.count - a.count)
    .slice(0, 6);
}

function doReport() {
  buildReport();
  window.print();
}

function buildReport() {
  if (!session) return;
  const active = risks.filter((d) => d.status !== "Closed");
  const crit = active.filter((d) => levelFor(post(d)) === "critical").length;
  const reds = active.filter((d) => isRed(post(d))).length;
  const exp = active.reduce((s, d) => s + d.exp, 0);
  const overdue = risks.filter((d) => reviewState(d.due) === "overdue").length;
  const imp = active.filter((d) => post(d) < d.prev).length;
  const wor = active.filter((d) => post(d) > d.prev).length;
  const top = active.slice().sort((a, b) => b.exp - a.exp).slice(0, 10);
  const nowLong = TODAY.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  let h = "";
  h += `<div class="rhead"><div class="rbrandlock"><svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Risk Studio"><rect width="64" height="64" rx="12" fill="#EDF5F8"/><line x1="12" y1="50.5" x2="52" y2="50.5" stroke="#5A5A5A" stroke-width="0.7" stroke-dasharray="1.6 2.4" opacity="0.5"/><g fill="#003366" fill-rule="evenodd"><path d="M13.6 14h7.1c5.8 0 9.4 3 9.4 8 0 4-2.4 6.8-6.4 7.6l-2.6.2-2.6.2v20H13.6Zm5.1 3.4v9.2h1.9c3.2 0 4.6-1.6 4.6-4.6 0-3-1.4-4.6-4.6-4.6Z"/><rect x="11.8" y="13.4" width="8.6" height="1.4" rx="0.4"/><rect x="11.8" y="49.6" width="8.6" height="1.4" rx="0.4"/></g><path d="M18.7 30C24 30 24 47 33 47S42 17 51 14" fill="none" stroke="#003366" stroke-width="3.4" stroke-linecap="round"/><circle cx="47.5" cy="17" r="3.4" fill="#4BACC6"/><circle cx="47.5" cy="17" r="1.2" fill="#FFFFFF"/></svg><div class="rbrandtext"><div class="rb1">Risk Studio</div><div class="rb2">Risk Register · by SOMA Project Controls</div></div></div><div class="rtitle"><div class="t1">Risk summary report</div><div class="t2">${esc(session.tenant.name)} — ${esc(session.tenant.programmeName)}</div><div class="t3">As at ${nowLong}</div></div></div>`;
  h += `<p class="exec">As at ${nowLong}, the capital programme carries <b>${active.length} active risks</b> with a residual exposure of <b>£${(exp / 1000).toFixed(2)}m</b>. After mitigation, <b>${reds}</b> ${reds === 1 ? "risk is" : "risks are"} rated High or Critical (${crit} critical), and ${overdue} review${overdue === 1 ? "" : "s"} ${overdue === 1 ? "is" : "are"} overdue. Since the last review, ${imp} risks have improved and ${wor} worsened.</p>`;
  h += `<div class="rkpis"><div><div class="l">Active risks</div><div class="v">${active.length}</div></div><div><div class="l">High + critical</div><div class="v">${reds}</div></div><div><div class="l">Residual exposure</div><div class="v">£${(exp / 1000).toFixed(2)}m</div></div><div><div class="l">Reviews overdue</div><div class="v">${overdue}</div></div></div>`;
  h += `<div style="display:flex;gap:22px"><div class="repsec" style="flex:1"><h3>Residual risk profile</h3>${heatMapHTML(active, 34)}</div><div class="repsec" style="flex:1"><h3>Exposure by category</h3>${barsHTML(active)}</div></div>`;
  h += '<div class="repsec"><h3>Top risks by exposure</h3><table><thead><tr><th>ID</th><th>Risk</th><th>Category</th><th>Owner</th><th>Residual rating</th><th>Exposure</th></tr></thead><tbody>';
  top.forEach((d) => {
    h += `<tr><td>${esc(d.id)}</td><td>${esc(d.title)}</td><td>${esc(d.cat)}</td><td>${esc(d.owner)}</td><td>${chip(post(d))} ${lvlPill(post(d))}${trendGlyph(d)}</td><td>£${d.exp}k</td></tr>`;
  });
  h += "</tbody></table></div>";
  h += `<div class="rfoot"><span>SOMA Project Controls · Commercial in confidence</span><span>Pilot · generated ${nowLong}</span></div>`;
  $("report").innerHTML = h;
}

function exportCsv() {
  const rows = [["ID", "Risk", "Category", "Owner", "Likelihood", "Impact", "Pre score", "Residual score", "Residual rating", "Status", "Review due", "Mitigation strategy"]];
  risks.forEach((d) => rows.push([d.id, d.title, d.cat, d.owner, LIKE[d.lpost], IMP[d.ipost], String(pre(d)), String(post(d)), levelName(post(d)), d.status, d.due, d.strategy || ""]));
  const csv = rows.map((r) => r.map(csvCell).join(",")).join("\n");
  const a = document.createElement("a");
  a.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
  a.download = `${session?.tenant.slug || "soma"}-risk-register.csv`;
  a.click();
}

function exportAuditCsv() {
  if (!canAdminUi()) return;
  const rows = [["When", "User", "Email", "Entity type", "Entity ID", "Action", "Summary", "Before JSON", "After JSON"]];
  auditEntries.forEach((entry) =>
    rows.push([
      entry.createdAt,
      entry.userName,
      entry.userEmail,
      entry.entityType,
      entry.entityId,
      entry.action,
      auditSummary(entry),
      entry.beforeJson,
      entry.afterJson,
    ]),
  );
  const csv = rows.map((r) => r.map(csvCell).join(",")).join("\n");
  const a = document.createElement("a");
  a.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
  a.download = `${session?.tenant.slug || "soma"}-audit-trail.csv`;
  a.click();
}

function draftPlannerEmail() {
  if (!curD) return;
  const d = curD;
  const open = d.actions
    .filter((a) => a.status !== "Done")
    .map((a) => `• ${a.task} — ${a.owner}${a.date ? `, due ${fmtDate(a.date)}` : ""} [${a.status}]`)
    .join("\n");
  const txt = `To: ${d.owner} (planner / risk owner)\nSubject: ${d.id} — ${d.title}\n\nHi ${d.owner.split(" ")[0]},\n\nFlagging ${d.id} for action ahead of the next review (${fmtDate(d.due)}).\n\nCause: ${d.cause}\nEvent: ${d.event}\nEffect: ${d.effect}\n\nMitigation strategy: ${d.strategy || "—"}\n\nResidual rating is ${levelName(post(d))} — ${LIKE[d.lpost]} likelihood × ${IMP[d.ipost]} impact (score ${post(d)}), exposure ~£${d.exp}k. Outstanding actions:\n${open}\n\nCould you confirm progress and update the register before the review date?\n\nThanks,\n${session?.user.name.split(" ")[0] || "SOMA"}`;
  const box = $<HTMLTextAreaElement>("m-emailbox");
  box.value = txt;
  box.style.display = "block";
}

function openFb() {
  $("fbform").style.display = "block";
  $("fbthanks").style.display = "none";
  $("fb-err").style.display = "none";
  showModal("fbmodal");
}

function closeFb() {
  hideModal("fbmodal");
}

async function submitFeedback() {
  const c = value("fb-comments");
  if (!c) {
    $("fb-err").style.display = "block";
    return;
  }
  const name = value("fb-name") || session?.user.name || "Anonymous reviewer";
  const area = value("fb-area");
  const sent = fbSent || "(not given)";
  const when = new Date().toLocaleString("en-GB");
  const payload = { name, area, sentiment: sent, comments: c, when, source: "SOMA Risk Studio" };
  try {
    const result = await sendFeedback(payload);
    $("fbform").style.display = "none";
    $("fbthanks").style.display = "block";
    $("fbthanks-sub").textContent = result.emailSent ? "Your feedback has been sent to the SOMA team. Thank you." : "Your feedback has been saved; email delivery is not configured in this environment.";
  } catch {
    mailtoFallback(payload);
    $("fbform").style.display = "none";
    $("fbthanks").style.display = "block";
    $("fbthanks-sub").textContent = "Your email app has opened with the feedback ready to send — just hit send.";
  }
}

function mailtoFallback(payload: Record<string, string>) {
  const subject = `Risk Studio feedback — ${payload.area}`;
  const body = `Feedback on SOMA Risk Studio\n\nFrom: ${payload.name}\nArea: ${payload.area}\nOverall: ${payload.sentiment}\nWhen: ${payload.when}\n\nComments:\n${payload.comments}\n`;
  window.location.href = `mailto:support@somaprojectcontrols.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

function applyRoleLocks() {
  if (!session) return;
  const canAdmin = canAdminUi();
  const canCreateRisk = hasPermissionUi("risk.create");
  const canUpdateRisk = hasPermissionUi("risk.update");
  const canDeleteRisk = hasPermissionUi("risk.delete");
  const canManageActions = hasPermissionUi("risk.action.manage");
  const canRecordProgress = hasPermissionUi("risk.action.progress");
  const canManageAppetite = hasPermissionUi("risk.appetite.manage");
  const canManageQuant = hasPermissionUi("qra.manage");
  const canApproveQuant = hasPermissionUi("qra.approve");
  const canManageControls = canManageControlsUi();
  const canManageConfiguration = canManageConfigurationUi();
  const canManageProgramme = canManageProgrammeItemsUi();
  const canManageImports = canManageImportsUi();
  const canManageEvidence = canManageEvidenceUi();
  const canSealEvidencePackage = canSealEvidencePackagesUi();
  const canManageReporting = canManageReportingUi();
  const canManageSrs = canManageSrsUi();
  setDisabled("newBtn", !canCreateRisk);
  setDisabled("rm-save", !(canCreateRisk || canUpdateRisk));
  setDisabled("m-edit", !canUpdateRisk);
  setDisabled("m-delete", !canDeleteRisk);
  setDisabled("m-addbtn", !canManageActions);
  setDisabled("m-asave", !canManageActions);
  setDisabled("m-aprogress", !canRecordProgress);
  setDisabled("m-quant-open", !canManageQuant);
  setDisabled("m-appetite-open", !canManageAppetite);
  setDisabled("q-save", !canManageQuant);
  setDisabled("q-workflow-note", !canManageQuant);
  setDisabled("q-attest", !canApproveQuant);
  document.querySelectorAll("#appetitemodal input,#appetitemodal textarea,#appetitemodal select,#appetitemodal button").forEach((el) => {
    if ((el as HTMLElement).id === "appetite-x" || (el as HTMLElement).id === "appetite-cancel") return;
    (el as HTMLInputElement | HTMLButtonElement | HTMLSelectElement | HTMLTextAreaElement).disabled = !canManageAppetite;
  });
  document.querySelectorAll("#m-actions .lnk").forEach((button) => ((button as HTMLButtonElement).disabled = !canManageActions));
  document.querySelectorAll("#cats input,#cats button,#scales input,#scales button").forEach((el) => ((el as HTMLInputElement | HTMLButtonElement).disabled = !canAdmin));
  document.querySelectorAll("#user-form input,#user-form select,#user-form button,#usersTb button,#audit-refresh,#audit-export,#package-grant-form input,#package-grant-form select,#package-grant-form button,#packageGrantsTb button,#complianceCard input,#complianceCard select,#complianceCard button:not(.btn),#retentionTb button,#integrationsCard input,#integrationsCard select,#integrationsCard textarea,#integrationsCard button:not(.btn)").forEach((el) => ((el as HTMLInputElement | HTMLButtonElement).disabled = !canAdmin));
  document.querySelectorAll("#structureAdmin input,#structureAdmin textarea,#structureAdmin select,#structureAdmin button").forEach((el) => ((el as HTMLInputElement | HTMLButtonElement | HTMLSelectElement | HTMLTextAreaElement).disabled = !canAdmin));
  document.querySelectorAll("#v-controls input,#v-controls textarea,#v-controls select,#v-controls button").forEach((el) => {
    if ((el as HTMLElement).id === "controls-refresh") return;
    (el as HTMLInputElement | HTMLButtonElement | HTMLSelectElement | HTMLTextAreaElement).disabled = !canManageControls;
  });
  document.querySelectorAll("#v-controls .control-admin-only").forEach((el) => ((el as HTMLButtonElement).disabled = !canManageControls));
  document.querySelectorAll("#v-intelligence input,#v-intelligence textarea,#v-intelligence select,#v-intelligence button").forEach((el) => {
    const id = (el as HTMLElement).id;
    if (["programme-refresh", "programme-search", "programme-type-filter", "programme-status-filter"].includes(id)) return;
    (el as HTMLInputElement | HTMLButtonElement | HTMLSelectElement | HTMLTextAreaElement).disabled = !canManageProgramme;
  });
  document.querySelectorAll("#v-imports input,#v-imports textarea,#v-imports select,#v-imports button").forEach((el) => {
    const id = (el as HTMLElement).id;
    if (["imports-refresh"].includes(id)) return;
    (el as HTMLInputElement | HTMLButtonElement | HTMLSelectElement | HTMLTextAreaElement).disabled = !canManageImports;
  });
  // Round-trip export controls that act on the selected export batch also require an active batch.
  const hasActiveExportBatch = Boolean(activeExportBatchId);
  ["export-download", "reconcile-load-baseline", "export-reconcile"].forEach((id) => setDisabled(id, !canManageImports || !hasActiveExportBatch));
  document.querySelectorAll("#v-evidence input,#v-evidence textarea,#v-evidence select,#v-evidence button").forEach((el) => {
    const id = (el as HTMLElement).id;
    if (["evidence-refresh", "evidence-search", "evidence-type-filter", "evidence-status-filter"].includes(id)) return;
    (el as HTMLInputElement | HTMLButtonElement | HTMLSelectElement | HTMLTextAreaElement).disabled = !canManageEvidence;
  });
  setDisabled("package-seal", !canSealEvidencePackage);
  document.querySelectorAll('[data-package-action="seal"]').forEach((button) => {
    if (!(button as HTMLButtonElement).disabled) (button as HTMLButtonElement).disabled = !canSealEvidencePackage;
  });
  document.querySelectorAll("#v-configuration input,#v-configuration textarea,#v-configuration select,#v-configuration button").forEach((el) => {
    const id = (el as HTMLElement).id;
    if (["configuration-refresh", "custom-field-search", "custom-field-entity-filter", "custom-field-status-filter", "workflow-search", "workflow-entity-filter", "workflow-status-filter"].includes(id)) return;
    (el as HTMLInputElement | HTMLButtonElement | HTMLSelectElement | HTMLTextAreaElement).disabled = !canManageConfiguration;
  });
  document.querySelectorAll("#v-reporting input,#v-reporting textarea,#v-reporting select,#v-reporting button").forEach((el) => {
    if ((el as HTMLElement).id === "reporting-refresh") return;
    (el as HTMLInputElement | HTMLButtonElement | HTMLSelectElement | HTMLTextAreaElement).disabled = !canManageReporting;
  });
  document.querySelectorAll("#v-srs input,#v-srs textarea,#v-srs select,#v-srs button").forEach((el) => {
    if ((el as HTMLElement).id === "srs-refresh") return;
    if ((el as HTMLElement).hasAttribute("data-srs-run-id")) return;
    (el as HTMLInputElement | HTMLButtonElement | HTMLSelectElement | HTMLTextAreaElement).disabled = !canManageSrs;
  });
  $("user-form").classList.toggle("rolelock", !canAdmin);
  $("structureAdmin").classList.toggle("rolelock", !canAdmin);
  $("cats").classList.toggle("rolelock", !canAdmin);
  $("scales").classList.toggle("rolelock", !canAdmin);
  $("v-intelligence").classList.toggle("rolelock", !canManageProgramme);
  $("v-imports").classList.toggle("rolelock", !canManageImports);
  $("v-controls").classList.toggle("rolelock", !canManageControls);
  $("v-configuration").classList.toggle("rolelock", !canManageConfiguration);
  $("v-reporting").classList.toggle("rolelock", !canManageReporting);
}

function setDisabled(id: string, disabled: boolean) {
  const el = document.getElementById(id) as HTMLButtonElement | null;
  if (el) el.disabled = disabled;
}

function replaceRisk(risk: RiskRecord | undefined) {
  if (!risk) return;
  const index = risks.findIndex((item) => item.id === risk.id);
  if (index >= 0) risks[index] = risk;
  else risks.push(risk);
}

function closeDetail() {
  closeQuantification();
  hideModal("modal");
}

function applyTheme(theme: Record<string, string>) {
  const root = document.documentElement;
  if (theme.navy) root.style.setProperty("--navy", theme.navy);
  if (theme.teal) root.style.setProperty("--teal", theme.teal);
  if (theme.lightTeal) root.style.setProperty("--lteal", theme.lightTeal);
  if (theme.ice) root.style.setProperty("--ice", theme.ice);
}

function levelFor(s: number): keyof typeof LV {
  return s <= BANDS.low ? "low" : s <= BANDS.medium ? "medium" : s <= BANDS.high ? "high" : "critical";
}

function levelName(s: number) {
  return LV[levelFor(s)];
}

function isRed(s: number) {
  const l = levelFor(s);
  return l === "high" || l === "critical";
}

function post(d: RiskRecord) {
  return d.lpost * d.ipost;
}

function pre(d: RiskRecord) {
  return d.lpre * d.ipre;
}

function chip(s: number) {
  const b = levelFor(s);
  return `<span class="chip" title="${levelName(s)}" style="background:${fillFor[b]};color:${inkFor[b]}">${s}</span>`;
}

function lvlPill(s: number) {
  const b = levelFor(s);
  return `<span class="lvl" style="background:${fillFor[b]};color:${inkFor[b]}">${levelName(s)}</span>`;
}

function lvlPillName(l: keyof typeof LV) {
  return `<span class="lvl" style="background:${fillFor[l]};color:${inkFor[l]}">${LV[l]}</span>`;
}

function trendGlyph(d: RiskRecord) {
  const c = post(d);
  const p = d.prev;
  if (c < p) return `<span class="trend down" title="Improved from ${p}">&#9660;</span>`;
  if (c > p) return `<span class="trend up" title="Worsened from ${p}">&#9650;</span>`;
  return '<span class="trend flat" title="No change">&#8211;</span>';
}

function fmtDate(iso: string) {
  return iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short" }) : "";
}

function fmtDateTime(iso: string) {
  return iso ? new Date(iso).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "";
}

function monthLabel(date: Date) {
  return date.toLocaleString("en-GB", { month: "long", year: "numeric" });
}

function monthDate(day: number) {
  return `${TODAY.getFullYear()}-${String(TODAY.getMonth() + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}

function todayIso() {
  return `${TODAY.getFullYear()}-${String(TODAY.getMonth() + 1).padStart(2, "0")}-${String(TODAY.getDate()).padStart(2, "0")}`;
}

function auditSummary(entry: AuditEntry) {
  const after = safeParse<Record<string, unknown>>(entry.afterJson);
  const before = safeParse<Record<string, unknown>>(entry.beforeJson);
  const source = after || before || {};
  if (entry.entityType === "risk") return String(source.title || source.code || entry.entityId);
  if (entry.entityType === "action") return String(source.task || entry.entityId);
  if (entry.entityType === "user") return String(source.email || source.name || entry.entityId);
  if (entry.entityType === "tenant_settings") return "Tenant configuration changed";
  return entry.entityId;
}

function safeParse<T>(text: string): T | null {
  if (!text) return null;
  try {
    return JSON.parse(text) as T;
  } catch {
    return null;
  }
}

function reviewState(iso: string) {
  const d = new Date(iso);
  const diff = (d.getTime() - TODAY.getTime()) / 86400000;
  if (diff < 0) return "overdue";
  if (diff <= 10) return "soon";
  return "scheduled";
}

function statusPill(s: string) {
  const c = s === "Managed" ? "o-managed" : s === "Closed" ? "o-closed" : "o-open";
  return `<span class="pill ${c}">${esc(s)}</span>`;
}

function statusPill2(s: RiskAction["status"]) {
  const c = s === "Done" ? "o-managed" : "o-open";
  return `<span class="pill ${c}">${esc(s)}</span>`;
}

function sortVal(d: RiskRecord, k: string): string | number {
  if (k === "pre") return pre(d);
  if (k === "post") return post(d);
  if (k === "due") return new Date(d.due).getTime();
  if (k === "title") return d.title.toLowerCase();
  return String((d as unknown as Record<string, unknown>)[k] || "").toLowerCase();
}

function updateArrows() {
  document.querySelectorAll("th.sortable").forEach((th) => {
    const a = th.querySelector(".ar");
    const isSorted = (th as HTMLElement).dataset.k === sortK;
    if (a) a.textContent = isSorted ? (sortDir < 0 ? " ▼" : " ▲") : "";
    th.setAttribute("aria-sort", isSorted ? (sortDir < 0 ? "descending" : "ascending") : "none");
  });
}

function csvCell(value: string) {
  return /[",\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

function value(id: string) {
  const el = $<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>(id);
  return el.value.trim();
}

function setValue(id: string, val: string) {
  const el = $<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>(id);
  el.value = val;
}

function $<T extends HTMLElement = HTMLElement>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Missing element: ${id}`);
  return el as T;
}

function esc(s: unknown) {
  return String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function escAttr(s: unknown) {
  return esc(s).replace(/'/g, "&#39;");
}

function cssEscape(value: string) {
  return typeof CSS !== "undefined" && "escape" in CSS ? CSS.escape(value) : value.replace(/["\\]/g, "\\$&");
}

function toast(message: string) {
  const el = document.getElementById("toast");
  if (!el) return;
  el.textContent = message;
  el.classList.add("show");
  window.setTimeout(() => el.classList.remove("show"), 2800);
}

function confirmDestructive(options: { title: string; message: string; confirmLabel: string }) {
  document.getElementById("confirm-ovl")?.remove();
  return new Promise<boolean>((resolve) => {
    const overlay = document.createElement("div");
    overlay.className = "ovl confirm-ovl show";
    overlay.id = "confirm-ovl";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.innerHTML = `
      <div class="confirm-sheet" role="document">
        <div class="confirm-icon">!</div>
        <div>
          <h2>${esc(options.title)}</h2>
          <p>${esc(options.message)}</p>
          <div class="confirm-actions">
            <button class="btn" data-confirm-cancel>Cancel</button>
            <button class="btnp danger-primary" data-confirm-ok>${esc(options.confirmLabel)}</button>
          </div>
        </div>
      </div>`;

    const cleanup = (answer: boolean) => {
      document.removeEventListener("keydown", onKey, true);
      overlay.remove();
      resolve(answer);
    };
    const onKey = (event: KeyboardEvent) => {
      if (event.key !== "Escape") return;
      event.stopPropagation();
      cleanup(false);
    };

    overlay.addEventListener("click", (event) => {
      if (event.target === overlay) cleanup(false);
    });
    overlay.querySelector("[data-confirm-cancel]")?.addEventListener("click", () => cleanup(false));
    overlay.querySelector("[data-confirm-ok]")?.addEventListener("click", () => cleanup(true));
    document.body.appendChild(overlay);
    document.addEventListener("keydown", onKey, true);
    overlay.querySelector<HTMLButtonElement>("[data-confirm-cancel]")?.focus();
  });
}

function errorMessage(err: unknown) {
  return err instanceof Error ? err.message : "Something went wrong";
}
